/*tslint:disable*/

/* tslint:disable */
/**
* Typescript Version: TS4 for Angular
* Application: seatback adplacer
* Version: 2.34.3 (ai-2)
* Created: 2026-02-13T13:22:57.270Z
* At: pub-adplacer.seatback.de
*/
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import {APIService, MultipartDefinition} from './api.service';
import type {SbLocalDateTime, SbDateTime, SbLocalDate, SbLocalTime} from './api-date-time';
import type {Resolution} from './api-resolution';
import type {GeoJSON, GeometryCollection, LineString, MultiLineString, MultiPoint, MultiPolygon, Polygon, Point} from 'geojson';
import type {BigNumber} from 'bignumber.js';


export enum Mode {
Entity = "Entity",
Definition = "Definition",
URL = "URL"
}@Injectable()
export class API {
public GET(url: string, pagination?: BehaviorSubject<Pagination> | null): Observable<any> {
	return this.api.GET(url, pagination);
}

public POST(url: string, body?: any): Observable<any> {
	return this.api.POST(url, body);
}

public PUT(url: string, body?: any): Observable<any> {
	return this.api.PUT(url, body);
}

public DELETE(url: string, body?: any): Observable<any> {
	return this.api.DELETE(url, body);
}
	public copy(from: any, to: any): void {
		if (from != null && to != null) {
			let type = from._type ? from._type : to._type;
			let properties = null;
			if (type != null) {
				let obj = this.createDTO(type);
				if (obj != null)
					properties = obj._properties;
			}
			if (properties != null) {
				for (let property of properties) {
					to[property] = from[property];
				}
			} else {
				for (let key in from) {
					to[key] = from[key];
				}
			}
		}
	}
	// Methods implemented by de.bpr_systems.web.api.rest.API:

public de_bpr_systems_web_api_rest_API_apiDocV2(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/API/OpenAPI/V2.json';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_application(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/API/Application';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_changelog(mode:Mode=Mode.Entity) : Observable<string[]> {
let url = '/API/Changelog';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_copyright(mode:Mode=Mode.Entity) : Observable<Response> {
let url = '/API/Copyright';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_environment(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/API/Environment';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_javaShortened(shorten : string, mode:Mode=Mode.Entity) : Observable<Response> {
let url = '/API/JAVA/'+encodeURIComponent(shorten)+'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_javaShortenedList(options: {shorten? : string[]} = {}, mode:Mode=Mode.Entity) : Observable<Response> {
if(!options)
options={};
let url = '/API/JAVA?'+(options.shorten!=null?''+this.api.queryParamArrayPrepare('shorten',options.shorten):'')+
'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_jwtPublicKey(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/API/JWT/public.key';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_online(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/API/Online';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_raiseError(options: {wrap? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/API/RaiseError?'+(options.wrap!=null?'&wrap='+options.wrap:'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_raiseErrorWithStatusCode(statusCode : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/API/RaiseError/'+statusCode+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_ResolveError(error : string, mode:Mode=Mode.Entity) : Observable<ResolvedErrorDTO> {
let url = '/API/ResolveError/'+encodeURIComponent(error)+'';
return <Observable<ResolvedErrorDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public de_bpr_systems_web_api_rest_API_typescriptShortened(shorten : string, options: {tsVersion? : string,
codeStyle? : CodeStyle} = {}, mode:Mode=Mode.Entity) : Observable<void> {
if(!options)
options={};
let url = '/API/TS/'+encodeURIComponent(shorten)+'?'+(options.tsVersion!=null?'&tsVersion='+options.tsVersion:'')+
''+(options.codeStyle!=null?'&codeStyle='+options.codeStyle:'')+
'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_typescriptShortenedList(options: {shorten? : string[],
tsVersion? : string,
codeStyle? : CodeStyle} = {}, mode:Mode=Mode.Entity) : Observable<void> {
if(!options)
options={};
let url = '/API/TS?'+(options.shorten!=null?''+this.api.queryParamArrayPrepare('shorten',options.shorten):'')+
''+(options.tsVersion!=null?'&tsVersion='+options.tsVersion:'')+
''+(options.codeStyle!=null?'&codeStyle='+options.codeStyle:'')+
'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_uptime(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/API/Uptime';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_API_version(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/API/Version';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.bpr_systems.web.api.rest.Authentication:

public de_bpr_systems_web_api_rest_Authentication_executeIDPLoginWithCode(idp_option_id : string, options: {code? : string,
redirectURL? : string} = {}, mode:Mode=Mode.Entity) : Observable<Serializable> {
if(!options)
options={};
let url = '/Authentication/IDP/'+encodeURIComponent(idp_option_id)+'/Login/Code?'+(options.code!=null?'&code='+options.code:'')+
''+(options.redirectURL!=null?'&redirectURL='+options.redirectURL:'')+
'';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_Authentication_executeNativeLogin(credentials_option_id : string, credentialsDTO : CredentialsDTO, mode:Mode=Mode.Entity) : Observable<Serializable> {
let url = '/Authentication/Credentials/'+encodeURIComponent(credentials_option_id)+'/Login';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, credentialsDTO));
}
public de_bpr_systems_web_api_rest_Authentication_retrieveAllowedOptions(mode:Mode=Mode.Entity) : Observable<AuthenticationOptionDTO[]> {
let url = '/Authentication/Option';
return <Observable<AuthenticationOptionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_Authentication_retrieveIDPLoginUrl(idp_option_id : string, options: {no_redirect? : boolean,
redirectURL? : string} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/Authentication/IDP/'+encodeURIComponent(idp_option_id)+'/Login?'+(options.no_redirect!=null?'&no_redirect='+options.no_redirect:'')+
''+(options.redirectURL!=null?'&redirectURL='+options.redirectURL:'')+
'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.bpr_systems.web.api.rest.Authorization:

public de_bpr_systems_web_api_rest_Authorization_refresh(string? : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Authorization/Refresh';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, string));
}// Methods implemented by de.bpr_systems.web.api.rest.Testing:

public de_bpr_systems_web_api_rest_Testing_datatype_dateTime(dateTime : SbDateTime, mode:Mode=Mode.Entity) : Observable<SbDateTime> {
let url = '/API/Testing/Datatype/DateTime';
return <Observable<SbDateTime>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_Testing_datatype_localDate(localDate : SbLocalDate, mode:Mode=Mode.Entity) : Observable<SbLocalDate> {
let url = '/API/Testing/Datatype/LocalDate';
return <Observable<SbLocalDate>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_Testing_datatype_localDateTime(localDateTime : SbLocalDateTime, mode:Mode=Mode.Entity) : Observable<SbLocalDateTime> {
let url = '/API/Testing/Datatype/LocalDateTime';
return <Observable<SbLocalDateTime>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_Testing_datatype_localTime(localTime : SbLocalTime, mode:Mode=Mode.Entity) : Observable<SbLocalTime> {
let url = '/API/Testing/Datatype/LocalTime';
return <Observable<SbLocalTime>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public de_bpr_systems_web_api_rest_Testing_initAuthentication(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/API/Testing/Authentication/Init';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.AdminEndpoints:

public _admin_AdminEndpoints_clearPlayoutConfirmations(options: {count? : number} = {}, mode:Mode=Mode.Entity) : Observable<number> {
if(!options)
options={};
let url = '/Admin/PlayoutConfirmation/Pending?count='+options.count+'';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_connectionPoolInfo(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/ConnectionPool';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_createCalendarBookingExample(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/CalendarBookingExample';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_AdminEndpoints_createCalendarExample(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/CalendarExample';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_AdminEndpoints_createMediumTransformation(mediumTransformationDTO : MediumTransformationDTO, options: {forClient? : number} = {}, mode:Mode=Mode.Entity) : Observable<MediumTransformationDTO> {
if(!options)
options={};
let url = '/Admin/MediumTransformation?'+(options.forClient!=null?'&forClient='+options.forClient:'')+
'';
return <Observable<MediumTransformationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumTransformationDTO));
}
public _admin_AdminEndpoints_createOrMigrateDefaultRoles(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Permission/Role/Defaults';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_AdminEndpoints_createSSP(sSPDTO : SSPDTO, mode:Mode=Mode.Entity) : Observable<SSPDTO> {
let url = '/Admin/SSP';
return <Observable<SSPDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, sSPDTO));
}
public _admin_AdminEndpoints_currentThreads(mode:Mode=Mode.Entity) : Observable<ThreadDTO[]> {
let url = '/Admin/Threads';
return <Observable<ThreadDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_currentThreadsGroupedByGroup(mode:Mode=Mode.Entity) : Observable<GroupedThreads> {
let url = '/Admin/Threads/Grouped/Group';
return <Observable<GroupedThreads>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_currentThreadsGroupedByPriority(mode:Mode=Mode.Entity) : Observable<GroupedThreads> {
let url = '/Admin/Threads/Grouped/Priority';
return <Observable<GroupedThreads>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_currentThreadsGroupedByStackTrace(mode:Mode=Mode.Entity) : Observable<GroupedThreads> {
let url = '/Admin/Threads/Grouped/StackTrace';
return <Observable<GroupedThreads>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_currentThreadsGroupedByState(mode:Mode=Mode.Entity) : Observable<GroupedThreads> {
let url = '/Admin/Threads/Grouped/State';
return <Observable<GroupedThreads>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_deleteLocalPairingDataOnDevice(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Device/'+device_id+'/Local/Pairing';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_deleteMediumTransformationById(id : number, mode:Mode=Mode.Entity) : Observable<MediumTransformationDTO> {
let url = '/Admin/MediumTransformation/'+id+'';
return <Observable<MediumTransformationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_deletePlaylistCache(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/PlaylistCache';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_deleteUnused(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/FixedAspectRatioImage/DeleteUnusedImages';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_deleteUnusedPermissions(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Permission/Unused';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_disconnectDeviceWebsocket(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Device/'+device_id+'/Websocket';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_editMediumTransformation(mediumTransformationDTO : MediumTransformationDTO, options: {forClient? : number} = {}, mode:Mode=Mode.Entity) : Observable<MediumTransformationDTO> {
if(!options)
options={};
let url = '/Admin/MediumTransformation?'+(options.forClient!=null?'&forClient='+options.forClient:'')+
'';
return <Observable<MediumTransformationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumTransformationDTO));
}
public _admin_AdminEndpoints_endpointStatistics(mode:Mode=Mode.Entity) : Observable<EndpointStatisticsDTO[]> {
let url = '/Admin/EndpointStatistics';
return <Observable<EndpointStatisticsDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_fixNonPersistedPlayoutDescriptors(mode:Mode=Mode.Entity) : Observable<CachedPlayoutDescriptorDTO[]> {
let url = '/Admin/PlayoutDescriptor/NonPersisted';
return <Observable<CachedPlayoutDescriptorDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_AdminEndpoints_getMediaFileInfos(options: {id? : number[],
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<MediumWithMediaFileInfo[]> {
if(!options)
options={};
let url = '/Admin/Medium/FFProbe?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumWithMediaFileInfo[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_mediumReprocessResources(options: {processed? : boolean,
id? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumDTO[]> {
if(!options)
options={};
let url = '/Admin/Medium/ReprocessResources?'+(options.processed!=null?'&processed='+options.processed:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, pagination));
}
public _admin_AdminEndpoints_mediumTransformationRetrieveAll(options: {id? : number[],
global? : boolean,
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<MediumTransformationDTO[]> {
if(!options)
options={};
let url = '/Admin/MediumTransformation?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumTransformationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_performanceCheck(options: {database? : boolean,
io? : boolean,
network? : boolean,
calculation? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<PerformanceCheckResultDTO> {
if(!options)
options={};
let url = '/Admin/PerformanceCheck?'+(options.database!=null?'&database='+options.database:'')+
''+(options.io!=null?'&io='+options.io:'')+
''+(options.network!=null?'&network='+options.network:'')+
''+(options.calculation!=null?'&calculation='+options.calculation:'')+
'';
return <Observable<PerformanceCheckResultDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_pushCurrentPlaylistToConnectedDevices(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Device/Connected/Playlist/Current';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public _admin_AdminEndpoints_pushCurrentPlaylistToDevice(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Device/'+device_id+'/Playlist/Current';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public _admin_AdminEndpoints_queryExecutionStatistics(mode:Mode=Mode.Entity) : Observable<QueryExecutionStatisticsDTO[]> {
let url = '/Admin/QueryExecutionStatistics';
return <Observable<QueryExecutionStatisticsDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_refreshCounts(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Counts/Refresh';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_reportingSystemReportingExecution(mode:Mode=Mode.Entity) : Observable<Serializable> {
let url = '/Admin/ReportingSystem/ReportingExecution';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_reportingSystemReportingRendering(mode:Mode=Mode.Entity) : Observable<Serializable> {
let url = '/Admin/ReportingSystem/ReportingRendering';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_reportingSystemScheduledReportingCreation(mode:Mode=Mode.Entity) : Observable<Serializable> {
let url = '/Admin/ReportingSystem/ScheduledReportingCreation';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_rescaleFixedAspectRatioImages(entity : string, image_type : string, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/FixedAspectRatioImage/'+encodeURIComponent(entity)+'/'+encodeURIComponent(image_type)+'/Rescale';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public _admin_AdminEndpoints_resetEndpointStatistics(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/EndpointStatistics';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_resetQueryExecutionStatistics(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/QueryExecutionStatistics';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_resetTransactionExecutionStatistics(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/TransactionExecutionStatistics';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_AdminEndpoints_retrieveAllFixedAspectRatioImageEntities(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Admin/FixedAspectRatioImage/Map';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveAllFixedAspectRatioImages(entity : string, image_type : string, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO[]> {
let url = '/Admin/FixedAspectRatioImage/'+encodeURIComponent(entity)+'/'+encodeURIComponent(image_type)+'';
return <Observable<FixedAspectRatioImageDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_AdminEndpoints_retrieveCurrentPlayoutDescriptors(mode:Mode=Mode.Entity) : Observable<CachedPlayoutDescriptorDTO[]> {
let url = '/Admin/PlayoutDescriptor/Current';
return <Observable<CachedPlayoutDescriptorDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveDeviceSocketCommandLogCSV(seconds : number, options: {device? : number[],
screen? : number[],
command? : DeviceCommand[],
direction? : CommandDirection} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/Admin/DeviceSocket/CommandLogStatistic/'+seconds+'/CSV?'+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.command!=null?''+this.api.queryParamArrayPrepare('command',options.command):'')+
''+(options.direction!=null?'&direction='+options.direction:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveDeviceSocketCommandLogCSVSecondsAgo(seconds : number, secondsAgo : number, options: {device? : number[],
screen? : number[],
command? : DeviceCommand[],
direction? : CommandDirection} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/Admin/DeviceSocket/CommandLogStatistic/'+seconds+'/Ago/'+secondsAgo+'/CSV?'+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.command!=null?''+this.api.queryParamArrayPrepare('command',options.command):'')+
''+(options.direction!=null?'&direction='+options.direction:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveDeviceSocketCommandLogStatistic(seconds : number, options: {device? : number[],
screen? : number[],
command? : DeviceCommand[],
direction? : CommandDirection} = {}, mode:Mode=Mode.Entity) : Observable<DeviceSocketCommandLogStatisticDTO> {
if(!options)
options={};
let url = '/Admin/DeviceSocket/CommandLogStatistic/'+seconds+'?'+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.command!=null?''+this.api.queryParamArrayPrepare('command',options.command):'')+
''+(options.direction!=null?'&direction='+options.direction:'')+
'';
return <Observable<DeviceSocketCommandLogStatisticDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveDeviceSocketCommandLogStatisticSecondsAgo(seconds : number, secondsAgo : number, options: {device? : number[],
screen? : number[],
command? : DeviceCommand[],
direction? : CommandDirection} = {}, mode:Mode=Mode.Entity) : Observable<DeviceSocketCommandLogStatisticDTO> {
if(!options)
options={};
let url = '/Admin/DeviceSocket/CommandLogStatistic/'+seconds+'/Ago/'+secondsAgo+'?'+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.command!=null?''+this.api.queryParamArrayPrepare('command',options.command):'')+
''+(options.direction!=null?'&direction='+options.direction:'')+
'';
return <Observable<DeviceSocketCommandLogStatisticDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveNonPersistedPlayoutDescriptors(mode:Mode=Mode.Entity) : Observable<CachedPlayoutDescriptorDTO[]> {
let url = '/Admin/PlayoutDescriptor/NonPersisted';
return <Observable<CachedPlayoutDescriptorDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrievePlayoutConfirmationCount(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/PlayoutConfirmation/Pending';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_retrieveTokens(options: {uuid? : string,
hostname? : string,
ip? : string,
token? : string,
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<DeviceConfigurationRequestDTO[]> {
if(!options)
options={};
let url = '/Admin/Tokens?'+(options.uuid!=null?'&uuid='+options.uuid:'')+
''+(options.hostname!=null?'&hostname='+options.hostname:'')+
''+(options.ip!=null?'&ip='+options.ip:'')+
''+(options.token!=null?'&token='+options.token:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<DeviceConfigurationRequestDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_sessionFactoryInfo(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/SessionFactoryInfo';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_threadStatisticFor(seconds : number, mode:Mode=Mode.Entity) : Observable<ThreadStatistic> {
let url = '/Admin/Threads/'+seconds+'/Seconds/Statistic';
return <Observable<ThreadStatistic>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_transactionExecutionStatistics(mode:Mode=Mode.Entity) : Observable<TransactionExecutionStatisticsDTO[]> {
let url = '/Admin/TransactionExecutionStatistics';
return <Observable<TransactionExecutionStatisticsDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_AdminEndpoints_uptime(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/Uptime';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.Area:

public _admin_Area_createArea(areaDTO : AreaDTO, mode:Mode=Mode.Entity) : Observable<AreaDTO> {
let url = '/Admin/Area';
return <Observable<AreaDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, areaDTO));
}
public _admin_Area_deleteById(area_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Area/'+area_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_Area_editArea(areaDTO : AreaDTO, mode:Mode=Mode.Entity) : Observable<AreaDTO> {
let url = '/Admin/Area';
return <Observable<AreaDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, areaDTO));
}
public _admin_Area_retrieveAll(options: {id? : number[],
company? : number[],
category? : number[],
hasCompany? : boolean,
hasCategory? : boolean,
notInCategory? : number[],
search? : string,
filter? : {by: _admin_Area_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: _admin_Area_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
if(!options)
options={};
let url = '/Admin/Area?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.hasCategory!=null?'&hasCategory='+options.hasCategory:'')+
''+(options.notInCategory!=null?''+this.api.queryParamArrayPrepare('notInCategory',options.notInCategory):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Area_retrieveById(area_id : number, mode:Mode=Mode.Entity) : Observable<AreaDTO> {
let url = '/Admin/Area/'+area_id+'';
return <Observable<AreaDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.Attribute:

public _admin_Attribute_createCompanyDatatype(companyAttributeDatatypeDTO : CompanyAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Company';
return <Observable<CompanyAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, companyAttributeDatatypeDTO));
}
public _admin_Attribute_createDeviceDatatype(deviceAttributeDatatypeDTO : DeviceAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Device';
return <Observable<DeviceAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, deviceAttributeDatatypeDTO));
}
public _admin_Attribute_createLocationDatatype(locationAttributeDatatypeDTO : LocationAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Location';
return <Observable<LocationAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, locationAttributeDatatypeDTO));
}
public _admin_Attribute_createMediumGroupDatatype(mediumGroupAttributeDatatypeDTO : MediumGroupAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/MediumGroup';
return <Observable<MediumGroupAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupAttributeDatatypeDTO));
}
public _admin_Attribute_createMissingCompanyAttributes(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/Attribute/Datatype/Company/CreateMissingAttributes';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_Attribute_createMissingDeviceAttributes(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/Attribute/Datatype/Device/CreateMissingAttributes';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_Attribute_createMissingLocationAttributes(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/Attribute/Datatype/Location/CreateMissingAttributes';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_Attribute_createMissingMediumGroupAttributes(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/Attribute/Datatype/MediumGroup/CreateMissingAttributes';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_Attribute_createMissingProductAttributes(mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Admin/Attribute/Datatype/Product/CreateMissingAttributes';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_Attribute_createProductDatatype(productAttributeDatatypeDTO : ProductAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Product';
return <Observable<ProductAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, productAttributeDatatypeDTO));
}
public _admin_Attribute_editCompanyDatatype(companyAttributeDatatypeDTO : CompanyAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Company';
return <Observable<CompanyAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, companyAttributeDatatypeDTO));
}
public _admin_Attribute_editDeviceDatatype(deviceAttributeDatatypeDTO : DeviceAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Device';
return <Observable<DeviceAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, deviceAttributeDatatypeDTO));
}
public _admin_Attribute_editLocationDatatype(locationAttributeDatatypeDTO : LocationAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Location';
return <Observable<LocationAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationAttributeDatatypeDTO));
}
public _admin_Attribute_editMediumGroupDatatype(mediumGroupAttributeDatatypeDTO : MediumGroupAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/MediumGroup';
return <Observable<MediumGroupAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupAttributeDatatypeDTO));
}
public _admin_Attribute_editProductDatatype(productAttributeDatatypeDTO : ProductAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO> {
let url = '/Admin/Attribute/Datatype/Product';
return <Observable<ProductAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, productAttributeDatatypeDTO));
}
public _admin_Attribute_retrieveAllCompanyDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/Admin/Attribute/Datatype/Company?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<CompanyAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Attribute_retrieveAllDeviceDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/Admin/Attribute/Datatype/Device?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<DeviceAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Attribute_retrieveAllLocationDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/Admin/Attribute/Datatype/Location?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<LocationAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Attribute_retrieveAllMediumGroupDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/Admin/Attribute/Datatype/MediumGroup?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Attribute_retrieveAllProductDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/Admin/Attribute/Datatype/Product?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<ProductAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api._admin.BackgroundWorker:

public _admin_BackgroundWorker_calculateDeviceAuditionStatistics(days : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/BackgroundWorker/DeviceStatistics/DeviceAuditionStatistics/'+days+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_BackgroundWorker_fullyRecalculateDeviceAuditionStatistics(options: {after? : SbDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/Admin/BackgroundWorker/DeviceStatistics/DeviceAuditionStatistics/Full?'+(options.after!=null?'&after='+this.api.queryParamDatePrepare(options.after):'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, pagination));
}
public _admin_BackgroundWorker_interrupt(name : string, mode:Mode=Mode.Entity) : Observable<BackgroundWorkerDTO> {
let url = '/Admin/BackgroundWorker/'+encodeURIComponent(name)+'/Interrupt';
return <Observable<BackgroundWorkerDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_BackgroundWorker_retrieveAll(mode:Mode=Mode.Entity) : Observable<BackgroundWorkerDTO[]> {
let url = '/Admin/BackgroundWorker';
return <Observable<BackgroundWorkerDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_BackgroundWorker_retrieveByName(name : string, mode:Mode=Mode.Entity) : Observable<BackgroundWorkerDTO> {
let url = '/Admin/BackgroundWorker/'+encodeURIComponent(name)+'';
return <Observable<BackgroundWorkerDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.category.AreaCategory:

public _admin_category_AreaCategory_createCategory(areaCategoryDTO : AreaCategoryDTO, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO> {
let url = '/Admin/Category/Area';
return <Observable<AreaCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, areaCategoryDTO));
}
public _admin_category_AreaCategory_deleteById(areaCategory_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Area/'+areaCategory_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_AreaCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Area/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_AreaCategory_editCategory(areaCategoryDTO : AreaCategoryDTO, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO> {
let url = '/Admin/Category/Area';
return <Observable<AreaCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, areaCategoryDTO));
}
public _admin_category_AreaCategory_retrieveAll(options: {id? : number[],
company? : number[],
hasCompany? : boolean,
hasAreas? : boolean,
notInHierarchyOf? : number,
search? : string,
filter? : {by: _admin_category_AreaCategory_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: _admin_category_AreaCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO[]> {
if(!options)
options={};
let url = '/Admin/Category/Area?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.hasAreas!=null?'&hasAreas='+options.hasAreas:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AreaCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_category_AreaCategory_retrieveById(areaCategory_id : number, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO> {
let url = '/Admin/Category/Area/'+areaCategory_id+'';
return <Observable<AreaCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.category.AssetCategory:

public _admin_category_AssetCategory_createCategory(assetCategoryDTO : AssetCategoryDTO, mode:Mode=Mode.Entity) : Observable<AssetCategoryDTO> {
let url = '/Admin/Category/Asset';
return <Observable<AssetCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, assetCategoryDTO));
}
public _admin_category_AssetCategory_deleteById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Asset/'+category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_AssetCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Asset/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_AssetCategory_editCategory(assetCategoryDTO : AssetCategoryDTO, mode:Mode=Mode.Entity) : Observable<AssetCategoryDTO> {
let url = '/Admin/Category/Asset';
return <Observable<AssetCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, assetCategoryDTO));
}
public _admin_category_AssetCategory_retrieveAll(options: {id? : number[],
company? : number[],
forCompany? : number,
hasCompany? : boolean,
notInHierarchyOf? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetCategoryDTO[]> {
if(!options)
options={};
let url = '/Admin/Category/Asset?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_category_AssetCategory_retrieveById(category_id : number, mode:Mode=Mode.Entity) : Observable<AssetCategoryDTO> {
let url = '/Admin/Category/Asset/'+category_id+'';
return <Observable<AssetCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.category.CalendarCategory:

public _admin_category_CalendarCategory_createCategory(calendarCategoryDTO : CalendarCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO> {
let url = '/Admin/Category/Calendar';
return <Observable<CalendarCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarCategoryDTO));
}
public _admin_category_CalendarCategory_deleteById(calendar_category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Calendar/'+calendar_category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_CalendarCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Calendar/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_CalendarCategory_editCategory(calendarCategoryDTO : CalendarCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO> {
let url = '/Admin/Category/Calendar';
return <Observable<CalendarCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarCategoryDTO));
}
public _admin_category_CalendarCategory_retrieveAll(options: {id? : number[],
company? : number[],
notInHierarchyOf? : number,
search? : string,
filter? : {by: _admin_category_CalendarCategory_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: _admin_category_CalendarCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO[]> {
if(!options)
options={};
let url = '/Admin/Category/Calendar?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CalendarCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_category_CalendarCategory_retrieveById(calendarCategory_id : number, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO> {
let url = '/Admin/Category/Calendar/'+calendarCategory_id+'';
return <Observable<CalendarCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.category.CalendarEntryCategory:

public _admin_category_CalendarEntryCategory_createCategory(calendarEntryCategoryDTO : CalendarEntryCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO> {
let url = '/Admin/Category/CalendarEntry';
return <Observable<CalendarEntryCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarEntryCategoryDTO));
}
public _admin_category_CalendarEntryCategory_deleteById(calendar_entry_category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/CalendarEntry/'+calendar_entry_category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_CalendarEntryCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/CalendarEntry/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_CalendarEntryCategory_editCategory(calendarEntryCategoryDTO : CalendarEntryCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO> {
let url = '/Admin/Category/CalendarEntry';
return <Observable<CalendarEntryCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarEntryCategoryDTO));
}
public _admin_category_CalendarEntryCategory_retrieveAll(options: {id? : number[],
notInHierarchyOf? : number,
search? : string,
filter? : {by: _admin_category_CalendarEntryCategory_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: _admin_category_CalendarEntryCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO[]> {
if(!options)
options={};
let url = '/Admin/Category/CalendarEntry?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CalendarEntryCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_category_CalendarEntryCategory_retrieveById(calendarEntryCategory_id : number, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO> {
let url = '/Admin/Category/CalendarEntry/'+calendarEntryCategory_id+'';
return <Observable<CalendarEntryCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.category.CullCategory:

public _admin_category_CullCategory_createCategory(cullCategoryDTO : CullCategoryDTO, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO> {
let url = '/Admin/Category/Cull';
return <Observable<CullCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullCategoryDTO));
}
public _admin_category_CullCategory_deleteById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Cull/'+category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_CullCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/Cull/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_CullCategory_editCategory(cullCategoryDTO : CullCategoryDTO, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO> {
let url = '/Admin/Category/Cull';
return <Observable<CullCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, cullCategoryDTO));
}
public _admin_category_CullCategory_retrieveAll(options: {id? : number[],
company? : number[],
forCompany? : number,
hasCompany? : boolean,
notInHierarchyOf? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO[]> {
if(!options)
options={};
let url = '/Admin/Category/Cull?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<CullCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_category_CullCategory_retrieveById(cullCategory_id : number, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO> {
let url = '/Admin/Category/Cull/'+cullCategory_id+'';
return <Observable<CullCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.category.MediumGroupCategory:

public _admin_category_MediumGroupCategory_createCategory(mediumGroupCategoryDTO : MediumGroupCategoryDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO> {
let url = '/Admin/Category/MediumGroup';
return <Observable<MediumGroupCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupCategoryDTO));
}
public _admin_category_MediumGroupCategory_deleteById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/MediumGroup/'+category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_MediumGroupCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Category/MediumGroup/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_category_MediumGroupCategory_editCategory(mediumGroupCategoryDTO : MediumGroupCategoryDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO> {
let url = '/Admin/Category/MediumGroup';
return <Observable<MediumGroupCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupCategoryDTO));
}
public _admin_category_MediumGroupCategory_retrieveAll(options: {id? : number[],
company? : number[],
forCompany? : number,
hasCompany? : boolean,
notInHierarchyOf? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO[]> {
if(!options)
options={};
let url = '/Admin/Category/MediumGroup?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_category_MediumGroupCategory_retrieveById(category_id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO> {
let url = '/Admin/Category/MediumGroup/'+category_id+'';
return <Observable<MediumGroupCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.Client:

public _admin_Client_addAdmin(client_id : number, userDTO : UserDTO, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Admin/Client/'+client_id+'/Admin';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, userDTO));
}
public _admin_Client_blockUser(client_id : number, user_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Client/'+client_id+'/User/'+user_id+'/Block';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_Client_connectClient(client_id : number, connect_client_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Client/'+client_id+'/Connection/'+connect_client_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_Client_create(clientCreationDTO : ClientCreationDTO, mode:Mode=Mode.Entity) : Observable<ClientDTO> {
let url = '/Admin/Client';
return <Observable<ClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, clientCreationDTO));
}
public _admin_Client_disconnectClient(client_id : number, connect_client_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Client/'+client_id+'/Connection/'+connect_client_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_Client_edit(clientDTO : ClientDTO, mode:Mode=Mode.Entity) : Observable<ClientDTO> {
let url = '/Admin/Client';
return <Observable<ClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, clientDTO));
}
public _admin_Client_removeAdmin(client_id : number, user_id : number, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Admin/Client/'+client_id+'/Admin/'+user_id+'';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_Client_retrieveAdmins(client_id : number, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<UserFullDTO[]> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/Admin?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<UserFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Client_retrieveAll(options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: _admin_Client_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/Admin/Client?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Client_retrieveAllMembers(client_id : number, options: {blocked? : boolean,
hasPermission? : string[],
hasRole_id? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO[]> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/User?'+(options.blocked!=null?'&blocked='+options.blocked:'')+
''+(options.hasPermission!=null?''+this.api.queryParamArrayPrepare('hasPermission',options.hasPermission):'')+
''+(options.hasRole_id!=null?''+this.api.queryParamArrayPrepare('hasRole_id',options.hasRole_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<UserClientFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Client_retrieveById(client_id : number, mode:Mode=Mode.Entity) : Observable<ClientDTO> {
let url = '/Admin/Client/'+client_id+'';
return <Observable<ClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_Client_retrieveConnectedClients(client_id : number, options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: _admin_Client_retrieveConnectedClients_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/Connection?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api._admin.DevelopmentEndpoints:

public _admin_DevelopmentEndpoints_executedNamedFunction(name : string, mode:Mode=Mode.Entity) : Observable<Serializable> {
let url = '/Admin/Development/Function/'+encodeURIComponent(name)+'';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_DevelopmentEndpoints_generateLongId(mode:Mode=Mode.Entity) : Observable<IdentityDTO> {
let url = '/Admin/Development/LongId';
return <Observable<IdentityDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.DeviceSocket:

public _admin_DeviceSocket_retrieveAllCommandQueueManagers(mode:Mode=Mode.Entity) : Observable<CommandQueueManagerDTO[]> {
let url = '/Admin/DeviceSocket/CommandQueueManager';
return <Observable<CommandQueueManagerDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_DeviceSocket_retrieveCommandQueueManagerForCommand(command : DeviceCommand, mode:Mode=Mode.Entity) : Observable<CommandQueueManagerDTO> {
let url = '/Admin/DeviceSocket/CommandQueueManager/'+command+'';
return <Observable<CommandQueueManagerDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_DeviceSocket_setAllCommandQueueManagerMaxThreads(maxThreads : number, mode:Mode=Mode.Entity) : Observable<CommandQueueManagerDTO[]> {
let url = '/Admin/DeviceSocket/CommandQueueManager/MaxThreads/'+maxThreads+'';
return <Observable<CommandQueueManagerDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public _admin_DeviceSocket_setAllCommandQueueManagerMinThreads(minThreads : number, mode:Mode=Mode.Entity) : Observable<CommandQueueManagerDTO[]> {
let url = '/Admin/DeviceSocket/CommandQueueManager/MinThreads/'+minThreads+'';
return <Observable<CommandQueueManagerDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public _admin_DeviceSocket_setCommandQueueManagerMaxThreadsForCommand(command : DeviceCommand, maxThreads : number, mode:Mode=Mode.Entity) : Observable<CommandQueueManagerDTO> {
let url = '/Admin/DeviceSocket/CommandQueueManager/'+command+'/MaxThreads/'+maxThreads+'';
return <Observable<CommandQueueManagerDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public _admin_DeviceSocket_setCommandQueueManagerMinThreadsForCommand(command : DeviceCommand, minThreads : number, mode:Mode=Mode.Entity) : Observable<CommandQueueManagerDTO> {
let url = '/Admin/DeviceSocket/CommandQueueManager/'+command+'/MinThreads/'+minThreads+'';
return <Observable<CommandQueueManagerDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}// Methods implemented by de.seatback.adplacer.api._admin.HQL:

public _admin_HQL_asSQL(string : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/HQL/As/SQL';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, string));
}
public _admin_HQL_retrieveAll(string : string, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<Serializable[]> {
let url = '/Admin/HQL/Select';
return <Observable<Serializable[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, string, pagination));
}// Methods implemented by de.seatback.adplacer.api._admin.License:

public _admin_License_assignMachineCodeToDeviceMachineLicense(client_id : number, license_id : number, machine_code : string, mode:Mode=Mode.Entity) : Observable<ScreenDTO[]> {
let url = '/Admin/Client/'+client_id+'/License/'+license_id+'/Device/MachineCode/Assign/'+encodeURIComponent(machine_code)+'';
return <Observable<ScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_autoAssignById(client_id : number, license_id : number, options: {machineCode? : string[],
productive? : boolean,
disabled? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<LicenseDTO> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/License/'+license_id+'/Assignment?'+(options.machineCode!=null?''+this.api.queryParamArrayPrepare('machineCode',options.machineCode):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
'';
return <Observable<LicenseDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_autoAssignLicenses(client_id : number, options: {type? : LicenseType[],
id? : number[],
machineCode? : string[],
productive? : boolean,
disabled? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<LicenseDTO[]> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/License/Assignment?'+(options.type!=null?''+this.api.queryParamArrayPrepare('type',options.type):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.machineCode!=null?''+this.api.queryParamArrayPrepare('machineCode',options.machineCode):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
'';
return <Observable<LicenseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_autoAssignLicensesByType(client_id : number, type : LicenseType, options: {id? : number[],
machineCode? : string[],
productive? : boolean,
disabled? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<LicenseDTO[]> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/License/Type/'+type+'/Assignment?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.machineCode!=null?''+this.api.queryParamArrayPrepare('machineCode',options.machineCode):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
'';
return <Observable<LicenseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_createLicense(client_id : number, type : LicenseType, mode:Mode=Mode.Entity) : Observable<LicenseDTO> {
let url = '/Admin/Client/'+client_id+'/License/'+type+'/Create';
return <Observable<LicenseDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_createLicenses(client_id : number, type : LicenseType, count : number, mode:Mode=Mode.Entity) : Observable<LicenseDTO[]> {
let url = '/Admin/Client/'+client_id+'/License/'+type+'/Create/'+count+'';
return <Observable<LicenseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_delete(client_id : number, license_id : number, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/Client/'+client_id+'/License/'+license_id+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_License_freeMachineCodeToDeviceMachineLicense(client_id : number, license_id : number, mode:Mode=Mode.Entity) : Observable<ScreenDTO[]> {
let url = '/Admin/Client/'+client_id+'/License/'+license_id+'/Device/MachineCode/Assign';
return <Observable<ScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_License_loadLicense(client_id : number, serial : string, mode:Mode=Mode.Entity) : Observable<LicenseDTO> {
let url = '/Admin/Client/'+client_id+'/License/Load/'+encodeURIComponent(serial)+'';
return <Observable<LicenseDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_License_loadLicenses(client_id : number, loadLicenseRequest : LoadLicenseRequest, mode:Mode=Mode.Entity) : Observable<LicenseDTO[]> {
let url = '/Admin/Client/'+client_id+'/License/Load';
return <Observable<LicenseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, loadLicenseRequest));
}
public _admin_License_retrieveClientLicenseById(client_id : number, license_id : number, mode:Mode=Mode.Entity) : Observable<LicenseDTO> {
let url = '/Admin/Client/'+client_id+'/License/'+license_id+'';
return <Observable<LicenseDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_License_retrieveClientLicenses(client_id : number, options: {type? : LicenseType,
id? : number[],
uuid? : string[],
configured? : boolean,
used? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LicenseDTO[]> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/License?'+(options.type!=null?'&type='+options.type:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.uuid!=null?''+this.api.queryParamArrayPrepare('uuid',options.uuid):'')+
''+(options.configured!=null?'&configured='+options.configured:'')+
''+(options.used!=null?'&used='+options.used:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<LicenseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_License_retrieveClientLicensesAsCSV(client_id : number, options: {type? : LicenseType,
id? : number[],
uuid? : string[],
configured? : boolean,
used? : boolean,
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/License/CSV?'+(options.type!=null?'&type='+options.type:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.uuid!=null?''+this.api.queryParamArrayPrepare('uuid',options.uuid):'')+
''+(options.configured!=null?'&configured='+options.configured:'')+
''+(options.used!=null?'&used='+options.used:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_License_unassignAll(client_id : number, options: {id? : number[],
used? : boolean,
machineCode? : string[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/Admin/Client/'+client_id+'/License/Assignment?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.used!=null?'&used='+options.used:'')+
''+(options.machineCode!=null?''+this.api.queryParamArrayPrepare('machineCode',options.machineCode):'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_License_unassignById(client_id : number, license_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Client/'+client_id+'/License/'+license_id+'/Assignment';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}// Methods implemented by de.seatback.adplacer.api._admin.Membership:

public _admin_Membership_retrieveAll(options: {blocked? : boolean,
user_id? : number[],
user_username? : string[],
user_email? : string[],
user_search? : string,
client_id? : number[],
client_identifier? : string[],
client_search? : string,
hasPermission? : string[],
hasRole_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO[]> {
if(!options)
options={};
let url = '/Admin/UserClient?'+(options.blocked!=null?'&blocked='+options.blocked:'')+
''+(options.user_id!=null?''+this.api.queryParamArrayPrepare('user_id',options.user_id):'')+
''+(options.user_username!=null?''+this.api.queryParamArrayPrepare('user_username',options.user_username):'')+
''+(options.user_email!=null?''+this.api.queryParamArrayPrepare('user_email',options.user_email):'')+
''+(options.user_search!=null?'&user_search='+options.user_search:'')+
''+(options.client_id!=null?''+this.api.queryParamArrayPrepare('client_id',options.client_id):'')+
''+(options.client_identifier!=null?''+this.api.queryParamArrayPrepare('client_identifier',options.client_identifier):'')+
''+(options.client_search!=null?'&client_search='+options.client_search:'')+
''+(options.hasPermission!=null?''+this.api.queryParamArrayPrepare('hasPermission',options.hasPermission):'')+
''+(options.hasRole_id!=null?''+this.api.queryParamArrayPrepare('hasRole_id',options.hasRole_id):'')+
'';
return <Observable<UserClientFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api._admin.Metrics:

public _admin_Metrics_scrape(path : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/Metrics/Scrape/'+encodeURIComponent(path)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_Metrics_scrapeDefault(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/Metrics/Scrape';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_Metrics_scrapePrefix(prefix : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/Metrics/Scrape/'+encodeURIComponent(prefix)+'/Prefix';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.OSM:

public _admin_OSM_getAnyAreas(query : string, mode:Mode=Mode.Entity) : Observable<PolygonDTO[]> {
let url = '/OSM/'+encodeURIComponent(query)+'';
return <Observable<PolygonDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_OSM_getBoroughAreas(query : string, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/OSM/Borough/'+encodeURIComponent(query)+'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_OSM_getBundeslandAreas(query : string, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/OSM/Bundesland/'+encodeURIComponent(query)+'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_OSM_getCityAreas(query : string, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/OSM/City/'+encodeURIComponent(query)+'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_OSM_getKrSAreas(query : string, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/OSM/KrS/'+encodeURIComponent(query)+'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_OSM_getLandAreas(query : string, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/OSM/Land/'+encodeURIComponent(query)+'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_OSM_getZipAreas(query : string, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/OSM/ZIP/'+encodeURIComponent(query)+'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.Role:

public _admin_Role_createGlobalRole(roleDTO : RoleDTO, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/Admin/Role';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, roleDTO));
}
public _admin_Role_retrieveAll(options: {id? : number[],
hasPermission? : string[],
search? : string,
canBeInheritedBy? : number[],
order? : {by: _admin_Role_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<RoleDTO[]> {
if(!options)
options={};
let url = '/Admin/Role?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.hasPermission!=null?''+this.api.queryParamArrayPrepare('hasPermission',options.hasPermission):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.canBeInheritedBy!=null?''+this.api.queryParamArrayPrepare('canBeInheritedBy',options.canBeInheritedBy):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<RoleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_Role_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/Admin/Role/'+id+'';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.Setting:

public _admin_Setting_createOrUpdateSetting(settingFullDTO : SettingFullDTO, mode:Mode=Mode.Entity) : Observable<SettingFullDTO> {
let url = '/Admin/Setting';
return <Observable<SettingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, settingFullDTO));
}
public _admin_Setting_createOrUpdateSettingForClient(clientId : number, settingFullDTO : SettingFullDTO, mode:Mode=Mode.Entity) : Observable<SettingFullDTO> {
let url = '/Admin/Setting/Client/'+clientId+'';
return <Observable<SettingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, settingFullDTO));
}
public _admin_Setting_deleteSetting(key : string, options: {client_id? : number} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/Admin/Setting/'+encodeURIComponent(key)+'?'+(options.client_id!=null?'&client_id='+options.client_id:'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_Setting_getSettings(options: {client_id? : number} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/Admin/Setting/?'+(options.client_id!=null?'&client_id='+options.client_id:'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _admin_Setting_reloadSettingsCache(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Admin/Setting/Reload';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.SSPServiceEndpoint:

public _admin_SSPServiceEndpoint_test(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Admin/SSPService/Test';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._admin.User:

public _admin_User_addRoleInMembership(id : number, client_id : number, role_id : number, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Admin/User/'+id+'/Client/'+client_id+'/Role/'+role_id+'';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_User_block(id : number, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/Admin/User/'+id+'/Blocked';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_User_blockMembership(id : number, client_id : number, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Admin/User/'+id+'/Client/'+client_id+'/Blocked';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public _admin_User_create(userFullDTO : UserFullDTO, options: {mailLanguage? : string} = {}, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
if(!options)
options={};
let url = '/Admin/User?'+(options.mailLanguage!=null?'&mailLanguage='+options.mailLanguage:'')+
'';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, userFullDTO));
}
public _admin_User_edit(id : number, userFullDTO : UserFullDTO, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/Admin/User/'+id+'';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, userFullDTO));
}
public _admin_User_removeRoleFromMembership(id : number, client_id : number, role_id : number, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Admin/User/'+id+'/Client/'+client_id+'/Role/'+role_id+'';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_User_retrieveAll(options: {id? : number[],
username? : string[],
email? : string[],
search? : string,
blocked? : boolean,
isForDevice? : boolean,
memberOfClient_id? : number[],
memberOfClient_identifier? : string[],
memberOfClient_search? : string,
blockedInClient? : boolean,
hasPermissionInClient? : string[],
hasRoleInClient_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<UserFullDTO[]> {
if(!options)
options={};
let url = '/Admin/User?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.username!=null?''+this.api.queryParamArrayPrepare('username',options.username):'')+
''+(options.email!=null?''+this.api.queryParamArrayPrepare('email',options.email):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.blocked!=null?'&blocked='+options.blocked:'')+
''+(options.isForDevice!=null?'&isForDevice='+options.isForDevice:'')+
''+(options.memberOfClient_id!=null?''+this.api.queryParamArrayPrepare('memberOfClient_id',options.memberOfClient_id):'')+
''+(options.memberOfClient_identifier!=null?''+this.api.queryParamArrayPrepare('memberOfClient_identifier',options.memberOfClient_identifier):'')+
''+(options.memberOfClient_search!=null?'&memberOfClient_search='+options.memberOfClient_search:'')+
''+(options.blockedInClient!=null?'&blockedInClient='+options.blockedInClient:'')+
''+(options.hasPermissionInClient!=null?''+this.api.queryParamArrayPrepare('hasPermissionInClient',options.hasPermissionInClient):'')+
''+(options.hasRoleInClient_id!=null?''+this.api.queryParamArrayPrepare('hasRoleInClient_id',options.hasRoleInClient_id):'')+
'';
return <Observable<UserFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_User_retrieveAllMemberships(id : number, options: {blocked? : boolean,
search? : string,
hasPermissionInClient? : string[],
hasRoleInClient_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO[]> {
if(!options)
options={};
let url = '/Admin/User/'+id+'/Client?'+(options.blocked!=null?'&blocked='+options.blocked:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPermissionInClient!=null?''+this.api.queryParamArrayPrepare('hasPermissionInClient',options.hasPermissionInClient):'')+
''+(options.hasRoleInClient_id!=null?''+this.api.queryParamArrayPrepare('hasRoleInClient_id',options.hasRoleInClient_id):'')+
'';
return <Observable<ManagedUserClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_User_retrieveClientMembership(id : number, client_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/Admin/User/'+id+'/Client/'+client_id+'';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public _admin_User_setRestoreCode(restoreCode : string, userFullDTO : UserFullDTO, options: {validTill? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
if(!options)
options={};
let url = '/Admin/User/RestoreCode/'+encodeURIComponent(restoreCode)+'?'+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
'';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, userFullDTO));
}
public _admin_User_unblock(id : number, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/Admin/User/'+id+'/Blocked';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public _admin_User_unblockMembership(id : number, client_id : number, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Admin/User/'+id+'/Client/'+client_id+'/Blocked';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}// Methods implemented by de.seatback.adplacer.api._platform.ssp.adcast.Delivery:

public _platform_ssp_adcast_Delivery_adRequest(identifier : string, options: {width? : number,
height? : number,
latitude? : number,
longitude? : number} = {}, mode:Mode=Mode.Entity) : Observable<Vast> {
if(!options)
options={};
let url = '/SSP/Delivery/'+encodeURIComponent(identifier)+'?'+(options.width!=null?'&width='+options.width:'')+
''+(options.height!=null?'&height='+options.height:'')+
''+(options.latitude!=null?'&latitude='+options.latitude:'')+
''+(options.longitude!=null?'&longitude='+options.longitude:'')+
'';
return <Observable<Vast>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_adcast_Delivery_adRequestDeprecated(apiKey : string, identifier : string, options: {width? : number,
height? : number,
latitude? : number,
longitude? : number} = {}, mode:Mode=Mode.Entity) : Observable<Vast> {
if(!options)
options={};
let url = '/SSP/Delivery/'+encodeURIComponent(apiKey)+'/'+encodeURIComponent(identifier)+'?'+(options.width!=null?'&width='+options.width:'')+
''+(options.height!=null?'&height='+options.height:'')+
''+(options.latitude!=null?'&latitude='+options.latitude:'')+
''+(options.longitude!=null?'&longitude='+options.longitude:'')+
'';
return <Observable<Vast>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_adcast_Delivery_errorNoAd(errorcode : number, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/SSP/Delivery/error/reason/'+errorcode+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_adcast_Delivery_playerAdError(requestId : string, options: {errorcode? : number} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SSP/Delivery/Request/'+encodeURIComponent(requestId)+'/error?'+(options.errorcode!=null?'&errorcode='+options.errorcode:'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_adcast_Delivery_playerAdSuccess(requestId : string, options: {startTimestamp? : SbDateTime,
endTimestamp? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<PlayoutDTO> {
if(!options)
options={};
let url = '/SSP/Delivery/Request/'+encodeURIComponent(requestId)+'/success?'+(options.startTimestamp!=null?'&startTimestamp='+this.api.queryParamDatePrepare(options.startTimestamp):'')+
''+(options.endTimestamp!=null?'&endTimestamp='+this.api.queryParamDatePrepare(options.endTimestamp):'')+
'';
return <Observable<PlayoutDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_adcast_Delivery_playerAdTracking(requestId : string, trackingState : string, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SSP/Delivery/Request/'+encodeURIComponent(requestId)+'/tracking/'+encodeURIComponent(trackingState)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._platform.ssp.adcast.Exchange:

public _platform_ssp_adcast_Exchange_bidRequest(key : string, playerid : string, options: {url? : string} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/SSP/Exchange/Test/'+encodeURIComponent(key)+'/'+encodeURIComponent(playerid)+'?url='+options.url+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._platform.ssp.adcast.SSP:
// Methods implemented by de.seatback.adplacer.api._platform.ssp.loopback.LoopbackSSP:

public _platform_ssp_loopback_LoopbackSSP_errorCall(screen_id : number, identifier : string, mode:Mode=Mode.Entity) : Observable<void> {
let url = '/LoopbackSSP/'+screen_id+'/Error/'+encodeURIComponent(identifier)+'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_loopback_LoopbackSSP_successCall(screen_id : number, identifier : string, mode:Mode=Mode.Entity) : Observable<void> {
let url = '/LoopbackSSP/'+screen_id+'/Success/'+encodeURIComponent(identifier)+'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _platform_ssp_loopback_LoopbackSSP_vastTrackingCall(screen_id : number, identifier : string, trackingState : string, mode:Mode=Mode.Entity) : Observable<void> {
let url = '/LoopbackSSP/'+screen_id+'/VAST/'+encodeURIComponent(identifier)+'/Tracking/'+encodeURIComponent(trackingState)+'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._public.DeviceConfiguration:

public _public_DeviceConfiguration_retrieve(options: {token? : string,
hostname? : string,
uuid? : string,
allowUuidPair? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<DeviceConfigurationTokenDTO> {
if(!options)
options={};
let url = '/DeviceConfiguration?'+(options.token!=null?'&token='+options.token:'')+
''+(options.hostname!=null?'&hostname='+options.hostname:'')+
''+(options.uuid!=null?'&uuid='+options.uuid:'')+
''+(options.allowUuidPair!=null?'&allowUuidPair='+options.allowUuidPair:'')+
'';
return <Observable<DeviceConfigurationTokenDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._public.PublicEndpoints:

public _public_PublicEndpoints_asset(asset : string, created : number, file : string, options: {still? : boolean,
thumbnail? : ThumbnailSize,
disposition? : Disposition} = {}, mode:Mode=Mode.Entity) : Observable<void> {
if(!options)
options={};
let url = '/Public/Asset/'+encodeURIComponent(asset)+'/'+created+'/'+encodeURIComponent(file)+'?'+(options.still!=null?'&still='+options.still:'')+
''+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+
''+(options.disposition!=null?'&disposition='+options.disposition:'')+
'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_attachment(created : number, file : string, options: {still? : boolean,
thumbnail? : ThumbnailSize,
disposition? : Disposition} = {}, mode:Mode=Mode.Entity) : Observable<void> {
if(!options)
options={};
let url = '/Public/Attachment/'+created+'/'+encodeURIComponent(file)+'?'+(options.still!=null?'&still='+options.still:'')+
''+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+
''+(options.disposition!=null?'&disposition='+options.disposition:'')+
'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_fixedAspectRatioImage(entity : string, purpose : string, created : number, file : string, options: {thumbnail? : ThumbnailSize,
disposition? : Disposition} = {}, mode:Mode=Mode.Entity) : Observable<void> {
if(!options)
options={};
let url = '/Public/Image/'+encodeURIComponent(entity)+'/'+encodeURIComponent(purpose)+'/'+created+'/'+encodeURIComponent(file)+'?'+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+
''+(options.disposition!=null?'&disposition='+options.disposition:'')+
'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_getCurrencies(mode:Mode=Mode.Entity) : Observable<CurrencyDTO[]> {
let url = '/Public/Currency';
return <Observable<CurrencyDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_getPublicSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Public/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_media(created : number, file : string, options: {still? : boolean,
thumbnail? : ThumbnailSize,
disposition? : Disposition} = {}, mode:Mode=Mode.Entity) : Observable<void> {
if(!options)
options={};
let url = '/Public/Media/'+created+'/'+encodeURIComponent(file)+'?'+(options.still!=null?'&still='+options.still:'')+
''+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+
''+(options.disposition!=null?'&disposition='+options.disposition:'')+
'';
return <Observable<void>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_retrieveAllDiscussableDTOsAsTypescriptEnum(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Public/Discussable/Enum/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_retrieveAllErrorCodesAsTypescriptEnum(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Public/ErrorCode/Enum/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_retrieveAllTaggableDTOsAsTypescriptEnum(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Public/Taggable/Enum/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_settings(options: {setting? : string[],
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/Public/Setting?'+(options.setting!=null?''+this.api.queryParamArrayPrepare('setting',options.setting):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_showRequestIp(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Public/IP';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public _public_PublicEndpoints_telemetryForMac(mac : string, options: {msg? : string} = {}, mode:Mode=Mode.Entity) : Observable<Serializable> {
if(!options)
options={};
let url = '/Public/Telemetry/'+encodeURIComponent(mac)+'?'+(options.msg!=null?'&msg='+options.msg:'')+
'';
return <Observable<Serializable>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api._public.PublicTodoEndpoints:

public _public_PublicTodoEndpoints_deviceTemplateInfo(device_id : number, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Public/Todo/Device/'+device_id+'/TemplateInfo';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.addons.Playlists:

public addons_Playlists_multiSideSolutions(options: {from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/Addons/Playlists/MSS?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public addons_Playlists_nordland(options: {from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/Addons/Playlists/Nordland?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.addons.Strongbytes:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: addon_strongbytes_playout_export
*	All: -
*/
public addons_Strongbytes_playoutsCSV(from : SbDateTime, till : SbDateTime, options: {screen? : number[],
device? : number[],
location? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/Addons/Strongbytes/Playout/csv/'+from+'/'+till+'?'+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: addon_strongbytes_playout_export
*	All: -
*/
public addons_Strongbytes_playoutsPerDescriptor(from : SbDateTime, till : SbDateTime, options: {screen? : number[],
device? : number[],
location? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<StrongBytesDescriptedPlayout[]> {
if(!options)
options={};
let url = '/Addons/Strongbytes/Playout/Descriptor/'+from+'/'+till+'?'+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<StrongBytesDescriptedPlayout[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ApiServlet:
// Methods implemented by de.seatback.adplacer.api.auth.Authentication:

public auth_Authentication_aiServiceLogin(ai_service : string, token : string, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Authentication/AI/'+encodeURIComponent(ai_service)+'/Login/'+encodeURIComponent(token)+'';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public auth_Authentication_checkRestore(checkRestoreDTO : CheckRestoreDTO, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Authentication/CheckRestore';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, checkRestoreDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ai_access
*	All: -
*/
public auth_Authentication_createAILoginToken(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Authentication/AI/Token';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public auth_Authentication_forgotPassword(options: {email? : string,
username? : string} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/Authentication/ForgotPassword?'+(options.email!=null?'&email='+options.email:'')+
''+(options.username!=null?'&username='+options.username:'')+
'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public auth_Authentication_login(credentialsDTO : CredentialsDTO, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Authentication/Login';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, credentialsDTO));
}
public auth_Authentication_passwordRequirements(mode:Mode=Mode.Entity) : Observable<PasswordRequirementDTO> {
let url = '/Authentication/PasswordRequirements';
return <Observable<PasswordRequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public auth_Authentication_restorePassword(loginRestoreDTO : LoginRestoreDTO, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Authentication/Restore';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, loginRestoreDTO));
}// Methods implemented by de.seatback.adplacer.api.ca.am.AM:
// Methods implemented by de.seatback.adplacer.api.ca.am.ApiKey:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public ca_am_ApiKey_create(apiKeyCreationDTO : ApiKeyCreationDTO, mode:Mode=Mode.Entity) : Observable<ApiKeyCreationInfoDTO> {
let url = '/CA/AM/ApiKey';
return <Observable<ApiKeyCreationInfoDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, apiKeyCreationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public ca_am_ApiKey_delete(identifier : string, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/AM/ApiKey/'+encodeURIComponent(identifier)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public ca_am_ApiKey_edit(identifier : string, apiKeyDTO : ApiKeyDTO, mode:Mode=Mode.Entity) : Observable<ApiKeyDTO> {
let url = '/CA/AM/ApiKey/'+encodeURIComponent(identifier)+'';
return <Observable<ApiKeyDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, apiKeyDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public ca_am_ApiKey_expire(identifier : string, mode:Mode=Mode.Entity) : Observable<ApiKeyDTO> {
let url = '/CA/AM/ApiKey/'+encodeURIComponent(identifier)+'/Expire';
return <Observable<ApiKeyDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public ca_am_ApiKey_retrieveAll(options: {search? : string,
id? : number[],
identifier? : string[],
order? : {by: ca_am_ApiKey_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ApiKeyDTO[]> {
if(!options)
options={};
let url = '/CA/AM/ApiKey?'+(options.search!=null?'&search='+options.search:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ApiKeyDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.am.Permission:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_edit
*	All: -
*/
public ca_am_Permission_retrieveEffectivePermissions(options: {permission? : string[]} = {}, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CA/AM/Permission?'+this.api.queryParamArrayPrepare('permission',options.permission)+'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_edit
*	All: -
*/
public ca_am_Permission_retrieveUserPermissions(user_id : number, mode:Mode=Mode.Entity) : Observable<string[]> {
let url = '/CA/AM/Permission/User/'+user_id+'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ca.am.Role:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_show
*	All: -
*/
public ca_am_Role_checkNameAvailability(options: {name? : string} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/CA/AM/Role/CheckNameAvailability?name='+options.name+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_create
*	All: -
*/
public ca_am_Role_createRole(roleDTO : RoleDTO, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/CA/AM/Role';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, roleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_create
*	All: -
*/
public ca_am_Role_createRolePreview(roleDTO : RoleDTO, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/CA/AM/Role/Preview';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, roleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_delete
*	All: -
*/
public ca_am_Role_deleteRole(role_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/AM/Role/'+role_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_edit
*	All: -
*/
public ca_am_Role_editRole(roleDTO : RoleDTO, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/CA/AM/Role';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, roleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_edit
*	All: -
*/
public ca_am_Role_editRolePreview(roleDTO : RoleDTO, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/CA/AM/Role/Preview';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, roleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_list
*	All: -
*/
public ca_am_Role_retrieveAll(options: {id? : number[],
hasPermission? : string[],
search? : string,
owned? : boolean,
canEdit? : boolean,
canAddUser? : boolean,
canBeInheritedBy? : number[],
order? : {by: ca_am_Role_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<RoleDTO[]> {
if(!options)
options={};
let url = '/CA/AM/Role?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.hasPermission!=null?''+this.api.queryParamArrayPrepare('hasPermission',options.hasPermission):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.owned!=null?'&owned='+options.owned:'')+
''+(options.canEdit!=null?'&canEdit='+options.canEdit:'')+
''+(options.canAddUser!=null?'&canAddUser='+options.canAddUser:'')+
''+(options.canBeInheritedBy!=null?''+this.api.queryParamArrayPrepare('canBeInheritedBy',options.canBeInheritedBy):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<RoleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_edit
*	All: -
*/
public ca_am_Role_retrieveAllInUserContext(user_id : number, options: {id? : number[],
hasPermission? : string[],
search? : string,
owned? : boolean,
order? : {by: ca_am_Role_retrieveAllInUserContext_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<RoleDTO[]> {
if(!options)
options={};
let url = '/CA/AM/Role/User/'+user_id+'?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.hasPermission!=null?''+this.api.queryParamArrayPrepare('hasPermission',options.hasPermission):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.owned!=null?'&owned='+options.owned:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<RoleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: role_show
*	All: -
*/
public ca_am_Role_retrieveById(role_id : number, mode:Mode=Mode.Entity) : Observable<RoleDTO> {
let url = '/CA/AM/Role/'+role_id+'';
return <Observable<RoleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ca.am.User:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_create
*	All: -
*/
public ca_am_User_addUser(managedUserClientDTO : ManagedUserClientDTO, options: {mailLanguage? : string} = {}, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
if(!options)
options={};
let url = '/CA/AM/User?'+(options.mailLanguage!=null?'&mailLanguage='+options.mailLanguage:'')+
'';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, managedUserClientDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_create
*	All: -
*/
public ca_am_User_addUserPreview(managedUserClientDTO : ManagedUserClientDTO, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/Preview';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, managedUserClientDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_block
*	All: -
*/
public ca_am_User_blockUser(managedUserClientDTO : ManagedUserClientDTO, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/Block';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, managedUserClientDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_edit
*	All: -
*/
public ca_am_User_editUser(managedUserClientDTO : ManagedUserClientDTO, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, managedUserClientDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_edit
*	All: -
*/
public ca_am_User_editUserPreview(managedUserClientDTO : ManagedUserClientDTO, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/Preview';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, managedUserClientDTO));
}
public ca_am_User_endImpersonation(mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/Impersonate';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_impersonate
*	All: -
*/
public ca_am_User_impersonate(user_id : number, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/'+user_id+'/Impersonate';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_delete
*	All: -
*/
public ca_am_User_removeUser(user_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/AM/User/'+user_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_list
*	All: -
*/
public ca_am_User_retrieveAll(options: {search? : string,
hasPermission? : string[],
hasRole? : number[],
canEdit? : boolean,
order? : {by: ca_am_User_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO[]> {
if(!options)
options={};
let url = '/CA/AM/User?'+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPermission!=null?''+this.api.queryParamArrayPrepare('hasPermission',options.hasPermission):'')+
''+(options.hasRole!=null?''+this.api.queryParamArrayPrepare('hasRole',options.hasRole):'')+
''+(options.canEdit!=null?'&canEdit='+options.canEdit:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ManagedUserClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_list
*	All: -
*/
public ca_am_User_retrieveById(user_id : number, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/'+user_id+'';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_unblock
*	All: -
*/
public ca_am_User_unblockUser(managedUserClientDTO : ManagedUserClientDTO, mode:Mode=Mode.Entity) : Observable<ManagedUserClientDTO> {
let url = '/CA/AM/User/Unblock';
return <Observable<ManagedUserClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, managedUserClientDTO));
}// Methods implemented by de.seatback.adplacer.api.ca.CA:
// Methods implemented by de.seatback.adplacer.api.ca.md.AreaCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_create
*	All: -
*/
public ca_md_AreaCategory_createCategories(areaCategoryDTO : AreaCategoryDTO[], mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO[]> {
let url = '/CA/MD/AreaCategory/Mass';
return <Observable<AreaCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, areaCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_create
*	All: -
*/
public ca_md_AreaCategory_createCategory(areaCategoryDTO : AreaCategoryDTO, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO> {
let url = '/CA/MD/AreaCategory';
return <Observable<AreaCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, areaCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_delete
*	All: -
*/
public ca_md_AreaCategory_deleteById(areaCategory_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/AreaCategory/'+areaCategory_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_delete
*	All: -
*/
public ca_md_AreaCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/AreaCategory/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_edit
*	All: -
*/
public ca_md_AreaCategory_editCategories(areaCategoryDTO : AreaCategoryDTO[], mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO[]> {
let url = '/CA/MD/AreaCategory/Mass';
return <Observable<AreaCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, areaCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_edit
*	All: -
*/
public ca_md_AreaCategory_editCategory(areaCategoryDTO : AreaCategoryDTO, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO> {
let url = '/CA/MD/AreaCategory';
return <Observable<AreaCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, areaCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_list
*	All: -
*/
public ca_md_AreaCategory_retrieveAll(options: {id? : number[],
company? : number[],
global? : boolean,
hasCompany? : boolean,
hasAreas? : boolean,
notInHierarchyOf? : number,
search? : string,
filter? : {by: ca_md_AreaCategory_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: ca_md_AreaCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO[]> {
if(!options)
options={};
let url = '/CA/MD/AreaCategory?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.hasAreas!=null?'&hasAreas='+options.hasAreas:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AreaCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_show
*	All: -
*/
public ca_md_AreaCategory_retrieveById(areaCategory_id : number, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO> {
let url = '/CA/MD/AreaCategory/'+areaCategory_id+'';
return <Observable<AreaCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_category_show
*	All: -
*/
public ca_md_AreaCategory_retrieveOfficial(options: {id? : number[],
hasAreas? : boolean,
search? : string,
filter? : {by: ca_md_AreaCategory_retrieveOfficial_filter, param?: string, values: string[]}[],
order? : {by: ca_md_AreaCategory_retrieveOfficial_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AreaCategoryDTO[]> {
if(!options)
options={};
let url = '/CA/MD/AreaCategory/Official?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.hasAreas!=null?'&hasAreas='+options.hasAreas:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AreaCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.CampaignType:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_type_create
*	All: -
*/
public ca_md_CampaignType_create(campaignTypeDTO : CampaignTypeDTO, mode:Mode=Mode.Entity) : Observable<CampaignTypeDTO> {
let url = '/CA/MD/CampaignType';
return <Observable<CampaignTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignTypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_type_delete
*	All: -
*/
public ca_md_CampaignType_deleteById(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/CampaignType/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_type_edit
*	All: -
*/
public ca_md_CampaignType_edit(campaignTypeDTO : CampaignTypeDTO, mode:Mode=Mode.Entity) : Observable<CampaignTypeDTO> {
let url = '/CA/MD/CampaignType';
return <Observable<CampaignTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignTypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_type_list
*	All: -
*/
public ca_md_CampaignType_retrieveAll(options: {search? : string,
global? : boolean,
hasCampaigns? : boolean,
id? : number[],
order? : {by: ca_md_CampaignType_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignTypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/CampaignType?'+(options.search!=null?'&search='+options.search:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.hasCampaigns!=null?'&hasCampaigns='+options.hasCampaigns:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CampaignTypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_type_show
*	All: -
*/
public ca_md_CampaignType_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<CampaignTypeDTO> {
let url = '/CA/MD/CampaignType/'+id+'';
return <Observable<CampaignTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_type_list
*	All: -
*/
public ca_md_CampaignType_retrieveHierarchy(options: {search? : string,
global? : boolean,
hasCampaigns? : boolean,
id? : number[],
order? : {by: ca_md_CampaignType_retrieveHierarchy_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignTypeHierarchyDTO[]> {
if(!options)
options={};
let url = '/CA/MD/CampaignType/Hierarchy?'+(options.search!=null?'&search='+options.search:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.hasCampaigns!=null?'&hasCampaigns='+options.hasCampaigns:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CampaignTypeHierarchyDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.CompanyAttribute:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attribute_datatype_create
*	All: -
*/
public ca_md_CompanyAttribute_createDatatype(companyAttributeDatatypeDTO : CompanyAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO> {
let url = '/CA/MD/CompanyAttribute/Datatype';
return <Observable<CompanyAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, companyAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attributes_edit
*	All: -
*/
public ca_md_CompanyAttribute_editAttribute(companyAttributeDTO : CompanyAttributeDTO, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDTO> {
let url = '/CA/MD/CompanyAttribute';
return <Observable<CompanyAttributeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, companyAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attributes_edit
*	All: -
*/
public ca_md_CompanyAttribute_editAttributes(companyAttributeDTO : CompanyAttributeDTO[], mode:Mode=Mode.Entity) : Observable<CompanyAttributeDTO[]> {
let url = '/CA/MD/CompanyAttribute/Mass';
return <Observable<CompanyAttributeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, companyAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attribute_datatype_edit
*	All: -
*/
public ca_md_CompanyAttribute_editDatatype(companyAttributeDatatypeDTO : CompanyAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO> {
let url = '/CA/MD/CompanyAttribute/Datatype';
return <Observable<CompanyAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, companyAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attribute_datatype_list
*	All: -
*/
public ca_md_CompanyAttribute_retrieveAllDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/CompanyAttribute/Datatype?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<CompanyAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attribute_datatype_show
*	All: -
*/
public ca_md_CompanyAttribute_retrieveDatatypeById(datatype_id : string, mode:Mode=Mode.Entity) : Observable<CompanyAttributeDatatypeDTO> {
let url = '/CA/MD/CompanyAttribute/Datatype/'+encodeURIComponent(datatype_id)+'';
return <Observable<CompanyAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_attributes_show
*	All: -
*/
public ca_md_CompanyAttribute_retrieveValuesByDatatypeId(datatype_id : string, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CA/MD/CompanyAttribute/Datatype/'+encodeURIComponent(datatype_id)+'/Values?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.CullCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_create
*	All: -
*/
public ca_md_CullCategory_createCategories(cullCategoryDTO : CullCategoryDTO[], mode:Mode=Mode.Entity) : Observable<CullCategoryDTO[]> {
let url = '/CA/MD/CullCategory/Mass';
return <Observable<CullCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_create
*	All: -
*/
public ca_md_CullCategory_createCategory(cullCategoryDTO : CullCategoryDTO, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO> {
let url = '/CA/MD/CullCategory';
return <Observable<CullCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_delete
*	All: -
*/
public ca_md_CullCategory_deleteById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/CullCategory/'+category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_delete
*	All: -
*/
public ca_md_CullCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/CullCategory/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_edit
*	All: -
*/
public ca_md_CullCategory_editCategories(cullCategoryDTO : CullCategoryDTO[], mode:Mode=Mode.Entity) : Observable<CullCategoryDTO[]> {
let url = '/CA/MD/CullCategory/Mass';
return <Observable<CullCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, cullCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_edit
*	All: -
*/
public ca_md_CullCategory_editCategory(cullCategoryDTO : CullCategoryDTO, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO> {
let url = '/CA/MD/CullCategory';
return <Observable<CullCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, cullCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_list
*	All: -
*/
public ca_md_CullCategory_retrieveAll(options: {id? : number[],
company? : number[],
forCompany? : number,
global? : boolean,
hasCompany? : boolean,
notInHierarchyOf? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO[]> {
if(!options)
options={};
let url = '/CA/MD/CullCategory?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<CullCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_category_show
*	All: -
*/
public ca_md_CullCategory_retrieveById(cullCategory_id : number, mode:Mode=Mode.Entity) : Observable<CullCategoryDTO> {
let url = '/CA/MD/CullCategory/'+cullCategory_id+'';
return <Observable<CullCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ca.md.DeviceAttribute:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attribute_datatype_create
*	All: -
*/
public ca_md_DeviceAttribute_createDatatype(deviceAttributeDatatypeDTO : DeviceAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO> {
let url = '/CA/MD/DeviceAttribute/Datatype';
return <Observable<DeviceAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, deviceAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attributes_edit
*	All: -
*/
public ca_md_DeviceAttribute_editAttribute(deviceAttributeDTO : DeviceAttributeDTO, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDTO> {
let url = '/CA/MD/DeviceAttribute';
return <Observable<DeviceAttributeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, deviceAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attributes_edit
*	All: -
*/
public ca_md_DeviceAttribute_editAttributes(deviceAttributeDTO : DeviceAttributeDTO[], mode:Mode=Mode.Entity) : Observable<DeviceAttributeDTO[]> {
let url = '/CA/MD/DeviceAttribute/Mass';
return <Observable<DeviceAttributeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, deviceAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attribute_datatype_edit
*	All: -
*/
public ca_md_DeviceAttribute_editDatatype(deviceAttributeDatatypeDTO : DeviceAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO> {
let url = '/CA/MD/DeviceAttribute/Datatype';
return <Observable<DeviceAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, deviceAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attribute_datatype_list
*	All: -
*/
public ca_md_DeviceAttribute_retrieveAllDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/DeviceAttribute/Datatype?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<DeviceAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attribute_datatype_show
*	All: -
*/
public ca_md_DeviceAttribute_retrieveDatatypeById(datatype_id : string, mode:Mode=Mode.Entity) : Observable<DeviceAttributeDatatypeDTO> {
let url = '/CA/MD/DeviceAttribute/Datatype/'+encodeURIComponent(datatype_id)+'';
return <Observable<DeviceAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_attributes_show
*	All: -
*/
public ca_md_DeviceAttribute_retrieveValuesByDatatypeId(datatype_id : string, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CA/MD/DeviceAttribute/Datatype/'+encodeURIComponent(datatype_id)+'/Values?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.LocationAttribute:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attribute_datatype_create
*	All: -
*/
public ca_md_LocationAttribute_createDatatype(locationAttributeDatatypeDTO : LocationAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO> {
let url = '/CA/MD/LocationAttribute/Datatype';
return <Observable<LocationAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, locationAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attributes_edit
*	All: -
*/
public ca_md_LocationAttribute_editAttribute(locationAttributeDTO : LocationAttributeDTO, mode:Mode=Mode.Entity) : Observable<LocationAttributeDTO> {
let url = '/CA/MD/LocationAttribute';
return <Observable<LocationAttributeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attributes_edit
*	All: -
*/
public ca_md_LocationAttribute_editAttributes(locationAttributeDTO : LocationAttributeDTO[], mode:Mode=Mode.Entity) : Observable<LocationAttributeDTO[]> {
let url = '/CA/MD/LocationAttribute/Mass';
return <Observable<LocationAttributeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attribute_datatype_edit
*	All: -
*/
public ca_md_LocationAttribute_editDatatype(locationAttributeDatatypeDTO : LocationAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO> {
let url = '/CA/MD/LocationAttribute/Datatype';
return <Observable<LocationAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attribute_datatype_list
*	All: -
*/
public ca_md_LocationAttribute_retrieveAllDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/LocationAttribute/Datatype?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<LocationAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attribute_datatype_show
*	All: -
*/
public ca_md_LocationAttribute_retrieveDatatypeById(datatype_id : string, mode:Mode=Mode.Entity) : Observable<LocationAttributeDatatypeDTO> {
let url = '/CA/MD/LocationAttribute/Datatype/'+encodeURIComponent(datatype_id)+'';
return <Observable<LocationAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_attributes_show
*	All: -
*/
public ca_md_LocationAttribute_retrieveValuesByDatatypeId(datatype_id : string, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CA/MD/LocationAttribute/Datatype/'+encodeURIComponent(datatype_id)+'/Values?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.LocationType:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_create
*	All: -
*/
public ca_md_LocationType_clipIllustration(location_type_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/LocationType/'+location_type_id+'/Illustration';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_create
*	All: -
*/
public ca_md_LocationType_copyIllustrationFrom(location_type_id : number, from_location_type_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/LocationType/'+location_type_id+'/Illustration/Copy/'+from_location_type_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_create
*	All: -
*/
public ca_md_LocationType_createLocationType(locationTypeDTO : LocationTypeDTO, mode:Mode=Mode.Entity) : Observable<LocationTypeDTO> {
let url = '/CA/MD/LocationType';
return <Observable<LocationTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, locationTypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_create
*	All: -
*/
public ca_md_LocationType_definitionIllustration(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/CA/MD/LocationType/Illustration';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_create
*	All: -
*/
public ca_md_LocationType_deleteIllustration(location_type_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/LocationType/'+location_type_id+'/Illustration';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_delete
*	All: -
*/
public ca_md_LocationType_deleteLocationType(location_type_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/LocationType/'+location_type_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_edit
*	All: -
*/
public ca_md_LocationType_editLocationType(locationTypeDTO : LocationTypeDTO, mode:Mode=Mode.Entity) : Observable<LocationTypeDTO> {
let url = '/CA/MD/LocationType';
return <Observable<LocationTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationTypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_list
*	All: -
*/
public ca_md_LocationType_retrieveAll(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LocationTypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/LocationType?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<LocationTypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_type_create
*	All: -
*/
public ca_md_LocationType_uploadIllustration(location_type_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/LocationType/'+location_type_id+'/Illustration';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ca.md.MD:
// Methods implemented by de.seatback.adplacer.api.ca.md.MediumGroupAttribute:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attribute_datatype_create
*	All: -
*/
public ca_md_MediumGroupAttribute_createDatatype(mediumGroupAttributeDatatypeDTO : MediumGroupAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO> {
let url = '/CA/MD/MediumGroupAttribute/Datatype';
return <Observable<MediumGroupAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attributes_edit
*	All: -
*/
public ca_md_MediumGroupAttribute_editAttribute(mediumGroupAttributeDTO : MediumGroupAttributeDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDTO> {
let url = '/CA/MD/MediumGroupAttribute';
return <Observable<MediumGroupAttributeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attributes_edit
*	All: -
*/
public ca_md_MediumGroupAttribute_editAttributes(mediumGroupAttributeDTO : MediumGroupAttributeDTO[], mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDTO[]> {
let url = '/CA/MD/MediumGroupAttribute/Mass';
return <Observable<MediumGroupAttributeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attribute_datatype_edit
*	All: -
*/
public ca_md_MediumGroupAttribute_editDatatype(mediumGroupAttributeDatatypeDTO : MediumGroupAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO> {
let url = '/CA/MD/MediumGroupAttribute/Datatype';
return <Observable<MediumGroupAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attribute_datatype_list
*	All: -
*/
public ca_md_MediumGroupAttribute_retrieveAllDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/MediumGroupAttribute/Datatype?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attribute_datatype_show
*	All: -
*/
public ca_md_MediumGroupAttribute_retrieveDatatypeById(datatype_id : string, mode:Mode=Mode.Entity) : Observable<MediumGroupAttributeDatatypeDTO> {
let url = '/CA/MD/MediumGroupAttribute/Datatype/'+encodeURIComponent(datatype_id)+'';
return <Observable<MediumGroupAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_attributes_show
*	All: -
*/
public ca_md_MediumGroupAttribute_retrieveValuesByDatatypeId(datatype_id : string, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CA/MD/MediumGroupAttribute/Datatype/'+encodeURIComponent(datatype_id)+'/Values?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.PlayerHardware:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_clipDepiction(player_hardware_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Depiction';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_clipLogo(player_hardware_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_copyDepictionFrom(player_hardware_id : number, from_player_hardware_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Depiction/Copy/'+from_player_hardware_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_copyLogoFrom(player_hardware_id : number, from_player_hardware_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Logo/Copy/'+from_player_hardware_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_create
*	All: -
*/
public ca_md_PlayerHardware_createPlayerHardware(playerHardwareDTO : PlayerHardwareDTO, mode:Mode=Mode.Entity) : Observable<PlayerHardwareDTO> {
let url = '/CA/MD/PlayerHardware';
return <Observable<PlayerHardwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playerHardwareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_definitionDepiction(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/CA/MD/PlayerHardware/Depiction';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_definitionLogo(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/CA/MD/PlayerHardware/Logo';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_deleteDepiction(player_hardware_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Depiction';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_deleteLogo(player_hardware_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Logo';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_delete
*	All: -
*/
public ca_md_PlayerHardware_deletePlayerHardware(player_hardware_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_editPlayerHardware(playerHardwareDTO : PlayerHardwareDTO, mode:Mode=Mode.Entity) : Observable<PlayerHardwareDTO> {
let url = '/CA/MD/PlayerHardware';
return <Observable<PlayerHardwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, playerHardwareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_list
*	All: -
*/
public ca_md_PlayerHardware_retrieveAll(options: {id? : number[],
global? : boolean,
search? : string,
manufacturer_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PlayerHardwareDTO[]> {
if(!options)
options={};
let url = '/CA/MD/PlayerHardware?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.manufacturer_id!=null?''+this.api.queryParamArrayPrepare('manufacturer_id',options.manufacturer_id):'')+
'';
return <Observable<PlayerHardwareDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_show
*	All: -
*/
public ca_md_PlayerHardware_retrieveById(player_hardware_id : number, mode:Mode=Mode.Entity) : Observable<PlayerHardwareDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'';
return <Observable<PlayerHardwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_uploadDepiction(player_hardware_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Depiction';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_hardware_edit
*	All: -
*/
public ca_md_PlayerHardware_uploadLogo(player_hardware_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerHardware/'+player_hardware_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ca.md.PlayerSoftware:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_edit
*	All: -
*/
public ca_md_PlayerSoftware_clipLogo(player_software_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerSoftware/'+player_software_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_edit
*	All: -
*/
public ca_md_PlayerSoftware_copyLogoFrom(player_software_id : number, from_player_software_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerSoftware/'+player_software_id+'/Logo/Copy/'+from_player_software_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_create
*	All: -
*/
public ca_md_PlayerSoftware_createPlayerSoftware(playerSoftwareDTO : PlayerSoftwareDTO, mode:Mode=Mode.Entity) : Observable<PlayerSoftwareDTO> {
let url = '/CA/MD/PlayerSoftware';
return <Observable<PlayerSoftwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playerSoftwareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_edit
*	All: -
*/
public ca_md_PlayerSoftware_definitionLogo(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/CA/MD/PlayerSoftware/Logo';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_edit
*	All: -
*/
public ca_md_PlayerSoftware_deleteLogo(player_software_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/PlayerSoftware/'+player_software_id+'/Logo';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_delete
*	All: -
*/
public ca_md_PlayerSoftware_deletePlayerSoftware(player_software_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/PlayerSoftware/'+player_software_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_edit
*	All: -
*/
public ca_md_PlayerSoftware_editPlayerSoftware(playerSoftwareDTO : PlayerSoftwareDTO, mode:Mode=Mode.Entity) : Observable<PlayerSoftwareDTO> {
let url = '/CA/MD/PlayerSoftware';
return <Observable<PlayerSoftwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, playerSoftwareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_list
*	All: -
*/
public ca_md_PlayerSoftware_retrieveAll(options: {id? : number[],
global? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PlayerSoftwareDTO[]> {
if(!options)
options={};
let url = '/CA/MD/PlayerSoftware?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<PlayerSoftwareDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_show
*	All: -
*/
public ca_md_PlayerSoftware_retrieveById(player_software_id : number, mode:Mode=Mode.Entity) : Observable<PlayerSoftwareDTO> {
let url = '/CA/MD/PlayerSoftware/'+player_software_id+'';
return <Observable<PlayerSoftwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: player_software_edit
*	All: -
*/
public ca_md_PlayerSoftware_uploadLogo(player_software_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/PlayerSoftware/'+player_software_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ca.md.ProductAttribute:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attribute_datatype_create
*	All: -
*/
public ca_md_ProductAttribute_createDatatype(productAttributeDatatypeDTO : ProductAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO> {
let url = '/CA/MD/ProductAttribute/Datatype';
return <Observable<ProductAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, productAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attributes_edit
*	All: -
*/
public ca_md_ProductAttribute_editAttribute(productAttributeDTO : ProductAttributeDTO, mode:Mode=Mode.Entity) : Observable<ProductAttributeDTO> {
let url = '/CA/MD/ProductAttribute';
return <Observable<ProductAttributeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, productAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attributes_edit
*	All: -
*/
public ca_md_ProductAttribute_editAttributes(productAttributeDTO : ProductAttributeDTO[], mode:Mode=Mode.Entity) : Observable<ProductAttributeDTO[]> {
let url = '/CA/MD/ProductAttribute/Mass';
return <Observable<ProductAttributeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, productAttributeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attribute_datatype_edit
*	All: -
*/
public ca_md_ProductAttribute_editDatatype(productAttributeDatatypeDTO : ProductAttributeDatatypeDTO, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO> {
let url = '/CA/MD/ProductAttribute/Datatype';
return <Observable<ProductAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, productAttributeDatatypeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attribute_datatype_list
*	All: -
*/
public ca_md_ProductAttribute_retrieveAllDatatypes(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO[]> {
if(!options)
options={};
let url = '/CA/MD/ProductAttribute/Datatype?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<ProductAttributeDatatypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attribute_datatype_show
*	All: -
*/
public ca_md_ProductAttribute_retrieveDatatypeById(datatype_id : string, mode:Mode=Mode.Entity) : Observable<ProductAttributeDatatypeDTO> {
let url = '/CA/MD/ProductAttribute/Datatype/'+encodeURIComponent(datatype_id)+'';
return <Observable<ProductAttributeDatatypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_attributes_show
*	All: -
*/
public ca_md_ProductAttribute_retrieveValuesByDatatypeId(datatype_id : string, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CA/MD/ProductAttribute/Datatype/'+encodeURIComponent(datatype_id)+'/Values?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ca.md.ScreenHardware:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_clipDepiction(screen_hardware_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Depiction';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_clipLogo(screen_hardware_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_copyDepictionFrom(screen_hardware_id : number, from_screen_hardware_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Depiction/Copy/'+from_screen_hardware_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_copyLogoFrom(screen_hardware_id : number, from_screen_hardware_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Logo/Copy/'+from_screen_hardware_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_create
*	All: -
*/
public ca_md_ScreenHardware_createScreenHardware(screenHardwareDTO : ScreenHardwareDTO, mode:Mode=Mode.Entity) : Observable<ScreenHardwareDTO> {
let url = '/CA/MD/ScreenHardware';
return <Observable<ScreenHardwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, screenHardwareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_definitionDepiction(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/CA/MD/ScreenHardware/Depiction';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_definitionLogo(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/CA/MD/ScreenHardware/Logo';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_deleteDepiction(screen_hardware_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Depiction';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_deleteLogo(screen_hardware_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Logo';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_delete
*	All: -
*/
public ca_md_ScreenHardware_deleteScreenHardware(screen_hardware_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_editScreenHardware(screenHardwareDTO : ScreenHardwareDTO, mode:Mode=Mode.Entity) : Observable<ScreenHardwareDTO> {
let url = '/CA/MD/ScreenHardware';
return <Observable<ScreenHardwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, screenHardwareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_list
*	All: -
*/
public ca_md_ScreenHardware_retrieveAll(options: {id? : number[],
global? : boolean,
nativeResolution? : Resolution[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ScreenHardwareDTO[]> {
if(!options)
options={};
let url = '/CA/MD/ScreenHardware?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.nativeResolution!=null?''+this.api.queryParamArrayPrepare('nativeResolution',this.api.queryParamResolutionPrepare(options.nativeResolution)):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<ScreenHardwareDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_show
*	All: -
*/
public ca_md_ScreenHardware_retrieveById(screen_hardware_id : number, mode:Mode=Mode.Entity) : Observable<ScreenHardwareDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'';
return <Observable<ScreenHardwareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_uploadDepiction(screen_hardware_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Depiction';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_hardware_edit
*	All: -
*/
public ca_md_ScreenHardware_uploadLogo(screen_hardware_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/CA/MD/ScreenHardware/'+screen_hardware_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ca.md.WeeklySchedule:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_create
*	All: -
*/
public ca_md_WeeklySchedule_createDayTimeHours(dayTimeHoursDTO : DayTimeHoursDTO, mode:Mode=Mode.Entity) : Observable<DayTimeHoursDTO> {
let url = '/CA/MD/WeeklySchedule/DayTimeRange';
return <Observable<DayTimeHoursDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, dayTimeHoursDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_create
*	All: -
*/
public ca_md_WeeklySchedule_createOrRetrieveAllByDefinition(weeklyScheduleDTO : WeeklyScheduleDTO, options: {exact? : boolean,
global? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<WeeklyScheduleDTO[]> {
if(!options)
options={};
let url = '/CA/MD/WeeklySchedule/Definition?'+(options.exact!=null?'&exact='+options.exact:'')+
''+(options.global!=null?'&global='+options.global:'')+
'';
return <Observable<WeeklyScheduleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, weeklyScheduleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_create
*	All: -
*/
public ca_md_WeeklySchedule_createWeeklySchedule(weeklyScheduleDTO : WeeklyScheduleDTO, mode:Mode=Mode.Entity) : Observable<WeeklyScheduleDTO> {
let url = '/CA/MD/WeeklySchedule';
return <Observable<WeeklyScheduleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, weeklyScheduleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_delete
*	All: -
*/
public ca_md_WeeklySchedule_deleteById(weeklySchedule_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/CA/MD/WeeklySchedule/'+weeklySchedule_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_edit
*	All: -
*/
public ca_md_WeeklySchedule_editWeeklySchedule(weeklyScheduleDTO : WeeklyScheduleDTO, mode:Mode=Mode.Entity) : Observable<WeeklyScheduleDTO> {
let url = '/CA/MD/WeeklySchedule';
return <Observable<WeeklyScheduleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, weeklyScheduleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_list
*	All: -
*/
public ca_md_WeeklySchedule_retrieveAll(options: {global? : boolean,
id? : number[],
search? : string,
identifier? : string[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<WeeklyScheduleDTO[]> {
if(!options)
options={};
let url = '/CA/MD/WeeklySchedule?'+(options.global!=null?'&global='+options.global:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
'';
return <Observable<WeeklyScheduleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_list
*	All: -
*/
public ca_md_WeeklySchedule_retrieveAllByDefinition(weeklyScheduleDTO : WeeklyScheduleDTO, options: {exact? : boolean,
global? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<WeeklyScheduleDTO[]> {
if(!options)
options={};
let url = '/CA/MD/WeeklySchedule/Definition?'+(options.exact!=null?'&exact='+options.exact:'')+
''+(options.global!=null?'&global='+options.global:'')+
'';
return <Observable<WeeklyScheduleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_show
*	All: -
*/
public ca_md_WeeklySchedule_retrieveById(weeklySchedule_id : number, mode:Mode=Mode.Entity) : Observable<WeeklyScheduleDTO> {
let url = '/CA/MD/WeeklySchedule/'+weeklySchedule_id+'';
return <Observable<WeeklyScheduleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: weekly_schedule_show
*	All: -
*/
public ca_md_WeeklySchedule_retrieveRangesById(weeklySchedule_id : number, from : SbLocalDateTime, till : SbLocalDateTime, mode:Mode=Mode.Entity) : Observable<LocalDateTimeRangeDTO[]> {
let url = '/CA/MD/WeeklySchedule/'+weeklySchedule_id+'/Range/'+from+'/'+till+'';
return <Observable<LocalDateTimeRangeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.cs.CS:
// Methods implemented by de.seatback.adplacer.api.cs.Cull:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull__refreshCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<CullDTO> {
let url = '/CS/Cull/'+cull_id+'/Refresh';
return <Observable<CullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_atomSetupForCullAtom(cullAtomDTO : CullAtomDTO, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/CS/Cull/AtomSetup';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullAtomDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_atomSetupForCullAtoms(cullAtomDTO : CullAtomDTO[], mode:Mode=Mode.Entity) : Observable<any[]> {
let url = '/CS/Cull/AtomSetup/Mass';
return <Observable<any[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullAtomDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_atomSetups(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/CS/Cull/AtomSetup';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_checkNameAvailability(options: {type? : string,
name? : string} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/CS/Cull/CheckNameAvailability?type='+options.type+'&name='+options.name+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_createCacheTimeCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<TimeCullDTO> {
let url = '/CS/Cull/Time/'+cull_id+'/CreateCache';
return <Observable<TimeCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_client_create
*	All: -
*/
public cs_Cull_createClientCullClientScoped(clientCullDTO : ClientCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Client';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, clientCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_client_create
*	All: -
*/
public cs_Cull_createClientCullClientScopedPreview(clientCullDTO : ClientCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Client/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, clientCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_client_create
*	All: -
*/
public cs_Cull_createClientCullCompanyScoped(company_id : number, clientCullDTO : ClientCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Client/Company/'+company_id+'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, clientCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_client_create
*	All: -
*/
public cs_Cull_createClientCullCompanyScopedPreview(company_id : number, clientCullDTO : ClientCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Client/Company/'+company_id+'/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, clientCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_content_create
*	All: -
*/
public cs_Cull_createContentCullClientScoped(contentCullDTO : ContentCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Content';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_content_create
*	All: -
*/
public cs_Cull_createContentCullClientScopedPreview(contentCullDTO : ContentCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Content/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_content_create
*	All: -
*/
public cs_Cull_createContentCullCompanyScoped(company_id : number, contentCullDTO : ContentCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Content/Company/'+company_id+'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_content_create
*	All: -
*/
public cs_Cull_createContentCullCompanyScopedPreview(company_id : number, contentCullDTO : ContentCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Content/Company/'+company_id+'/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_geo_create
*	All: -
*/
public cs_Cull_createGeoCullClientScoped(geoCullDTO : GeoCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Geo';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, geoCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_geo_create
*	All: -
*/
public cs_Cull_createGeoCullClientScopedPreview(geoCullDTO : GeoCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Geo/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, geoCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_geo_create
*	All: -
*/
public cs_Cull_createGeoCullCompanyScoped(company_id : number, geoCullDTO : GeoCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Geo/Company/'+company_id+'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, geoCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_geo_create
*	All: -
*/
public cs_Cull_createGeoCullCompanyScopedPreview(company_id : number, geoCullDTO : GeoCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Geo/Company/'+company_id+'/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, geoCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_player_create
*	All: -
*/
public cs_Cull_createPlayerCullClientScoped(playerCullDTO : PlayerCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Player';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playerCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_player_create
*	All: -
*/
public cs_Cull_createPlayerCullClientScopedPreview(playerCullDTO : PlayerCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Player/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playerCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_player_create
*	All: -
*/
public cs_Cull_createPlayerCullCompanyScoped(company_id : number, playerCullDTO : PlayerCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Player/Company/'+company_id+'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playerCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_player_create
*	All: -
*/
public cs_Cull_createPlayerCullCompanyScopedPreview(company_id : number, playerCullDTO : PlayerCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Player/Company/'+company_id+'/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playerCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_time_create
*	All: -
*/
public cs_Cull_createTimeCullClientScoped(timeCullDTO : TimeCullDTO, options: {displayFrom? : SbLocalDateTime,
displayTill? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
if(!options)
options={};
let url = '/CS/Cull/Time?'+(options.displayFrom!=null?'&displayFrom='+this.api.queryParamDatePrepare(options.displayFrom):'')+
''+(options.displayTill!=null?'&displayTill='+this.api.queryParamDatePrepare(options.displayTill):'')+
'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, timeCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_time_create
*	All: -
*/
public cs_Cull_createTimeCullClientScopedPreview(timeCullDTO : TimeCullDTO, options: {displayFrom? : SbLocalDateTime,
displayTill? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
if(!options)
options={};
let url = '/CS/Cull/Time/Preview?'+(options.displayFrom!=null?'&displayFrom='+this.api.queryParamDatePrepare(options.displayFrom):'')+
''+(options.displayTill!=null?'&displayTill='+this.api.queryParamDatePrepare(options.displayTill):'')+
'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, timeCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_time_create
*	All: -
*/
public cs_Cull_createTimeCullCompanyScoped(company_id : number, timeCullDTO : TimeCullDTO, options: {displayFrom? : SbLocalDateTime,
displayTill? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
if(!options)
options={};
let url = '/CS/Cull/Time/Company/'+company_id+'?'+(options.displayFrom!=null?'&displayFrom='+this.api.queryParamDatePrepare(options.displayFrom):'')+
''+(options.displayTill!=null?'&displayTill='+this.api.queryParamDatePrepare(options.displayTill):'')+
'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, timeCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_time_create
*	All: -
*/
public cs_Cull_createTimeCullCompanyScopedPreview(company_id : number, timeCullDTO : TimeCullDTO, options: {displayFrom? : SbLocalDateTime,
displayTill? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
if(!options)
options={};
let url = '/CS/Cull/Time/Company/'+company_id+'/Preview?'+(options.displayFrom!=null?'&displayFrom='+this.api.queryParamDatePrepare(options.displayFrom):'')+
''+(options.displayTill!=null?'&displayTill='+this.api.queryParamDatePrepare(options.displayTill):'')+
'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, timeCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_cullUsageCount(cull_id : number, options: {type? : Entity[]} = {}, mode:Mode=Mode.Entity) : Observable<CullCountDTO[]> {
if(!options)
options={};
let url = '/CS/Cull/'+cull_id+'/Usage/Count?'+(options.type!=null?''+this.api.queryParamArrayPrepare('type',options.type):'')+
'';
return <Observable<CullCountDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_cullUsagesForType(cull_id : number, type : Entity, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DTO[]> {
let url = '/CS/Cull/'+cull_id+'/Usage/Type/'+type+'';
return <Observable<DTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_freeTextAutocomplete(item : string, cullAtomDTO : CullAtomDTO, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/CS/Cull/FreeText/'+encodeURIComponent(item)+'/AutoComplete?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullAtomDTO, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_listUsageTypes(options: {cullType? : string[]} = {}, mode:Mode=Mode.Entity) : Observable<Entity[]> {
if(!options)
options={};
let url = '/CS/Cull/Usage/Type?'+(options.cullType!=null?''+this.api.queryParamArrayPrepare('cullType',options.cullType):'')+
'';
return <Observable<Entity[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_listUsageTypesForClientCulls(mode:Mode=Mode.Entity) : Observable<Entity[]> {
let url = '/CS/Cull/Client/Usage/Type';
return <Observable<Entity[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_listUsageTypesForContentCulls(mode:Mode=Mode.Entity) : Observable<Entity[]> {
let url = '/CS/Cull/Content/Usage/Type';
return <Observable<Entity[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_listUsageTypesForGeoCulls(mode:Mode=Mode.Entity) : Observable<Entity[]> {
let url = '/CS/Cull/Geo/Usage/Type';
return <Observable<Entity[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_listUsageTypesForPlayerCulls(mode:Mode=Mode.Entity) : Observable<Entity[]> {
let url = '/CS/Cull/Player/Usage/Type';
return <Observable<Entity[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_listUsageTypesForTimeCulls(mode:Mode=Mode.Entity) : Observable<Entity[]> {
let url = '/CS/Cull/Time/Usage/Type';
return <Observable<Entity[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_refreshClientCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<ClientCullDTO> {
let url = '/CS/Cull/Client/'+cull_id+'/Refresh';
return <Observable<ClientCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_refreshContentCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<ContentCullDTO> {
let url = '/CS/Cull/Content/'+cull_id+'/Refresh';
return <Observable<ContentCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_refreshGeoCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<GeoCullDTO> {
let url = '/CS/Cull/Geo/'+cull_id+'/Refresh';
return <Observable<GeoCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_refreshPlayerCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<PlayerCullDTO> {
let url = '/CS/Cull/Player/'+cull_id+'/Refresh';
return <Observable<PlayerCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_refreshTimeCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<TimeCullDTO> {
let url = '/CS/Cull/Time/'+cull_id+'/Refresh';
return <Observable<TimeCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_list
*	All: -
*/
public cs_Cull_retrieveAll(options: {forCompany? : number,
company? : number[],
category? : number[],
id? : number[],
name? : string[],
type? : string,
search? : string,
global? : boolean,
showHidden? : boolean,
hasCategory? : boolean,
notInCategory? : number[],
inUse? : boolean,
currentlyInUse? : boolean,
isLocked? : boolean,
order? : {by: cs_Cull_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CullDTO[]> {
if(!options)
options={};
let url = '/CS/Cull?'+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.name!=null?''+this.api.queryParamArrayPrepare('name',options.name):'')+
''+(options.type!=null?'&type='+options.type:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.showHidden!=null?'&showHidden='+options.showHidden:'')+
''+(options.hasCategory!=null?'&hasCategory='+options.hasCategory:'')+
''+(options.notInCategory!=null?''+this.api.queryParamArrayPrepare('notInCategory',options.notInCategory):'')+
''+(options.inUse!=null?'&inUse='+options.inUse:'')+
''+(options.currentlyInUse!=null?'&currentlyInUse='+options.currentlyInUse:'')+
''+(options.isLocked!=null?'&isLocked='+options.isLocked:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveAtomDisplay(cullAtomDTO : CullAtomDTO[], mode:Mode=Mode.Entity) : Observable<any[]> {
let url = '/CS/Cull/Atoms/Display';
return <Observable<any[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullAtomDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveAtomTypeGroups(options: {type? : string} = {}, mode:Mode=Mode.Entity) : Observable<AtomTypeGroupDTO[]> {
if(!options)
options={};
let url = '/CS/Cull/AtomTypeGroups?'+(options.type!=null?'&type='+options.type:'')+
'';
return <Observable<AtomTypeGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveById(cull_id : number, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/'+cull_id+'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveByIdAsContentCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<ContentCullDTO> {
let url = '/CS/Cull/Content/'+cull_id+'';
return <Observable<ContentCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveByIdAsContentCullWithBase(cull_id : number, base : BookingScope, mode:Mode=Mode.Entity) : Observable<ContentCullDTO> {
let url = '/CS/Cull/Content/'+cull_id+'/'+base+'';
return <Observable<ContentCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveByIdAsPlayerCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<PlayerCullDTO> {
let url = '/CS/Cull/Player/'+cull_id+'';
return <Observable<PlayerCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveByIdAsPlayerCullWithBase(cull_id : number, base : ScreenScope, mode:Mode=Mode.Entity) : Observable<PlayerCullDTO> {
let url = '/CS/Cull/Player/'+cull_id+'/'+base+'';
return <Observable<PlayerCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveByIdAsTimeCull(cull_id : number, mode:Mode=Mode.Entity) : Observable<TimeCullDTO> {
let url = '/CS/Cull/Time/'+cull_id+'';
return <Observable<TimeCullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveClientAtomTypeGroups(mode:Mode=Mode.Entity) : Observable<AtomTypeGroupDTO[]> {
let url = '/CS/Cull/Client/AtomTypeGroups';
return <Observable<AtomTypeGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveClientCullValidity(cull_id : number, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
let url = '/CS/Cull/Client/'+cull_id+'/Validity';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveClientCullValidityWithBase(cull_id : number, base : ClientScope, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
let url = '/CS/Cull/Client/'+cull_id+'/'+base+'/Validity';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveContentAtomTypeGroups(mode:Mode=Mode.Entity) : Observable<AtomTypeGroupDTO[]> {
let url = '/CS/Cull/Content/AtomTypeGroups';
return <Observable<AtomTypeGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveContentCullValidity(cull_id : number, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/CS/Cull/Content/'+cull_id+'/Validity';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveContentCullValidityWithBase(cull_id : number, base : BookingScope, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/CS/Cull/Content/'+cull_id+'/'+base+'/Validity';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveCullGraph(cull_id : number, options: {depth? : number} = {}, mode:Mode=Mode.Entity) : Observable<CullGraphTreeNodeDTO> {
if(!options)
options={};
let url = '/CS/Cull/'+cull_id+'/CullGraph?'+(options.depth!=null?'&depth='+options.depth:'')+
'';
return <Observable<CullGraphTreeNodeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_list
*	All: -
*/
public cs_Cull_retrieveCullGraphs(options: {cull_id? : number[],
category? : number[],
name? : string[],
global? : boolean,
inUse? : boolean,
currentlyInUse? : boolean,
search? : string,
depth? : number,
notInCategory? : number[],
order? : {by: cs_Cull_retrieveCullGraphs_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CullGraphTreeNodeDTO[]> {
if(!options)
options={};
let url = '/CS/Cull/CullGraph?'+(options.cull_id!=null?''+this.api.queryParamArrayPrepare('cull_id',options.cull_id):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.name!=null?''+this.api.queryParamArrayPrepare('name',options.name):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.inUse!=null?'&inUse='+options.inUse:'')+
''+(options.currentlyInUse!=null?'&currentlyInUse='+options.currentlyInUse:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.depth!=null?'&depth='+options.depth:'')+
''+(options.notInCategory!=null?''+this.api.queryParamArrayPrepare('notInCategory',options.notInCategory):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CullGraphTreeNodeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrievePlayerAtomTypeGroups(mode:Mode=Mode.Entity) : Observable<AtomTypeGroupDTO[]> {
let url = '/CS/Cull/Player/AtomTypeGroups';
return <Observable<AtomTypeGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrievePlayerCullValidity(cull_id : number, mode:Mode=Mode.Entity) : Observable<ScreenDTO[]> {
let url = '/CS/Cull/Player/'+cull_id+'/Validity';
return <Observable<ScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrievePlayerCullValidityWithBase(cull_id : number, base : ScreenScope, mode:Mode=Mode.Entity) : Observable<ScreenDTO[]> {
let url = '/CS/Cull/Player/'+cull_id+'/'+base+'/Validity';
return <Observable<ScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveTimeAtomTypeGroups(mode:Mode=Mode.Entity) : Observable<AtomTypeGroupDTO[]> {
let url = '/CS/Cull/Time/AtomTypeGroups';
return <Observable<AtomTypeGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_retrieveValidityOfTimeCullById(cull_id : number, from : SbLocalDateTime, till : SbLocalDateTime, mode:Mode=Mode.Entity) : Observable<LocalDateTimeRangeDTO[]> {
let url = '/CS/Cull/Time/'+cull_id+'/Validity/'+from+'/'+till+'';
return <Observable<LocalDateTimeRangeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_Cull_selectionLookup(item : string, cullAtomDTO : CullAtomDTO, options: {search? : string,
lookup? : string[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DisplayableValueDTO[]> {
if(!options)
options={};
let url = '/CS/Cull/Selection/'+encodeURIComponent(item)+'/Lookup?'+(options.search!=null?'&search='+options.search:'')+
''+(options.lookup!=null?''+this.api.queryParamArrayPrepare('lookup',options.lookup):'')+
'';
return <Observable<DisplayableValueDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cullAtomDTO, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_hide
*	All: -
*/
public cs_Cull_setHidden(cull_id : number, options: {hidden? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<CullDTO> {
if(!options)
options={};
let url = '/CS/Cull/'+cull_id+'/Hidden?hidden='+options.hidden+'';
return <Observable<CullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_lock
*	All: -
*/
public cs_Cull_setLock(cull_id : number, options: {unlock? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<CullDTO> {
if(!options)
options={};
let url = '/CS/Cull/'+cull_id+'/Lock?'+(options.unlock!=null?'&unlock='+options.unlock:'')+
'';
return <Observable<CullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_lock_admin
*	All: -
*/
public cs_Cull_setLockAdmin(cull_id : number, options: {unlock? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<CullDTO> {
if(!options)
options={};
let url = '/CS/Cull/'+cull_id+'/Lock/Admin?'+(options.unlock!=null?'&unlock='+options.unlock:'')+
'';
return <Observable<CullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_client_edit
*	All: -
*/
public cs_Cull_updateClientCull(clientCullDTO : ClientCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Client';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, clientCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_client_edit
*	All: -
*/
public cs_Cull_updateClientCullPreview(clientCullDTO : ClientCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Client/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, clientCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_content_edit
*	All: -
*/
public cs_Cull_updateContentCull(contentCullDTO : ContentCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Content';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, contentCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_content_edit
*	All: -
*/
public cs_Cull_updateContentCullPreview(contentCullDTO : ContentCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Content/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, contentCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_geo_edit
*	All: -
*/
public cs_Cull_updateGeoCull(geoCullDTO : GeoCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Geo';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, geoCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_geo_edit
*	All: -
*/
public cs_Cull_updateGeoCullPreview(geoCullDTO : GeoCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Geo/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, geoCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_player_edit
*	All: -
*/
public cs_Cull_updatePlayerCull(playerCullDTO : PlayerCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Player';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, playerCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_player_edit
*	All: -
*/
public cs_Cull_updatePlayerCullPreview(playerCullDTO : PlayerCullDTO, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
let url = '/CS/Cull/Player/Preview';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, playerCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_time_edit
*	All: -
*/
public cs_Cull_updateTimeCull(timeCullDTO : TimeCullDTO, options: {displayFrom? : SbLocalDateTime,
displayTill? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
if(!options)
options={};
let url = '/CS/Cull/Time?'+(options.displayFrom!=null?'&displayFrom='+this.api.queryParamDatePrepare(options.displayFrom):'')+
''+(options.displayTill!=null?'&displayTill='+this.api.queryParamDatePrepare(options.displayTill):'')+
'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, timeCullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_time_edit
*	All: -
*/
public cs_Cull_updateTimeCullPreview(timeCullDTO : TimeCullDTO, options: {displayFrom? : SbLocalDateTime,
displayTill? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CullWithAtomsDTO> {
if(!options)
options={};
let url = '/CS/Cull/Time/Preview?'+(options.displayFrom!=null?'&displayFrom='+this.api.queryParamDatePrepare(options.displayFrom):'')+
''+(options.displayTill!=null?'&displayTill='+this.api.queryParamDatePrepare(options.displayTill):'')+
'';
return <Observable<CullWithAtomsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, timeCullDTO));
}// Methods implemented by de.seatback.adplacer.api.cs.GeoCull:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_GeoCull_playerAggregation(options: {min? : Point,
geoCull? : number[],
max? : Point} = {}, mode:Mode=Mode.Entity) : Observable<PlayerAggregationDTO> {
if(!options)
options={};
let url = '/CS/GeoCull/PlayerAggregation?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+'&'+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+'&'+(options.max!=null?'&max='+this.api.asString(options.max):'')+'';
return <Observable<PlayerAggregationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_GeoCull_players(options: {min? : Point,
geoCull? : number[],
max? : Point} = {}, mode:Mode=Mode.Entity) : Observable<ScreenFullDTO[]> {
if(!options)
options={};
let url = '/CS/GeoCull/Players?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+'&'+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+'&'+(options.max!=null?'&max='+this.api.asString(options.max):'')+'';
return <Observable<ScreenFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_GeoCull_polygons(options: {min? : Point,
geoCull? : number[],
max? : Point} = {}, mode:Mode=Mode.Entity) : Observable<PolygonDTO[]> {
if(!options)
options={};
let url = '/CS/GeoCull/Polygons?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+'&'+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+'&'+(options.max!=null?'&max='+this.api.asString(options.max):'')+'';
return <Observable<PolygonDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.cs.PlayerCull:

public cs_PlayerCull_coordinateCluster(options: {screenScope? : ScreenScope,
min? : Point,
max? : Point,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<CoordinateClusterDTO[]> {
if(!options)
options={};
let url = '/CS/PlayerCull/CoordinateCluster?'+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'&'+(options.min!=null?'&min='+this.api.asString(options.min):'')+'&'+(options.max!=null?'&max='+this.api.asString(options.max):'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'';
return <Observable<CoordinateClusterDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cull_show
*	All: -
*/
public cs_PlayerCull_playerAggregation(options: {min? : Point,
max? : Point,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<PlayerAggregationDTO> {
if(!options)
options={};
let url = '/CS/PlayerCull/PlayerAggregation?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+'&'+(options.max!=null?'&max='+this.api.asString(options.max):'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'';
return <Observable<PlayerAggregationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public cs_PlayerCull_players(options: {min? : Point,
max? : Point,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ScreenFullDTO[]> {
if(!options)
options={};
let url = '/CS/PlayerCull/Players?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+'&'+(options.max!=null?'&max='+this.api.asString(options.max):'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'';
return <Observable<ScreenFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.assets.Asset:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_edit
*	All: -
*/
public dm_assets_Asset_addTagToAsset(asset_id : number, name : string, mode:Mode=Mode.Entity) : Observable<AssetDTO> {
let url = '/DM/Asset/'+asset_id+'/Tag/'+encodeURIComponent(name)+'';
return <Observable<AssetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_Asset_assetFileRetrieveById(asset_id : number, asset_file_id : number, mode:Mode=Mode.Entity) : Observable<AssetFileDTO> {
let url = '/DM/Asset/'+asset_id+'/File/'+asset_file_id+'';
return <Observable<AssetFileDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_Asset_assetFilesRetrieveById(asset_id : number, options: {width? : number,
height? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetFileDTO[]> {
if(!options)
options={};
let url = '/DM/Asset/'+asset_id+'/File?'+(options.width!=null?'&width='+options.width:'')+
''+(options.height!=null?'&height='+options.height:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetFileDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_Asset_assetRetrieveById(asset_id : number, mode:Mode=Mode.Entity) : Observable<AssetFullDTO> {
let url = '/DM/Asset/'+asset_id+'';
return <Observable<AssetFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_delete
*	All: -
*/
public dm_assets_Asset_deleteAsset(asset_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/Asset/'+asset_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_edit
*	All: -
*/
public dm_assets_Asset_editAsset(asset_id : number, assetFullDTO : AssetFullDTO, mode:Mode=Mode.Entity) : Observable<AssetDTO> {
let url = '/DM/Asset/'+asset_id+'';
return <Observable<AssetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, assetFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_list
*	All: -
*/
public dm_assets_Asset_getTagsOfAsset(asset_id : number, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/DM/Asset/'+asset_id+'/Tag?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_edit
*	All: -
*/
public dm_assets_Asset_removeTagFromAsset(asset_id : number, name : string, mode:Mode=Mode.Entity) : Observable<AssetDTO> {
let url = '/DM/Asset/'+asset_id+'/Tag/'+encodeURIComponent(name)+'';
return <Observable<AssetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_list
*	All: -
*/
public dm_assets_Asset_repositoryAssetsRetrieveAll(options: {search? : string,
category_id? : number[],
tags? : string[],
repository_id? : number[],
width? : number[],
height? : number[],
resolution? : Resolution[],
order? : {by: dm_assets_Asset_repositoryAssetsRetrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetDTO[]> {
if(!options)
options={};
let url = '/DM/Asset?'+(options.search!=null?'&search='+options.search:'')+
''+(options.category_id!=null?''+this.api.queryParamArrayPrepare('category_id',options.category_id):'')+
''+(options.tags!=null?''+this.api.queryParamArrayPrepare('tags',options.tags):'')+
''+(options.repository_id!=null?''+this.api.queryParamArrayPrepare('repository_id',options.repository_id):'')+
''+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AssetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_create
*	All: -
*/
public dm_assets_Asset_uploadAssetFile(asset_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<AssetFileFullDTO> {
let url = '/DM/Asset/'+asset_id+'/File/Upload';
return <Observable<AssetFileFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_create
*	All: -
*/
public dm_assets_Asset_uploadAssetFileLink(asset_id : number, assetFileLink : AssetFileLink, mode:Mode=Mode.Entity) : Observable<AssetFileFullDTO> {
let url = '/DM/Asset/'+asset_id+'/File/Link';
return <Observable<AssetFileFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, assetFileLink));
}// Methods implemented by de.seatback.adplacer.api.dm.assets.AssetCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_AssetCategory_assetCategoryRetrieveById(category_id : number, mode:Mode=Mode.Entity) : Observable<AssetCategoryFullDTO> {
let url = '/DM/AssetCategory/'+category_id+'';
return <Observable<AssetCategoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_category_delete
*	All: -
*/
public dm_assets_AssetCategory_deleteById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/AssetCategory/'+category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_category_delete
*	All: -
*/
public dm_assets_AssetCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/AssetCategory/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_edit
*	All: -
*/
public dm_assets_AssetCategory_editAssetCategory(asset_category_id : number, assetCategoryFullDTO : AssetCategoryFullDTO, mode:Mode=Mode.Entity) : Observable<AssetCategoryFullDTO> {
let url = '/DM/AssetCategory/'+asset_category_id+'';
return <Observable<AssetCategoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, assetCategoryFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_AssetCategory_retrieveAll(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetCategoryFullDTO[]> {
if(!options)
options={};
let url = '/DM/AssetCategory?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetCategoryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.dm.assets.AssetFile:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_edit_files
*	All: -
*/
public dm_assets_AssetFile_deleteFile(asset_file_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/AssetFile/'+asset_file_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_AssetFile_retrieveById(asset_file_id : number, mode:Mode=Mode.Entity) : Observable<AssetFileFullDTO> {
let url = '/DM/AssetFile/'+asset_file_id+'';
return <Observable<AssetFileFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.assets.AssetRepository:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_list
*	All: -
*/
public dm_assets_AssetRepository_assetsRetrieveAll(asset_repository_id : number, options: {width? : number[],
height? : number[],
resolution? : Resolution[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetFullDTO[]> {
if(!options)
options={};
let url = '/DM/AssetRepository/'+asset_repository_id+'/Asset?'+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_show
*	All: -
*/
public dm_assets_AssetRepository_createAssetCategory(asset_repository_id : number, assetCategoryFullDTO : AssetCategoryFullDTO, mode:Mode=Mode.Entity) : Observable<AssetCategoryFullDTO> {
let url = '/DM/AssetRepository/'+asset_repository_id+'/Category';
return <Observable<AssetCategoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, assetCategoryFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_create
*	All: -
*/
public dm_assets_AssetRepository_createAssetInRepository(asset_repository_id : number, assetFullDTO : AssetFullDTO, mode:Mode=Mode.Entity) : Observable<AssetFullDTO> {
let url = '/DM/AssetRepository/'+asset_repository_id+'/Asset';
return <Observable<AssetFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, assetFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_create
*	All: -
*/
public dm_assets_AssetRepository_createRepository(assetRepositoryFullDTO : AssetRepositoryFullDTO, mode:Mode=Mode.Entity) : Observable<AssetRepositoryFullDTO> {
let url = '/DM/AssetRepository';
return <Observable<AssetRepositoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, assetRepositoryFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_delete
*	All: -
*/
public dm_assets_AssetRepository_deleteRepository(asset_repository_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/AssetRepository/'+asset_repository_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_edit
*	All: -
*/
public dm_assets_AssetRepository_editAssetRepository(asset_repository_id : number, assetRepositoryFullDTO : AssetRepositoryFullDTO, mode:Mode=Mode.Entity) : Observable<AssetRepositoryFullDTO> {
let url = '/DM/AssetRepository/'+asset_repository_id+'';
return <Observable<AssetRepositoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, assetRepositoryFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_show
*	All: -
*/
public dm_assets_AssetRepository_getRepoCategories(asset_repository_id : number, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetCategoryFullDTO[]> {
if(!options)
options={};
let url = '/DM/AssetRepository/'+asset_repository_id+'/Category?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetCategoryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_list
*	All: -
*/
public dm_assets_AssetRepository_retrieveAll(options: {search? : string,
repository_id? : number[],
category_id? : number[],
hasAssets? : boolean,
order? : {by: dm_assets_AssetRepository_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetRepositoryFullDTO[]> {
if(!options)
options={};
let url = '/DM/AssetRepository?'+(options.search!=null?'&search='+options.search:'')+
''+(options.repository_id!=null?''+this.api.queryParamArrayPrepare('repository_id',options.repository_id):'')+
''+(options.category_id!=null?''+this.api.queryParamArrayPrepare('category_id',options.category_id):'')+
''+(options.hasAssets!=null?'&hasAssets='+options.hasAssets:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AssetRepositoryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_repository_show
*	All: -
*/
public dm_assets_AssetRepository_retrieveById(asset_repository_id : number, mode:Mode=Mode.Entity) : Observable<AssetRepositoryFullDTO> {
let url = '/DM/AssetRepository/'+asset_repository_id+'';
return <Observable<AssetRepositoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.assets.AssetTag:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_edit
*	All: -
*/
public dm_assets_AssetTag_createAssetTag(string : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/DM/AssetTag';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, string));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_list
*	All: -
*/
public dm_assets_AssetTag_retrieveAll(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/DM/AssetTag?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: asset_show
*	All: -
*/
public dm_assets_AssetTag_retrieveById(tag : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/DM/AssetTag/'+encodeURIComponent(tag)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.DM:
// Methods implemented by de.seatback.adplacer.api.dm.geo.Address:

public dm_geo_Address_geocode(addressDTO : AddressDTO, mode:Mode=Mode.Entity) : Observable<Point> {
let url = '/DM/GEO/Address/Geocode';
return <Observable<Point>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, addressDTO));
}// Methods implemented by de.seatback.adplacer.api.dm.geo.Area:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_create
*	All: -
*/
public dm_geo_Area_createArea(areaDTO : AreaDTO, mode:Mode=Mode.Entity) : Observable<AreaDTO> {
let url = '/DM/GEO/Area';
return <Observable<AreaDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, areaDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_create
*	All: -
*/
public dm_geo_Area_createAreas(areaDTO : AreaDTO[], mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/DM/GEO/Area/Mass';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, areaDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_delete
*	All: -
*/
public dm_geo_Area_deleteById(area_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/GEO/Area/'+area_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_edit
*	All: -
*/
public dm_geo_Area_editArea(areaDTO : AreaDTO, mode:Mode=Mode.Entity) : Observable<AreaDTO> {
let url = '/DM/GEO/Area';
return <Observable<AreaDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, areaDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_edit
*	All: -
*/
public dm_geo_Area_editAreas(areaDTO : AreaDTO[], mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
let url = '/DM/GEO/Area/Mass';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, areaDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_list
*	All: -
*/
public dm_geo_Area_retrieveAll(options: {id? : number[],
company? : number[],
category? : number[],
global? : boolean,
hasCompany? : boolean,
hasCategory? : boolean,
notInCategory? : number[],
search? : string,
filter? : {by: dm_geo_Area_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: dm_geo_Area_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
if(!options)
options={};
let url = '/DM/GEO/Area?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.hasCategory!=null?'&hasCategory='+options.hasCategory:'')+
''+(options.notInCategory!=null?''+this.api.queryParamArrayPrepare('notInCategory',options.notInCategory):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_show
*	All: -
*/
public dm_geo_Area_retrieveById(area_id : number, mode:Mode=Mode.Entity) : Observable<AreaDTO> {
let url = '/DM/GEO/Area/'+area_id+'';
return <Observable<AreaDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: area_list
*	All: -
*/
public dm_geo_Area_retrieveOfficial(options: {id? : number[],
category? : number[],
hasCategory? : boolean,
notInCategory? : number[],
search? : string,
filter? : {by: dm_geo_Area_retrieveOfficial_filter, param?: string, values: string[]}[],
order? : {by: dm_geo_Area_retrieveOfficial_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AreaDTO[]> {
if(!options)
options={};
let url = '/DM/GEO/Area/Official?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.hasCategory!=null?'&hasCategory='+options.hasCategory:'')+
''+(options.notInCategory!=null?''+this.api.queryParamArrayPrepare('notInCategory',options.notInCategory):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AreaDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.dm.geo.GEO:
// Methods implemented by de.seatback.adplacer.api.dm.geo.LineString:

public dm_geo_LineString_retrieveLineStringById(id : number, mode:Mode=Mode.Entity) : Observable<LineStringDTO> {
let url = '/DM/GEO/LineString/'+id+'';
return <Observable<LineStringDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public dm_geo_LineString_retrieveLineStringsByIds(options: {id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LineStringDTO[]> {
if(!options)
options={};
let url = '/DM/GEO/LineString?'+this.api.queryParamArrayPrepare('id',options.id)+'';
return <Observable<LineStringDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.geo.Point:

public dm_geo_Point_retrievePointById(id : number, mode:Mode=Mode.Entity) : Observable<PointDTO> {
let url = '/DM/GEO/Point/'+id+'';
return <Observable<PointDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public dm_geo_Point_retrievePointsByIds(options: {id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<PointDTO[]> {
if(!options)
options={};
let url = '/DM/GEO/Point?'+this.api.queryParamArrayPrepare('id',options.id)+'';
return <Observable<PointDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.geo.Polygon:

public dm_geo_Polygon_retrievePolygonById(id : number, mode:Mode=Mode.Entity) : Observable<PolygonDTO> {
let url = '/DM/GEO/Polygon/'+id+'';
return <Observable<PolygonDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public dm_geo_Polygon_retrievePolygonsByIds(options: {id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<PolygonDTO[]> {
if(!options)
options={};
let url = '/DM/GEO/Polygon?'+this.api.queryParamArrayPrepare('id',options.id)+'';
return <Observable<PolygonDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.time.Calendar:

public dm_time_Calendar_create(type_id : number, calendarFullDTO : CalendarFullDTO, mode:Mode=Mode.Entity) : Observable<CalendarFullDTO> {
let url = '/DM/TIME/Calendar/Type/'+type_id+'';
return <Observable<CalendarFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarFullDTO));
}
public dm_time_Calendar_createCalendarEntry(id : number, calendar_entry_type_id : number, calendarEntryFullDTO : CalendarEntryFullDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryFullDTO> {
let url = '/DM/TIME/Calendar/'+id+'/Entry/'+calendar_entry_type_id+'';
return <Observable<CalendarEntryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarEntryFullDTO));
}
public dm_time_Calendar_retrieveAll(options: {id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarFullDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/Calendar?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
'';
return <Observable<CalendarFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_Calendar_retrieveAllCalendarEntryTypesByCalendarType(type_id : number, options: {id? : number[],
identifier? : string[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarEntryTypeFullDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/Calendar/Type/'+type_id+'/EntryType?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
'';
return <Observable<CalendarEntryTypeFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_Calendar_retrieveAllCalendarTypes(options: {id? : number[],
identifier? : string[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarTypeDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/Calendar/Type?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
'';
return <Observable<CalendarTypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_Calendar_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<CalendarDTO> {
let url = '/DM/TIME/Calendar/'+id+'';
return <Observable<CalendarDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.time.CalendarCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_create
*	All: -
*/
public dm_time_CalendarCategory_createCategories(calendarCategoryDTO : CalendarCategoryDTO[], mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO[]> {
let url = '/DM/TIME/CalendarCategory/Mass';
return <Observable<CalendarCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_create
*	All: -
*/
public dm_time_CalendarCategory_createCategory(calendarCategoryDTO : CalendarCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO> {
let url = '/DM/TIME/CalendarCategory';
return <Observable<CalendarCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_delete
*	All: -
*/
public dm_time_CalendarCategory_deleteById(calendar_category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarCategory/'+calendar_category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_delete
*	All: -
*/
public dm_time_CalendarCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarCategory/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_edit
*	All: -
*/
public dm_time_CalendarCategory_editCategories(calendarCategoryDTO : CalendarCategoryDTO[], mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO[]> {
let url = '/DM/TIME/CalendarCategory/Mass';
return <Observable<CalendarCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_edit
*	All: -
*/
public dm_time_CalendarCategory_editCategory(calendarCategoryDTO : CalendarCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO> {
let url = '/DM/TIME/CalendarCategory';
return <Observable<CalendarCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_list
*	All: -
*/
public dm_time_CalendarCategory_retrieveAll(options: {id? : number[],
company? : number[],
global? : boolean,
notInHierarchyOf? : number,
search? : string,
filter? : {by: dm_time_CalendarCategory_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: dm_time_CalendarCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/CalendarCategory?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CalendarCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_category_show
*	All: -
*/
public dm_time_CalendarCategory_retrieveById(calendarCategory_id : number, mode:Mode=Mode.Entity) : Observable<CalendarCategoryDTO> {
let url = '/DM/TIME/CalendarCategory/'+calendarCategory_id+'';
return <Observable<CalendarCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.time.CalendarEntry:

public dm_time_CalendarEntry_changeEntryType(id : number, entry_type_id : number, mode:Mode=Mode.Entity) : Observable<CalendarEntryFullDTO> {
let url = '/DM/TIME/CalendarEntry/'+id+'/Type/'+entry_type_id+'';
return <Observable<CalendarEntryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public dm_time_CalendarEntry_deleteById(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarEntry/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public dm_time_CalendarEntry_retrieveAll(options: {id? : number[],
calendar_id? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarEntryFullDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/CalendarEntry?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.calendar_id!=null?''+this.api.queryParamArrayPrepare('calendar_id',options.calendar_id):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
'';
return <Observable<CalendarEntryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_CalendarEntry_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<CalendarEntryDTO> {
let url = '/DM/TIME/CalendarEntry/'+id+'';
return <Observable<CalendarEntryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public dm_time_CalendarEntry_update(calendarEntryFullDTO : CalendarEntryFullDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryFullDTO> {
let url = '/DM/TIME/CalendarEntry';
return <Observable<CalendarEntryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarEntryFullDTO));
}// Methods implemented by de.seatback.adplacer.api.dm.time.CalendarEntryCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_create
*	All: -
*/
public dm_time_CalendarEntryCategory_createCategories(calendarEntryCategoryDTO : CalendarEntryCategoryDTO[], mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO[]> {
let url = '/DM/TIME/CalendarEntryCategory/Mass';
return <Observable<CalendarEntryCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarEntryCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_create
*	All: -
*/
public dm_time_CalendarEntryCategory_createCategory(calendarEntryCategoryDTO : CalendarEntryCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO> {
let url = '/DM/TIME/CalendarEntryCategory';
return <Observable<CalendarEntryCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarEntryCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_delete
*	All: -
*/
public dm_time_CalendarEntryCategory_deleteById(calendar_entry_category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarEntryCategory/'+calendar_entry_category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_delete
*	All: -
*/
public dm_time_CalendarEntryCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarEntryCategory/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_edit
*	All: -
*/
public dm_time_CalendarEntryCategory_editCategories(calendarEntryCategoryDTO : CalendarEntryCategoryDTO[], mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO[]> {
let url = '/DM/TIME/CalendarEntryCategory/Mass';
return <Observable<CalendarEntryCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarEntryCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_edit
*	All: -
*/
public dm_time_CalendarEntryCategory_editCategory(calendarEntryCategoryDTO : CalendarEntryCategoryDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO> {
let url = '/DM/TIME/CalendarEntryCategory';
return <Observable<CalendarEntryCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarEntryCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_list
*	All: -
*/
public dm_time_CalendarEntryCategory_retrieveAll(options: {id? : number[],
global? : boolean,
notInHierarchyOf? : number,
search? : string,
filter? : {by: dm_time_CalendarEntryCategory_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: dm_time_CalendarEntryCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/CalendarEntryCategory?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CalendarEntryCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: calendar_entry_category_show
*	All: -
*/
public dm_time_CalendarEntryCategory_retrieveById(calendarEntryCategory_id : number, mode:Mode=Mode.Entity) : Observable<CalendarEntryCategoryDTO> {
let url = '/DM/TIME/CalendarEntryCategory/'+calendarEntryCategory_id+'';
return <Observable<CalendarEntryCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.time.CalendarEntryMetaDataType:

public dm_time_CalendarEntryMetaDataType_create(type_id : number, calendarEntryMetaDataTypeDTO : CalendarEntryMetaDataTypeDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryMetaDataTypeDTO> {
let url = '/DM/TIME/CalendarEntryMetaDataType/Type/'+type_id+'';
return <Observable<CalendarEntryMetaDataTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarEntryMetaDataTypeDTO));
}
public dm_time_CalendarEntryMetaDataType_delete(type_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarEntryMetaDataType/'+type_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public dm_time_CalendarEntryMetaDataType_edit(type_id : number, calendarEntryMetaDataTypeDTO : CalendarEntryMetaDataTypeDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryMetaDataTypeDTO> {
let url = '/DM/TIME/CalendarEntryMetaDataType/'+type_id+'';
return <Observable<CalendarEntryMetaDataTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarEntryMetaDataTypeDTO));
}
public dm_time_CalendarEntryMetaDataType_retrieveAll(options: {id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarEntryMetaDataTypeDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/CalendarEntryMetaDataType?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
'';
return <Observable<CalendarEntryMetaDataTypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_CalendarEntryMetaDataType_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<CalendarEntryMetaDataTypeDTO> {
let url = '/DM/TIME/CalendarEntryMetaDataType/'+id+'';
return <Observable<CalendarEntryMetaDataTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.time.CalendarEntryType:

public dm_time_CalendarEntryType_create(calendarEntryTypeFullDTO : CalendarEntryTypeFullDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryTypeFullDTO> {
let url = '/DM/TIME/CalendarEntryType/Type/';
return <Observable<CalendarEntryTypeFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarEntryTypeFullDTO));
}
public dm_time_CalendarEntryType_delete(type_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarEntryType/'+type_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public dm_time_CalendarEntryType_retrieveAll(options: {id? : number[],
calendar_type_id? : number[],
identifiers? : string[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarEntryTypeFullDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/CalendarEntryType?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.calendar_type_id!=null?''+this.api.queryParamArrayPrepare('calendar_type_id',options.calendar_type_id):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
'';
return <Observable<CalendarEntryTypeFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_CalendarEntryType_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<CalendarEntryTypeDTO> {
let url = '/DM/TIME/CalendarEntryType/'+id+'';
return <Observable<CalendarEntryTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public dm_time_CalendarEntryType_update(type_id : number, calendarEntryTypeFullDTO : CalendarEntryTypeFullDTO, mode:Mode=Mode.Entity) : Observable<CalendarEntryTypeFullDTO> {
let url = '/DM/TIME/CalendarEntryType/'+type_id+'';
return <Observable<CalendarEntryTypeFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarEntryTypeFullDTO));
}// Methods implemented by de.seatback.adplacer.api.dm.time.CalendarType:

public dm_time_CalendarType_create(type_id : number, calendarTypeDTO : CalendarTypeDTO, mode:Mode=Mode.Entity) : Observable<CalendarTypeDTO> {
let url = '/DM/TIME/CalendarType/Type/'+type_id+'';
return <Observable<CalendarTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, calendarTypeDTO));
}
public dm_time_CalendarType_delete(type_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/TIME/CalendarType/'+type_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public dm_time_CalendarType_retrieveAll(options: {id? : number[],
identifiers? : string[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CalendarTypeDTO[]> {
if(!options)
options={};
let url = '/DM/TIME/CalendarType?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
'';
return <Observable<CalendarTypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public dm_time_CalendarType_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<CalendarTypeDTO> {
let url = '/DM/TIME/CalendarType/'+id+'';
return <Observable<CalendarTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public dm_time_CalendarType_update(type_id : number, calendarTypeDTO : CalendarTypeDTO, mode:Mode=Mode.Entity) : Observable<CalendarTypeDTO> {
let url = '/DM/TIME/CalendarType/'+type_id+'';
return <Observable<CalendarTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, calendarTypeDTO));
}// Methods implemented by de.seatback.adplacer.api.dm.time.TIME:
// Methods implemented by de.seatback.adplacer.api.dm.visitor.Reporting:
// Methods implemented by de.seatback.adplacer.api.dm.visitor.VISITOR:
// Methods implemented by de.seatback.adplacer.api.dm.visitor.VisitorDiurnalCycle:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_diurnal_cycle_create
*	All: -
*/
public dm_visitor_VisitorDiurnalCycle_create(visitorDiurnalCycleDTO : VisitorDiurnalCycleDTO, mode:Mode=Mode.Entity) : Observable<VisitorDiurnalCycleDTO> {
let url = '/DM/VISITOR/DiurnalCycle';
return <Observable<VisitorDiurnalCycleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, visitorDiurnalCycleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_diurnal_cycle_show
*	All: -
*/
public dm_visitor_VisitorDiurnalCycle_DoStuffById(id : number, mode:Mode=Mode.Entity) : Observable<Object> {
let url = '/DM/VISITOR/DiurnalCycle/'+id+'/DoStuff';
return <Observable<Object>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_diurnal_cycle_edit
*	All: -
*/
public dm_visitor_VisitorDiurnalCycle_edit(visitorDiurnalCycleDTO : VisitorDiurnalCycleDTO, mode:Mode=Mode.Entity) : Observable<VisitorDiurnalCycleDTO> {
let url = '/DM/VISITOR/DiurnalCycle';
return <Observable<VisitorDiurnalCycleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, visitorDiurnalCycleDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_diurnal_cycle_list
*	All: -
*/
public dm_visitor_VisitorDiurnalCycle_retrieveAll(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VisitorDiurnalCycleDTO[]> {
if(!options)
options={};
let url = '/DM/VISITOR/DiurnalCycle?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<VisitorDiurnalCycleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_diurnal_cycle_show
*	All: -
*/
public dm_visitor_VisitorDiurnalCycle_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<VisitorDiurnalCycleDTO> {
let url = '/DM/VISITOR/DiurnalCycle/'+id+'';
return <Observable<VisitorDiurnalCycleDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_diurnal_cycle_show
*	All: -
*/
public dm_visitor_VisitorDiurnalCycle_retrieveVisitorsById(id : number, options: {localTime? : SbLocalTime} = {}, mode:Mode=Mode.Entity) : Observable<number> {
if(!options)
options={};
let url = '/DM/VISITOR/DiurnalCycle/'+id+'/Visitors?'+(options.localTime!=null?'&localTime='+this.api.queryParamDatePrepare(options.localTime):'')+
'';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.visitor.VisitorTracker:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_screen_assignment_modify
*	All: -
*/
public dm_visitor_VisitorTracker_assignTrackerToScreens(visitorTracker_id : number, visitorTrackerScreenDTO : VisitorTrackerScreenDTO[], mode:Mode=Mode.Entity) : Observable<VisitorTrackerScreenDTO[]> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'/Screens';
return <Observable<VisitorTrackerScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, visitorTrackerScreenDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_visitor_aggregation
*	All: -
*/
public dm_visitor_VisitorTracker_createTrackedVisitor(trackedVisitorFullDTO : TrackedVisitorFullDTO, mode:Mode=Mode.Entity) : Observable<TrackedVisitorFullDTO> {
let url = '/DM/VISITOR/Tracker/Visitors';
return <Observable<TrackedVisitorFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, trackedVisitorFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_visitor_aggregation
*	All: -
*/
public dm_visitor_VisitorTracker_createTrackedVisitorLocal(trackedVisitorLocalFullDTO : TrackedVisitorLocalFullDTO, mode:Mode=Mode.Entity) : Observable<TrackedVisitorLocalFullDTO> {
let url = '/DM/VISITOR/Tracker/Visitor/Local';
return <Observable<TrackedVisitorLocalFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, trackedVisitorLocalFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_visitor_aggregation
*	All: -
*/
public dm_visitor_VisitorTracker_createTrackedVisitorLocalsAtTracker(tracker_id : number, trackedVisitorLocalDTO : TrackedVisitorLocalDTO[], mode:Mode=Mode.Entity) : Observable<TrackedVisitorLocalDTO[]> {
let url = '/DM/VISITOR/Tracker/'+tracker_id+'/Visitors/Local';
return <Observable<TrackedVisitorLocalDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, trackedVisitorLocalDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_visitor_aggregation
*	All: -
*/
public dm_visitor_VisitorTracker_createTrackedVisitorsAtTracker(tracker_id : number, trackedVisitorDTO : TrackedVisitorDTO[], mode:Mode=Mode.Entity) : Observable<TrackedVisitorDTO[]> {
let url = '/DM/VISITOR/Tracker/'+tracker_id+'/Visitors';
return <Observable<TrackedVisitorDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, trackedVisitorDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_create
*	All: -
*/
public dm_visitor_VisitorTracker_createVisitorTracker(visitorTrackerFullDTO : VisitorTrackerFullDTO, mode:Mode=Mode.Entity) : Observable<VisitorTrackerFullDTO> {
let url = '/DM/VISITOR/Tracker';
return <Observable<VisitorTrackerFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, visitorTrackerFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_delete
*	All: -
*/
public dm_visitor_VisitorTracker_deleteVisitorTracker(visitorTracker_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_edit
*	All: -
*/
public dm_visitor_VisitorTracker_editVisitorTracker(visitorTrackerFullDTO : VisitorTrackerFullDTO, mode:Mode=Mode.Entity) : Observable<VisitorTrackerFullDTO> {
let url = '/DM/VISITOR/Tracker';
return <Observable<VisitorTrackerFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, visitorTrackerFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_visitor_aggregation
*	All: -
*/
public dm_visitor_VisitorTracker_getTrackedVisitorLocal(visitorTracker_id : number, mode:Mode=Mode.Entity) : Observable<VisitorTrackerScreenDTO[]> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'/Screens';
return <Observable<VisitorTrackerScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_list
*	All: -
*/
public dm_visitor_VisitorTracker_retrieveAll(options: {search? : string,
productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
location_id? : number} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VisitorTrackerFullDTO[]> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker?'+(options.search!=null?'&search='+options.search:'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.location_id!=null?'&location_id='+options.location_id:'')+
'';
return <Observable<VisitorTrackerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_show
*	All: -
*/
public dm_visitor_VisitorTracker_retrieveById(visitorTracker_id : number, mode:Mode=Mode.Entity) : Observable<VisitorTrackerFullDTO> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'';
return <Observable<VisitorTrackerFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_show
*	All: -
*/
public dm_visitor_VisitorTracker_retrieveTrackedVisitorForDate(visitorTracker_id : number, date : SbDateTime, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TrackedVisitorDTO> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'/Visitors/'+date+'';
return <Observable<TrackedVisitorDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_show
*	All: -
*/
public dm_visitor_VisitorTracker_retrieveTrackedVisitorForDateLocal(visitorTracker_id : number, date : SbLocalDateTime, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TrackedVisitorLocalDTO> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'/Visitors/'+date+'/Local';
return <Observable<TrackedVisitorLocalDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_show
*	All: -
*/
public dm_visitor_VisitorTracker_retrieveTrackedVisitorsByTrackerId(visitorTracker_id : number, from : SbDateTime, till : SbDateTime, mode:Mode=Mode.Entity) : Observable<TrackedVisitorDTO[]> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'/Visitors/'+from+'/'+till+'';
return <Observable<TrackedVisitorDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_show
*	All: -
*/
public dm_visitor_VisitorTracker_retrieveTrackedVisitorsLocalByTrackerId(visitorTracker_id : number, from : SbLocalDateTime, till : SbLocalDateTime, mode:Mode=Mode.Entity) : Observable<TrackedVisitorLocalDTO[]> {
let url = '/DM/VISITOR/Tracker/'+visitorTracker_id+'/Visitors/'+from+'/'+till+'/Local';
return <Observable<TrackedVisitorLocalDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.visitor.VisitorTrackerReporting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramed(options: {interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FramedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<FramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedByChannels(options: {id? : number[],
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FramedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<FramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedGroupedBy(groupedBy : string, options: {interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedLocal(options: {interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/Local?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedLocalByChannels(options: {id? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/Local/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedLocalByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/Local/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorFramedLocalGroupedBy(groupedBy : string, options: {interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/Framed/Local/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBased(options: {from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<HourBasedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<HourBasedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedByChannels(options: {id? : number[],
from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<HourBasedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<HourBasedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedGroupedBy(groupedBy : string, options: {from? : SbDateTime,
till? : SbDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedLocal(options: {from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedHourBasedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/Local?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<LocalizedHourBasedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedLocalByChannels(options: {id? : number[],
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedHourBasedReportingDTO> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/Local/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<LocalizedHourBasedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedLocalByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/Local/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public dm_visitor_VisitorTrackerReporting_trackedVisitorHourBasedLocalGroupedBy(groupedBy : string, options: {from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCullIntersection? : boolean,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DM/VISITOR/Tracker/Reporting/TrackedVisitor/HourBased/Local/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.dm.visitor.VisitorTrackerScreen:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_screen_assignment_list
*	All: -
*/
public dm_visitor_VisitorTrackerScreen_retrieveAll(options: {tracker_id? : number[],
screen_id? : number[],
location_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VisitorTrackerScreenFullDTO[]> {
if(!options)
options={};
let url = '/DM/VISITOR/TrackerScreen?'+(options.tracker_id!=null?''+this.api.queryParamArrayPrepare('tracker_id',options.tracker_id):'')+
''+(options.screen_id!=null?''+this.api.queryParamArrayPrepare('screen_id',options.screen_id):'')+
''+(options.location_id!=null?''+this.api.queryParamArrayPrepare('location_id',options.location_id):'')+
'';
return <Observable<VisitorTrackerScreenFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_screen_assignment_show
*	All: -
*/
public dm_visitor_VisitorTrackerScreen_retrieveAllAssignmentsAtLocation(location_id : number, mode:Mode=Mode.Entity) : Observable<VisitorTrackerScreenAssignmentsDTO> {
let url = '/DM/VISITOR/TrackerScreen/Location/'+location_id+'';
return <Observable<VisitorTrackerScreenAssignmentsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Booking:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Booking_editBookings(bookingDTO : BookingDTO[], mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Booking';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Booking_editBookingsPlanningPreview(planning_id : number, bookingDTO : BookingDTO[], mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Booking/Planning/'+planning_id+'/Preview';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Booking_editBookingsPreview(bookingDTO : BookingDTO[], mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Booking/Preview';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Booking_editPlanningBookings(planning_id : number, bookingDTO : BookingDTO[], mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Booking/Planning/'+planning_id+'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Booking_requestVerification(bookingDTO : BookingDTO[], mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Booking/RequestVerification';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: booking_list
*	All: -
*/
public ds_cm_Booking_retrieveAll(options: {publisher_id? : number,
id? : number[],
customer_id? : number[],
marker_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
media_id? : number[],
deprecated? : boolean,
excluded? : boolean,
current? : boolean,
finished? : boolean,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Booking_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Booking?'+(options.publisher_id!=null?'&publisher_id='+options.publisher_id:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.customer_id!=null?''+this.api.queryParamArrayPrepare('customer_id',options.customer_id):'')+
''+(options.marker_id!=null?''+this.api.queryParamArrayPrepare('marker_id',options.marker_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.media_id!=null?''+this.api.queryParamArrayPrepare('media_id',options.media_id):'')+
''+(options.deprecated!=null?'&deprecated='+options.deprecated:'')+
''+(options.excluded!=null?'&excluded='+options.excluded:'')+
''+(options.current!=null?'&current='+options.current:'')+
''+(options.finished!=null?'&finished='+options.finished:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: booking_show
*	All: -
*/
public ds_cm_Booking_retrieveById(booking_id : number, mode:Mode=Mode.Entity) : Observable<BookingDTO> {
let url = '/DS/CM/Booking/'+booking_id+'';
return <Observable<BookingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Booking_setMediumGroupPlanningPreview(planning_id : number, medium_group_id : number, bookingDTO : BookingDTO[], options: {overrideAssigned? : boolean,
overrideExcluded? : boolean,
overrideDeprecated? : boolean,
excludeNotAssigned? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Booking/Planning/'+planning_id+'/Preview/SetMediumGroup/'+medium_group_id+'?'+(options.overrideAssigned!=null?'&overrideAssigned='+options.overrideAssigned:'')+
''+(options.overrideExcluded!=null?'&overrideExcluded='+options.overrideExcluded:'')+
''+(options.overrideDeprecated!=null?'&overrideDeprecated='+options.overrideDeprecated:'')+
''+(options.excludeNotAssigned!=null?'&excludeNotAssigned='+options.excludeNotAssigned:'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Booking_setMediumGroupPreview(medium_group_id : number, bookingDTO : BookingDTO[], options: {overrideAssigned? : boolean,
overrideExcluded? : boolean,
overrideDeprecated? : boolean,
excludeNotAssigned? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Booking/Preview/SetMediumGroup/'+medium_group_id+'?'+(options.overrideAssigned!=null?'&overrideAssigned='+options.overrideAssigned:'')+
''+(options.overrideExcluded!=null?'&overrideExcluded='+options.overrideExcluded:'')+
''+(options.overrideDeprecated!=null?'&overrideDeprecated='+options.overrideDeprecated:'')+
''+(options.excludeNotAssigned!=null?'&excludeNotAssigned='+options.excludeNotAssigned:'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Booking_setMediumPlanningPreview(planning_id : number, medium_id : number, bookingDTO : BookingDTO[], options: {overrideAssigned? : boolean,
overrideExcluded? : boolean,
overrideDeprecated? : boolean,
excludeNotAssigned? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Booking/Planning/'+planning_id+'/Preview/SetMedium/'+medium_id+'?'+(options.overrideAssigned!=null?'&overrideAssigned='+options.overrideAssigned:'')+
''+(options.overrideExcluded!=null?'&overrideExcluded='+options.overrideExcluded:'')+
''+(options.overrideDeprecated!=null?'&overrideDeprecated='+options.overrideDeprecated:'')+
''+(options.excludeNotAssigned!=null?'&excludeNotAssigned='+options.excludeNotAssigned:'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Booking_setMediumPreview(medium_id : number, bookingDTO : BookingDTO[], options: {overrideAssigned? : boolean,
overrideExcluded? : boolean,
overrideDeprecated? : boolean,
excludeNotAssigned? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Booking/Preview/SetMedium/'+medium_id+'?'+(options.overrideAssigned!=null?'&overrideAssigned='+options.overrideAssigned:'')+
''+(options.overrideExcluded!=null?'&overrideExcluded='+options.overrideExcluded:'')+
''+(options.overrideDeprecated!=null?'&overrideDeprecated='+options.overrideDeprecated:'')+
''+(options.excludeNotAssigned!=null?'&excludeNotAssigned='+options.excludeNotAssigned:'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, bookingDTO));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Budget:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_create
*	All: -
*/
public ds_cm_Budget_createBudget(budgetDTO : BudgetDTO, mode:Mode=Mode.Entity) : Observable<BudgetDTO> {
let url = '/DS/CM/Budget';
return <Observable<BudgetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, budgetDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_planning_create
*	All: -
*/
public ds_cm_Budget_createBudgetPlanning(planning_id : number, budgetDTO : BudgetDTO, mode:Mode=Mode.Entity) : Observable<BudgetDTO> {
let url = '/DS/CM/Budget//planning/'+planning_id+'';
return <Observable<BudgetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, budgetDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_delete
*	All: -
*/
public ds_cm_Budget_deleteBudget(budget_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Budget/'+budget_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_edit
*	All: -
*/
public ds_cm_Budget_editBudget(budgetDTO : BudgetDTO, mode:Mode=Mode.Entity) : Observable<BudgetDTO> {
let url = '/DS/CM/Budget';
return <Observable<BudgetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, budgetDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_planning_edit
*	All: -
*/
public ds_cm_Budget_editBudgetPlanning(planning_id : number, budgetDTO : BudgetDTO, mode:Mode=Mode.Entity) : Observable<BudgetDTO> {
let url = '/DS/CM/Budget//planning/'+planning_id+'';
return <Observable<BudgetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, budgetDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_list
*	All: -
*/
public ds_cm_Budget_retrieveAll(options: {company_id? : number[],
budget_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<BudgetDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Budget?'+(options.company_id!=null?''+this.api.queryParamArrayPrepare('company_id',options.company_id):'')+
''+(options.budget_id!=null?''+this.api.queryParamArrayPrepare('budget_id',options.budget_id):'')+
'';
return <Observable<BudgetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: budget_show
*	All: -
*/
public ds_cm_Budget_retrieveOne(budget_id : number, mode:Mode=Mode.Entity) : Observable<BudgetDTO> {
let url = '/DS/CM/Budget/'+budget_id+'';
return <Observable<BudgetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Campaign:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_create
*	All: -
*/
public ds_cm_Campaign_createCampaign(company_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Company/'+company_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCampaignOverwritePlanning(planning_id : number, overwrite_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Planning/'+planning_id+'/Overwrite/'+overwrite_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCampaignOverwritePlanningPreview(planning_id : number, overwrite_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Planning/'+planning_id+'/Overwrites/'+overwrite_id+'/Preview';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCampaignPlanning(planning_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Planning/'+planning_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCampaignPlanningPreview(planning_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Planning/'+planning_id+'/Preview';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_create
*	All: -
*/
public ds_cm_Campaign_createCampaignPreview(company_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Company/'+company_id+'/Preview';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Campaign_createCommercial(campaign_id : number, commercialFullDTO : CommercialFullDTO, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO> {
let url = '/DS/CM/Campaign/'+campaign_id+'/Commercials';
return <Observable<CommercialFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCommercialPlanning(campaign_id : number, planning_id : number, commercialFullDTO : CommercialFullDTO, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO> {
let url = '/DS/CM/Campaign/'+campaign_id+'/Commercials/Planning/'+planning_id+'';
return <Observable<CommercialFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCommercialPlanningOverwrite(planning_id : number, overwrite_id : number, commercialFullDTO : CommercialFullDTO, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO> {
let url = '/DS/CM/Campaign/Commercials/Planning/'+planning_id+'/Overwrite/'+overwrite_id+'';
return <Observable<CommercialFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCommercialPlanningOverwritePreview(planning_id : number, overwrite_id : number, commercialFullDTO : CommercialFullDTO, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO> {
let url = '/DS/CM/Campaign/Commercials/Planning/'+planning_id+'/Overwrite/'+overwrite_id+'/Preview';
return <Observable<CommercialFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_createCommercialPlanningPreview(campaign_id : number, planning_id : number, commercialFullDTO : CommercialFullDTO, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO> {
let url = '/DS/CM/Campaign/'+campaign_id+'/Commercials/Planning/'+planning_id+'/Preview';
return <Observable<CommercialFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Campaign_createCommercialPreview(campaign_id : number, commercialFullDTO : CommercialFullDTO, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO> {
let url = '/DS/CM/Campaign/'+campaign_id+'/Commercials/Preview';
return <Observable<CommercialFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_create
*	All: -
*/
public ds_cm_Campaign_createLevel(company_id : number, campaignLevelDTO : CampaignLevelDTO, mode:Mode=Mode.Entity) : Observable<CampaignLevelDTO> {
let url = '/DS/CM/Campaign/Level/'+company_id+'';
return <Observable<CampaignLevelDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignLevelDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_create
*	All: -
*/
public ds_cm_Campaign_createLevels(company_id : number, campaignLevelDTO : CampaignLevelDTO[], mode:Mode=Mode.Entity) : Observable<CampaignLevelDTO[]> {
let url = '/DS/CM/Campaign/Level/'+company_id+'/Mass';
return <Observable<CampaignLevelDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, campaignLevelDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_delete
*	All: -
*/
public ds_cm_Campaign_deleteById(campaign_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Campaign/'+campaign_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_deleteByIdInPlanning(campaign_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/'+planning_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_delete
*	All: -
*/
public ds_cm_Campaign_deleteLevelById(company_id : number, level : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Campaign/Level/'+company_id+'/'+level+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Campaign_editCampaign(campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_editCampaignPlanning(planning_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Planning/'+planning_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Campaign_editCampaignPlanningPreview(planning_id : number, campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Planning/'+planning_id+'/Preview';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Campaign_editCampaignPreview(campaignDTO : CampaignDTO, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Preview';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_edit
*	All: -
*/
public ds_cm_Campaign_editLevel(company_id : number, campaignLevelDTO : CampaignLevelDTO, mode:Mode=Mode.Entity) : Observable<CampaignLevelDTO> {
let url = '/DS/CM/Campaign/Level/'+company_id+'';
return <Observable<CampaignLevelDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignLevelDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_edit
*	All: -
*/
public ds_cm_Campaign_editLevels(company_id : number, campaignLevelDTO : CampaignLevelDTO[], mode:Mode=Mode.Entity) : Observable<CampaignLevelDTO[]> {
let url = '/DS/CM/Campaign/Level/'+company_id+'/Mass';
return <Observable<CampaignLevelDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, campaignLevelDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_report
*	All: -
*/
public ds_cm_Campaign_report(options: {reportName? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
customer? : number[],
campaign? : number[],
commercial? : number[],
requirement? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ReportingFullDTO> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Report?'+(options.reportName!=null?'&reportName='+options.reportName:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.customer!=null?''+this.api.queryParamArrayPrepare('customer',options.customer):'')+
''+(options.campaign!=null?''+this.api.queryParamArrayPrepare('campaign',options.campaign):'')+
''+(options.commercial!=null?''+this.api.queryParamArrayPrepare('commercial',options.commercial):'')+
''+(options.requirement!=null?''+this.api.queryParamArrayPrepare('requirement',options.requirement):'')+
'';
return <Observable<ReportingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_list
*	All: -
*/
public ds_cm_Campaign_retrieveAll(options: {id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
assignedTargeting? : number[],
order? : {by: ds_cm_Campaign_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CampaignDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_list
*	All: -
*/
public ds_cm_Campaign_retrieveAllFrontendEnhanced(options: {id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
maxMediaCount? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
assignedTargeting? : number[],
order? : {by: ds_cm_Campaign_retrieveAllFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/FrontendEnhanced?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CampaignWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveAllInPlanning(planning_id : number, options: {id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
assignedTargeting? : number[],
order? : {by: ds_cm_Campaign_retrieveAllInPlanning_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Planning/'+planning_id+'?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CampaignDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveAllInPlanningFrontendEnhanced(planning_id : number, options: {id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
maxMediaCount? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
assignedTargeting? : number[],
order? : {by: ds_cm_Campaign_retrieveAllInPlanningFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Planning/'+planning_id+'/FrontendEnhanced?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CampaignWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Campaign_retrieveById(campaign_id : number, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/'+campaign_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Campaign_retrieveByIdentifier(campaign_identifier : string, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Identifier/'+encodeURIComponent(campaign_identifier)+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveByIdentifierInPlanning(campaign_identifier : string, planning_id : number, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/Identifier/'+encodeURIComponent(campaign_identifier)+'/Planning/'+planning_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Campaign_retrieveByIdFrontendEnhanced(campaign_id : number, options: {maxMediaCount? : number} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignWithPreviewDTO> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
'';
return <Observable<CampaignWithPreviewDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveByIdInPlanning(campaign_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<CampaignDTO> {
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/'+planning_id+'';
return <Observable<CampaignDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveByIdInPlanningFrontendEnhanced(campaign_id : number, planning_id : number, options: {maxMediaCount? : number} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CampaignWithPreviewDTO> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/'+planning_id+'/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
'';
return <Observable<CampaignWithPreviewDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Campaign_retrieveCommercialsByCampaignId(campaign_id : number, options: {id? : number[],
identifier? : string[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Campaign_retrieveCommercialsByCampaignId_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Commercials?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced(campaign_id : number, options: {maxMediaCount? : number,
id? : number[],
identifier? : string[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Commercials/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveCommercialsInPlanningByCampaignId(campaign_id : number, planning_id : number, options: {id? : number[],
identifier? : string[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Campaign_retrieveCommercialsInPlanningByCampaignId_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/'+planning_id+'/Commercials?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveCommercialsInPlanningByCampaignIdFrontendEnhanced(campaign_id : number, planning_id : number, options: {maxMediaCount? : number,
id? : number[],
identifier? : string[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Campaign_retrieveCommercialsInPlanningByCampaignIdFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/'+planning_id+'/Commercials/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveCommercialsInPlanningSubmissionByCampaignId(campaign_id : number, submission_id : number, options: {id? : number[],
identifier? : string[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Campaign_retrieveCommercialsInPlanningSubmissionByCampaignId_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/Submission/'+submission_id+'/Commercials?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Campaign_retrieveCommercialsInPlanningSubmissionByCampaignIdFrontendEnhanced(campaign_id : number, submission_id : number, options: {maxMediaCount? : number,
id? : number[],
identifier? : string[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Campaign_retrieveCommercialsInPlanningSubmissionByCampaignIdFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/'+campaign_id+'/Planning/Submission/'+submission_id+'/Commercials/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_show
*	All: -
*/
public ds_cm_Campaign_retrieveLevelById(company_id : number, level : number, mode:Mode=Mode.Entity) : Observable<CampaignLevelDTO> {
let url = '/DS/CM/Campaign/Level/'+company_id+'/'+level+'';
return <Observable<CampaignLevelDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_level_list
*	All: -
*/
public ds_cm_Campaign_retrieveLevels(company_id : number, mode:Mode=Mode.Entity) : Observable<CampaignLevelDTO[]> {
let url = '/DS/CM/Campaign/Level/'+company_id+'';
return <Observable<CampaignLevelDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.CM:
// Methods implemented by de.seatback.adplacer.api.ds.cm.Commercial:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Commercial_createRequirement(commercial_id : number, requirementFullDTO : RequirementFullDTO, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO> {
let url = '/DS/CM/Commercial/'+commercial_id+'/Requirements';
return <Observable<RequirementFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, requirementFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_createRequirementPlanning(commercial_id : number, planning_id : number, requirementFullDTO : RequirementFullDTO, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO> {
let url = '/DS/CM/Commercial/'+commercial_id+'/Requirements/Planning/'+planning_id+'';
return <Observable<RequirementFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, requirementFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_createRequirementPlanningOverwrite(planning_id : number, overwrite_id : number, requirementFullDTO : RequirementFullDTO, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO> {
let url = '/DS/CM/Commercial/Requirements/Planning/'+planning_id+'/Overwrite/'+overwrite_id+'';
return <Observable<RequirementFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, requirementFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_createRequirementPlanningOverwritePreview(planning_id : number, overwrite_id : number, requirementFullDTO : RequirementFullDTO, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO> {
let url = '/DS/CM/Commercial/Requirements/Planning/'+planning_id+'/Overwrite/'+overwrite_id+'/Preview';
return <Observable<RequirementFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, requirementFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_createRequirementPlanningPreview(commercial_id : number, planning_id : number, requirementFullDTO : RequirementFullDTO, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO> {
let url = '/DS/CM/Commercial/'+commercial_id+'/Requirements/Planning/'+planning_id+'/Preview';
return <Observable<RequirementFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, requirementFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Commercial_createRequirementPreview(commercial_id : number, requirementFullDTO : RequirementFullDTO, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO> {
let url = '/DS/CM/Commercial/'+commercial_id+'/Requirements/Preview';
return <Observable<RequirementFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, requirementFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_delete
*	All: -
*/
public ds_cm_Commercial_deleteById(commercial_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Commercial/'+commercial_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_deleteByIdInPlanning(commercial_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Commercial/'+commercial_id+'/Planning/'+planning_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Commercial_editCommercial(commercialDTO : CommercialDTO, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, commercialDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_editCommercialPlanning(planning_id : number, commercialDTO : CommercialDTO, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/Planning/'+planning_id+'';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, commercialDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Commercial_editCommercialPlanningPreview(planning_id : number, commercialDTO : CommercialDTO, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/Planning/'+planning_id+'/Preview';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, commercialDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Commercial_editCommercialPreview(commercialDTO : CommercialDTO, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/Preview';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, commercialDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveAll(options: {id? : number[],
identifier? : string[],
campaign_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Commercial_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Commercial?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.campaign_id!=null?''+this.api.queryParamArrayPrepare('campaign_id',options.campaign_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveAllFrontendEnhanced(options: {maxMediaCount? : number,
id? : number[],
identifier? : string[],
campaign_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Commercial_retrieveAllFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Commercial/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.campaign_id!=null?''+this.api.queryParamArrayPrepare('campaign_id',options.campaign_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveAllInPlanning(planning_id : number, options: {id? : number[],
identifier? : string[],
campaign_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Commercial_retrieveAllInPlanning_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Commercial/Planning/'+planning_id+'?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.campaign_id!=null?''+this.api.queryParamArrayPrepare('campaign_id',options.campaign_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveAllInPlanningFrontendEnhanced(planning_id : number, options: {maxMediaCount? : number,
id? : number[],
identifier? : string[],
campaign_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Commercial_retrieveAllInPlanningFrontendEnhanced_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Commercial/Plannin/'+planning_id+'/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.campaign_id!=null?''+this.api.queryParamArrayPrepare('campaign_id',options.campaign_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CommercialWithPreviewDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveById(commercial_id : number, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/'+commercial_id+'';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveByIdentifier(commercial_identifier : string, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/Identifier/'+encodeURIComponent(commercial_identifier)+'';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Commercial_retrieveByIdentifierInPlanning(commercial_identifier : string, planning_id : number, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/Identifier/'+encodeURIComponent(commercial_identifier)+'/Planning/'+planning_id+'';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveByIdFrontendEnhanced(commercial_id : number, options: {maxMediaCount? : number} = {}, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO> {
if(!options)
options={};
let url = '/DS/CM/Commercial/'+commercial_id+'/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
'';
return <Observable<CommercialWithPreviewDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Commercial_retrieveByIdInPlanning(commercial_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<CommercialDTO> {
let url = '/DS/CM/Commercial/'+commercial_id+'/Planning/'+planning_id+'';
return <Observable<CommercialDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Commercial_retrieveByIdInPlanningFrontendEnhanced(commercial_id : number, planning_id : number, options: {maxMediaCount? : number} = {}, mode:Mode=Mode.Entity) : Observable<CommercialWithPreviewDTO> {
if(!options)
options={};
let url = '/DS/CM/Commercial/'+commercial_id+'/Planning/'+planning_id+'/FrontendEnhanced?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
'';
return <Observable<CommercialWithPreviewDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Commercial_retrieveRequirements(commercial_id : number, options: {id? : number[],
identifier? : string[],
search? : string,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Commercial_retrieveRequirements_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Commercial/'+commercial_id+'/Requirements?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<RequirementFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Commercial_retrieveRequirementsInPlanningByCommercialId(commercial_id : number, planning_id : number, options: {id? : number[],
identifier? : string[],
search? : string,
incomplete? : boolean,
playerCullSet? : number,
timeCullSet? : number,
geoCullSet? : number,
status? : BookingStatus[],
contentCull? : number[],
order? : {by: ds_cm_Commercial_retrieveRequirementsInPlanningByCommercialId_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<RequirementFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Commercial/'+commercial_id+'/Planning/'+planning_id+'/Requirements?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.playerCullSet!=null?'&playerCullSet='+options.playerCullSet:'')+
''+(options.timeCullSet!=null?'&timeCullSet='+options.timeCullSet:'')+
''+(options.geoCullSet!=null?'&geoCullSet='+options.geoCullSet:'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<RequirementFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Commercial_setPriority(commercialDTO : CommercialDTO[], mode:Mode=Mode.Entity) : Observable<CommercialDTO[]> {
let url = '/DS/CM/Commercial/Priority';
return <Observable<CommercialDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, commercialDTO));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.ContentShare:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_create
*	All: -
*/
public ds_cm_ContentShare_createContentShare(contentShareFullDTO : ContentShareFullDTO, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentShareFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_ContentShare_createContentShareInPlanning(planning_id : number, contentShareFullDTO : ContentShareFullDTO, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare/Planning/'+planning_id+'';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentShareFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_ContentShare_createContentShareOverwriteInPlanning(planning_id : number, overwrite_id : number, contentShareFullDTO : ContentShareFullDTO, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare/Planning/'+planning_id+'/Overwrite/'+overwrite_id+'';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contentShareFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_delete
*	All: -
*/
public ds_cm_ContentShare_deleteById(content_share_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/ContentShare/'+content_share_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_ContentShare_deleteByIdInPlanning(content_share_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/ContentShare/'+content_share_id+'/Planning/'+planning_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_edit
*	All: -
*/
public ds_cm_ContentShare_editContentShare(contentShareFullDTO : ContentShareFullDTO, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, contentShareFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_ContentShare_editContentShareInPlanning(planning_id : number, contentShareFullDTO : ContentShareFullDTO, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare/Planning/'+planning_id+'';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, contentShareFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_list
*	All: -
*/
public ds_cm_ContentShare_retrieveAll(options: {id? : number[],
precondition? : number[],
planning_id? : number,
planning_submission_id? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
order? : {by: ds_cm_ContentShare_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/ContentShare?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?''+this.api.queryParamArrayPrepare('precondition',options.precondition):'')+
''+(options.planning_id!=null?'&planning_id='+options.planning_id:'')+
''+(options.planning_submission_id!=null?'&planning_submission_id='+options.planning_submission_id:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ContentShareFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_ContentShare_retrieveAllInPlanning(planning_id : number, options: {planning_submission_id? : number,
precondition? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
order? : {by: ds_cm_ContentShare_retrieveAllInPlanning_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/ContentShare/Planning/'+planning_id+'?'+(options.planning_submission_id!=null?'&planning_submission_id='+options.planning_submission_id:'')+
''+(options.precondition!=null?''+this.api.queryParamArrayPrepare('precondition',options.precondition):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ContentShareFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_show
*	All: -
*/
public ds_cm_ContentShare_retrieveById(content_share_id : number, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare/'+content_share_id+'';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_ContentShare_retrieveByIdInPlanning(content_share_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO> {
let url = '/DS/CM/ContentShare/'+content_share_id+'/Planning/'+planning_id+'';
return <Observable<ContentShareFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_list
*	All: -
*/
public ds_cm_ContentShare_retrieveHierarchy(options: {id? : number[],
precondition? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
order? : {by: ds_cm_ContentShare_retrieveHierarchy_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/ContentShare/Hierarchy?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?'&precondition='+options.precondition:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ContentShareFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_list
*	All: -
*/
public ds_cm_ContentShare_retrieveHierarchyInPlanning(planning_id : number, options: {planning_submission_id? : number,
id? : number[],
precondition? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
order? : {by: ds_cm_ContentShare_retrieveHierarchyInPlanning_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ContentShareFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/ContentShare/Hierarchy/Planning/'+planning_id+'?'+(options.planning_submission_id!=null?'&planning_submission_id='+options.planning_submission_id:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?'&precondition='+options.precondition:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ContentShareFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_share_show
*	All: -
*/
public ds_cm_ContentShare_retrieveSlotsById(content_share_id : number, mode:Mode=Mode.Entity) : Observable<ContentShareQuotaFullDTO[]> {
let url = '/DS/CM/ContentShare/'+content_share_id+'/Slots';
return <Observable<ContentShareQuotaFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Planning:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_accept
*	All: -
*/
public ds_cm_Planning_acceptById(planning_id : number, submission_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Planning/'+planning_id+'/Submission/'+submission_id+'/Accept';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_create
*	All: -
*/
public ds_cm_Planning_createPlanning(planningDTO : PlanningDTO, mode:Mode=Mode.Entity) : Observable<PlanningDTO> {
let url = '/DS/CM/Planning';
return <Observable<PlanningDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, planningDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_create
*	All: -
*/
public ds_cm_Planning_createPlanningForCustomer(company_id : number, planningDTO : PlanningDTO, mode:Mode=Mode.Entity) : Observable<PlanningDTO> {
let url = '/DS/CM/Planning/Company/'+company_id+'';
return <Observable<PlanningDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, planningDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_delete
*	All: -
*/
public ds_cm_Planning_deleteById(planning_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Planning/'+planning_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Planning_editPlanning(planningDTO : PlanningDTO, mode:Mode=Mode.Entity) : Observable<PlanningDTO> {
let url = '/DS/CM/Planning';
return <Observable<PlanningDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, planningDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_list
*	All: -
*/
public ds_cm_Planning_retrieveAll(options: {id? : number[],
company? : number[],
search? : string,
order? : {by: ds_cm_Planning_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PlanningDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Planning?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PlanningDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Planning_retrieveById(planning_id : number, mode:Mode=Mode.Entity) : Observable<PlanningDTO> {
let url = '/DS/CM/Planning/'+planning_id+'';
return <Observable<PlanningDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_submit
*	All: -
*/
public ds_cm_Planning_submissionsByCompany(company_id : number, mode:Mode=Mode.Entity) : Observable<PlanningSubmissionDTO[]> {
let url = '/DS/CM/Planning/Submission/Company/'+company_id+'';
return <Observable<PlanningSubmissionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_submit
*	All: -
*/
public ds_cm_Planning_submitById(planning_id : number, options: {name? : string,
description? : string,
forCustomer? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
campaign? : number[],
commercial? : number[],
requirement? : number[],
contentShares? : number[],
includeContentShareSubtree? : boolean,
deleteOtherPlannings? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<PlanningSubmissionDTO> {
if(!options)
options={};
let url = '/DS/CM/Planning/'+planning_id+'/Submission?'+(options.name!=null?'&name='+options.name:'')+
''+(options.description!=null?'&description='+options.description:'')+
''+(options.forCustomer!=null?'&forCustomer='+options.forCustomer:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.campaign!=null?''+this.api.queryParamArrayPrepare('campaign',options.campaign):'')+
''+(options.commercial!=null?''+this.api.queryParamArrayPrepare('commercial',options.commercial):'')+
''+(options.requirement!=null?''+this.api.queryParamArrayPrepare('requirement',options.requirement):'')+
''+(options.contentShares!=null?''+this.api.queryParamArrayPrepare('contentShares',options.contentShares):'')+
''+(options.includeContentShareSubtree!=null?'&includeContentShareSubtree='+options.includeContentShareSubtree:'')+
''+(options.deleteOtherPlannings!=null?'&deleteOtherPlannings='+options.deleteOtherPlannings:'')+
'';
return <Observable<PlanningSubmissionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_submit
*	All: -
*/
public ds_cm_Planning_withdrawSubmissionById(planning_id : number, submission_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Planning/'+planning_id+'/Submission/'+submission_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_submit
*	All: -
*/
public ds_cm_Planning_withdrawSubmissionsByPlanning(planning_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Planning/'+planning_id+'/Submission';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Reporting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_bookingsReport(options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
assignedTargeting? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Booking?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_bookingsReportGroupedBy(groupedBy : string, options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Booking/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_campaignReport(options: {from? : SbLocalDate,
till? : SbLocalDate,
publisher? : number[],
customer? : number[],
campaign? : number[],
campaignType? : number[],
commercial? : number[],
requirement? : number[],
booking? : number[],
medium? : number[],
mediumGroup? : number[],
product? : number[],
productCategory? : number[],
playerCull? : number[],
assignedTargeting? : number[],
playerCullIntersection? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<CampaignReportDTO> {
if(!options)
options={};
let url = '/DS/CM/Reporting/CampaignReport?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.publisher!=null?''+this.api.queryParamArrayPrepare('publisher',options.publisher):'')+
''+(options.customer!=null?''+this.api.queryParamArrayPrepare('customer',options.customer):'')+
''+(options.campaign!=null?''+this.api.queryParamArrayPrepare('campaign',options.campaign):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.commercial!=null?''+this.api.queryParamArrayPrepare('commercial',options.commercial):'')+
''+(options.requirement!=null?''+this.api.queryParamArrayPrepare('requirement',options.requirement):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.mediumGroup!=null?''+this.api.queryParamArrayPrepare('mediumGroup',options.mediumGroup):'')+
''+(options.product!=null?''+this.api.queryParamArrayPrepare('product',options.product):'')+
''+(options.productCategory!=null?''+this.api.queryParamArrayPrepare('productCategory',options.productCategory):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
'';
return <Observable<CampaignReportDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_campaignReportElementCountByType(type : string, options: {id? : number[],
elementType? : string[],
productive? : boolean,
from? : SbLocalDate,
till? : SbLocalDate} = {}, mode:Mode=Mode.Entity) : Observable<CampaignReportElementCountDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Reporting/CampaignReport/'+encodeURIComponent(type)+'/ElementCount?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.elementType!=null?''+this.api.queryParamArrayPrepare('elementType',options.elementType):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'';
return <Observable<CampaignReportElementCountDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_campaignsReport(options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCull? : number[],
assignedTargeting? : number[],
playerCullIntersection? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Campaign?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_campaignsReportGroupedBy(groupedBy : string, options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCull? : number[],
assignedTargeting? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Campaign/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_commercialsReport(options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
assignedTargeting? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Commercial?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_commercialsReportGroupedBy(groupedBy : string, options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Commercial/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_requirementsReport(options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
assignedTargeting? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Requirement?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ds_cm_reporting
*	All: -
*/
public ds_cm_Reporting_requirementsReportGroupedBy(groupedBy : string, options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/DS/CM/Reporting/Requirement/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_cm_Reporting_retrieveShareOfVoice(options: {from? : SbLocalDate,
till? : SbLocalDate,
productive? : boolean,
playerCull? : number} = {}, mode:Mode=Mode.Entity) : Observable<AdvertiserShareOfVoiceDTO> {
if(!options)
options={};
let url = '/DS/CM/Reporting/SoV?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.playerCull!=null?'&playerCull='+options.playerCull:'')+
'';
return <Observable<AdvertiserShareOfVoiceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Requirement:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Requirement_createManualBookingsForRequirement(requirement_id : number, markerDTO : MarkerDTO[], mode:Mode=Mode.Entity) : Observable<BookingRecalculationDTO> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Bookings/Manual';
return <Observable<BookingRecalculationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, markerDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Requirement_createManualBookingsForRequirementPlanning(requirement_id : number, planning_id : number, markerDTO : MarkerDTO[], mode:Mode=Mode.Entity) : Observable<BookingRecalculationDTO> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Bookings/Planning/'+planning_id+'/Manual';
return <Observable<BookingRecalculationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, markerDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_delete
*	All: -
*/
public ds_cm_Requirement_deleteById(requirement_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Requirement/'+requirement_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Requirement_deleteByIdInPlanning(requirement_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Planning/'+planning_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Requirement_editRequirement(requirementDTO : RequirementDTO, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, requirementDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Requirement_editRequirementPlanning(planning_id : number, requirementDTO : RequirementDTO, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/Planning/'+planning_id+'';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, requirementDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Requirement_editRequirementPlanningPreview(planning_id : number, requirementDTO : RequirementDTO, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/Planning/'+planning_id+'/Preview';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, requirementDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Requirement_editRequirementPreview(requirementDTO : RequirementDTO, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/Preview';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, requirementDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Requirement_retrieveBookings(requirement_id : number, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Bookings';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Requirement_retrieveBookingsInPlanning(requirement_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Planning/'+planning_id+'/Bookings';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Requirement_retrieveById(requirement_id : number, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/'+requirement_id+'';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public ds_cm_Requirement_retrieveByIdentifier(requirement_identifier : string, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/Identifier/'+encodeURIComponent(requirement_identifier)+'';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Requirement_retrieveByIdentifierInPlanning(requirement_identifier : string, planning_id : number, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/Identifier/'+encodeURIComponent(requirement_identifier)+'/Planning/'+planning_id+'';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_show
*	All: -
*/
public ds_cm_Requirement_retrieveByIdInPlanning(requirement_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<RequirementDTO> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Planning/'+planning_id+'';
return <Observable<RequirementDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Requirement_retrieveNonBookedMarkers(requirement_id : number, options: {search? : string,
order? : {by: ds_cm_Requirement_retrieveNonBookedMarkers_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MarkerFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Requirement/'+requirement_id+'/NonBookedMarker?'+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<MarkerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Requirement_retrieveNonBookedMarkersPlanning(requirement_id : number, planning_id : number, options: {search? : string,
order? : {by: ds_cm_Requirement_retrieveNonBookedMarkersPlanning_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MarkerFullDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Requirement/'+requirement_id+'/Planning/'+planning_id+'/NonBookedMarker?'+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<MarkerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_edit
*	All: -
*/
public ds_cm_Requirement_triggerRecalculateBookings(requirement_id : number, mode:Mode=Mode.Entity) : Observable<BookingRecalculationDTO> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Bookings';
return <Observable<BookingRecalculationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_edit
*	All: -
*/
public ds_cm_Requirement_triggerRecalculateBookingsPlanning(requirement_id : number, planning_id : number, mode:Mode=Mode.Entity) : Observable<BookingRecalculationDTO> {
let url = '/DS/CM/Requirement/'+requirement_id+'/Bookings/Planning/'+planning_id+'';
return <Observable<BookingRecalculationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.ScheduledCampaign:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_list
*	All: -
*/
public ds_cm_ScheduledCampaign_retrieveAll(options: {maxMediaCount? : number,
dropCommercials? : boolean,
dropRequirements? : boolean,
dropBooking? : boolean,
id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
planning? : number,
planningSubmission? : number,
assignedTargeting? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
order? : {by: ds_cm_ScheduledCampaign_retrieveAll_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ScheduledCampaignDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Scheduled?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.dropCommercials!=null?'&dropCommercials='+options.dropCommercials:'')+
''+(options.dropRequirements!=null?'&dropRequirements='+options.dropRequirements:'')+
''+(options.dropBooking!=null?'&dropBooking='+options.dropBooking:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.planningSubmission!=null?'&planningSubmission='+options.planningSubmission:'')+
''+(options.assignedTargeting!=null?''+this.api.queryParamArrayPrepare('assignedTargeting',options.assignedTargeting):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ScheduledCampaignDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_list
*	All: -
*/
public ds_cm_ScheduledCampaign_retrieveAllBookingsBelowRequirement(requirement_id : number, options: {maxMediaCount? : number,
id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
planning? : number,
planningSubmission? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
order? : {by: ds_cm_ScheduledCampaign_retrieveAllBookingsBelowRequirement_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ScheduledBookingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Scheduled/Commercial/Requirement/'+requirement_id+'/Booking?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.planningSubmission!=null?'&planningSubmission='+options.planningSubmission:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ScheduledBookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_list
*	All: -
*/
public ds_cm_ScheduledCampaign_retrieveAllCommercialsBelowCampaign(campaign_id : number, options: {maxMediaCount? : number,
dropRequirements? : boolean,
dropBooking? : boolean,
id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
planning? : number,
planningSubmission? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
order? : {by: ds_cm_ScheduledCampaign_retrieveAllCommercialsBelowCampaign_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ScheduledCommercialDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Scheduled/'+campaign_id+'/Commercial?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.dropRequirements!=null?'&dropRequirements='+options.dropRequirements:'')+
''+(options.dropBooking!=null?'&dropBooking='+options.dropBooking:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.planningSubmission!=null?'&planningSubmission='+options.planningSubmission:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ScheduledCommercialDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_list
*	All: -
*/
public ds_cm_ScheduledCampaign_retrieveAllRequirementsBelowCommercial(commercial_id : number, options: {maxMediaCount? : number,
dropBooking? : boolean,
id? : number[],
identifier? : string[],
company? : number[],
campaignType? : number[],
planning? : number,
planningSubmission? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
incomplete? : boolean,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
order? : {by: ds_cm_ScheduledCampaign_retrieveAllRequirementsBelowCommercial_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ScheduledRequirementDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Campaign/Scheduled/Commercial/'+commercial_id+'/Requirement?'+(options.maxMediaCount!=null?'&maxMediaCount='+options.maxMediaCount:'')+
''+(options.dropBooking!=null?'&dropBooking='+options.dropBooking:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.campaignType!=null?''+this.api.queryParamArrayPrepare('campaignType',options.campaignType):'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.planningSubmission!=null?'&planningSubmission='+options.planningSubmission:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.incomplete!=null?'&incomplete='+options.incomplete:'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ScheduledRequirementDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.cm.Targeting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_create
*	All: -
*/
public ds_cm_Targeting_createTargeting(targetingDTO : TargetingDTO, mode:Mode=Mode.Entity) : Observable<TargetingDTO> {
let url = '/DS/CM/Targeting';
return <Observable<TargetingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, targetingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_planning_create
*	All: -
*/
public ds_cm_Targeting_createTargetingPlanning(planning_id : number, targetingDTO : TargetingDTO, mode:Mode=Mode.Entity) : Observable<TargetingDTO> {
let url = '/DS/CM/Targeting//planning/'+planning_id+'';
return <Observable<TargetingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, targetingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_delete
*	All: -
*/
public ds_cm_Targeting_deleteTargeting(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/Targeting/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_edit
*	All: -
*/
public ds_cm_Targeting_editTargeting(targetingDTO : TargetingDTO, mode:Mode=Mode.Entity) : Observable<TargetingDTO> {
let url = '/DS/CM/Targeting';
return <Observable<TargetingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, targetingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_planning_edit
*	All: -
*/
public ds_cm_Targeting_editTargetingPlanning(planning_id : number, targetingDTO : TargetingDTO, mode:Mode=Mode.Entity) : Observable<TargetingDTO> {
let url = '/DS/CM/Targeting//planning/'+planning_id+'';
return <Observable<TargetingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, targetingDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_list
*	All: -
*/
public ds_cm_Targeting_retrieveAll(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TargetingDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Targeting?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TargetingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_show
*	All: -
*/
public ds_cm_Targeting_retrieveBucketsByTargetingId(id : number, options: {from? : SbDateTime,
till? : SbDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TargetingBucketDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Targeting/'+id+'/Bucket?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'';
return <Observable<TargetingBucketDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_list
*	All: -
*/
public ds_cm_Targeting_retrieveDiurnalBuckets(from : SbDateTime, till : SbDateTime, options: {company? : number[],
targeting? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<DiurnalBucketDTO[]> {
if(!options)
options={};
let url = '/DS/CM/Targeting/DiurnalBucket/From/'+from+'/Till/'+till+'?'+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.targeting!=null?''+this.api.queryParamArrayPrepare('targeting',options.targeting):'')+
'';
return <Observable<DiurnalBucketDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_show
*	All: -
*/
public ds_cm_Targeting_retrieveDiurnalBucketsByTargetingId(id : number, from : SbDateTime, till : SbDateTime, mode:Mode=Mode.Entity) : Observable<DiurnalBucketDTO[]> {
let url = '/DS/CM/Targeting/'+id+'/DiurnalBucket/From/'+from+'/Till/'+till+'';
return <Observable<DiurnalBucketDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: targeting_show
*	All: -
*/
public ds_cm_Targeting_retrieveOne(id : number, mode:Mode=Mode.Entity) : Observable<TargetingDTO> {
let url = '/DS/CM/Targeting/'+id+'';
return <Observable<TargetingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.DS:
// Methods implemented by de.seatback.adplacer.api.ds.rm.Inventory:

public ds_rm_Inventory_aggregation(filterableInventoryRequestDTO : FilterableInventoryRequestDTO[], options: {screenScope? : ScreenScope} = {}, mode:Mode=Mode.Entity) : Observable<InventoryAggregationDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Aggregation?'+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<InventoryAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, filterableInventoryRequestDTO));
}
public ds_rm_Inventory_calculatePricing(amount : number, options: {screen_id? : number[],
timingRelation? : TimingRelation,
durationPlayout? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<number> {
if(!options)
options={};
let url = '/DS/RM/Inventory/CalculatePricing/'+amount+'?'+(options.screen_id!=null?''+this.api.queryParamArrayPrepare('screen_id',options.screen_id):'')+
''+(options.timingRelation!=null?'&timingRelation='+options.timingRelation:'')+
''+(options.durationPlayout!=null?'&durationPlayout='+options.durationPlayout:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
'&till='+this.api.queryParamDatePrepare(options.till)+'';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_Channels(mode:Mode=Mode.Entity) : Observable<InventoryChannelFullDTO[]> {
let url = '/DS/RM/Inventory/BookableChannel';
return <Observable<InventoryChannelFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_fields(mode:Mode=Mode.Entity) : Observable<InventoryFieldDefinitionDTO[]> {
let url = '/DS/RM/Inventory/Field';
return <Observable<InventoryFieldDefinitionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_filterValues(inventoryFilterValueListRequestDTO : InventoryFilterValueListRequestDTO, options: {search? : string,
screenScope? : ScreenScope} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryFilterValueListResponseDTO> {
if(!options)
options={};
let url = '/DS/RM/Inventory/FilterValue?'+(options.search!=null?'&search='+options.search:'')+
''+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<InventoryFilterValueListResponseDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, inventoryFilterValueListRequestDTO, pagination));
}
public ds_rm_Inventory_geoAggregation(filterableInventoryRequestDTO : FilterableInventoryRequestDTO, options: {min? : Point,
max? : Point,
screenScope? : ScreenScope} = {}, mode:Mode=Mode.Entity) : Observable<InventoryGeoAggregationDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/GeoAggregation?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+
''+(options.max!=null?'&max='+this.api.asString(options.max):'')+
''+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<InventoryGeoAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, filterableInventoryRequestDTO));
}
public ds_rm_Inventory_geoAggregationFrontendEnhanced(maxRenderedElements : number, filterableInventoryRequestDTO : FilterableInventoryRequestDTO, options: {min? : Point,
max? : Point,
screenScope? : ScreenScope} = {}, mode:Mode=Mode.Entity) : Observable<InventoryGeoAggregationFrontendEnhancedDTO> {
if(!options)
options={};
let url = '/DS/RM/Inventory/GeoAggregation/FrontendEnhanced/'+maxRenderedElements+'?'+(options.min!=null?'&min='+this.api.asString(options.min):'')+
''+(options.max!=null?'&max='+this.api.asString(options.max):'')+
''+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<InventoryGeoAggregationFrontendEnhancedDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, filterableInventoryRequestDTO));
}
public ds_rm_Inventory_list(filterableInventoryRequestDTO : FilterableInventoryRequestDTO, options: {screenScope? : ScreenScope} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryElementDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory?'+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<InventoryElementDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, filterableInventoryRequestDTO, pagination));
}
public ds_rm_Inventory_Markers(options: {publisher_id? : number[],
channel_id? : number[],
width? : number[],
height? : number[],
resolution? : Resolution[]} = {}, mode:Mode=Mode.Entity) : Observable<InventoryMarkerFullDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/BookableMarker?'+(options.publisher_id!=null?''+this.api.queryParamArrayPrepare('publisher_id',options.publisher_id):'')+
''+(options.channel_id!=null?''+this.api.queryParamArrayPrepare('channel_id',options.channel_id):'')+
''+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
'';
return <Observable<InventoryMarkerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_Publisher(mode:Mode=Mode.Entity) : Observable<InventoryClientDTO[]> {
let url = '/DS/RM/Inventory/BookablePublisher';
return <Observable<InventoryClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_retrieveAllDevices(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
channel? : number[],
location? : number[],
playerCull? : number[],
playerHardware? : number[],
playerSoftware? : number[],
locationType_id? : number[],
screenHardware_id? : number[],
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ds_rm_Inventory_retrieveAllDevices_filter, param?: string, values: string[]}[],
order? : {by: ds_rm_Inventory_retrieveAllDevices_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryDeviceFullDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Device?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerHardware!=null?''+this.api.queryParamArrayPrepare('playerHardware',options.playerHardware):'')+
''+(options.playerSoftware!=null?''+this.api.queryParamArrayPrepare('playerSoftware',options.playerSoftware):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryDeviceFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_Inventory_retrieveAllLocations(options: {search? : string,
hasPoint? : boolean,
hasDevices? : boolean,
hasManager? : boolean,
locationType_id? : number[],
onlineStatus? : LocationOnlineStatus[],
identifier? : string[],
id? : number[],
playerCull? : number,
filter? : {by: ds_rm_Inventory_retrieveAllLocations_filter, param?: string, values: string[]}[],
order? : {by: ds_rm_Inventory_retrieveAllLocations_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LocationFullDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Location?'+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPoint!=null?'&hasPoint='+options.hasPoint:'')+
''+(options.hasDevices!=null?'&hasDevices='+options.hasDevices:'')+
''+(options.hasManager!=null?'&hasManager='+options.hasManager:'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.playerCull!=null?'&playerCull='+options.playerCull:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<LocationFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_Inventory_retrieveDeviceById(device_id : number, mode:Mode=Mode.Entity) : Observable<InventoryDeviceFullDTO> {
let url = '/DS/RM/Inventory/Device/'+device_id+'';
return <Observable<InventoryDeviceFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_retrieveDeviceFullById(device_id : number, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO> {
let url = '/DS/RM/Inventory/Device/'+device_id+'/Full';
return <Observable<DeviceFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_retrieveLocationById(location_id : number, mode:Mode=Mode.Entity) : Observable<LocationFullDTO> {
let url = '/DS/RM/Inventory/Location/'+location_id+'';
return <Observable<LocationFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_Inventory_search(options: {field? : string[],
limit? : string[],
screenScope? : ScreenScope} = {}, mode:Mode=Mode.Entity) : Observable<DTO> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Search?'+this.api.queryParamArrayPrepare('field',options.field)+this.api.queryParamArrayPrepare('limit',options.limit)+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<DTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.InventoryBlacklist:

public ds_rm_InventoryBlacklist_createScreenBookingBlacklist(screen_id : number, booking_id : number, mode:Mode=Mode.Entity) : Observable<ScreenBlacklistDTO> {
let url = '/DS/RM/Inventory/Blacklist/Screen/'+screen_id+'/Booking/'+booking_id+'';
return <Observable<ScreenBlacklistDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public ds_rm_InventoryBlacklist_deleteScreenBookingBlacklist(screen_id : number, booking_id : number, mode:Mode=Mode.Entity) : Observable<ScreenBlacklistDTO[]> {
let url = '/DS/RM/Inventory/Blacklist/Screen/'+screen_id+'/Booking/'+booking_id+'';
return <Observable<ScreenBlacklistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public ds_rm_InventoryBlacklist_retrieveAllBlacklistedBookings(options: {id? : number[],
advertiser_id? : number[],
publisher_id? : number[],
location_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
media_id? : number[],
timingStatus? : TimingStatus[],
status? : BookingStatus[],
deprecated? : boolean,
finished? : boolean,
contentCull? : number[],
order? : {by: ds_rm_InventoryBlacklist_retrieveAllBlacklistedBookings_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<InventoryBookingDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Blacklist/Booking?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser_id!=null?''+this.api.queryParamArrayPrepare('advertiser_id',options.advertiser_id):'')+
''+(options.publisher_id!=null?''+this.api.queryParamArrayPrepare('publisher_id',options.publisher_id):'')+
''+(options.location_id!=null?''+this.api.queryParamArrayPrepare('location_id',options.location_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.media_id!=null?''+this.api.queryParamArrayPrepare('media_id',options.media_id):'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.deprecated!=null?'&deprecated='+options.deprecated:'')+
''+(options.finished!=null?'&finished='+options.finished:'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryBookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryBlacklist_retrieveAllBlacklists(options: {screens? : number[],
bookings? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ScreenBlacklistDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Blacklist?'+(options.screens!=null?''+this.api.queryParamArrayPrepare('screens',options.screens):'')+
''+(options.bookings!=null?''+this.api.queryParamArrayPrepare('bookings',options.bookings):'')+
'';
return <Observable<ScreenBlacklistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.InventoryBooking:

public ds_rm_InventoryBooking_retrieveAll(options: {id? : number[],
advertiser_id? : number[],
publisher_id? : number[],
location_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
media_id? : number[],
timingStatus? : TimingStatus[],
status? : BookingStatus[],
deprecated? : boolean,
finished? : boolean,
contentCull? : number[],
order? : {by: ds_rm_InventoryBooking_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryBookingDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Booking?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser_id!=null?''+this.api.queryParamArrayPrepare('advertiser_id',options.advertiser_id):'')+
''+(options.publisher_id!=null?''+this.api.queryParamArrayPrepare('publisher_id',options.publisher_id):'')+
''+(options.location_id!=null?''+this.api.queryParamArrayPrepare('location_id',options.location_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.media_id!=null?''+this.api.queryParamArrayPrepare('media_id',options.media_id):'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.deprecated!=null?'&deprecated='+options.deprecated:'')+
''+(options.finished!=null?'&finished='+options.finished:'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryBookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryBooking_retrieveAllAdvertisers(options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: ds_rm_InventoryBooking_retrieveAllAdvertisers_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryClientDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Booking/Advertiser?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryBooking_retrieveAllLocations(options: {id? : number[],
identifier? : string[],
booking_id? : number[],
search? : string,
order? : {by: ds_rm_InventoryBooking_retrieveAllLocations_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryLocationDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Booking/Location?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.booking_id!=null?''+this.api.queryParamArrayPrepare('booking_id',options.booking_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryLocationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryBooking_retrieveAllPublishers(options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: ds_rm_InventoryBooking_retrieveAllPublishers_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<InventoryClientDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Booking/Publisher?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.InventoryPlaylist:

public ds_rm_InventoryPlaylist_retrieveAll(options: {id? : number[],
advertiser_id? : number[],
publisher_id? : number[],
location_id? : number[],
pool_id? : number[],
channel_id? : number[],
marker_id? : number[],
device_id? : number[],
screen_id? : number[],
playerCull? : number[],
from? : SbLocalDateTime,
till? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<SharedPlaylistDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Playlist?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser_id!=null?''+this.api.queryParamArrayPrepare('advertiser_id',options.advertiser_id):'')+
''+(options.publisher_id!=null?''+this.api.queryParamArrayPrepare('publisher_id',options.publisher_id):'')+
''+(options.location_id!=null?''+this.api.queryParamArrayPrepare('location_id',options.location_id):'')+
''+(options.pool_id!=null?''+this.api.queryParamArrayPrepare('pool_id',options.pool_id):'')+
''+(options.channel_id!=null?''+this.api.queryParamArrayPrepare('channel_id',options.channel_id):'')+
''+(options.marker_id!=null?''+this.api.queryParamArrayPrepare('marker_id',options.marker_id):'')+
''+(options.device_id!=null?''+this.api.queryParamArrayPrepare('device_id',options.device_id):'')+
''+(options.screen_id!=null?''+this.api.queryParamArrayPrepare('screen_id',options.screen_id):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'';
return <Observable<SharedPlaylistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryPlaylist_retrieveAllAggregatedByBookedMediumGroup(options: {id? : number[],
advertiser_id? : number[],
publisher_id? : number[],
location_id? : number[],
pool_id? : number[],
channel_id? : number[],
marker_id? : number[],
device_id? : number[],
screen_id? : number[],
playerCull? : number[],
from? : SbLocalDateTime,
till? : SbLocalDateTime} = {}, mode:Mode=Mode.Entity) : Observable<BookedMediumGroupAggregatedPlaylistDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Playlist/Aggregated/BookedMediumGroup?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser_id!=null?''+this.api.queryParamArrayPrepare('advertiser_id',options.advertiser_id):'')+
''+(options.publisher_id!=null?''+this.api.queryParamArrayPrepare('publisher_id',options.publisher_id):'')+
''+(options.location_id!=null?''+this.api.queryParamArrayPrepare('location_id',options.location_id):'')+
''+(options.pool_id!=null?''+this.api.queryParamArrayPrepare('pool_id',options.pool_id):'')+
''+(options.channel_id!=null?''+this.api.queryParamArrayPrepare('channel_id',options.channel_id):'')+
''+(options.marker_id!=null?''+this.api.queryParamArrayPrepare('marker_id',options.marker_id):'')+
''+(options.device_id!=null?''+this.api.queryParamArrayPrepare('device_id',options.device_id):'')+
''+(options.screen_id!=null?''+this.api.queryParamArrayPrepare('screen_id',options.screen_id):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'';
return <Observable<BookedMediumGroupAggregatedPlaylistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.InventoryScreen:

public ds_rm_InventoryScreen_deleteScreenTemplateEntries(options: {ids? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public ds_rm_InventoryScreen_export(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
channel? : number[],
marker? : number[],
location? : number[],
playerCull? : number[],
playerHardware? : number[],
playerSoftware? : number[],
locationType_id? : number[],
screenHardware_id? : number[],
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ds_rm_InventoryScreen_export_filter, param?: string, values: string[]}[],
order? : {by: ds_rm_InventoryScreen_export_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen/Export?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerHardware!=null?''+this.api.queryParamArrayPrepare('playerHardware',options.playerHardware):'')+
''+(options.playerSoftware!=null?''+this.api.queryParamArrayPrepare('playerSoftware',options.playerSoftware):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryScreen_listIds(filterableInventoryRequestDTO : FilterableInventoryRequestDTO, options: {screenScope? : ScreenScope} = {}, mode:Mode=Mode.Entity) : Observable<number[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen/Id?'+(options.screenScope!=null?'&screenScope='+options.screenScope:'')+
'';
return <Observable<number[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, filterableInventoryRequestDTO));
}
public ds_rm_InventoryScreen_playouts(screen_id : number, options: {after_timestamp? : SbDateTime,
after_descriptor? : number,
from? : SbDateTime,
till? : SbDateTime,
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<InventoryPlayoutDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen/'+screen_id+'/Playout?'+(options.after_timestamp!=null?'&after_timestamp='+this.api.queryParamDatePrepare(options.after_timestamp):'')+
''+(options.after_descriptor!=null?'&after_descriptor='+options.after_descriptor:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<InventoryPlayoutDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryScreen_retrieveAll(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
channel? : number[],
location? : number[],
playerCull? : number[],
playerHardware? : number[],
playerSoftware? : number[],
locationType_id? : number[],
screenHardware_id? : number[],
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ds_rm_InventoryScreen_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: ds_rm_InventoryScreen_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ScreenFullDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerHardware!=null?''+this.api.queryParamArrayPrepare('playerHardware',options.playerHardware):'')+
''+(options.playerSoftware!=null?''+this.api.queryParamArrayPrepare('playerSoftware',options.playerSoftware):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ScreenFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryScreen_retrieveById(screen_id : number, mode:Mode=Mode.Entity) : Observable<InventoryScreenFullDTO> {
let url = '/DS/RM/Inventory/Screen/'+screen_id+'';
return <Observable<InventoryScreenFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryScreen_retrieveFullById(screen_id : number, mode:Mode=Mode.Entity) : Observable<ScreenFullDTO> {
let url = '/DS/RM/Inventory/Screen/'+screen_id+'/Full';
return <Observable<ScreenFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryScreen_retrieveTemplateEntries(options: {ids? : number[],
dataSet? : number[],
dataSetEntry? : number[],
group? : number[],
screen_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
isRejected? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryFullDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.dataSet!=null?''+this.api.queryParamArrayPrepare('dataSet',options.dataSet):'')+
''+(options.dataSetEntry!=null?''+this.api.queryParamArrayPrepare('dataSetEntry',options.dataSetEntry):'')+
''+(options.group!=null?''+this.api.queryParamArrayPrepare('group',options.group):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.isRejected!=null?'&isRejected='+options.isRejected:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryScreen_retrieveTemplateEntriesByScreenId(screen_id : number, options: {ids? : number[],
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
isRejected? : boolean,
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Screen/'+screen_id+'/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.isRejected!=null?'&isRejected='+options.isRejected:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.InventoryTemplating:

public ds_rm_InventoryTemplating_pullRejectionFromTemplateScreenEntryByDataSetEntryId(id : number, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/DataSetEntry/'+id+'/Reject';
return <Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public ds_rm_InventoryTemplating_pullRejectionFromTemplateScreenEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/'+id+'/Reject';
return <Observable<TemplateScreenEntryWithDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public ds_rm_InventoryTemplating_rejectTemplateScreenEntryByDataSetEntryId(id : number, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/DataSetEntry/'+id+'/Reject';
return <Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public ds_rm_InventoryTemplating_rejectTemplateScreenEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/'+id+'/Reject';
return <Observable<TemplateScreenEntryWithDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public ds_rm_InventoryTemplating_renderTemplateScreenEntryForMedium(id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<Response> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/'+id+'/Medium/'+medium_id+'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryTemplating_renderTemplateScreenEntryPreviewForMedium(id : number, medium_id : number, options: {progress? : number} = {}, mode:Mode=Mode.Entity) : Observable<Response> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/'+id+'/Medium/'+medium_id+'/Preview/Still?'+(options.progress!=null?'&progress='+options.progress:'')+
'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryTemplating_retrieveManageableTemplateDataSetEntries(options: {ids? : number[],
identifiers? : string[],
screen_ids? : number[],
dataSet_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/DataSetEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.dataSet_ids!=null?''+this.api.queryParamArrayPrepare('dataSet_ids',options.dataSet_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveManageableTemplateDataSetEntriesByScreen(screen_id : number, options: {ids? : number[],
identifiers? : string[],
dataSet_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/'+screen_id+'/TemplateEntry/Manageable/DataSetEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
''+(options.dataSet_ids!=null?''+this.api.queryParamArrayPrepare('dataSet_ids',options.dataSet_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveManageableTemplateDataSetEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/DataSetEntry/'+id+'';
return <Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryTemplating_retrieveManageableTemplateScreenEntries(options: {ids? : number[],
dataSet? : number[],
dataSetEntry? : number[],
group? : number[],
device_ids? : number[],
screen_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
rejected? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.dataSet!=null?''+this.api.queryParamArrayPrepare('dataSet',options.dataSet):'')+
''+(options.dataSetEntry!=null?''+this.api.queryParamArrayPrepare('dataSetEntry',options.dataSetEntry):'')+
''+(options.group!=null?''+this.api.queryParamArrayPrepare('group',options.group):'')+
''+(options.device_ids!=null?''+this.api.queryParamArrayPrepare('device_ids',options.device_ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.rejected!=null?'&rejected='+options.rejected:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryWithDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveManageableTemplateScreenEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Manageable/'+id+'';
return <Observable<TemplateScreenEntryWithDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryTemplating_retrieveTemplateDataSetEntries(options: {ids? : number[],
identifiers? : string[],
screen_ids? : number[],
dataSet_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/DataSetEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.dataSet_ids!=null?''+this.api.queryParamArrayPrepare('dataSet_ids',options.dataSet_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateDataSetEntriesByScreen(screen_id : number, options: {ids? : number[],
identifiers? : string[],
dataSet_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/'+screen_id+'/TemplateEntry/DataSetEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
''+(options.dataSet_ids!=null?''+this.api.queryParamArrayPrepare('dataSet_ids',options.dataSet_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateDataSetEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/DataSetEntry/'+id+'';
return <Observable<TemplateDataSetEntryWithScreenEntryAggregationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ds_rm_InventoryTemplating_retrieveTemplateDataSets(options: {ids? : number[],
screen_ids? : number[],
company_ids? : number[],
group_ids? : number[],
source_ids? : number[],
subscription_ids? : number[],
inUse? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/DataSet?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.company_ids!=null?''+this.api.queryParamArrayPrepare('company_ids',options.company_ids):'')+
''+(options.group_ids!=null?''+this.api.queryParamArrayPrepare('group_ids',options.group_ids):'')+
''+(options.source_ids!=null?''+this.api.queryParamArrayPrepare('source_ids',options.source_ids):'')+
''+(options.subscription_ids!=null?''+this.api.queryParamArrayPrepare('subscription_ids',options.subscription_ids):'')+
''+(options.inUse!=null?'&inUse='+options.inUse:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateDataSetsByScreen(screen_id : number, options: {ids? : number[],
company_ids? : number[],
group_ids? : number[],
source_ids? : number[],
subscription_ids? : number[],
inUse? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/'+screen_id+'/TemplateEntry/DataSet?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.company_ids!=null?''+this.api.queryParamArrayPrepare('company_ids',options.company_ids):'')+
''+(options.group_ids!=null?''+this.api.queryParamArrayPrepare('group_ids',options.group_ids):'')+
''+(options.source_ids!=null?''+this.api.queryParamArrayPrepare('source_ids',options.source_ids):'')+
''+(options.subscription_ids!=null?''+this.api.queryParamArrayPrepare('subscription_ids',options.subscription_ids):'')+
''+(options.inUse!=null?'&inUse='+options.inUse:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateGroups(options: {ids? : number[],
screen_ids? : number[],
global? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/Group?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateGroupsByScreen(screen_id : number, options: {ids? : number[],
global? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/'+screen_id+'/TemplateEntry/Group?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateScreenEntries(options: {ids? : number[],
dataSet? : number[],
dataSetEntry? : number[],
group? : number[],
device_ids? : number[],
screen_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
rejected? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.dataSet!=null?''+this.api.queryParamArrayPrepare('dataSet',options.dataSet):'')+
''+(options.dataSetEntry!=null?''+this.api.queryParamArrayPrepare('dataSetEntry',options.dataSetEntry):'')+
''+(options.group!=null?''+this.api.queryParamArrayPrepare('group',options.group):'')+
''+(options.device_ids!=null?''+this.api.queryParamArrayPrepare('device_ids',options.device_ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.rejected!=null?'&rejected='+options.rejected:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryWithDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateScreenEntriesByScreen(screen_id : number, options: {ids? : number[],
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
rejected? : boolean,
dataSet? : number[],
dataSetEntry? : number[],
group? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Inventory/Templating/Screen/'+screen_id+'/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.rejected!=null?'&rejected='+options.rejected:'')+
''+(options.dataSet!=null?''+this.api.queryParamArrayPrepare('dataSet',options.dataSet):'')+
''+(options.dataSetEntry!=null?''+this.api.queryParamArrayPrepare('dataSetEntry',options.dataSetEntry):'')+
''+(options.group!=null?''+this.api.queryParamArrayPrepare('group',options.group):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryWithDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_InventoryTemplating_retrieveTemplateScreenEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO> {
let url = '/DS/RM/Inventory/Templating/Screen/TemplateEntry/'+id+'';
return <Observable<TemplateScreenEntryWithDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.Publisher:

public ds_rm_Publisher_retrieveAll(options: {id? : number[],
identifier? : string[],
search? : string,
hasPoint? : boolean,
hasCampaigns? : boolean,
hasMedia? : boolean,
hasMediumGroups? : boolean,
isCustomer? : boolean,
hasCulls? : boolean,
managesLocations? : boolean,
filter? : {by: ds_rm_Publisher_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: ds_rm_Publisher_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/DS/RM/Publisher?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPoint!=null?'&hasPoint='+options.hasPoint:'')+
''+(options.hasCampaigns!=null?'&hasCampaigns='+options.hasCampaigns:'')+
''+(options.hasMedia!=null?'&hasMedia='+options.hasMedia:'')+
''+(options.hasMediumGroups!=null?'&hasMediumGroups='+options.hasMediumGroups:'')+
''+(options.isCustomer!=null?'&isCustomer='+options.isCustomer:'')+
''+(options.hasCulls!=null?'&hasCulls='+options.hasCulls:'')+
''+(options.managesLocations!=null?'&managesLocations='+options.managesLocations:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ds_rm_Publisher_retrievePublisherById(publisher_id : number, mode:Mode=Mode.Entity) : Observable<ClientDTO> {
let url = '/DS/RM/Publisher/'+publisher_id+'';
return <Observable<ClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ds.rm.RM:
// Methods implemented by de.seatback.adplacer.api.mm.assets.Asset:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_show
*	All: -
*/
public mm_assets_Asset_assetFileRetrieveById(asset_id : number, asset_file_id : number, mode:Mode=Mode.Entity) : Observable<AssetFileDTO> {
let url = '/MM/Asset/'+asset_id+'/File/'+asset_file_id+'';
return <Observable<AssetFileDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_show
*	All: -
*/
public mm_assets_Asset_assetFilesRetrieveById(asset_id : number, options: {width? : number,
height? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetFileDTO[]> {
if(!options)
options={};
let url = '/MM/Asset/'+asset_id+'/File?'+(options.width!=null?'&width='+options.width:'')+
''+(options.height!=null?'&height='+options.height:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetFileDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_show
*	All: -
*/
public mm_assets_Asset_assetRetrieveById(asset_id : number, mode:Mode=Mode.Entity) : Observable<SharedAssetFullDTO> {
let url = '/MM/Asset/'+asset_id+'';
return <Observable<SharedAssetFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_list
*	All: -
*/
public mm_assets_Asset_getTagsOfAsset(asset_id : number, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/MM/Asset/'+asset_id+'/Tag?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_list
*	All: -
*/
public mm_assets_Asset_retrieveSharedAssets(options: {search? : string,
category_id? : number[],
tags? : string[],
repository_id? : number[],
width? : number[],
height? : number[],
resolution? : Resolution[],
order? : {by: mm_assets_Asset_retrieveSharedAssets_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<SharedAssetFullDTO[]> {
if(!options)
options={};
let url = '/MM/Asset?'+(options.search!=null?'&search='+options.search:'')+
''+(options.category_id!=null?''+this.api.queryParamArrayPrepare('category_id',options.category_id):'')+
''+(options.tags!=null?''+this.api.queryParamArrayPrepare('tags',options.tags):'')+
''+(options.repository_id!=null?''+this.api.queryParamArrayPrepare('repository_id',options.repository_id):'')+
''+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<SharedAssetFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_show
*	All: -
*/
public mm_assets_Asset_sharedAssetTags(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/MM/Asset/Tag/All?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.mm.assets.AssetRepository:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_list
*	All: -
*/
public mm_assets_AssetRepository_assetsRetrieveAll(asset_repository_id : number, options: {width? : number[],
height? : number[],
resolution? : Resolution[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetFullDTO[]> {
if(!options)
options={};
let url = '/MM/AssetRepository/'+asset_repository_id+'/Asset?'+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_repository_show
*	All: -
*/
public mm_assets_AssetRepository_getRepoCategories(asset_repository_id : number, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AssetCategoryFullDTO[]> {
if(!options)
options={};
let url = '/MM/AssetRepository/'+asset_repository_id+'/Category?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AssetCategoryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_show
*	All: -
*/
public mm_assets_AssetRepository_getRepositoryTags(options: {repository_id? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/MM/AssetRepository/Tags?'+(options.repository_id!=null?''+this.api.queryParamArrayPrepare('repository_id',options.repository_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_repository_show
*	All: -
*/
public mm_assets_AssetRepository_retrieveById(asset_repository_id : number, mode:Mode=Mode.Entity) : Observable<SharedAssetRepositoryDTO> {
let url = '/MM/AssetRepository/'+asset_repository_id+'';
return <Observable<SharedAssetRepositoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: shared_asset_repository_list
*	All: -
*/
public mm_assets_AssetRepository_retrieveSharedRepositories(options: {search? : string,
repository_id? : number[],
category_id? : number[],
hasAssets? : boolean,
order? : {by: mm_assets_AssetRepository_retrieveSharedRepositories_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<SharedAssetRepositoryDTO[]> {
if(!options)
options={};
let url = '/MM/AssetRepository?'+(options.search!=null?'&search='+options.search:'')+
''+(options.repository_id!=null?''+this.api.queryParamArrayPrepare('repository_id',options.repository_id):'')+
''+(options.category_id!=null?''+this.api.queryParamArrayPrepare('category_id',options.category_id):'')+
''+(options.hasAssets!=null?'&hasAssets='+options.hasAssets:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<SharedAssetRepositoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.mm.Medium:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public mm_Medium_bookedDevicesById(medium_id : number, options: {planning? : number,
planningSubmission? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
channel? : number[],
location? : number[],
playerCull? : number[],
search? : string,
withinPolygon? : Polygon[],
id? : number[],
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
identifier? : string[],
filter? : {by: mm_Medium_bookedDevicesById_filter, param?: string, values: string[]}[],
order? : {by: mm_Medium_bookedDevicesById_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/'+medium_id+'/Device?'+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.planningSubmission!=null?'&planningSubmission='+options.planningSubmission:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<DeviceFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_Medium_convertById(medium_id : number, mediumFullDTO : MediumFullDTO, options: {width? : number,
height? : number} = {}, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
if(!options)
options={};
let url = '/MM/Medium/'+medium_id+'/Convert?width='+options.width+'&height='+options.height+'';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_create
*	All: -
*/
public mm_Medium_create(mediumFullDTO : MediumFullDTO, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
let url = '/MM/Medium';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: medium_create, asset_show
*/
public mm_Medium_createFromAssetFile(asset_file_id : number, mediumFullDTO : MediumFullDTO, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
let url = '/MM/Medium/AssetFile/'+asset_file_id+'';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_delete
*	All: -
*/
public mm_Medium_deleteMedium(medium_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Medium/'+medium_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_edit
*	All: -
*/
public mm_Medium_edit(mediumFullDTO : MediumFullDTO, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
let url = '/MM/Medium';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_edit
*	All: -
*/
public mm_Medium_editMultiple(mediumFullDTO : MediumFullDTO[], mode:Mode=Mode.Entity) : Observable<MediumFullDTO[]> {
let url = '/MM/Medium/Mass';
return <Observable<MediumFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_lock
*	All: -
*/
public mm_Medium_lockMedia(options: {medium_id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<MediumFullDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/Lock?'+this.api.queryParamArrayPrepare('medium_id',options.medium_id)+'';
return <Observable<MediumFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_lock
*	All: -
*/
public mm_Medium_lockMedium(medium_id : number, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
let url = '/MM/Medium/'+medium_id+'/Lock';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_list
*	All: -
*/
public mm_Medium_retrieveAll(options: {id? : number[],
forCompany? : number,
identifier? : string[],
locked? : boolean,
search? : string,
hasMediumGroup? : boolean,
mediumGroup? : number,
hasTemplateGroup? : boolean,
templateGroup? : number[],
hasFolder? : boolean,
folder_id? : number,
contentType? : string[],
isImage? : boolean,
isVideo? : boolean,
isHtml? : boolean,
width? : number[],
height? : number[],
resolution? : Resolution[],
duration? : number,
deviation? : number,
hashMD5? : string[],
company? : number[],
fileFormat_id? : number[],
containerFormat? : string[],
audioCodec? : string[],
videoCodec? : string[],
order? : {by: mm_Medium_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumFullDTO[]> {
if(!options)
options={};
let url = '/MM/Medium?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.locked!=null?'&locked='+options.locked:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.hasMediumGroup!=null?'&hasMediumGroup='+options.hasMediumGroup:'')+
''+(options.mediumGroup!=null?'&mediumGroup='+options.mediumGroup:'')+
''+(options.hasTemplateGroup!=null?'&hasTemplateGroup='+options.hasTemplateGroup:'')+
''+(options.templateGroup!=null?''+this.api.queryParamArrayPrepare('templateGroup',options.templateGroup):'')+
''+(options.hasFolder!=null?'&hasFolder='+options.hasFolder:'')+
''+(options.folder_id!=null?'&folder_id='+options.folder_id:'')+
''+(options.contentType!=null?''+this.api.queryParamArrayPrepare('contentType',options.contentType):'')+
''+(options.isImage!=null?'&isImage='+options.isImage:'')+
''+(options.isVideo!=null?'&isVideo='+options.isVideo:'')+
''+(options.isHtml!=null?'&isHtml='+options.isHtml:'')+
''+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
''+(options.duration!=null?'&duration='+options.duration:'')+
''+(options.deviation!=null?'&deviation='+options.deviation:'')+
''+(options.hashMD5!=null?''+this.api.queryParamArrayPrepare('hashMD5',options.hashMD5):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.fileFormat_id!=null?''+this.api.queryParamArrayPrepare('fileFormat_id',options.fileFormat_id):'')+
''+(options.containerFormat!=null?''+this.api.queryParamArrayPrepare('containerFormat',options.containerFormat):'')+
''+(options.audioCodec!=null?''+this.api.queryParamArrayPrepare('audioCodec',options.audioCodec):'')+
''+(options.videoCodec!=null?''+this.api.queryParamArrayPrepare('videoCodec',options.videoCodec):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<MediumFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_show
*	All: -
*/
public mm_Medium_retrieveAllResolutions(options: {company? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ResolutionDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/UsedResolutions?'+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
'';
return <Observable<ResolutionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_show
*	All: -
*/
public mm_Medium_retrieveBookingsForMediumById(medium_id : number, options: {planning? : number,
planningSubmission? : number,
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
timingStatus? : TimingStatus[],
status? : BookingStatus[],
contentCull? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/'+medium_id+'/Booking?'+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.planningSubmission!=null?'&planningSubmission='+options.planningSubmission:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_show
*	All: -
*/
public mm_Medium_retrieveById(id : number, options: {thumbnail? : string,
meta? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
if(!options)
options={};
let url = '/MM/Medium/'+id+'?'+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+
''+(options.meta!=null?'&meta='+options.meta:'')+
'';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_show
*	All: -
*/
public mm_Medium_retrievePossibleMarkersByMediumId(medium_id : number, mode:Mode=Mode.Entity) : Observable<MarkerFullDTO[]> {
let url = '/MM/Medium/'+medium_id+'/Marker';
return <Observable<MarkerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_upload
*	All: -
*/
public mm_Medium_uploadFile(medium_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
let url = '/MM/Medium/'+medium_id+'';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_upload
*	All: -
*/
public mm_Medium_uploadFileHtml(medium_id : number, htmlDTO : HtmlDTO, mode:Mode=Mode.Entity) : Observable<MediumFullDTO> {
let url = '/MM/Medium/'+medium_id+'/Html';
return <Observable<MediumFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, htmlDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_upload
*	All: -
*/
public mm_Medium_uploadFileHtmlPreview(htmlDTO : HtmlDTO, mode:Mode=Mode.Entity) : Observable<FileLink> {
let url = '/MM/Medium/Html/Preview';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, htmlDTO));
}// Methods implemented by de.seatback.adplacer.api.mm.MediumFolder:

public mm_MediumFolder_createRootFolder(mediumFolderDTO : MediumFolderDTO, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO> {
let url = '/MM/Medium/Folder';
return <Observable<MediumFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumFolderDTO));
}
public mm_MediumFolder_createSubFolder(id : number, mediumFolderDTO : MediumFolderDTO, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO> {
let url = '/MM/Medium/Folder/'+id+'/Subfolder';
return <Observable<MediumFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumFolderDTO));
}
public mm_MediumFolder_deleteById(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Medium/Folder/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public mm_MediumFolder_edit(mediumFolderDTO : MediumFolderDTO, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO> {
let url = '/MM/Medium/Folder';
return <Observable<MediumFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumFolderDTO));
}
public mm_MediumFolder_moveTo(id : number, target_id : number, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO> {
let url = '/MM/Medium/Folder/'+id+'/Parent/'+target_id+'';
return <Observable<MediumFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public mm_MediumFolder_moveToRoot(id : number, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO> {
let url = '/MM/Medium/Folder/'+id+'/Parent';
return <Observable<MediumFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public mm_MediumFolder_retrieveAll(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/Folder?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumFolder_retrieveAllBeneath(id : number, options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/Folder/'+id+'/Subfolder?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumFolder_retrieveAllInHierarchy(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/Folder/Hierarchy?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumFolder_retrieveAllInHierarchyBeneath(id : number, options: {hierarchy? : boolean,
id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO[]> {
if(!options)
options={};
let url = '/MM/Medium/Folder/'+id+'/Subfolder/Hierarchy?'+(options.hierarchy!=null?'&hierarchy='+options.hierarchy:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumFolder_retrieveById(id : number, options: {company? : number} = {}, mode:Mode=Mode.Entity) : Observable<MediumFolderDTO> {
if(!options)
options={};
let url = '/MM/Medium/Folder/'+id+'?'+(options.company!=null?'&company='+options.company:'')+
'';
return <Observable<MediumFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.MediumGroup:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_addDefaultMarker(mediumGroup_id : number, medium_id : number, markerDTO : MarkerDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/'+medium_id+'/DefaultMarker';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, markerDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_addDefaultMarkers(mediumGroup_id : number, medium_id : number, markerDTO : MarkerDTO[], mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/'+medium_id+'/DefaultMarker/Mass';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, markerDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_addMedia(mediumGroup_id : number, mediumDTO : MediumDTO[], mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/Mass';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_addMedium(mediumGroup_id : number, mediumDTO : MediumDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_add_promoted_products
*	All: -
*/
public mm_MediumGroup_addPromotedProducts(mediumGroup_id : number, options: {product_id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Product?'+this.api.queryParamArrayPrepare('product_id',options.product_id)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_create
*	All: -
*/
public mm_MediumGroup_create(company_id : number, mediumGroupDTO : MediumGroupDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/Company/'+company_id+'';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_create
*	All: -
*/
public mm_MediumGroup_createForTemplateGroup(company_id : number, templateGroup_id : number, mediumGroupDTO : MediumGroupDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/Company/'+company_id+'/TemplateGroup/'+templateGroup_id+'';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: medium_group_create, asset_show
*/
public mm_MediumGroup_createFromAsset(company_id : number, asset_id : number, mediumGroupDTO : MediumGroupDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/Company/'+company_id+'/Asset/'+asset_id+'';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_delete
*	All: -
*/
public mm_MediumGroup_deleteMediumGroup(mediumGroup_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_edit(mediumGroupDTO : MediumGroupDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_manage_promoted_products
*	All: -
*/
public mm_MediumGroup_manageProducts(mediumGroup_id : number, productDTO : ProductDTO[], mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Product/Manage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, productDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_removeDefaultMarker(mediumGroup_id : number, medium_id : number, marker_id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/'+medium_id+'/'+marker_id+'';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_removeMedium(mediumGroup_id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/'+medium_id+'';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_remove_promoted_products
*	All: -
*/
public mm_MediumGroup_removePromotedProducts(mediumGroup_id : number, options: {product_id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Product?'+this.api.queryParamArrayPrepare('product_id',options.product_id)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_list
*	All: -
*/
public mm_MediumGroup_retrieveAll(options: {id? : number[],
company? : number[],
identifier? : string[],
category? : number[],
templateGroup? : number[],
asset? : number[],
hasMedia? : boolean,
hasFolder? : boolean,
hasProducts? : boolean,
hasTemplateGroup? : boolean,
hasAsset? : boolean,
folder_id? : number,
hasCategory? : boolean,
notInCategory? : number[],
search? : string,
order? : {by: mm_MediumGroup_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO[]> {
if(!options)
options={};
let url = '/MM/MediumGroup?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.templateGroup!=null?''+this.api.queryParamArrayPrepare('templateGroup',options.templateGroup):'')+
''+(options.asset!=null?''+this.api.queryParamArrayPrepare('asset',options.asset):'')+
''+(options.hasMedia!=null?'&hasMedia='+options.hasMedia:'')+
''+(options.hasFolder!=null?'&hasFolder='+options.hasFolder:'')+
''+(options.hasProducts!=null?'&hasProducts='+options.hasProducts:'')+
''+(options.hasTemplateGroup!=null?'&hasTemplateGroup='+options.hasTemplateGroup:'')+
''+(options.hasAsset!=null?'&hasAsset='+options.hasAsset:'')+
''+(options.folder_id!=null?'&folder_id='+options.folder_id:'')+
''+(options.hasCategory!=null?'&hasCategory='+options.hasCategory:'')+
''+(options.notInCategory!=null?''+this.api.queryParamArrayPrepare('notInCategory',options.notInCategory):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<MediumGroupFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_show
*	All: -
*/
public mm_MediumGroup_retrieveById(mediumGroup_id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'';
return <Observable<MediumGroupFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_retrieveDefaultMarkersByMediumId(mediumGroup_id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<MarkerFullDTO[]> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/'+medium_id+'/DefaultMarker';
return <Observable<MarkerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_edit
*	All: -
*/
public mm_MediumGroup_retrievePossibleMarkersInMediumGroupByMediumId(mediumGroup_id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<MarkerFullDTO[]> {
let url = '/MM/MediumGroup/'+mediumGroup_id+'/Medium/'+medium_id+'/Marker';
return <Observable<MarkerFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.MediumGroupCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_create
*	All: -
*/
public mm_MediumGroupCategory_createCategories(mediumGroupCategoryDTO : MediumGroupCategoryDTO[], mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO[]> {
let url = '/MM/MediumGroupCategory/Mass';
return <Observable<MediumGroupCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_create
*	All: -
*/
public mm_MediumGroupCategory_createCategory(mediumGroupCategoryDTO : MediumGroupCategoryDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO> {
let url = '/MM/MediumGroupCategory';
return <Observable<MediumGroupCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_delete
*	All: -
*/
public mm_MediumGroupCategory_deleteById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/MediumGroupCategory/'+category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_delete
*	All: -
*/
public mm_MediumGroupCategory_deleteSubtreeById(category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/MediumGroupCategory/'+category_id+'/Subtree';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_edit
*	All: -
*/
public mm_MediumGroupCategory_editCategories(mediumGroupCategoryDTO : MediumGroupCategoryDTO[], mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO[]> {
let url = '/MM/MediumGroupCategory/Mass';
return <Observable<MediumGroupCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_edit
*	All: -
*/
public mm_MediumGroupCategory_editCategory(mediumGroupCategoryDTO : MediumGroupCategoryDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO> {
let url = '/MM/MediumGroupCategory';
return <Observable<MediumGroupCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupCategoryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_list
*	All: -
*/
public mm_MediumGroupCategory_retrieveAll(options: {id? : number[],
company? : number[],
forCompany? : number,
global? : boolean,
hasCompany? : boolean,
notInHierarchyOf? : number,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO[]> {
if(!options)
options={};
let url = '/MM/MediumGroupCategory?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.forCompany!=null?'&forCompany='+options.forCompany:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.hasCompany!=null?'&hasCompany='+options.hasCompany:'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_group_category_show
*	All: -
*/
public mm_MediumGroupCategory_retrieveById(category_id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupCategoryDTO> {
let url = '/MM/MediumGroupCategory/'+category_id+'';
return <Observable<MediumGroupCategoryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.MediumGroupFolder:

public mm_MediumGroupFolder_createRootFolder(mediumGroupFolderDTO : MediumGroupFolderDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO> {
let url = '/MM/MediumGroup/Folder';
return <Observable<MediumGroupFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupFolderDTO));
}
public mm_MediumGroupFolder_createSubFolder(id : number, mediumGroupFolderDTO : MediumGroupFolderDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO> {
let url = '/MM/MediumGroup/Folder/'+id+'/Subfolder';
return <Observable<MediumGroupFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupFolderDTO));
}
public mm_MediumGroupFolder_deleteById(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/MediumGroup/Folder/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public mm_MediumGroupFolder_edit(mediumGroupFolderDTO : MediumGroupFolderDTO, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO> {
let url = '/MM/MediumGroup/Folder';
return <Observable<MediumGroupFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, mediumGroupFolderDTO));
}
public mm_MediumGroupFolder_moveTo(id : number, target_id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO> {
let url = '/MM/MediumGroup/Folder/'+id+'/Parent/'+target_id+'';
return <Observable<MediumGroupFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public mm_MediumGroupFolder_moveToRoot(id : number, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO> {
let url = '/MM/MediumGroup/Folder/'+id+'/Parent';
return <Observable<MediumGroupFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public mm_MediumGroupFolder_retrieveAll(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO[]> {
if(!options)
options={};
let url = '/MM/MediumGroup/Folder?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumGroupFolder_retrieveAllBeneath(id : number, options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO[]> {
if(!options)
options={};
let url = '/MM/MediumGroup/Folder/'+id+'/Subfolder?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumGroupFolder_retrieveAllInHierarchy(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO[]> {
if(!options)
options={};
let url = '/MM/MediumGroup/Folder/Hierarchy?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumGroupFolder_retrieveAllInHierarchyBeneath(id : number, options: {hierarchy? : boolean,
id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO[]> {
if(!options)
options={};
let url = '/MM/MediumGroup/Folder/'+id+'/Subfolder/Hierarchy?'+(options.hierarchy!=null?'&hierarchy='+options.hierarchy:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumGroupFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public mm_MediumGroupFolder_retrieveById(id : number, options: {company? : number} = {}, mode:Mode=Mode.Entity) : Observable<MediumGroupFolderDTO> {
if(!options)
options={};
let url = '/MM/MediumGroup/Folder/'+id+'?'+(options.company!=null?'&company='+options.company:'')+
'';
return <Observable<MediumGroupFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.MM:
// Methods implemented by de.seatback.adplacer.api.mm.templating.advertiser.TemplateDataSet:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_create
*	All: -
*/
public mm_templating_advertiser_TemplateDataSet_create(templateDataSetDTO : TemplateDataSetDTO, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO> {
let url = '/MM/Templating/DataSet';
return <Observable<TemplateDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateDataSetDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_delete
*	All: -
*/
public mm_templating_advertiser_TemplateDataSet_delete(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/DataSet/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_edit
*	All: -
*/
public mm_templating_advertiser_TemplateDataSet_edit(templateDataSetDTO : TemplateDataSetDTO, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO> {
let url = '/MM/Templating/DataSet';
return <Observable<TemplateDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, templateDataSetDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_list
*	All: -
*/
public mm_templating_advertiser_TemplateDataSet_retrieveAll(options: {ids? : number[],
search? : string,
group_ids? : number[],
order? : {by: mm_templating_advertiser_TemplateDataSet_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/DataSet?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.group_ids!=null?''+this.api.queryParamArrayPrepare('group_ids',options.group_ids):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<TemplateDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_show
*	All: -
*/
public mm_templating_advertiser_TemplateDataSet_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO> {
let url = '/MM/Templating/DataSet/'+id+'';
return <Observable<TemplateDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.advertiser.TemplateDataSetEntry:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_create
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_createInDataSet(data_set_id : number, templateDataSetEntryDTO : TemplateDataSetEntryDTO, options: {update? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO> {
if(!options)
options={};
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry?'+(options.update!=null?'&update='+options.update:'')+
'';
return <Observable<TemplateDataSetEntryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateDataSetEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_create
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_createMassInDataSet(data_set_id : number, templateDataSetEntryDTO : TemplateDataSetEntryDTO[], options: {update? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry/Mass?'+(options.update!=null?'&update='+options.update:'')+
'';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateDataSetEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_entry_delete
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_deleteInDataSet(data_set_id : number, id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_entry_edit
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_editInDataSet(data_set_id : number, templateDataSetEntryDTO : TemplateDataSetEntryDTO, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO> {
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry';
return <Observable<TemplateDataSetEntryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, templateDataSetEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_entry_edit
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_editMassInDataSet(data_set_id : number, templateDataSetEntryDTO : TemplateDataSetEntryDTO[], mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry/Mass';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, templateDataSetEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_entry_render_medium
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_render(data_set_id : number, id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry/'+id+'/Medium/'+medium_id+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_entry_list
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_retrieveAll(data_set_id : number, options: {ids? : number[],
search? : string,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
order? : {by: mm_templating_advertiser_TemplateDataSetEntry_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_show
*	All: -
*/
public mm_templating_advertiser_TemplateDataSetEntry_retrieveInDataSetByIdentifier(data_set_id : number, identifier : string, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO> {
let url = '/MM/Templating/DataSet/'+data_set_id+'/Entry/Identifier/'+encodeURIComponent(identifier)+'';
return <Observable<TemplateDataSetEntryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.provider.TemplateGroup:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_group_create
*	All: -
*/
public mm_templating_provider_TemplateGroup_create(templateGroupDTO : TemplateGroupDTO, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO> {
let url = '/MM/Templating/Group';
return <Observable<TemplateGroupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateGroupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_group_delete
*	All: -
*/
public mm_templating_provider_TemplateGroup_delete(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/Group/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_group_render_medium
*	All: -
*/
public mm_templating_provider_TemplateGroup_render(id : number, medium_id : number, templateEntryDTO : TemplateEntryDTO, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/MM/Templating/Group/'+id+'/Medium/'+medium_id+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_group_list
*	All: -
*/
public mm_templating_provider_TemplateGroup_retrieveAll(options: {search? : string,
id? : number[],
order? : {by: mm_templating_provider_TemplateGroup_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Group?'+(options.search!=null?'&search='+options.search:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<TemplateGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_group_show
*	All: -
*/
public mm_templating_provider_TemplateGroup_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO> {
let url = '/MM/Templating/Group/'+id+'';
return <Observable<TemplateGroupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.provider.TemplateSource:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_create
*	All: -
*/
public mm_templating_provider_TemplateSource_create(templateSourceDTO : TemplateSourceDTO, mode:Mode=Mode.Entity) : Observable<TemplateSourceDTO> {
let url = '/MM/Templating/Source';
return <Observable<TemplateSourceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateSourceDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_delete
*	All: -
*/
public mm_templating_provider_TemplateSource_delete(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/Source/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_data_set_edit
*	All: -
*/
public mm_templating_provider_TemplateSource_edit(templateSourceDTO : TemplateSourceDTO, mode:Mode=Mode.Entity) : Observable<TemplateSourceDTO> {
let url = '/MM/Templating/Source';
return <Observable<TemplateSourceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, templateSourceDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_list
*	All: -
*/
public mm_templating_provider_TemplateSource_retrieveAll(options: {search? : string,
id? : number[],
template_group_id? : number[],
order? : {by: mm_templating_provider_TemplateSource_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateSourceDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Source?'+(options.search!=null?'&search='+options.search:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.template_group_id!=null?''+this.api.queryParamArrayPrepare('template_group_id',options.template_group_id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<TemplateSourceDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_show
*	All: -
*/
public mm_templating_provider_TemplateSource_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateSourceDTO> {
let url = '/MM/Templating/Source/'+id+'';
return <Observable<TemplateSourceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.provider.TemplateSourceEntry:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_create
*	All: -
*/
public mm_templating_provider_TemplateSourceEntry_createTemplateEntry(source_id : number, templateSourceEntryDTO : TemplateSourceEntryDTO, mode:Mode=Mode.Entity) : Observable<TemplateSourceEntryDTO> {
let url = '/MM/Templating/Source/'+source_id+'/Entry';
return <Observable<TemplateSourceEntryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateSourceEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_delete
*	All: -
*/
public mm_templating_provider_TemplateSourceEntry_deleteInSource(source_id : number, id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/Source/'+source_id+'/Entry/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_create
*	All: -
*/
public mm_templating_provider_TemplateSourceEntry_editInSource(source_id : number, templateSourceEntryDTO : TemplateSourceEntryDTO[], mode:Mode=Mode.Entity) : Observable<TemplateSourceEntryDTO[]> {
let url = '/MM/Templating/Source/'+source_id+'/Entry';
return <Observable<TemplateSourceEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, templateSourceEntryDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_render_medium
*	All: -
*/
public mm_templating_provider_TemplateSourceEntry_render(source_id : number, id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/MM/Templating/Source/'+source_id+'/Entry/'+id+'/Medium/'+medium_id+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_list
*	All: -
*/
public mm_templating_provider_TemplateSourceEntry_retrieveAllInSource(source_id : number, options: {ids? : number[],
search? : string,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateSourceEntryDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Source/'+source_id+'/Entry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
'';
return <Observable<TemplateSourceEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_show
*	All: -
*/
public mm_templating_provider_TemplateSourceEntry_retrieveInSourceByIdentifier(source_id : number, identifier : string, mode:Mode=Mode.Entity) : Observable<TemplateSourceEntryDTO> {
let url = '/MM/Templating/Source/'+source_id+'/Entry/Identifier/'+encodeURIComponent(identifier)+'';
return <Observable<TemplateSourceEntryDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.publisher.TemplateScreenEntry:

public mm_templating_publisher_TemplateScreenEntry_render(template_group_id : number, id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<Response> {
let url = '/MM/Templating/Group/'+template_group_id+'/ScreenEntry/'+id+'/Medium/'+medium_id+'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public mm_templating_publisher_TemplateScreenEntry_renderPreview(template_group_id : number, id : number, medium_id : number, options: {progress? : number} = {}, mode:Mode=Mode.Entity) : Observable<Response> {
if(!options)
options={};
let url = '/MM/Templating/Group/'+template_group_id+'/ScreenEntry/'+id+'/Medium/'+medium_id+'/Preview/Still?'+(options.progress!=null?'&progress='+options.progress:'')+
'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public mm_templating_publisher_TemplateScreenEntry_retrieveAll(template_group_id : number, options: {id? : number[],
search? : string,
screenId? : number[],
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Group/'+template_group_id+'/ScreenEntry?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.screenId!=null?''+this.api.queryParamArrayPrepare('screenId',options.screenId):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
'';
return <Observable<TemplateScreenEntryWithDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.store.TemplateStore:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_create
*	All: -
*/
public mm_templating_store_TemplateStore_createTemplateStore(templateStoreDTO : TemplateStoreDTO, mode:Mode=Mode.Entity) : Observable<TemplateStoreDTO> {
let url = '/MM/Templating/Store';
return <Observable<TemplateStoreDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, templateStoreDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_delete
*	All: -
*/
public mm_templating_store_TemplateStore_deleteTemplateStore(templateStore_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/Store/'+templateStore_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_edit
*	All: -
*/
public mm_templating_store_TemplateStore_editTemplateStore(templateStoreDTO : TemplateStoreDTO, mode:Mode=Mode.Entity) : Observable<TemplateStoreDTO> {
let url = '/MM/Templating/Store';
return <Observable<TemplateStoreDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, templateStoreDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_show
*	All: -
*/
public mm_templating_store_TemplateStore_getTemplateStore(templateStore_id : number, mode:Mode=Mode.Entity) : Observable<TemplateStoreDTO> {
let url = '/MM/Templating/Store/'+templateStore_id+'';
return <Observable<TemplateStoreDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_list
*	All: -
*/
public mm_templating_store_TemplateStore_retrieveTemplateStore(options: {search? : string,
id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateStoreDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Store/?'+(options.search!=null?'&search='+options.search:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
'';
return <Observable<TemplateStoreDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.store.TemplateStoreData:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_data_delete
*	All: -
*/
public mm_templating_store_TemplateStoreData_deleteTemplateStoreData(templateStoreData_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/MM/Templating/Store/Data/'+templateStoreData_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_data_show
*	All: -
*/
public mm_templating_store_TemplateStoreData_getTemplateStoreData(templateStoreData_id : number, mode:Mode=Mode.Entity) : Observable<TemplateStoreDataDTO> {
let url = '/MM/Templating/Store/Data/'+templateStoreData_id+'';
return <Observable<TemplateStoreDataDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_store_data_list
*	All: -
*/
public mm_templating_store_TemplateStoreData_retrieveTemplateStoreData(options: {search? : string,
locked? : boolean,
medium_id? : number[],
template_store_id? : number[],
id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateStoreDataDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Store/Data/?'+(options.search!=null?'&search='+options.search:'')+
''+(options.locked!=null?'&locked='+options.locked:'')+
''+(options.medium_id!=null?''+this.api.queryParamArrayPrepare('medium_id',options.medium_id):'')+
''+(options.template_store_id!=null?''+this.api.queryParamArrayPrepare('template_store_id',options.template_store_id):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
'';
return <Observable<TemplateStoreDataDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.mm.templating.TemplateSourceConfiguration:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_source_entry_list
*	All: -
*/
public mm_templating_TemplateSourceConfiguration_retrieveConfigurations(source_id : number, options: {ids? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetSourceSubscriptionDTO[]> {
if(!options)
options={};
let url = '/MM/Templating/Source/'+source_id+'/Configuration?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetSourceSubscriptionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.pm.PM:
// Methods implemented by de.seatback.adplacer.api.pm.Product:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_add_to_category
*	All: -
*/
public pm_Product_addProductToCategory(product_id : number, product_category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/Product/'+product_id+'/ProductCategory/'+product_category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_promoting_medium_group_add
*	All: -
*/
public pm_Product_addPromotingMediumGroup(product_id : number, options: {medium_group_id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/PM/Product/'+product_id+'/MediumGroup?'+this.api.queryParamArrayPrepare('medium_group_id',options.medium_group_id)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_create
*	All: -
*/
public pm_Product_clipDepiction(product_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/PM/Product/'+product_id+'/Depiction';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_create
*	All: -
*/
public pm_Product_copyDepictionFrom(product_id : number, from_product_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/PM/Product/'+product_id+'/Depiction/Copy/'+from_product_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_create
*	All: -
*/
public pm_Product_createProduct(productFullDTO : ProductFullDTO, mode:Mode=Mode.Entity) : Observable<ProductFullDTO> {
let url = '/PM/Product';
return <Observable<ProductFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, productFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_create
*	All: -
*/
public pm_Product_definitionDepiction(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/PM/Product/Depiction';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_create
*	All: -
*/
public pm_Product_deleteDepiction(product_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/Product/'+product_id+'/Depiction';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_delete
*	All: -
*/
public pm_Product_deleteProduct(product_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/Product/'+product_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_edit
*	All: -
*/
public pm_Product_editProduct(productFullDTO : ProductFullDTO, mode:Mode=Mode.Entity) : Observable<ProductFullDTO> {
let url = '/PM/Product';
return <Observable<ProductFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, productFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_promoting_medium_group_show
*	All: -
*/
public pm_Product_getPromotingMediumGroups(product_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumGroupFullDTO[]> {
let url = '/PM/Product/'+product_id+'/MediumGroup';
return <Observable<MediumGroupFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_promoting_medium_group_manage
*	All: -
*/
public pm_Product_manageMediumGroupsInProducts(product_id : number, mediumGroupDTO : MediumGroupDTO[], mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/Product/'+product_id+'/MediumGroup/Manage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, mediumGroupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_remove_from_category
*	All: -
*/
public pm_Product_removeProductFromCategory(product_id : number, product_category_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/Product/'+product_id+'/ProductCategory/'+product_category_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_promoting_medium_group_remove
*	All: -
*/
public pm_Product_removePromotingMediumGroup(product_id : number, options: {medium_group_id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/PM/Product/'+product_id+'/MediumGroup?'+this.api.queryParamArrayPrepare('medium_group_id',options.medium_group_id)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_list
*	All: -
*/
public pm_Product_retrieveAll(options: {id? : number[],
search? : string,
manufacturer_id? : number[],
productCategory_id? : number[],
order? : {by: pm_Product_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ProductFullDTO[]> {
if(!options)
options={};
let url = '/PM/Product?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.manufacturer_id!=null?''+this.api.queryParamArrayPrepare('manufacturer_id',options.manufacturer_id):'')+
''+(options.productCategory_id!=null?''+this.api.queryParamArrayPrepare('productCategory_id',options.productCategory_id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ProductFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_show
*	All: -
*/
public pm_Product_retrieveById(product_id : number, mode:Mode=Mode.Entity) : Observable<ProductFullDTO> {
let url = '/PM/Product/'+product_id+'';
return <Observable<ProductFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_create
*	All: -
*/
public pm_Product_uploadDepiction(product_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/PM/Product/'+product_id+'/Depiction';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.pm.ProductCategory:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_create
*	All: -
*/
public pm_ProductCategory_clipIllustration(productCategory_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/PM/ProductCategory/'+productCategory_id+'/Illustration';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_create
*	All: -
*/
public pm_ProductCategory_copyIllustrationFrom(productCategory_id : number, from_productCategory_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/PM/ProductCategory/'+productCategory_id+'/Illustration/Copy/'+from_productCategory_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_create
*	All: -
*/
public pm_ProductCategory_createProductCategory(productCategoryFullDTO : ProductCategoryFullDTO, mode:Mode=Mode.Entity) : Observable<ProductCategoryFullDTO> {
let url = '/PM/ProductCategory';
return <Observable<ProductCategoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, productCategoryFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_create
*	All: -
*/
public pm_ProductCategory_definitionIllustration(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/PM/ProductCategory/Illustration';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_create
*	All: -
*/
public pm_ProductCategory_deleteIllustration(productCategory_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/ProductCategory/'+productCategory_id+'/Illustration';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_delete
*	All: -
*/
public pm_ProductCategory_deleteProductCategory(productCategory_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/PM/ProductCategory/'+productCategory_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_edit
*	All: -
*/
public pm_ProductCategory_editProductCategory(productCategoryFullDTO : ProductCategoryFullDTO, mode:Mode=Mode.Entity) : Observable<ProductCategoryFullDTO> {
let url = '/PM/ProductCategory';
return <Observable<ProductCategoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, productCategoryFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_list
*	All: -
*/
public pm_ProductCategory_retrieveAll(options: {id? : number[],
search? : string,
order? : {by: pm_ProductCategory_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ProductCategoryFullDTO[]> {
if(!options)
options={};
let url = '/PM/ProductCategory?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ProductCategoryFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_show
*	All: -
*/
public pm_ProductCategory_retrieveById(productCategory_id : number, mode:Mode=Mode.Entity) : Observable<ProductCategoryFullDTO> {
let url = '/PM/ProductCategory/'+productCategory_id+'';
return <Observable<ProductCategoryFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: product_category_create
*	All: -
*/
public pm_ProductCategory_uploadIllustration(productCategory_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/PM/ProductCategory/'+productCategory_id+'/Illustration';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.shared.Attachment:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_attach_to_location, attachment_attach_to_campaign, attachment_attach_to_channel, attachment_attach_to_campaign, attachment_attach_to_device, attachment_attach_to_company, attachment_attach_to_product, attachment_attach_to_ssp, attachment_attach_to_ssp_contract, attachment_attach_to_deal, attachment_attach_to_visitor_tracker, attachment_attach_to_area, attachment_attach_to_player_software, attachment_attach_to_player_hardware, attachment_attach_to_screen_hardware, attachment_attach_to_discussion_topic, attachment_attach_to_discussion_post
*	All: -
*/
public shared_Attachment_attachToEntity(entity : string, entity_id : number, attachmentAssignmentDTO : AttachmentAssignmentDTO[], mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Shared/Attachment/Entity/'+encodeURIComponent(entity)+'/'+entity_id+'/Attach';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, attachmentAssignmentDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_create
*	All: -
*/
public shared_Attachment_createLinkAttachment(attachmentDTO : AttachmentDTO, mode:Mode=Mode.Entity) : Observable<AttachmentDTO> {
let url = '/Shared/Attachment/Link';
return <Observable<AttachmentDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, attachmentDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_delete
*	All: -
*/
public shared_Attachment_deleteAttachment(attachment_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/Attachment/'+attachment_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_detach_from_location, attachment_detach_from_campaign, attachment_detach_from_channel, attachment_detach_from_campaign, attachment_detach_from_device, attachment_detach_from_company, attachment_detach_from_product, attachment_detach_from_ssp, attachment_detach_from_ssp_contract, attachment_detach_from_deal, attachment_detach_from_visitor_tracker, attachment_detach_from_area, attachment_detach_from_player_software, attachment_detach_from_player_hardware, attachment_detach_from_screen_hardware, attachment_detach_from_discussion_topic, attachment_detach_from_discussion_post
*	All: -
*/
public shared_Attachment_detachFromEntity(entity : string, entity_id : number, attachmentAssignmentDTO : AttachmentAssignmentDTO[], mode:Mode=Mode.Entity) : Observable<number> {
let url = '/Shared/Attachment/Entity/'+encodeURIComponent(entity)+'/'+entity_id+'/Detach';
return <Observable<number>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, attachmentAssignmentDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_edit
*	All: -
*/
public shared_Attachment_editAttachment(attachmentDTO : AttachmentDTO, mode:Mode=Mode.Entity) : Observable<AttachmentDTO> {
let url = '/Shared/Attachment';
return <Observable<AttachmentDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, attachmentDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_list
*	All: -
*/
public shared_Attachment_retrieveAll(options: {id? : number[],
hasFolder? : boolean,
folder_id? : number,
attachment_type? : AttachmentType[],
display_type? : DisplayType[],
file_type? : string[],
search? : string,
owned? : boolean,
order? : {by: shared_Attachment_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AttachmentDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.hasFolder!=null?'&hasFolder='+options.hasFolder:'')+
''+(options.folder_id!=null?'&folder_id='+options.folder_id:'')+
''+(options.attachment_type!=null?''+this.api.queryParamArrayPrepare('attachment_type',options.attachment_type):'')+
''+(options.display_type!=null?''+this.api.queryParamArrayPrepare('display_type',options.display_type):'')+
''+(options.file_type!=null?''+this.api.queryParamArrayPrepare('file_type',options.file_type):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.owned!=null?'&owned='+options.owned:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AttachmentDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: -
*/
public shared_Attachment_retrieveAllAttachmentsForEntity(entity : string, entity_id : number, options: {id? : number[],
hasFolder? : boolean,
folder_id? : number,
attachment_type? : AttachmentType[],
display_type? : DisplayType[],
file_type? : string[],
search? : string,
owned? : boolean,
order? : {by: shared_Attachment_retrieveAllAttachmentsForEntity_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AttachmentAssignmentDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment/Entity/'+encodeURIComponent(entity)+'/'+entity_id+'?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.hasFolder!=null?'&hasFolder='+options.hasFolder:'')+
''+(options.folder_id!=null?'&folder_id='+options.folder_id:'')+
''+(options.attachment_type!=null?''+this.api.queryParamArrayPrepare('attachment_type',options.attachment_type):'')+
''+(options.display_type!=null?''+this.api.queryParamArrayPrepare('display_type',options.display_type):'')+
''+(options.file_type!=null?''+this.api.queryParamArrayPrepare('file_type',options.file_type):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.owned!=null?'&owned='+options.owned:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AttachmentAssignmentDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_show
*	All: -
*/
public shared_Attachment_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<AttachmentDTO> {
let url = '/Shared/Attachment/'+id+'';
return <Observable<AttachmentDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Attachment_UpdateLinkAttachments(options: {attachment_id? : number[],
updateTitle? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<AttachmentDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment/Link/Update?'+this.api.queryParamArrayPrepare('attachment_id',options.attachment_id)+(options.updateTitle!=null?'&updateTitle='+options.updateTitle:'')+
'';
return <Observable<AttachmentDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: attachment_create
*	All: -
*/
public shared_Attachment_uploadAttachment(singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<AttachmentDTO> {
let url = '/Shared/Attachment/Upload';
return <Observable<AttachmentDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.shared.AttachmentFolder:

public shared_AttachmentFolder_createRootFolder(attachmentFolderDTO : AttachmentFolderDTO, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO> {
let url = '/Shared/Attachment/Folder';
return <Observable<AttachmentFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, attachmentFolderDTO));
}
public shared_AttachmentFolder_createSubFolder(id : number, attachmentFolderDTO : AttachmentFolderDTO, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO> {
let url = '/Shared/Attachment/Folder/'+id+'/Subfolder';
return <Observable<AttachmentFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, attachmentFolderDTO));
}
public shared_AttachmentFolder_deleteById(id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/Attachment/Folder/'+id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_AttachmentFolder_edit(attachmentFolderDTO : AttachmentFolderDTO, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO> {
let url = '/Shared/Attachment/Folder';
return <Observable<AttachmentFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, attachmentFolderDTO));
}
public shared_AttachmentFolder_moveTo(id : number, target_id : number, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO> {
let url = '/Shared/Attachment/Folder/'+id+'/Parent/'+target_id+'';
return <Observable<AttachmentFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public shared_AttachmentFolder_moveToRoot(id : number, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO> {
let url = '/Shared/Attachment/Folder/'+id+'/Parent';
return <Observable<AttachmentFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_AttachmentFolder_retrieveAll(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment/Folder?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AttachmentFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_AttachmentFolder_retrieveAllBeneath(id : number, options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment/Folder/'+id+'/Subfolder?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AttachmentFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_AttachmentFolder_retrieveAllInHierarchy(options: {id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment/Folder/Hierarchy?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AttachmentFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_AttachmentFolder_retrieveAllInHierarchyBeneath(id : number, options: {hierarchy? : boolean,
id? : number[],
company? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO[]> {
if(!options)
options={};
let url = '/Shared/Attachment/Folder/'+id+'/Subfolder/Hierarchy?'+(options.hierarchy!=null?'&hierarchy='+options.hierarchy:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.company!=null?''+this.api.queryParamArrayPrepare('company',options.company):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<AttachmentFolderDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_AttachmentFolder_retrieveById(id : number, options: {company? : number} = {}, mode:Mode=Mode.Entity) : Observable<AttachmentFolderDTO> {
if(!options)
options={};
let url = '/Shared/Attachment/Folder/'+id+'?'+(options.company!=null?'&company='+options.company:'')+
'';
return <Observable<AttachmentFolderDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Attribute:

public shared_Attribute_retrieve(options: {type? : AttributeType[]} = {}, mode:Mode=Mode.Entity) : Observable<AttributeMapDTO> {
if(!options)
options={};
let url = '/Attribute?'+(options.type!=null?''+this.api.queryParamArrayPrepare('type',options.type):'')+
'';
return <Observable<AttributeMapDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Client:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_clearSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_Client_clearUserWebSettingByField(field : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/User/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_Client_clearUserWebSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/User/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_clearWebSettingByField(field : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_clearWebSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_create
*	All: -
*/
public shared_Client_findUserByEmail(email : string, mode:Mode=Mode.Entity) : Observable<ManagedUserDTO> {
let url = '/Client/Directory/User/Email/'+encodeURIComponent(email)+'';
return <Observable<ManagedUserDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_create
*	All: -
*/
public shared_Client_registerUser(managedUserDTO : ManagedUserDTO, options: {mailLanguage? : string} = {}, mode:Mode=Mode.Entity) : Observable<ManagedUserDTO> {
if(!options)
options={};
let url = '/Client/Directory/User?'+(options.mailLanguage!=null?'&mailLanguage='+options.mailLanguage:'')+
'';
return <Observable<ManagedUserDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, managedUserDTO));
}
public shared_Client_retrieve(mode:Mode=Mode.Entity) : Observable<ClientDTO> {
let url = '/Client';
return <Observable<ClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveAccessibleClients(options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: shared_Client_retrieveAccessibleClients_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/Client/Accessible?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_Client_retrieveConnectedClients(options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: shared_Client_retrieveConnectedClients_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/Client/Connected?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: content_editor
*	All: -
*/
public shared_Client_retrieveEditorSignature(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/Editor/Signature';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveInfo(mode:Mode=Mode.Entity) : Observable<ClientInfoDTO> {
let url = '/Client/Info';
return <Observable<ClientInfoDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_retrieveManagedClientById(client_id : number, mode:Mode=Mode.Entity) : Observable<ClientDTO> {
let url = '/Client/Managed/'+client_id+'';
return <Observable<ClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_retrieveManagedClients(mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
let url = '/Client/Managed';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrievePersonalPermissions(mode:Mode=Mode.Entity) : Observable<string[]> {
let url = '/Client/Permission';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveUserWebSettingByField(field : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/User/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveUserWebSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/User/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveWebSettingByField(field : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_retrieveWebSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Client_switchTo(clientDTO : ClientDTO, mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Client/Switch';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, clientDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_updateSettings(map : any, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, map));
}
public shared_Client_updateUserWebSettingByField(field : string, string : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/User/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, string));
}
public shared_Client_updateUserWebSettings(map : any, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/User/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, map));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_updateWebSettingByField(field : string, string : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, string));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_admin
*	All: -
*/
public shared_Client_updateWebSettings(map : any, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Client/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, map));
}// Methods implemented by de.seatback.adplacer.api.shared.ClientConnection:

public shared_ClientConnection_acceptClientConnectionEstablishmentRequest(incomingClientConnectionEstablishmentRequestDTO : IncomingClientConnectionEstablishmentRequestDTO, mode:Mode=Mode.Entity) : Observable<ClientConnectionEstablishmentRequestDTO> {
let url = '/Client/Connection/Request/Incoming/Accept';
return <Observable<ClientConnectionEstablishmentRequestDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, incomingClientConnectionEstablishmentRequestDTO));
}
public shared_ClientConnection_deleteInvitationCode(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Client/Connection/InvitationCode';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_ClientConnection_findClientByInvitationCode(code : string, mode:Mode=Mode.Entity) : Observable<InventoryClientDTO> {
let url = '/Client/Connection/InvitationCode/'+encodeURIComponent(code)+'';
return <Observable<InventoryClientDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_ClientConnection_generateInvitationCode(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/Connection/InvitationCode';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public shared_ClientConnection_getInvitationCode(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Client/Connection/InvitationCode';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_ClientConnection_requestClientConnectionEstablishment(invitationCode : string, mode:Mode=Mode.Entity) : Observable<ClientConnectionEstablishmentRequestDTO> {
let url = '/Client/Connection/Request/'+encodeURIComponent(invitationCode)+'';
return <Observable<ClientConnectionEstablishmentRequestDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public shared_ClientConnection_retrieveClientConnectionEstablishmentRequests(options: {id? : number[],
connected? : boolean,
search? : string,
order? : {by: shared_ClientConnection_retrieveClientConnectionEstablishmentRequests_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientConnectionEstablishmentRequestDTO[]> {
if(!options)
options={};
let url = '/Client/Connection/Request?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.connected!=null?'&connected='+options.connected:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientConnectionEstablishmentRequestDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_ClientConnection_retrieveConnectedClients(options: {id? : number[],
identifier? : string[],
search? : string,
order? : {by: shared_ClientConnection_retrieveConnectedClients_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/Client/Connection?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_ClientConnection_retrieveIncomingClientConnectionEstablishmentRequests(options: {id? : number[],
connected? : boolean,
search? : string,
order? : {by: shared_ClientConnection_retrieveIncomingClientConnectionEstablishmentRequests_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<IncomingClientConnectionEstablishmentRequestDTO[]> {
if(!options)
options={};
let url = '/Client/Connection/Request/Incoming?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.connected!=null?'&connected='+options.connected:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<IncomingClientConnectionEstablishmentRequestDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_ClientConnection_withdrawClientConnectionEstablishmentRequest(requested_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Client/Connection/Request/'+requested_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}// Methods implemented by de.seatback.adplacer.api.shared.ClientOrder:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_change_order
*	All: -
*/
public shared_ClientOrder_putCampaignAfter(campaign_id : number, after_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Campaign/'+campaign_id+'/After/'+after_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: campaign_change_order
*	All: -
*/
public shared_ClientOrder_putCampaignBefore(campaign_id : number, before_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Campaign/'+campaign_id+'/Before/'+before_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_change_order
*	All: -
*/
public shared_ClientOrder_putChannelAfter(channel_id : number, after_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Channel/'+channel_id+'/After/'+after_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_change_order
*	All: -
*/
public shared_ClientOrder_putChannelBefore(channel_id : number, before_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Channel/'+channel_id+'/Before/'+before_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_change_order
*	All: -
*/
public shared_ClientOrder_putPlanningAfter(planning_id : number, after_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Planning/'+planning_id+'/After/'+after_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: planning_change_order
*	All: -
*/
public shared_ClientOrder_putPlanningBefore(planning_id : number, before_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Planning/'+planning_id+'/Before/'+before_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_change_order
*	All: -
*/
public shared_ClientOrder_putPoolAfter(pool_id : number, after_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Pool/'+pool_id+'/After/'+after_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_change_order
*	All: -
*/
public shared_ClientOrder_putPoolBefore(pool_id : number, before_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/Pool/'+pool_id+'/Before/'+before_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public shared_ClientOrder_putUserClientAfter(userClient_id : number, after_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/UserClient/'+userClient_id+'/After/'+after_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
public shared_ClientOrder_putUserClientBefore(userClient_id : number, before_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ClientOrder/UserClient/'+userClient_id+'/Before/'+before_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}// Methods implemented by de.seatback.adplacer.api.shared.ColorDefinition:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: color_definition_create
*	All: -
*/
public shared_ColorDefinition_createColorDefinition(colorDefinitionDTO : ColorDefinitionDTO, mode:Mode=Mode.Entity) : Observable<ColorDefinitionDTO> {
let url = '/ColorDefinition';
return <Observable<ColorDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, colorDefinitionDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: color_definition_delete
*	All: -
*/
public shared_ColorDefinition_deleteColorDefinition(colorDefinition_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/ColorDefinition/'+colorDefinition_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: color_definition_edit
*	All: -
*/
public shared_ColorDefinition_editColorDefinition(colorDefinitionDTO : ColorDefinitionDTO, mode:Mode=Mode.Entity) : Observable<ColorDefinitionDTO> {
let url = '/ColorDefinition';
return <Observable<ColorDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, colorDefinitionDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: color_definition_show
*	All: -
*/
public shared_ColorDefinition_getColorDefinition(colorDefinition_id : number, mode:Mode=Mode.Entity) : Observable<ColorDefinitionDTO> {
let url = '/ColorDefinition/'+colorDefinition_id+'';
return <Observable<ColorDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: color_definition_list
*	All: -
*/
public shared_ColorDefinition_getColorDefinitions(options: {global? : boolean,
id? : number[],
color? : string[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ColorDefinitionDTO[]> {
if(!options)
options={};
let url = '/ColorDefinition?'+(options.global!=null?'&global='+options.global:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.color!=null?''+this.api.queryParamArrayPrepare('color',options.color):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<ColorDefinitionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.Company:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_clipHeaderImage(company_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/Company/'+company_id+'/HeaderImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_clipLogo(company_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/Company/'+company_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_copyHeaderImageFrom(company_id : number, from_company_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/Company/'+company_id+'/HeaderImage/Copy/'+from_company_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_copyLogoFrom(company_id : number, from_company_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/Company/'+company_id+'/Logo/Copy/'+from_company_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_create
*	All: -
*/
public shared_Company_createCompanies(companyFullDTO : CompanyFullDTO[], mode:Mode=Mode.Entity) : Observable<CompanyFullDTO[]> {
let url = '/Company/Mass';
return <Observable<CompanyFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, companyFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_create
*	All: -
*/
public shared_Company_createCompany(companyFullDTO : CompanyFullDTO, mode:Mode=Mode.Entity) : Observable<CompanyFullDTO> {
let url = '/Company';
return <Observable<CompanyFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, companyFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: contact_create
*	All: -
*/
public shared_Company_createContact(company_id : number, contactDTO : ContactDTO, mode:Mode=Mode.Entity) : Observable<ContactDTO> {
let url = '/Company/'+company_id+'/Contacts';
return <Observable<ContactDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, contactDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_definitionHeaderImage(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/Company/HeaderImage';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_definitionLogo(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/Company/Logo';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: contact_delete
*	All: -
*/
public shared_Company_deleteContact(company_id : number, contact_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Company/'+company_id+'/Contacts/'+contact_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_deleteHeaderImage(company_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Company/'+company_id+'/HeaderImage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_deleteLogo(company_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Company/'+company_id+'/Logo';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_editCompanies(companyDTO : CompanyDTO[], mode:Mode=Mode.Entity) : Observable<CompanyDTO[]> {
let url = '/Company/Mass';
return <Observable<CompanyDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, companyDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_editCompany(companyDTO : CompanyDTO, mode:Mode=Mode.Entity) : Observable<CompanyDTO> {
let url = '/Company';
return <Observable<CompanyDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, companyDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: contact_edit
*	All: -
*/
public shared_Company_editContact(contactDTO : ContactDTO, mode:Mode=Mode.Entity) : Observable<ContactDTO> {
let url = '/Company/Contacts';
return <Observable<ContactDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, contactDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_export
*	All: -
*/
public shared_Company_export(options: {id? : number[],
identifier? : string[],
search? : string,
hasPoint? : boolean,
hasCampaigns? : boolean,
hasMedia? : boolean,
hasMediumGroups? : boolean,
isCustomer? : boolean,
hasCulls? : boolean,
managesLocations? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
reportName? : string,
filter? : {by: shared_Company_export_filter, param?: string, values: string[]}[],
order? : {by: shared_Company_export_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ReportingFullDTO> {
if(!options)
options={};
let url = '/Company/Export?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPoint!=null?'&hasPoint='+options.hasPoint:'')+
''+(options.hasCampaigns!=null?'&hasCampaigns='+options.hasCampaigns:'')+
''+(options.hasMedia!=null?'&hasMedia='+options.hasMedia:'')+
''+(options.hasMediumGroups!=null?'&hasMediumGroups='+options.hasMediumGroups:'')+
''+(options.isCustomer!=null?'&isCustomer='+options.isCustomer:'')+
''+(options.hasCulls!=null?'&hasCulls='+options.hasCulls:'')+
''+(options.managesLocations!=null?'&managesLocations='+options.managesLocations:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.reportName!=null?'&reportName='+options.reportName:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ReportingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_resolveAndUpdateAllPointsFromAddresses(pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CompanyFullDTO[]> {
let url = '/Company/ResolveAllPointsFromAddresses';
return <Observable<CompanyFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_resolveAndUpdatePointFromAddress(company_id : number, mode:Mode=Mode.Entity) : Observable<CompanyFullDTO> {
let url = '/Company/'+company_id+'/ResolvePointFromAddress';
return <Observable<CompanyFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_show
*	All: -
*/
public shared_Company_resolvePointFromAddress(company_id : number, mode:Mode=Mode.Entity) : Observable<Point> {
let url = '/Company/'+company_id+'/ResolvePointFromAddress';
return <Observable<Point>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_list
*	All: -
*/
public shared_Company_retrieveAll(options: {id? : number[],
identifier? : string[],
search? : string,
hasPoint? : boolean,
hasCampaigns? : boolean,
hasMedia? : boolean,
hasMediumGroups? : boolean,
isCustomer? : boolean,
hasCulls? : boolean,
managesLocations? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
filter? : {by: shared_Company_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: shared_Company_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CompanyFullDTO[]> {
if(!options)
options={};
let url = '/Company?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPoint!=null?'&hasPoint='+options.hasPoint:'')+
''+(options.hasCampaigns!=null?'&hasCampaigns='+options.hasCampaigns:'')+
''+(options.hasMedia!=null?'&hasMedia='+options.hasMedia:'')+
''+(options.hasMediumGroups!=null?'&hasMediumGroups='+options.hasMediumGroups:'')+
''+(options.isCustomer!=null?'&isCustomer='+options.isCustomer:'')+
''+(options.hasCulls!=null?'&hasCulls='+options.hasCulls:'')+
''+(options.managesLocations!=null?'&managesLocations='+options.managesLocations:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<CompanyFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: contact_list
*	All: -
*/
public shared_Company_retrieveAllContacts(company_id : number, mode:Mode=Mode.Entity) : Observable<ContactDTO[]> {
let url = '/Company/'+company_id+'/Contacts';
return <Observable<ContactDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_show
*	All: -
*/
public shared_Company_retrieveCompanyById(company_id : number, mode:Mode=Mode.Entity) : Observable<CompanyFullDTO> {
let url = '/Company/'+company_id+'';
return <Observable<CompanyFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_uploadHeaderImage(company_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/Company/'+company_id+'/HeaderImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: company_edit
*	All: -
*/
public shared_Company_uploadLogo(company_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/Company/'+company_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.shared.CronDefinition:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cron_definition_create
*	All: -
*/
public shared_CronDefinition_createCronDefinition(cronDefinitionDTO : CronDefinitionDTO, options: {previewDateTime? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CronDefinitionDTO> {
if(!options)
options={};
let url = '/Shared/CronDefinition?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<CronDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cronDefinitionDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cron_definition_create
*	All: -
*/
public shared_CronDefinition_createCronDefinitionPreview(cronDefinitionDTO : CronDefinitionDTO, options: {previewDateTime? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CronDefinitionDTO> {
if(!options)
options={};
let url = '/Shared/CronDefinition//Preview?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<CronDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, cronDefinitionDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cron_definition_delete
*	All: -
*/
public shared_CronDefinition_deleteCronDefinition(cronDefinition_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/CronDefinition/'+cronDefinition_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cron_definition_edit
*	All: -
*/
public shared_CronDefinition_editCronDefinition(cronDefinitionDTO : CronDefinitionDTO, options: {previewDateTime? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<CronDefinitionDTO> {
if(!options)
options={};
let url = '/Shared/CronDefinition?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<CronDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, cronDefinitionDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cron_definition_list
*	All: -
*/
public shared_CronDefinition_retrieveAll(options: {search? : string,
previewDateTime? : SbDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CronDefinitionDTO[]> {
if(!options)
options={};
let url = '/Shared/CronDefinition?'+(options.search!=null?'&search='+options.search:'')+
''+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<CronDefinitionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: cron_definition_show
*	All: -
*/
public shared_CronDefinition_retrieveById(cronDefinition_id : number, options: {previewDateTime? : SbDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<CronDefinitionDTO> {
if(!options)
options={};
let url = '/Shared/CronDefinition/'+cronDefinition_id+'?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<CronDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.Deal:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: deal_delete
*	All: -
*/
public shared_Deal_deleteDeal(deal_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/Deal/'+deal_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: deal_edit
*	All: -
*/
public shared_Deal_editDeal(dealDTO : DealDTO, mode:Mode=Mode.Entity) : Observable<DealDTO> {
let url = '/Shared/Deal';
return <Observable<DealDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, dealDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: deal_list
*	All: -
*/
public shared_Deal_retrieveAll(options: {deal_id? : number[],
ssp_contract_id? : number[],
ssp_id? : number[],
identifier? : string[],
ssp_contract_identifier? : string[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DealDTO[]> {
if(!options)
options={};
let url = '/Shared/Deal?'+(options.deal_id!=null?''+this.api.queryParamArrayPrepare('deal_id',options.deal_id):'')+
''+(options.ssp_contract_id!=null?''+this.api.queryParamArrayPrepare('ssp_contract_id',options.ssp_contract_id):'')+
''+(options.ssp_id!=null?''+this.api.queryParamArrayPrepare('ssp_id',options.ssp_id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.ssp_contract_identifier!=null?''+this.api.queryParamArrayPrepare('ssp_contract_identifier',options.ssp_contract_identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<DealDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.Discussion:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate
*	All: -
*/
public shared_Discussion_createAnswerPost(post_id : number, postDTO : PostDTO, mode:Mode=Mode.Entity) : Observable<PostDTO> {
let url = '/Discussion/Post/'+post_id+'';
return <Observable<PostDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, postDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create
*	All: -
*/
public shared_Discussion_createTopic(linkedEntity_type : string, linkedEntity_id : number, topicDTO : TopicDTO, mode:Mode=Mode.Entity) : Observable<TopicDTO> {
let url = '/Discussion/Topic/LinkedEntity/'+encodeURIComponent(linkedEntity_type)+'/'+linkedEntity_id+'';
return <Observable<TopicDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, topicDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate
*	All: -
*/
public shared_Discussion_createTopicPost(topic_id : number, postDTO : PostDTO, mode:Mode=Mode.Entity) : Observable<PostDTO> {
let url = '/Discussion/Topic/'+topic_id+'';
return <Observable<PostDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, postDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate, discussion_moderate
*	All: -
*/
public shared_Discussion_deletePost(post_id : number, options: {restore? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/Discussion/Post/'+post_id+'?'+(options.restore!=null?'&restore='+options.restore:'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate, discussion_moderate
*	All: -
*/
public shared_Discussion_deleteTopic(topic_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Discussion/Topic/'+topic_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate
*	All: -
*/
public shared_Discussion_editPost(postDTO : PostDTO, mode:Mode=Mode.Entity) : Observable<PostDTO> {
let url = '/Discussion/Post';
return <Observable<PostDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, postDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate
*	All: -
*/
public shared_Discussion_editTopic(topicDTO : TopicDTO, mode:Mode=Mode.Entity) : Observable<TopicDTO> {
let url = '/Discussion/Topic';
return <Observable<TopicDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, topicDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_list
*	All: -
*/
public shared_Discussion_retrieveAllTopics(options: {topic_id? : number[],
LinkedEntity? : LinkedEntityDTO[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TopicDTO[]> {
if(!options)
options={};
let url = '/Discussion/Topic?'+(options.topic_id!=null?''+this.api.queryParamArrayPrepare('topic_id',options.topic_id):'')+
''+(options.LinkedEntity!=null?''+this.api.queryParamArrayPrepare('LinkedEntity',options.LinkedEntity):'')+
'';
return <Observable<TopicDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_list
*	All: -
*/
public shared_Discussion_retrieveAllTopicsByLinkedEntityType(linkedEntity_type : string, options: {id? : number[],
linkedEntity_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TopicDTO[]> {
if(!options)
options={};
let url = '/Discussion/Topic/LinkedEntity/'+encodeURIComponent(linkedEntity_type)+'?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.linkedEntity_id!=null?''+this.api.queryParamArrayPrepare('linkedEntity_id',options.linkedEntity_id):'')+
'';
return <Observable<TopicDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_list
*	All: -
*/
public shared_Discussion_retrieveTopicById(topic_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_list
*	All: -
*/
public shared_Discussion_retrieveTopicsWithOptions(discussableBulkOptions : DiscussableBulkOptions, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TopicDTO[]> {
let url = '/Discussion/Topic/BulkGet';
return <Observable<TopicDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, discussableBulkOptions, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_participate
*	All: -
*/
public shared_Discussion_retrieveUsersByPermissionName(permissionName : string, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<UserDTO[]> {
if(!options)
options={};
let url = '/Discussion/Topic/'+encodeURIComponent(permissionName)+'/Users?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<UserDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_setDone(topic_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/Done';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_setDoneAndSolution(topic_id : number, post_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/Done/Solution/'+post_id+'';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_setNotDone(topic_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/Done';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_setPinnedPost(topic_id : number, post_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/PinnedPost/'+post_id+'';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_setSolution(topic_id : number, post_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/Solution/'+post_id+'';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_unsetPinnedPost(topic_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/PinnedPost';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: discussion_create, discussion_moderate
*	All: -
*/
public shared_Discussion_unsetSolution(topic_id : number, mode:Mode=Mode.Entity) : Observable<TopicFullDTO> {
let url = '/Discussion/Topic/'+topic_id+'/Solution';
return <Observable<TopicFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}// Methods implemented by de.seatback.adplacer.api.shared.File:

public shared_File_downloadFile(uri : string, options: {thumbnail? : ThumbnailSize} = {}, mode:Mode=Mode.Entity) : Observable<Response> {
if(!options)
options={};
let url = '/File/'+encodeURIComponent(uri)+'/Download?'+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_File_getFile(uri : string, options: {thumbnail? : ThumbnailSize} = {}, mode:Mode=Mode.Entity) : Observable<Response> {
if(!options)
options={};
let url = '/File/'+encodeURIComponent(uri)+'?'+(options.thumbnail!=null?'&thumbnail='+options.thumbnail:'')+'';
return <Observable<Response>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Meta:

public shared_Meta_entityDefinitions(mode:Mode=Mode.Entity) : Observable<EntityDefinitionDTO[]> {
let url = '/Meta/Entity';
return <Observable<EntityDefinitionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Meta_rateEntitiesForKeywords(options: {keyword? : string[],
entity? : Entity[],
property? : string[]} = {}, mode:Mode=Mode.Entity) : Observable<RatingDTO[]> {
if(!options)
options={};
let url = '/Meta/Entity/Rate?'+this.api.queryParamArrayPrepare('keyword',options.keyword)+(options.entity!=null?''+this.api.queryParamArrayPrepare('entity',options.entity):'')+
''+(options.property!=null?''+this.api.queryParamArrayPrepare('property',options.property):'')+
'';
return <Observable<RatingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Meta_retrieveEntities(entity : Entity, options: {word? : string[],
partialWord? : string[],
details? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<EntityDTO[]> {
if(!options)
options={};
let url = '/Meta/Entity/'+entity+'?'+(options.word!=null?''+this.api.queryParamArrayPrepare('word',options.word):'')+
''+(options.partialWord!=null?''+this.api.queryParamArrayPrepare('partialWord',options.partialWord):'')+
''+(options.details!=null?'&details='+options.details:'')+
'';
return <Observable<EntityDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_Meta_retrieveWordings(options: {entity? : Entity[],
property? : string[],
word? : string[],
partialWord? : string[],
minCount? : number,
maxCount? : number} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<WordingDTO[]> {
if(!options)
options={};
let url = '/Meta/Wording?'+(options.entity!=null?''+this.api.queryParamArrayPrepare('entity',options.entity):'')+
''+(options.property!=null?''+this.api.queryParamArrayPrepare('property',options.property):'')+
''+(options.word!=null?''+this.api.queryParamArrayPrepare('word',options.word):'')+
''+(options.partialWord!=null?''+this.api.queryParamArrayPrepare('partialWord',options.partialWord):'')+
''+(options.minCount!=null?'&minCount='+options.minCount:'')+
''+(options.maxCount!=null?'&maxCount='+options.maxCount:'')+
'';
return <Observable<WordingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public shared_Meta_searchEntities(options: {count? : number,
word? : string[],
partialWord? : string[],
entity? : Entity[],
details? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<EntityDTO[]> {
if(!options)
options={};
let url = '/Meta/Search?'+(options.count!=null?'&count='+options.count:'')+
''+(options.word!=null?''+this.api.queryParamArrayPrepare('word',options.word):'')+
''+(options.partialWord!=null?''+this.api.queryParamArrayPrepare('partialWord',options.partialWord):'')+
''+(options.entity!=null?''+this.api.queryParamArrayPrepare('entity',options.entity):'')+
''+(options.details!=null?'&details='+options.details:'')+
'';
return <Observable<EntityDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Notification:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: notification_archive
*	All: -
*/
public shared_Notification_archiveById(notification : number, mode:Mode=Mode.Entity) : Observable<NotificationDTO> {
let url = '/Notification/'+notification+'/Archive';
return <Observable<NotificationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: notification_read
*	All: -
*/
public shared_Notification_readById(notification : number, mode:Mode=Mode.Entity) : Observable<NotificationDTO> {
let url = '/Notification/'+notification+'/Read';
return <Observable<NotificationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: notification_list
*	All: -
*/
public shared_Notification_retrieveAll(options: {search? : string,
read? : boolean,
archived? : boolean,
status? : string[],
loglevel? : string[],
category? : string[],
id? : number[],
order? : {by: shared_Notification_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NotificationDTO[]> {
if(!options)
options={};
let url = '/Notification?'+(options.search!=null?'&search='+options.search:'')+
''+(options.read!=null?'&read='+options.read:'')+
''+(options.archived!=null?'&archived='+options.archived:'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.loglevel!=null?''+this.api.queryParamArrayPrepare('loglevel',options.loglevel):'')+
''+(options.category!=null?''+this.api.queryParamArrayPrepare('category',options.category):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<NotificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: notification_show
*	All: -
*/
public shared_Notification_retrieveById(notification_id : number, mode:Mode=Mode.Entity) : Observable<NotificationDTO> {
let url = '/Notification/'+notification_id+'';
return <Observable<NotificationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: notification_show
*	All: -
*/
public shared_Notification_retrieveCategories(options: {search? : string,
id? : string[],
order? : {by: shared_Notification_retrieveCategories_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NotificationCategoryDTO[]> {
if(!options)
options={};
let url = '/Notification/Category?'+(options.search!=null?'&search='+options.search:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<NotificationCategoryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.Permission:

public shared_Permission_implicatedBy(permission : string, mode:Mode=Mode.Entity) : Observable<string[]> {
let url = '/Permission/'+encodeURIComponent(permission)+'/implicatedBy';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_implications(permission : string, mode:Mode=Mode.Entity) : Observable<string[]> {
let url = '/Permission/'+encodeURIComponent(permission)+'/implications';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_implicationsIndex(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Permission/implications';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_implicationsIndexFull(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/Permission/implications/full';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_retrieveAll(options: {search? : string} = {}, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/Permission?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_retrieveAllAsTypescriptEnum(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Permission/Enum/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_retrieveTranslatorTS(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Permission/Translator/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Permission_tree(options: {permission? : string[],
excluded? : string[],
entity? : string[],
feature? : string[],
function? : string[],
module? : string[],
hasEntity? : boolean,
hasFeature? : boolean,
hasFunction? : boolean,
hasModule? : boolean,
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<PermissionEntryDTO[]> {
if(!options)
options={};
let url = '/Permission/Tree?'+(options.permission!=null?''+this.api.queryParamArrayPrepare('permission',options.permission):'')+
''+(options.excluded!=null?''+this.api.queryParamArrayPrepare('excluded',options.excluded):'')+
''+(options.entity!=null?''+this.api.queryParamArrayPrepare('entity',options.entity):'')+
''+(options.feature!=null?''+this.api.queryParamArrayPrepare('feature',options.feature):'')+
''+(options.function!=null?''+this.api.queryParamArrayPrepare('function',options.function):'')+
''+(options.module!=null?''+this.api.queryParamArrayPrepare('module',options.module):'')+
''+(options.hasEntity!=null?'&hasEntity='+options.hasEntity:'')+
''+(options.hasFeature!=null?'&hasFeature='+options.hasFeature:'')+
''+(options.hasFunction!=null?'&hasFunction='+options.hasFunction:'')+
''+(options.hasModule!=null?'&hasModule='+options.hasModule:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<PermissionEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Puppeteer:

public shared_Puppeteer_screenshotPagePDF(options: {url? : string,
renderMode? : PDFRenderMode} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/Puppeteer/PDF?url='+options.url+'&renderMode='+options.renderMode+'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Puppeteer_screenshotPagePNG(options: {url? : string,
format? : ScreenshotFormat} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/Puppeteer/Screenshot?url='+options.url+'&format='+options.format+'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Reporting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_list
*	All: -
*/
public shared_Reporting_getGenerateReport(reporting_id : number, options: {reporting_template_id? : number} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingFileDTO> {
if(!options)
options={};
let url = '/Shared/Reporting/'+reporting_id+'/Generate?'+(options.reporting_template_id!=null?'&reporting_template_id='+options.reporting_template_id:'')+
'';
return <Observable<ReportingFileDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_show
*	All: -
*/
public shared_Reporting_renderByIdWithFTL(reporting_id : number, stringDTO : StringDTO, mode:Mode=Mode.Entity) : Observable<FileLink> {
let url = '/Shared/Reporting/'+reporting_id+'/Render';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, stringDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_list
*	All: -
*/
public shared_Reporting_retrieveAll(options: {search? : string,
reporting_scheduling_id? : number,
reporting_setup_id? : number} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingFullDTO[]> {
if(!options)
options={};
let url = '/Shared/Reporting?'+(options.search!=null?'&search='+options.search:'')+
''+(options.reporting_scheduling_id!=null?'&reporting_scheduling_id='+options.reporting_scheduling_id:'')+
''+(options.reporting_setup_id!=null?'&reporting_setup_id='+options.reporting_setup_id:'')+
'';
return <Observable<ReportingFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_list
*	All: -
*/
public shared_Reporting_retrieveAllGenerated(options: {reporting_id? : number[],
reporting_template_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingFileDTO[]> {
if(!options)
options={};
let url = '/Shared/Reporting/Generated?'+(options.reporting_id!=null?''+this.api.queryParamArrayPrepare('reporting_id',options.reporting_id):'')+
''+(options.reporting_template_id!=null?''+this.api.queryParamArrayPrepare('reporting_template_id',options.reporting_template_id):'')+
'';
return <Observable<ReportingFileDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_show
*	All: -
*/
public shared_Reporting_retrieveById(reporting_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingFullDTO> {
let url = '/Shared/Reporting/'+reporting_id+'';
return <Observable<ReportingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.ReportingScheduling:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_scheduling_list
*	All: -
*/
public shared_ReportingScheduling_retrieveAll(options: {search? : string,
reporting_setup_id? : number,
reporting_scheduling_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingSchedulingDTO[]> {
if(!options)
options={};
let url = '/Shared/ReportingScheduling?'+(options.search!=null?'&search='+options.search:'')+
''+(options.reporting_setup_id!=null?'&reporting_setup_id='+options.reporting_setup_id:'')+
''+(options.reporting_scheduling_id!=null?''+this.api.queryParamArrayPrepare('reporting_scheduling_id',options.reporting_scheduling_id):'')+
'';
return <Observable<ReportingSchedulingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_scheduling_list
*	All: -
*/
public shared_ReportingScheduling_retrieveById(id : number, mode:Mode=Mode.Entity) : Observable<ReportingSchedulingDTO> {
let url = '/Shared/ReportingScheduling/'+id+'';
return <Observable<ReportingSchedulingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.ReportingSetup:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_create
*	All: -
*/
public shared_ReportingSetup_createScheduledReportingSetup(reporting_type : number, scheduledReportingSetupDTO : ScheduledReportingSetupDTO, mode:Mode=Mode.Entity) : Observable<ScheduledReportingSetupDTO> {
let url = '/Shared/ReportingSetup/Scheduled/Type/'+reporting_type+'';
return <Observable<ScheduledReportingSetupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, scheduledReportingSetupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_delete
*	All: -
*/
public shared_ReportingSetup_deleteReportingSetup(reporting_setup_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/ReportingSetup/'+reporting_setup_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_edit
*	All: -
*/
public shared_ReportingSetup_editScheduledReportingSetup(scheduledReportingSetupDTO : ScheduledReportingSetupDTO, mode:Mode=Mode.Entity) : Observable<ScheduledReportingSetupDTO> {
let url = '/Shared/ReportingSetup/Scheduled';
return <Observable<ScheduledReportingSetupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, scheduledReportingSetupDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_show
*	All: -
*/
public shared_ReportingSetup_retrieveAdHocReportingSetupById(reporting_setup_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AdHocReportingSetupDTO> {
let url = '/Shared/ReportingSetup/AdHoc/'+reporting_setup_id+'';
return <Observable<AdHocReportingSetupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_list
*	All: -
*/
public shared_ReportingSetup_retrieveAll(options: {search? : string,
global? : boolean,
id? : number[],
active? : boolean,
order? : {by: shared_ReportingSetup_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingSetupDTO[]> {
if(!options)
options={};
let url = '/Shared/ReportingSetup?'+(options.search!=null?'&search='+options.search:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.active!=null?'&active='+options.active:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ReportingSetupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_list
*	All: -
*/
public shared_ReportingSetup_retrieveAllAdHocReportingSetups(options: {search? : string,
global? : boolean,
id? : number[],
active? : boolean,
order? : {by: shared_ReportingSetup_retrieveAllAdHocReportingSetups_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<AdHocReportingSetupDTO[]> {
if(!options)
options={};
let url = '/Shared/ReportingSetup/AdHoc?'+(options.search!=null?'&search='+options.search:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.active!=null?'&active='+options.active:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<AdHocReportingSetupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_list
*	All: -
*/
public shared_ReportingSetup_retrieveAllScheduledReportingSetups(options: {search? : string,
global? : boolean,
id? : number[],
active? : boolean,
order? : {by: shared_ReportingSetup_retrieveAllScheduledReportingSetups_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ScheduledReportingSetupDTO[]> {
if(!options)
options={};
let url = '/Shared/ReportingSetup/Scheduled?'+(options.search!=null?'&search='+options.search:'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.active!=null?'&active='+options.active:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ScheduledReportingSetupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_show
*	All: -
*/
public shared_ReportingSetup_retrieveById(reporting_setup_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingSetupDTO> {
let url = '/Shared/ReportingSetup/'+reporting_setup_id+'';
return <Observable<ReportingSetupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_setup_show
*	All: -
*/
public shared_ReportingSetup_retrieveScheduledReportingSetupById(reporting_setup_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ScheduledReportingSetupDTO> {
let url = '/Shared/ReportingSetup/Scheduled/'+reporting_setup_id+'';
return <Observable<ScheduledReportingSetupDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.ReportingTemplate:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_template_create
*	All: -
*/
public shared_ReportingTemplate_createReportingTemplate(reporting_type : number, reportingTemplateFullDTO : ReportingTemplateFullDTO, mode:Mode=Mode.Entity) : Observable<ReportingTemplateFullDTO> {
let url = '/Shared/ReportingTemplate/Type/'+reporting_type+'';
return <Observable<ReportingTemplateFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, reportingTemplateFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_template_delete
*	All: -
*/
public shared_ReportingTemplate_deleteReportingTemplate(reporting_template_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/ReportingTemplate/'+reporting_template_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_template_edit
*	All: -
*/
public shared_ReportingTemplate_editReportingTemplate(reportingTemplateFullDTO : ReportingTemplateFullDTO, mode:Mode=Mode.Entity) : Observable<ReportingTemplateFullDTO> {
let url = '/Shared/ReportingTemplate';
return <Observable<ReportingTemplateFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, reportingTemplateFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_template_list
*	All: -
*/
public shared_ReportingTemplate_retrieveAll(options: {search? : string,
reporting_type_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingTemplateFullDTO[]> {
if(!options)
options={};
let url = '/Shared/ReportingTemplate?'+(options.search!=null?'&search='+options.search:'')+
''+(options.reporting_type_id!=null?''+this.api.queryParamArrayPrepare('reporting_type_id',options.reporting_type_id):'')+
'';
return <Observable<ReportingTemplateFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_template_show
*	All: -
*/
public shared_ReportingTemplate_retrieveById(reporting_template_id : number, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingTemplateFullDTO> {
let url = '/Shared/ReportingTemplate/'+reporting_template_id+'';
return <Observable<ReportingTemplateFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.ReportingType:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_type_list
*	All: -
*/
public shared_ReportingType_retrieveAll(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingTypeDTO[]> {
if(!options)
options={};
let url = '/Shared/ReportingType?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<ReportingTypeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: reporting_type_show
*	All: -
*/
public shared_ReportingType_retrieveById(reporting_id : number, options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ReportingTypeDTO> {
if(!options)
options={};
let url = '/Shared/ReportingType/'+reporting_id+'?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<ReportingTypeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.Setting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_setting_delete
*	All: -
*/
public shared_Setting_deleteSetting(setting_key : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Setting/'+encodeURIComponent(setting_key)+'/Client';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_setting_edit
*	All: -
*/
public shared_Setting_editSetting(settingFullDTO : SettingFullDTO, mode:Mode=Mode.Entity) : Observable<SettingFullDTO> {
let url = '/Setting';
return <Observable<SettingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, settingFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_setting_list
*	All: -
*/
public shared_Setting_getClientSettings(options: {setting? : string[],
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/Setting/Client?'+(options.setting!=null?''+this.api.queryParamArrayPrepare('setting',options.setting):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_setting_show
*	All: -
*/
public shared_Setting_getSetting(setting_key : string, mode:Mode=Mode.Entity) : Observable<SettingDTO> {
let url = '/Setting/'+encodeURIComponent(setting_key)+'/Client';
return <Observable<SettingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Setting_getSettings(options: {setting? : string[],
search? : string} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/Setting?'+(options.setting!=null?''+this.api.queryParamArrayPrepare('setting',options.setting):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Setting_getSettingValue(setting_key : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/Setting/'+encodeURIComponent(setting_key)+'/Value';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.SHARED:
// Methods implemented by de.seatback.adplacer.api.shared.SSP:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ssp_list
*	All: -
*/
public shared_SSP_retrieveAll(options: {ssp_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<SSPDTO[]> {
if(!options)
options={};
let url = '/Shared/SSP?'+(options.ssp_id!=null?''+this.api.queryParamArrayPrepare('ssp_id',options.ssp_id):'')+
'';
return <Observable<SSPDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.SSPContract:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: deal_create
*	All: -
*/
public shared_SSPContract_createDeal(sspContract_id : number, dealDTO : DealDTO, mode:Mode=Mode.Entity) : Observable<DealDTO> {
let url = '/Shared/SSPContract/'+sspContract_id+'/Deal';
return <Observable<DealDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, dealDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ssp_contract_create
*	All: -
*/
public shared_SSPContract_createSSPContract(sSPContractDTO : SSPContractDTO, mode:Mode=Mode.Entity) : Observable<SSPContractDTO> {
let url = '/Shared/SSPContract';
return <Observable<SSPContractDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, sSPContractDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ssp_contract_delete
*	All: -
*/
public shared_SSPContract_deleteSSPContract(sspContract_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/SSPContract/'+sspContract_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ssp_contract_edit
*	All: -
*/
public shared_SSPContract_editSSPContract(sSPContractDTO : SSPContractDTO, mode:Mode=Mode.Entity) : Observable<SSPContractDTO> {
let url = '/Shared/SSPContract';
return <Observable<SSPContractDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, sSPContractDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ssp_contract_list
*	All: -
*/
public shared_SSPContract_retrieveAll(options: {ssp_contract_id? : number[],
ssp_id? : number[],
identifier? : string[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<SSPContractDTO[]> {
if(!options)
options={};
let url = '/Shared/SSPContract?'+(options.ssp_contract_id!=null?''+this.api.queryParamArrayPrepare('ssp_contract_id',options.ssp_contract_id):'')+
''+(options.ssp_id!=null?''+this.api.queryParamArrayPrepare('ssp_id',options.ssp_id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<SSPContractDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ssp_contract_show
*	All: -
*/
public shared_SSPContract_retrieveById(sspContract_id : number, mode:Mode=Mode.Entity) : Observable<SSPContractDTO> {
let url = '/Shared/SSPContract/'+sspContract_id+'';
return <Observable<SSPContractDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Status:

public shared_Status_badges(mode:Mode=Mode.Entity) : Observable<BadgesDTO> {
let url = '/Status/Badges';
return <Observable<BadgesDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_Status_status(mode:Mode=Mode.Entity) : Observable<UserClientFullDTO> {
let url = '/Status';
return <Observable<UserClientFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.System:

public shared_System_aiServiceURL(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/System/AIServiceURL';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_System_retrieveDefaultRolesAllAsTypescriptEnum(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/System/Role/Default/Enum/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_System_retrieveDefaultRolesTranslatorTS(mode:Mode=Mode.Entity) : Observable<string> {
let url = '/System/Role/Default/Translator/TS';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.shared.Tag:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_create
*	All: -
*/
public shared_Tag_createTag(tagDTO : TagDTO, mode:Mode=Mode.Entity) : Observable<TagDTO> {
let url = '/Tag';
return <Observable<TagDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, tagDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_connect
*	All: -
*/
public shared_Tag_createTagEntity(tag_id : number, linkedEntity_type : string, linkedEntity_id : number, mode:Mode=Mode.Entity) : Observable<TagEntityDTO> {
let url = '/Tag/'+tag_id+'/'+encodeURIComponent(linkedEntity_type)+'/'+linkedEntity_id+'';
return <Observable<TagEntityDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_delete
*	All: -
*/
public shared_Tag_deleteTag(tag_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Tag/'+tag_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_disconnect
*	All: -
*/
public shared_Tag_deleteTagEntity(tag_id : number, linkedEntity_type : string, linkedEntity_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Tag/'+tag_id+'/'+encodeURIComponent(linkedEntity_type)+'/'+linkedEntity_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_edit
*	All: -
*/
public shared_Tag_editTag(tagDTO : TagDTO, mode:Mode=Mode.Entity) : Observable<TagDTO> {
let url = '/Tag';
return <Observable<TagDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, tagDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_list
*	All: -
*/
public shared_Tag_getDtoEnums(mode:Mode=Mode.Entity) : Observable<string[]> {
let url = '/Tag/PolymorphicEntities';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_show
*	All: -
*/
public shared_Tag_getTag(tag_id : number, mode:Mode=Mode.Entity) : Observable<TagDTO> {
let url = '/Tag/'+tag_id+'';
return <Observable<TagDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_connection_list
*	All: -
*/
public shared_Tag_getTagEntitiesInBulkGroupByLinkedEntityId(linkedEntity_type : string, options: {linkedEntity_id? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/Tag/TagEntity/'+encodeURIComponent(linkedEntity_type)+'?'+(options.linkedEntity_id!=null?''+this.api.queryParamArrayPrepare('linkedEntity_id',options.linkedEntity_id):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_connection_list
*	All: -
*/
public shared_Tag_getTagEntity(linkedEntity_type : string, linkedLinkedEntity_id : number, mode:Mode=Mode.Entity) : Observable<TagEntityDTO[]> {
let url = '/Tag/TagEntity/'+encodeURIComponent(linkedEntity_type)+'/'+linkedLinkedEntity_id+'';
return <Observable<TagEntityDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: tag_list
*	All: -
*/
public shared_Tag_getTags(options: {search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TagDTO[]> {
if(!options)
options={};
let url = '/Tag?'+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TagDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.TimeRange:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: time_range_create
*	All: -
*/
public shared_TimeRange_createTimeRange(timeRangeDTO : TimeRangeDTO, options: {previewDateTime? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<TimeRangeDTO> {
if(!options)
options={};
let url = '/Shared/TimeRange?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<TimeRangeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, timeRangeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: time_range_create
*	All: -
*/
public shared_TimeRange_createTimeRangePreview(timeRangeDTO : TimeRangeDTO, options: {previewDateTime? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<TimeRangeDTO> {
if(!options)
options={};
let url = '/Shared/TimeRange//Preview?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<TimeRangeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, timeRangeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: time_range_delete
*	All: -
*/
public shared_TimeRange_deleteTimeRange(timeRange_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/Shared/TimeRange/'+timeRange_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: time_range_edit
*	All: -
*/
public shared_TimeRange_editTimeRange(timeRangeDTO : TimeRangeDTO, options: {previewDateTime? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<TimeRangeDTO> {
if(!options)
options={};
let url = '/Shared/TimeRange?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<TimeRangeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, timeRangeDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: time_range_list
*	All: -
*/
public shared_TimeRange_retrieveAll(options: {search? : string,
previewDateTime? : SbDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TimeRangeDTO[]> {
if(!options)
options={};
let url = '/Shared/TimeRange?'+(options.search!=null?'&search='+options.search:'')+
''+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<TimeRangeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: time_range_show
*	All: -
*/
public shared_TimeRange_retrieveById(timeRange_id : number, options: {previewDateTime? : SbDateTime} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TimeRangeDTO> {
if(!options)
options={};
let url = '/Shared/TimeRange/'+timeRange_id+'?'+(options.previewDateTime!=null?'&previewDateTime='+this.api.queryParamDatePrepare(options.previewDateTime):'')+
'';
return <Observable<TimeRangeDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.shared.User:

public shared_User_changeEmail(changeEmailDTO : ChangeEmailDTO, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/User/Email';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, changeEmailDTO));
}
public shared_User_changePassword(changePasswordDTO : ChangePasswordDTO, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/User/Password';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, changePasswordDTO));
}
public shared_User_changePrimaryClient(clientDTO : ClientDTO, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/User/PrimaryClient';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, clientDTO));
}
public shared_User_changeUsername(changeUsernameDTO : ChangeUsernameDTO, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/User/Username';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, changeUsernameDTO));
}
public shared_User_clearClientSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/ClientSettings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_User_clearSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_User_clearWebSettingByField(field : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/User/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_User_clearWebSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_User_clipAvatar(fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/User/Avatar';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
public shared_User_definitionAvatar(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/User/Avatar';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_deleteAvatar(mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/User/Avatar';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
public shared_User_edit(userFullDTO : UserFullDTO, mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/User';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, userFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_create
*	All: -
*/
public shared_User_findUserByEmail(email : string, mode:Mode=Mode.Entity) : Observable<ManagedUserDTO> {
let url = '/User/FindByEmail/'+encodeURIComponent(email)+'';
return <Observable<ManagedUserDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: client_user_create
*	All: -
*/
public shared_User_registerUser(managedUserDTO : ManagedUserDTO, options: {mailLanguage? : string} = {}, mode:Mode=Mode.Entity) : Observable<ManagedUserDTO> {
if(!options)
options={};
let url = '/User?'+(options.mailLanguage!=null?'&mailLanguage='+options.mailLanguage:'')+
'';
return <Observable<ManagedUserDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, managedUserDTO));
}
public shared_User_retrieve(mode:Mode=Mode.Entity) : Observable<UserFullDTO> {
let url = '/User';
return <Observable<UserFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_retrieveById(user_id : number, mode:Mode=Mode.Entity) : Observable<UserDTO> {
let url = '/User/'+user_id+'';
return <Observable<UserDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_retrieveClientSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/ClientSettings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_retrieveSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_retrieveWebSettingByField(field : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/User/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_retrieveWebSettings(mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public shared_User_updateClientSettings(map : any, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/ClientSettings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, map));
}
public shared_User_updateSettings(map : any, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/Settings';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, map));
}
public shared_User_updateWebSettingByField(field : string, string : string, mode:Mode=Mode.Entity) : Observable<string> {
let url = '/User/WebSetting/'+encodeURIComponent(field)+'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, string));
}
public shared_User_updateWebSettings(map : any, mode:Mode=Mode.Entity) : Observable<any> {
let url = '/User/WebSetting';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, map));
}
public shared_User_uploadAvatar(singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/User/Avatar';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ss.cd.CD:
// Methods implemented by de.seatback.adplacer.api.ss.cd.Playout:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_cd_Playout_exportCSV(options: {descriptor? : number[],
advertiser? : number[],
device? : number[],
screen? : number[],
from? : SbDateTime,
till? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/CD/Playout/CSV?'+(options.descriptor!=null?''+this.api.queryParamArrayPrepare('descriptor',options.descriptor):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_cd_Playout_fetch(options: {descriptor? : number[],
advertiser? : number[],
device? : number[],
screen? : number[],
after_timestamp? : SbDateTime,
after_descriptor? : number,
from? : SbDateTime,
till? : SbDateTime,
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<PlayoutBaseDTO[]> {
if(!options)
options={};
let url = '/SS/CD/Playout?'+(options.descriptor!=null?''+this.api.queryParamArrayPrepare('descriptor',options.descriptor):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.after_timestamp!=null?'&after_timestamp='+this.api.queryParamDatePrepare(options.after_timestamp):'')+
''+(options.after_descriptor!=null?'&after_descriptor='+options.after_descriptor:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<PlayoutBaseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.cd.PlayoutDescriptor:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_cd_PlayoutDescriptor_exportCSV(options: {id? : number[],
advertiser? : number[],
device? : number[],
screen? : number[],
booking? : number[],
medium? : number[],
productive? : boolean,
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/CD/PlayoutDescriptor/CSV?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_cd_PlayoutDescriptor_exportCSVWithFullDetails(options: {id? : number[],
advertiser? : number[],
device? : number[],
screen? : number[],
booking? : number[],
medium? : number[],
productive? : boolean,
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/CD/PlayoutDescriptor/Full/CSV?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_cd_PlayoutDescriptor_retrieveAll(options: {id? : number[],
advertiser? : number[],
device? : number[],
screen? : number[],
booking? : number[],
medium? : number[],
productive? : boolean,
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
order? : {by: ss_cd_PlayoutDescriptor_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PublisherPlayoutDescriptorFullDTO[]> {
if(!options)
options={};
let url = '/SS/CD/PlayoutDescriptor?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PublisherPlayoutDescriptorFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.fm.FM:
// Methods implemented by de.seatback.adplacer.api.ss.fm.Location:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_clipHeaderImage(location_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/FM/Location/'+location_id+'/HeaderImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_clipLogo(location_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/FM/Location/'+location_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_copyHeaderImageFrom(location_id : number, from_location_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/FM/Location/'+location_id+'/HeaderImage/Copy/'+from_location_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_copyLogoFrom(location_id : number, from_location_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/FM/Location/'+location_id+'/Logo/Copy/'+from_location_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_create
*	All: -
*/
public ss_fm_Location_createLocation(locationFullDTO : LocationFullDTO, mode:Mode=Mode.Entity) : Observable<LocationFullDTO> {
let url = '/SS/FM/Location';
return <Observable<LocationFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, locationFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_create
*	All: -
*/
public ss_fm_Location_createLocationManagedByCompany(company_id : number, locationFullDTO : LocationFullDTO, mode:Mode=Mode.Entity) : Observable<LocationFullDTO> {
let url = '/SS/FM/Location/ManagedByCompany/'+company_id+'';
return <Observable<LocationFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, locationFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_definitionHeaderImage(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/SS/FM/Location/HeaderImage';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_definitionLogo(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/SS/FM/Location/Logo';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_delete
*	All: -
*/
public ss_fm_Location_deleteById(location_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/FM/Location/'+location_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_deleteHeaderImage(location_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/FM/Location/'+location_id+'/HeaderImage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_deleteLogo(location_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/FM/Location/'+location_id+'/Logo';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_editLocation(locationDTO : LocationDTO, mode:Mode=Mode.Entity) : Observable<LocationDTO> {
let url = '/SS/FM/Location';
return <Observable<LocationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_editLocations(locationDTO : LocationDTO[], mode:Mode=Mode.Entity) : Observable<LocationDTO[]> {
let url = '/SS/FM/Location/Mass';
return <Observable<LocationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, locationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_export
*	All: -
*/
public ss_fm_Location_export(options: {search? : string,
hasPoint? : boolean,
hasDevices? : boolean,
hasManager? : boolean,
onlineStatus? : LocationOnlineStatus[],
manager? : number[],
identifier? : string[],
id? : number[],
playerCull? : number[],
playerCullIntersection? : boolean,
locationType? : number[],
serviceHour? : number[],
reportName? : string,
filter? : {by: ss_fm_Location_export_filter, param?: string, values: string[]}[],
order? : {by: ss_fm_Location_export_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ReportingFullDTO> {
if(!options)
options={};
let url = '/SS/FM/Location/Export?'+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPoint!=null?'&hasPoint='+options.hasPoint:'')+
''+(options.hasDevices!=null?'&hasDevices='+options.hasDevices:'')+
''+(options.hasManager!=null?'&hasManager='+options.hasManager:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.manager!=null?''+this.api.queryParamArrayPrepare('manager',options.manager):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.locationType!=null?''+this.api.queryParamArrayPrepare('locationType',options.locationType):'')+
''+(options.serviceHour!=null?''+this.api.queryParamArrayPrepare('serviceHour',options.serviceHour):'')+
''+(options.reportName!=null?'&reportName='+options.reportName:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ReportingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_removeServiceHours(location_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/FM/Location/'+location_id+'/ServiceHours/';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_resolveAndUpdateAllPointsFromAddresses(pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LocationFullDTO[]> {
let url = '/SS/FM/Location/ResolveAllPointsFromAddresses';
return <Observable<LocationFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_resolveAndUpdatePointFromAddress(location_id : number, mode:Mode=Mode.Entity) : Observable<LocationFullDTO> {
let url = '/SS/FM/Location/'+location_id+'/ResolvePointFromAddress';
return <Observable<LocationFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_show
*	All: -
*/
public ss_fm_Location_resolvePointFromAddress(location_id : number, mode:Mode=Mode.Entity) : Observable<Point> {
let url = '/SS/FM/Location/'+location_id+'/ResolvePointFromAddress';
return <Observable<Point>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_list
*	All: -
*/
public ss_fm_Location_retrieveAll(options: {search? : string,
hasPoint? : boolean,
hasDevices? : boolean,
hasManager? : boolean,
onlineStatus? : LocationOnlineStatus[],
manager? : number[],
identifier? : string[],
id? : number[],
playerCull? : number[],
playerCullIntersection? : boolean,
locationType? : number[],
serviceHour? : number[],
filter? : {by: ss_fm_Location_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: ss_fm_Location_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<LocationFullDTO[]> {
if(!options)
options={};
let url = '/SS/FM/Location?'+(options.search!=null?'&search='+options.search:'')+
''+(options.hasPoint!=null?'&hasPoint='+options.hasPoint:'')+
''+(options.hasDevices!=null?'&hasDevices='+options.hasDevices:'')+
''+(options.hasManager!=null?'&hasManager='+options.hasManager:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.manager!=null?''+this.api.queryParamArrayPrepare('manager',options.manager):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.locationType!=null?''+this.api.queryParamArrayPrepare('locationType',options.locationType):'')+
''+(options.serviceHour!=null?''+this.api.queryParamArrayPrepare('serviceHour',options.serviceHour):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<LocationFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_show
*	All: -
*/
public ss_fm_Location_retrieveById(location_id : number, mode:Mode=Mode.Entity) : Observable<LocationFullDTO> {
let url = '/SS/FM/Location/'+location_id+'';
return <Observable<LocationFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_devices_show
*	All: -
*/
public ss_fm_Location_retrieveDevicesByLocationId(location_id : number, options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
hasServiceRequest? : boolean,
onlineStatus? : DeviceOnlineStatus[],
paired? : boolean,
channel? : number[],
pool? : number[],
hasPool? : boolean,
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
playerCull? : number[],
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ss_fm_Location_retrieveDevicesByLocationId_filter, param?: string, values: string[]}[],
order? : {by: ss_fm_Location_retrieveDevicesByLocationId_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO[]> {
if(!options)
options={};
let url = '/SS/FM/Location/'+location_id+'/Devices?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.hasServiceRequest!=null?'&hasServiceRequest='+options.hasServiceRequest:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.paired!=null?'&paired='+options.paired:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.pool!=null?''+this.api.queryParamArrayPrepare('pool',options.pool):'')+
''+(options.hasPool!=null?'&hasPool='+options.hasPool:'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<DeviceFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_show
*	All: -
*/
public ss_fm_Location_retrieveVisitorsForDateByLocationId(location_id : number, date : SbDateTime, mode:Mode=Mode.Entity) : Observable<VisitorAggregationDate> {
let url = '/SS/FM/Location/'+location_id+'/Visitors/'+date+'';
return <Observable<VisitorAggregationDate>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_show
*	All: -
*/
public ss_fm_Location_retrieveVisitorsForLocalDateByLocationId(location_id : number, date : SbLocalDate, mode:Mode=Mode.Entity) : Observable<VisitorAggregationDate> {
let url = '/SS/FM/Location/'+location_id+'/Visitors/'+date+'/Local';
return <Observable<VisitorAggregationDate>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_setServiceHoursByDefinition(location_id : number, weeklySchedule_id : number, mode:Mode=Mode.Entity) : Observable<LocationFullDTO> {
let url = '/SS/FM/Location/'+location_id+'/ServiceHours/'+weeklySchedule_id+'';
return <Observable<LocationFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_setVisitorsForDateByLocationId(location_id : number, date : SbDateTime, uniqueVisitorAggregationDate : UniqueVisitorAggregationDate, mode:Mode=Mode.Entity) : Observable<VisitorAggregationDate> {
let url = '/SS/FM/Location/'+location_id+'/Visitors/'+date+'';
return <Observable<VisitorAggregationDate>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, uniqueVisitorAggregationDate));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_setVisitorsForLocalDateByLocationId(location_id : number, date : SbLocalDate, uniqueVisitorAggregationDate : UniqueVisitorAggregationDate, mode:Mode=Mode.Entity) : Observable<VisitorAggregationDate> {
let url = '/SS/FM/Location/'+location_id+'/Visitors/'+date+'/Local';
return <Observable<VisitorAggregationDate>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, uniqueVisitorAggregationDate));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_uploadHeaderImage(location_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/FM/Location/'+location_id+'/HeaderImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_edit
*	All: -
*/
public ss_fm_Location_uploadLogo(location_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/FM/Location/'+location_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_visitor_aggregation
*	All: -
*/
public ss_fm_Location_visitorAggregation(location_id : number, options: {productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/SS/FM/Location/'+location_id+'/VisitorAggregation?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: location_visitor_aggregation
*	All: -
*/
public ss_fm_Location_visitorAggregationByChannels(location_id : number, options: {id? : number[],
productive? : boolean,
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
locations? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/SS/FM/Location/'+location_id+'/VisitorAggregation/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.fm.Reporting:
// Methods implemented by de.seatback.adplacer.api.ss.nm.Blacklist:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_booking_blacklist_create
*	All: -
*/
public ss_nm_Blacklist_createScreenBookingBlacklist(screen_id : number, booking_id : number, mode:Mode=Mode.Entity) : Observable<ScreenBlacklistDTO> {
let url = '/SS/NM/Blacklist/Screen/'+screen_id+'/Booking/'+booking_id+'';
return <Observable<ScreenBlacklistDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_booking_blacklist_delete
*	All: -
*/
public ss_nm_Blacklist_deleteScreenBookingBlacklist(screen_id : number, booking_id : number, mode:Mode=Mode.Entity) : Observable<ScreenBlacklistDTO[]> {
let url = '/SS/NM/Blacklist/Screen/'+screen_id+'/Booking/'+booking_id+'';
return <Observable<ScreenBlacklistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_booking_blacklist_list
*	All: -
*/
public ss_nm_Blacklist_retrieveAllBlacklistedBookings(options: {id? : number[],
advertiser_id? : number[],
publisher_id? : number[],
location_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
media_id? : number[],
timingStatus? : TimingStatus[],
status? : BookingStatus[],
deprecated? : boolean,
finished? : boolean,
contentCull? : number[],
order? : {by: ss_nm_Blacklist_retrieveAllBlacklistedBookings_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<InventoryBookingDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Blacklist/Booking?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser_id!=null?''+this.api.queryParamArrayPrepare('advertiser_id',options.advertiser_id):'')+
''+(options.publisher_id!=null?''+this.api.queryParamArrayPrepare('publisher_id',options.publisher_id):'')+
''+(options.location_id!=null?''+this.api.queryParamArrayPrepare('location_id',options.location_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.media_id!=null?''+this.api.queryParamArrayPrepare('media_id',options.media_id):'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.deprecated!=null?'&deprecated='+options.deprecated:'')+
''+(options.finished!=null?'&finished='+options.finished:'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<InventoryBookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: screen_booking_blacklist_list
*	All: -
*/
public ss_nm_Blacklist_retrieveAllBlacklists(options: {screens? : number[],
bookings? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ScreenBlacklistDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Blacklist?'+(options.screens!=null?''+this.api.queryParamArrayPrepare('screens',options.screens):'')+
''+(options.bookings!=null?''+this.api.queryParamArrayPrepare('bookings',options.bookings):'')+
'';
return <Observable<ScreenBlacklistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Booking:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_booking_list
*	All: -
*/
public ss_nm_Booking_retrieveAll(options: {advertiser_id? : number,
id? : number[],
customer_id? : number[],
search? : string,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
marker_id? : number[],
media_id? : number[],
timingStatus? : TimingStatus[],
status? : BookingStatus[],
deprecated? : boolean,
excluded? : boolean,
current? : boolean,
finished? : boolean,
contentCull? : number[],
order? : {by: ss_nm_Booking_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PublisherBookingDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Booking?'+(options.advertiser_id!=null?'&advertiser_id='+options.advertiser_id:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.customer_id!=null?''+this.api.queryParamArrayPrepare('customer_id',options.customer_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.marker_id!=null?''+this.api.queryParamArrayPrepare('marker_id',options.marker_id):'')+
''+(options.media_id!=null?''+this.api.queryParamArrayPrepare('media_id',options.media_id):'')+
''+(options.timingStatus!=null?''+this.api.queryParamArrayPrepare('timingStatus',options.timingStatus):'')+
''+(options.status!=null?''+this.api.queryParamArrayPrepare('status',options.status):'')+
''+(options.deprecated!=null?'&deprecated='+options.deprecated:'')+
''+(options.excluded!=null?'&excluded='+options.excluded:'')+
''+(options.current!=null?'&current='+options.current:'')+
''+(options.finished!=null?'&finished='+options.finished:'')+
''+(options.contentCull!=null?''+this.api.queryParamArrayPrepare('contentCull',options.contentCull):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PublisherBookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_booking_show
*	All: -
*/
public ss_nm_Booking_retrieveById(booking_id : number, mode:Mode=Mode.Entity) : Observable<PublisherBookingDTO> {
let url = '/SS/NM/Booking/'+booking_id+'';
return <Observable<PublisherBookingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Channel:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_clipAmbianceImage(channel_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/AmbianceImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_clipLogo(channel_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_copyAmbianceImageFrom(channel_id : number, from_channel_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/AmbianceImage/Copy/'+from_channel_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_copyLogoFrom(channel_id : number, from_channel_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/Logo/Copy/'+from_channel_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_create
*	All: -
*/
public ss_nm_Channel_create(channelFullDTO : ChannelFullDTO, mode:Mode=Mode.Entity) : Observable<ChannelFullDTO> {
let url = '/SS/NM/Channel';
return <Observable<ChannelFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, channelFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Channel_createDevice(channel_id : number, deviceFullDTO : DeviceFullDTO, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/Device';
return <Observable<DeviceFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, deviceFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Channel_createDeviceAtLocation(channel_id : number, location_id : number, deviceFullDTO : DeviceFullDTO, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/'+location_id+'/Device';
return <Observable<DeviceFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, deviceFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Channel_createDevices(channel_id : number, deviceFullDTO : DeviceFullDTO[], mode:Mode=Mode.Entity) : Observable<DeviceFullDTO[]> {
let url = '/SS/NM/Channel/'+channel_id+'/Devices';
return <Observable<DeviceFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, deviceFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Channel_createDevicesAtLocation(channel_id : number, location_id : number, deviceFullDTO : DeviceFullDTO[], mode:Mode=Mode.Entity) : Observable<DeviceFullDTO[]> {
let url = '/SS/NM/Channel/'+channel_id+'/'+location_id+'/Devices';
return <Observable<DeviceFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, deviceFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_definitionAmbianceImage(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/SS/NM/Channel/AmbianceImage';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_definitionLogo(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/SS/NM/Channel/Logo';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_deleteAmbianceImage(channel_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Channel/'+channel_id+'/AmbianceImage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_delete
*	All: -
*/
public ss_nm_Channel_deleteById(channel_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Channel/'+channel_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_deleteLogo(channel_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Channel/'+channel_id+'/Logo';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_upload
*	All: -
*/
public ss_nm_Channel_getBookableMarkers(mode:Mode=Mode.Entity) : Observable<MarkerDTO[]> {
let url = '/SS/NM/Channel/BookableMarker';
return <Observable<MarkerDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_lock
*	All: -
*/
public ss_nm_Channel_lockChannel(channel_id : number, mode:Mode=Mode.Entity) : Observable<ChannelFullDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/Lock';
return <Observable<ChannelFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_list
*	All: -
*/
public ss_nm_Channel_retrieveAll(options: {search? : string,
locked? : boolean,
hasDevices? : boolean,
id? : number[],
width? : number[],
height? : number[],
resolution? : Resolution[],
order? : {by: ss_nm_Channel_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ChannelFullDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Channel?'+(options.search!=null?'&search='+options.search:'')+
''+(options.locked!=null?'&locked='+options.locked:'')+
''+(options.hasDevices!=null?'&hasDevices='+options.hasDevices:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.width!=null?''+this.api.queryParamArrayPrepare('width',options.width):'')+
''+(options.height!=null?''+this.api.queryParamArrayPrepare('height',options.height):'')+
''+(options.resolution!=null?''+this.api.queryParamArrayPrepare('resolution',this.api.queryParamResolutionPrepare(options.resolution)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ChannelFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_list
*	All: -
*/
public ss_nm_Channel_retrieveAllResolutions(mode:Mode=Mode.Entity) : Observable<ResolutionDTO[]> {
let url = '/SS/NM/Channel/UsedResolutions';
return <Observable<ResolutionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_show
*	All: -
*/
public ss_nm_Channel_retrieveById(channel_id : number, mode:Mode=Mode.Entity) : Observable<ChannelFullDTO> {
let url = '/SS/NM/Channel/'+channel_id+'';
return <Observable<ChannelFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Channel_retrieveDeviceByChannelId(channel_id : number, mode:Mode=Mode.Entity) : Observable<DeviceDTO[]> {
let url = '/SS/NM/Channel/'+channel_id+'/Devices';
return <Observable<DeviceDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_updateById(channelFullDTO : ChannelFullDTO, mode:Mode=Mode.Entity) : Observable<ChannelFullDTO> {
let url = '/SS/NM/Channel';
return <Observable<ChannelFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, channelFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_uploadAmbianceImage(channel_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/AmbianceImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: channel_edit
*	All: -
*/
public ss_nm_Channel_uploadLogo(channel_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Channel/'+channel_id+'/Logo';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Device:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Device_clipHeaderImage(device_id : number, fixedAspectRatioImageDTO : FixedAspectRatioImageDTO, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Device/'+device_id+'/HeaderImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, fixedAspectRatioImageDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Device_copyHeaderImageFrom(device_id : number, from_device_id : number, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Device/'+device_id+'/HeaderImage/Copy/'+from_device_id+'';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Device_definitionHeaderImage(mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDefinitionDTO> {
let url = '/SS/NM/Device/HeaderImage';
return <Observable<FixedAspectRatioImageDefinitionDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_delete
*	All: -
*/
public ss_nm_Device_deleteDevice(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_playlist_cache_delete
*	All: -
*/
public ss_nm_Device_deleteDevicePlaylistCache(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'/PlaylistCache';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: device_delete, device_mass_edit
*/
public ss_nm_Device_deleteDevices(options: {devices? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device?'+this.api.queryParamArrayPrepare('devices',options.devices)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Device_deleteHeaderImage(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'/HeaderImage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: device_playlist_cache_delete, device_mass_action
*/
public ss_nm_Device_deletesDevicePlaylistCache(options: {devices? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/PlaylistCache?'+this.api.queryParamArrayPrepare('devices',options.devices)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_properties_edit
*	All: -
*/
public ss_nm_Device_editDevice(ownedDeviceBaseDTO : OwnedDeviceBaseDTO, mode:Mode=Mode.Entity) : Observable<DeviceDTO> {
let url = '/SS/NM/Device';
return <Observable<DeviceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, ownedDeviceBaseDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: device_properties_edit, device_mass_edit
*/
public ss_nm_Device_editDevices(ownedDeviceBaseDTO : OwnedDeviceBaseDTO[], mode:Mode=Mode.Entity) : Observable<DeviceDTO[]> {
let url = '/SS/NM/Device/Mass';
return <Observable<DeviceDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, ownedDeviceBaseDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_clear_local_data
*	All: -
*/
public ss_nm_Device_executeCommandClearLocalData(device_id : number, options: {scope? : LocalDataScope[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Command/ClearLocalData?'+(options.scope!=null?''+this.api.queryParamArrayPrepare('scope',options.scope):'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_clear_local_settings
*	All: -
*/
public ss_nm_Device_executeCommandClearLocalSettings(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'/Command/ClearSettings';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_exit_player
*	All: -
*/
public ss_nm_Device_executeCommandExitPlayer(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'/Command/ExitPlayer';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show_calibration_image
*	All: -
*/
public ss_nm_Device_executeCommandHideCalibrationImage(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'/Command/HideCalibrationImage';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_reboot
*	All: -
*/
public ss_nm_Device_executeCommandReboot(device_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/'+device_id+'/Command/Reboot';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show_calibration_image
*	All: -
*/
public ss_nm_Device_executeCommandShowCalibrationImage(device_id : number, options: {millis? : number} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Command/ShowCalibrationImage?millis='+options.millis+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export
*	All: -
*/
public ss_nm_Device_export(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
hasServiceRequest? : boolean,
onlineStatus? : DeviceOnlineStatus[],
paired? : boolean,
channel? : number[],
pool? : number[],
hasPool? : boolean,
location? : number[],
hasLocation? : boolean,
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
locationManager? : number[],
hasLocationManager? : boolean,
isLicensed? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
reportName? : string,
filter? : {by: ss_nm_Device_export_filter, param?: string, values: string[]}[],
order? : {by: ss_nm_Device_export_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<ReportingFullDTO> {
if(!options)
options={};
let url = '/SS/NM/Device/Export?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.hasServiceRequest!=null?'&hasServiceRequest='+options.hasServiceRequest:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.paired!=null?'&paired='+options.paired:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.pool!=null?''+this.api.queryParamArrayPrepare('pool',options.pool):'')+
''+(options.hasPool!=null?'&hasPool='+options.hasPool:'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.hasLocation!=null?'&hasLocation='+options.hasLocation:'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.locationManager!=null?''+this.api.queryParamArrayPrepare('locationManager',options.locationManager):'')+
''+(options.hasLocationManager!=null?'&hasLocationManager='+options.hasLocationManager:'')+
''+(options.isLicensed!=null?'&isLicensed='+options.isLicensed:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.reportName!=null?'&reportName='+options.reportName:'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ReportingFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_nm_Device_exportPlayoutDescriptors(device_id : number, options: {id? : number[],
advertiser? : number[],
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
screen? : number[],
booking? : number[],
medium? : number[],
productive? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/PlayoutDescriptor/CSV?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_nm_Device_exportPlayoutDescriptorsWithFullDetails(device_id : number, options: {id? : number[],
advertiser? : number[],
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
screen? : number[],
booking? : number[],
medium? : number[],
productive? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/PlayoutDescriptor/Full/CSV?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_nm_Device_exportPlayouts(device_id : number, options: {advertiser? : number[],
from? : SbDateTime,
till? : SbDateTime,
descriptor? : number[],
screen? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Playout/CSV?'+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.descriptor!=null?''+this.api.queryParamArrayPrepare('descriptor',options.descriptor):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_fetchPlayouts(device_id : number, options: {after_timestamp? : SbDateTime,
after_descriptor? : number,
advertiser? : number[],
from? : SbDateTime,
till? : SbDateTime,
descriptor? : number[],
screen? : number[],
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<PlayoutDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Playout?'+(options.after_timestamp!=null?'&after_timestamp='+this.api.queryParamDatePrepare(options.after_timestamp):'')+
''+(options.after_descriptor!=null?'&after_descriptor='+options.after_descriptor:'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.descriptor!=null?''+this.api.queryParamArrayPrepare('descriptor',options.descriptor):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<PlayoutDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_properties_edit
*	All: -
*/
public ss_nm_Device_fulfillServiceRequest(device_id : number, mode:Mode=Mode.Entity) : Observable<NotificationDTO> {
let url = '/SS/NM/Device/'+device_id+'/FulfillServiceRequest';
return <Observable<NotificationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_log
*	All: -
*/
public ss_nm_Device_logs(device_id : number, options: {after? : number,
from? : SbDateTime,
till? : SbDateTime,
datatype? : string[],
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<DeviceLogDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Log?'+(options.after!=null?'&after='+options.after:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.datatype!=null?''+this.api.queryParamArrayPrepare('datatype',options.datatype):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<DeviceLogDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: device_clear_local_settings, device_mass_action
*/
public ss_nm_Device_massExecuteCommandClearLocalSettings(options: {devices? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/Command/ClearSettings?'+this.api.queryParamArrayPrepare('devices',options.devices)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: device_exit_player, device_mass_action
*/
public ss_nm_Device_massExecuteCommandExitPlayer(options: {devices? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/Command/ExitPlayer?'+this.api.queryParamArrayPrepare('devices',options.devices)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: device_reboot, device_mass_action
*/
public ss_nm_Device_massExecuteCommandReboot(options: {devices? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/Command/Reboot?'+this.api.queryParamArrayPrepare('devices',options.devices)+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_pair, device_repair
*	All: -
*/
public ss_nm_Device_pair(device_id : number, token : string, mode:Mode=Mode.Entity) : Observable<DeviceConfigurationTokenDTO> {
let url = '/SS/NM/Device/'+device_id+'/Pair/'+encodeURIComponent(token)+'';
return <Observable<DeviceConfigurationTokenDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_pair, device_repair
*	All: -
*/
public ss_nm_Device_pairWithUUID(device_id : number, uuid : string, mode:Mode=Mode.Entity) : Observable<DeviceConfigurationTokenDTO> {
let url = '/SS/NM/Device/'+device_id+'/Pair/UUID/'+encodeURIComponent(uuid)+'';
return <Observable<DeviceConfigurationTokenDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_positions(device_id : number, options: {after? : SbDateTime,
from? : SbDateTime,
till? : SbDateTime,
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<PositionDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Position?'+(options.after!=null?'&after='+this.api.queryParamDatePrepare(options.after):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<PositionDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_list
*	All: -
*/
public ss_nm_Device_retrieveAll(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
hasServiceRequest? : boolean,
onlineStatus? : DeviceOnlineStatus[],
paired? : boolean,
channel? : number[],
pool? : number[],
hasPool? : boolean,
location? : number[],
hasLocation? : boolean,
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
locationManager? : number[],
hasLocationManager? : boolean,
isLicensed? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ss_nm_Device_retrieveAll_filter, param?: string, values: string[]}[],
order? : {by: ss_nm_Device_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.hasServiceRequest!=null?'&hasServiceRequest='+options.hasServiceRequest:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.paired!=null?'&paired='+options.paired:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.pool!=null?''+this.api.queryParamArrayPrepare('pool',options.pool):'')+
''+(options.hasPool!=null?'&hasPool='+options.hasPool:'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.hasLocation!=null?'&hasLocation='+options.hasLocation:'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.locationManager!=null?''+this.api.queryParamArrayPrepare('locationManager',options.locationManager):'')+
''+(options.hasLocationManager!=null?'&hasLocationManager='+options.hasLocationManager:'')+
''+(options.isLicensed!=null?'&isLicensed='+options.isLicensed:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<DeviceFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_retrieveAllPlayoutDescriptors(device_id : number, options: {id? : number[],
advertiser? : number[],
screen? : number[],
booking? : number[],
medium? : number[],
productive? : boolean,
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
order? : {by: ss_nm_Device_retrieveAllPlayoutDescriptors_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PublisherPlayoutDescriptorWithScreenDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/PlayoutDescriptor?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PublisherPlayoutDescriptorWithScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_list
*	All: -
*/
public ss_nm_Device_retrieveAllShortAttributes(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
hasServiceRequest? : boolean,
onlineStatus? : DeviceOnlineStatus[],
paired? : boolean,
channel? : number[],
pool? : number[],
hasPool? : boolean,
location? : number[],
hasLocation? : boolean,
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
locationManager? : number[],
hasLocationManager? : boolean,
isLicensed? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ss_nm_Device_retrieveAllShortAttributes_filter, param?: string, values: string[]}[],
order? : {by: ss_nm_Device_retrieveAllShortAttributes_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceFullShortAttributeDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/ShortAttributes?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.hasServiceRequest!=null?'&hasServiceRequest='+options.hasServiceRequest:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.paired!=null?'&paired='+options.paired:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.pool!=null?''+this.api.queryParamArrayPrepare('pool',options.pool):'')+
''+(options.hasPool!=null?'&hasPool='+options.hasPool:'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.hasLocation!=null?'&hasLocation='+options.hasLocation:'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.locationManager!=null?''+this.api.queryParamArrayPrepare('locationManager',options.locationManager):'')+
''+(options.hasLocationManager!=null?'&hasLocationManager='+options.hasLocationManager:'')+
''+(options.isLicensed!=null?'&isLicensed='+options.isLicensed:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<DeviceFullShortAttributeDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_retrieveById(device_id : number, mode:Mode=Mode.Entity) : Observable<DeviceDTO> {
let url = '/SS/NM/Device/'+device_id+'';
return <Observable<DeviceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_retrieveDeviceGeoStats(device_id : number, mode:Mode=Mode.Entity) : Observable<DeviceGeoStatsDTO> {
let url = '/SS/NM/Device/'+device_id+'/GeoStats';
return <Observable<DeviceGeoStatsDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_retrieveDeviceTrips(device_id : number, options: {withinPolygon? : Polygon[],
id? : number[],
from? : SbDateTime,
till? : SbDateTime,
order? : {by: ss_nm_Device_retrieveDeviceTrips_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<DeviceTripDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Trip?'+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<DeviceTripDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_retrieveFittingCulls(device_id : number, mode:Mode=Mode.Entity) : Observable<PlayerCullDTO[]> {
let url = '/SS/NM/Device/'+device_id+'/FittingCulls';
return <Observable<PlayerCullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Device_retrieveFullById(device_id : number, mode:Mode=Mode.Entity) : Observable<DeviceFullDTO> {
let url = '/SS/NM/Device/'+device_id+'/Full';
return <Observable<DeviceFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Device_retrieveOfflinePlaylist(device_id : number, mode:Mode=Mode.Entity) : Observable<SharedScreenOfflinePlaylistDTO[]> {
let url = '/SS/NM/Device/'+device_id+'/OfflinePlaylist';
return <Observable<SharedScreenOfflinePlaylistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_offline_playlist
*	All: -
*/
public ss_nm_Device_retrieveOfflinePlaylistNeon(device_id : number, mode:Mode=Mode.Entity) : Observable<FileLink> {
let url = '/SS/NM/Device/'+device_id+'/OfflinePlaylist/Neon';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_offline_playlist
*	All: -
*/
public ss_nm_Device_retrieveOfflinePlaylistSMIL(device_id : number, mode:Mode=Mode.Entity) : Observable<FileLink> {
let url = '/SS/NM/Device/'+device_id+'/OfflinePlaylist/SMIL';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Device_setCredentials(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
hasServiceRequest? : boolean,
onlineStatus? : DeviceOnlineStatus[],
paired? : boolean,
channel? : number[],
pool? : number[],
hasPool? : boolean,
location? : number[],
hasLocation? : boolean,
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
locationManager? : number[],
hasLocationManager? : boolean,
isLicensed? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ss_nm_Device_setCredentials_filter, param?: string, values: string[]}[],
order? : {by: ss_nm_Device_setCredentials_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<DeviceConfigurationEntryDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Credential?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.hasServiceRequest!=null?'&hasServiceRequest='+options.hasServiceRequest:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.paired!=null?'&paired='+options.paired:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.pool!=null?''+this.api.queryParamArrayPrepare('pool',options.pool):'')+
''+(options.hasPool!=null?'&hasPool='+options.hasPool:'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.hasLocation!=null?'&hasLocation='+options.hasLocation:'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.locationManager!=null?''+this.api.queryParamArrayPrepare('locationManager',options.locationManager):'')+
''+(options.hasLocationManager!=null?'&hasLocationManager='+options.hasLocationManager:'')+
''+(options.isLicensed!=null?'&isLicensed='+options.isLicensed:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<DeviceConfigurationEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
public ss_nm_Device_setCredentialsCSV(options: {productive? : boolean,
offline? : boolean,
external? : boolean,
disabled? : boolean,
hasServiceRequest? : boolean,
onlineStatus? : DeviceOnlineStatus[],
paired? : boolean,
channel? : number[],
pool? : number[],
hasPool? : boolean,
location? : number[],
hasLocation? : boolean,
playerHardware_id? : number[],
playerSoftware_id? : number[],
screenHardware_id? : number[],
locationType_id? : number[],
locationManager? : number[],
hasLocationManager? : boolean,
isLicensed? : boolean,
playerCull? : number[],
playerCullIntersection? : boolean,
search? : string,
tag? : number[],
withinPolygon? : Polygon[],
id? : number[],
identifier? : string[],
filter? : {by: ss_nm_Device_setCredentialsCSV_filter, param?: string, values: string[]}[],
order? : {by: ss_nm_Device_setCredentialsCSV_order, param?: string, direction: Order}} = {}, mode:Mode=Mode.Entity) : Observable<string> {
if(!options)
options={};
let url = '/SS/NM/Device/Credential/CSV?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.offline!=null?'&offline='+options.offline:'')+
''+(options.external!=null?'&external='+options.external:'')+
''+(options.disabled!=null?'&disabled='+options.disabled:'')+
''+(options.hasServiceRequest!=null?'&hasServiceRequest='+options.hasServiceRequest:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.paired!=null?'&paired='+options.paired:'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.pool!=null?''+this.api.queryParamArrayPrepare('pool',options.pool):'')+
''+(options.hasPool!=null?'&hasPool='+options.hasPool:'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.hasLocation!=null?'&hasLocation='+options.hasLocation:'')+
''+(options.playerHardware_id!=null?''+this.api.queryParamArrayPrepare('playerHardware_id',options.playerHardware_id):'')+
''+(options.playerSoftware_id!=null?''+this.api.queryParamArrayPrepare('playerSoftware_id',options.playerSoftware_id):'')+
''+(options.screenHardware_id!=null?''+this.api.queryParamArrayPrepare('screenHardware_id',options.screenHardware_id):'')+
''+(options.locationType_id!=null?''+this.api.queryParamArrayPrepare('locationType_id',options.locationType_id):'')+
''+(options.locationManager!=null?''+this.api.queryParamArrayPrepare('locationManager',options.locationManager):'')+
''+(options.hasLocationManager!=null?'&hasLocationManager='+options.hasLocationManager:'')+
''+(options.isLicensed!=null?'&isLicensed='+options.isLicensed:'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.tag!=null?''+this.api.queryParamArrayPrepare('tag',options.tag):'')+
''+(options.withinPolygon!=null?''+this.api.queryParamArrayPrepare('withinPolygon',options.withinPolygon):'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.identifier!=null?''+this.api.queryParamArrayPrepare('identifier',options.identifier):'')+
''+(options.filter!=null?''+this.api.queryParamArrayPrepare('filter',this.api.filterParamArray(options.filter)):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<string>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_unpair
*	All: -
*/
public ss_nm_Device_unpair(device_id : number, options: {clearLocalPairingData? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Device/'+device_id+'/Pair?'+(options.clearLocalPairingData!=null?'&clearLocalPairingData='+options.clearLocalPairingData:'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_create
*	All: -
*/
public ss_nm_Device_uploadHeaderImage(device_id : number, singleFileUpload : SingleFileUpload, mode:Mode=Mode.Entity) : Observable<FixedAspectRatioImageDTO> {
let url = '/SS/NM/Device/'+device_id+'/HeaderImage';
return <Observable<FixedAspectRatioImageDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, this.api.asMultipart(singleFileUpload)));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.DeviceLog:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_DeviceLog_datatypes(options: {id? : string[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<string[]> {
if(!options)
options={};
let url = '/SS/NM/DeviceLog/Datatype?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<string[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_log
*	All: -
*/
public ss_nm_DeviceLog_exportLogs(options: {id? : number[],
from? : SbDateTime,
till? : SbDateTime,
datatype? : string[],
device? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/DeviceLog/Export?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.datatype!=null?''+this.api.queryParamArrayPrepare('datatype',options.datatype):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_DeviceLog_fetchLogs(options: {id? : number[],
after? : number,
from? : SbDateTime,
till? : SbDateTime,
datatype? : string[],
device? : number[],
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<DeviceLogDTO[]> {
if(!options)
options={};
let url = '/SS/NM/DeviceLog?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.after!=null?'&after='+options.after:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.datatype!=null?''+this.api.queryParamArrayPrepare('datatype',options.datatype):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<DeviceLogDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.MediumTransformation:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: medium_edit, medium_transformation_show
*/
public ss_nm_MediumTransformation_applyToMediumById(id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<MediumDTO> {
let url = '/SS/NM/MediumTransformation/'+id+'/ApplyTo/Medium/'+medium_id+'';
return <Observable<MediumDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: -
*	All: medium_show, medium_transformation_show
*/
public ss_nm_MediumTransformation_getTransformedMediumByIdForTransformation(id : number, medium_id : number, mode:Mode=Mode.Entity) : Observable<MediumDTO> {
let url = '/SS/NM/MediumTransformation/'+id+'/Medium/'+medium_id+'';
return <Observable<MediumDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: medium_transformation_list
*	All: -
*/
public ss_nm_MediumTransformation_retrieveAll(options: {id? : number[],
global? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<MediumTransformationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/MediumTransformation?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<MediumTransformationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Network:

public ss_nm_Network_bookingFeed(options: {active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
location? : number[],
playerCull? : number[],
advertiser? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/BookingFeed?'+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_bookings(options: {id? : number[],
active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
location? : number[],
playerCull? : number[],
advertiser? : number[],
targeting? : number[],
isTargeted? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<BookingDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Bookings?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.targeting!=null?''+this.api.queryParamArrayPrepare('targeting',options.targeting):'')+
''+(options.isTargeted!=null?'&isTargeted='+options.isTargeted:'')+
'';
return <Observable<BookingDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Network_channelDeviceStatus(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ChannelDeviceStatusDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/ChannelDeviceStatus?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<ChannelDeviceStatusDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Network_channelDeviceStatusGroupedBy(groupedBy : string, options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Network/ChannelDeviceStatus/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Network_deviceStatus(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<ChannelDeviceStatusDTO> {
if(!options)
options={};
let url = '/SS/NM/Network/DeviceStatus?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<ChannelDeviceStatusDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Network_deviceStatusGroupedBy(groupedBy : string, options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Network/DeviceStatus/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Network_locationStatus(options: {playerCulls? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocationStatusDTO> {
if(!options)
options={};
let url = '/SS/NM/Network/LocationStatus?'+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<LocationStatusDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Network_locationStatusWithManager(options: {playerCulls? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocationStatusDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/LocationStatusWithManager?'+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<LocationStatusDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_recalculateVisitorAggregation(visitorRecalculationParameters : VisitorRecalculationParameters, options: {from? : SbDateTime,
till? : SbDateTime} = {}, mode:Mode=Mode.Entity) : Observable<boolean> {
if(!options)
options={};
let url = '/SS/NM/Network/RecalculateVisitorAggregation?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, visitorRecalculationParameters));
}
public ss_nm_Network_retrieveAllAggregatedPlaylistsByBookedMediumGroup(options: {active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
location? : number[],
playerCull? : number[],
advertiser? : number[],
targeting? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<BookedMediumGroupAggregatedPlaylistDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Playlist/Aggregated/BookedMediumGroup?'+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.targeting!=null?''+this.api.queryParamArrayPrepare('targeting',options.targeting):'')+
'';
return <Observable<BookedMediumGroupAggregatedPlaylistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_retrieveAllSharedContentShareAssignments(options: {planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
location? : number[],
playerCull? : number[],
advertiser? : number[],
targeting? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<SharedClientCentricContentShareAssignmentDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/ContentShareAssignment?'+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.targeting!=null?''+this.api.queryParamArrayPrepare('targeting',options.targeting):'')+
'';
return <Observable<SharedClientCentricContentShareAssignmentDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_retrieveAllSharedPlaybackSchedules(options: {planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
location? : number[],
playerCull? : number[],
advertiser? : number[],
targeting? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<SharedPlaybackScheduleDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/PlaybackSchedule?'+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.targeting!=null?''+this.api.queryParamArrayPrepare('targeting',options.targeting):'')+
'';
return <Observable<SharedPlaybackScheduleDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_retrieveAllSharedPlaylists(options: {active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
location? : number[],
playerCull? : number[],
advertiser? : number[],
targeting? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<SharedPlaylistDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Playlist?'+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.targeting!=null?''+this.api.queryParamArrayPrepare('targeting',options.targeting):'')+
'';
return <Observable<SharedPlaylistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_retrieveAllSharedSetlists(options: {active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
location? : number[],
marker? : number[],
channel? : number[],
playerCull? : number[],
advertiser? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<SharedSetlistDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Setlist?'+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
'';
return <Observable<SharedSetlistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_retrieveNetworkAccess(options: {active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
screen? : number[],
device? : number[],
location? : number[],
marker? : number[],
channel? : number[],
playerCull? : number[],
advertiser? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<SharedClientNetworkAccessDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Access?'+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
'';
return <Observable<SharedClientNetworkAccessDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Network_storeSharedPlaylists(options: {active? : boolean,
permitted? : boolean,
hasTemplateBookingPermittedScreenEntries? : boolean,
planning? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
playerCull? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<SharedPlaylistDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/SharedPlaylists?'+(options.active!=null?'&active='+options.active:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.hasTemplateBookingPermittedScreenEntries!=null?'&hasTemplateBookingPermittedScreenEntries='+options.hasTemplateBookingPermittedScreenEntries:'')+
''+(options.planning!=null?'&planning='+options.planning:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
'';
return <Observable<SharedPlaylistDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.NetworkAggregation:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_NetworkAggregation_channel(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkAggregationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Aggregation/Channel?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<NetworkAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_NetworkAggregation_location(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkAggregationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Aggregation/Location?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<NetworkAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_NetworkAggregation_locationManagedBy(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkAggregationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Aggregation/Location/ManagedBy?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<NetworkAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_NetworkAggregation_markerResolution(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkAggregationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Aggregation/Marker/Resolution?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<NetworkAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_NetworkAggregation_pool(options: {productive? : boolean,
onlineStatus? : DeviceOnlineStatus[],
playerCulls? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkAggregationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Network/Aggregation/Pool?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onlineStatus!=null?''+this.api.queryParamArrayPrepare('onlineStatus',options.onlineStatus):'')+
''+(options.playerCulls!=null?''+this.api.queryParamArrayPrepare('playerCulls',options.playerCulls):'')+
'';
return <Observable<NetworkAggregationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.NetworkPriceModel:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_price_model_create
*	All: -
*/
public ss_nm_NetworkPriceModel_createNetworkPriceModel(networkPriceModelDTO : NetworkPriceModelDTO, mode:Mode=Mode.Entity) : Observable<NetworkPriceModelDTO> {
let url = '/DS/CM/NetworkPriceModel';
return <Observable<NetworkPriceModelDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, networkPriceModelDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_price_model_delete
*	All: -
*/
public ss_nm_NetworkPriceModel_deleteNetworkPriceModel(network_price_model_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/DS/CM/NetworkPriceModel/'+network_price_model_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_price_model_edit
*	All: -
*/
public ss_nm_NetworkPriceModel_editNetworkPriceModel(networkPriceModelDTO : NetworkPriceModelDTO, mode:Mode=Mode.Entity) : Observable<NetworkPriceModelDTO> {
let url = '/DS/CM/NetworkPriceModel';
return <Observable<NetworkPriceModelDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, networkPriceModelDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_price_model_list
*	All: -
*/
public ss_nm_NetworkPriceModel_retrieveAll(options: {company_id? : number[],
network_price_model_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkPriceModelDTO[]> {
if(!options)
options={};
let url = '/DS/CM/NetworkPriceModel?'+(options.company_id!=null?''+this.api.queryParamArrayPrepare('company_id',options.company_id):'')+
''+(options.network_price_model_id!=null?''+this.api.queryParamArrayPrepare('network_price_model_id',options.network_price_model_id):'')+
'';
return <Observable<NetworkPriceModelDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_price_model_show
*	All: -
*/
public ss_nm_NetworkPriceModel_retrieveOne(network_price_model_id : number, mode:Mode=Mode.Entity) : Observable<NetworkPriceModelDTO> {
let url = '/DS/CM/NetworkPriceModel/'+network_price_model_id+'';
return <Observable<NetworkPriceModelDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.NetworkShare:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_create
*	All: -
*/
public ss_nm_NetworkShare_createNetworkShare(networkShareDTO : NetworkShareDTO, mode:Mode=Mode.Entity) : Observable<NetworkShareDTO> {
let url = '/SS/NM/NetworkShare';
return <Observable<NetworkShareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, networkShareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_delete
*	All: -
*/
public ss_nm_NetworkShare_deleteById(network_share_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/NetworkShare/'+network_share_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_edit
*	All: -
*/
public ss_nm_NetworkShare_editNetworkShare(networkShareDTO : NetworkShareDTO, mode:Mode=Mode.Entity) : Observable<NetworkShareDTO> {
let url = '/SS/NM/NetworkShare';
return <Observable<NetworkShareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, networkShareDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_list
*	All: -
*/
public ss_nm_NetworkShare_retrieveAll(options: {id? : number[],
precondition? : number[],
search? : string,
order? : {by: ss_nm_NetworkShare_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkShareDTO[]> {
if(!options)
options={};
let url = '/SS/NM/NetworkShare?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?''+this.api.queryParamArrayPrepare('precondition',options.precondition):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<NetworkShareDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_show
*	All: -
*/
public ss_nm_NetworkShare_retrieveById(network_share_id : number, mode:Mode=Mode.Entity) : Observable<NetworkShareDTO> {
let url = '/SS/NM/NetworkShare/'+network_share_id+'';
return <Observable<NetworkShareDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_show
*	All: -
*/
public ss_nm_NetworkShare_retrieveClients(options: {device_id? : number[],
screen_id? : number[],
playerCull_id? : number[],
order? : {by: ss_nm_NetworkShare_retrieveClients_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/SS/NM/NetworkShare/Advertiser?'+this.api.queryParamArrayPrepare('device_id',options.device_id)+this.api.queryParamArrayPrepare('screen_id',options.screen_id)+this.api.queryParamArrayPrepare('playerCull_id',options.playerCull_id)+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_show
*	All: -
*/
public ss_nm_NetworkShare_retrieveClientsByNetworkShare(networkShare_id : number, options: {device_id? : number[],
screen_id? : number[],
playerCull_id? : number[],
order? : {by: ss_nm_NetworkShare_retrieveClientsByNetworkShare_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ClientDTO[]> {
if(!options)
options={};
let url = '/SS/NM/NetworkShare/'+networkShare_id+'/Advertiser?'+this.api.queryParamArrayPrepare('device_id',options.device_id)+this.api.queryParamArrayPrepare('screen_id',options.screen_id)+this.api.queryParamArrayPrepare('playerCull_id',options.playerCull_id)+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<ClientDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_list
*	All: -
*/
public ss_nm_NetworkShare_retrieveHierarchy(options: {id? : number[],
precondition? : number,
search? : string,
order? : {by: ss_nm_NetworkShare_retrieveHierarchy_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<NetworkShareDTO[]> {
if(!options)
options={};
let url = '/SS/NM/NetworkShare/Hierarchy?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?'&precondition='+options.precondition:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<NetworkShareDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: network_share_show
*	All: -
*/
public ss_nm_NetworkShare_retrieveScreensByAdvertiser(advertiser_id : number, options: {device_id? : number[],
screen_id? : number[],
playerCull_id? : number[]} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<ScreenFullDTO[]> {
if(!options)
options={};
let url = '/SS/NM/NetworkShare/Advertiser/'+advertiser_id+'?'+this.api.queryParamArrayPrepare('device_id',options.device_id)+this.api.queryParamArrayPrepare('screen_id',options.screen_id)+this.api.queryParamArrayPrepare('playerCull_id',options.playerCull_id)+'';
return <Observable<ScreenFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.NM:
// Methods implemented by de.seatback.adplacer.api.ss.nm.PlaybackSchedule:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_create
*	All: -
*/
public ss_nm_PlaybackSchedule_createPlaybackSchedule(playbackScheduleFullDTO : PlaybackScheduleFullDTO, mode:Mode=Mode.Entity) : Observable<PlaybackScheduleFullDTO> {
let url = '/SS/NM/PlaybackSchedule';
return <Observable<PlaybackScheduleFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, playbackScheduleFullDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_delete
*	All: -
*/
public ss_nm_PlaybackSchedule_deletePlaybackSchedule(playback_schedule_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/PlaybackSchedule/'+playback_schedule_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_list
*	All: -
*/
public ss_nm_PlaybackSchedule_retrieveAll(options: {id? : number[],
precondition? : number[],
search? : string,
order? : {by: ss_nm_PlaybackSchedule_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PlaybackScheduleFullDTO[]> {
if(!options)
options={};
let url = '/SS/NM/PlaybackSchedule?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?''+this.api.queryParamArrayPrepare('precondition',options.precondition):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PlaybackScheduleFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_show
*	All: -
*/
public ss_nm_PlaybackSchedule_retrieveById(playback_schedule_id : number, mode:Mode=Mode.Entity) : Observable<PlaybackScheduleFullDTO> {
let url = '/SS/NM/PlaybackSchedule/'+playback_schedule_id+'';
return <Observable<PlaybackScheduleFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_list
*	All: -
*/
public ss_nm_PlaybackSchedule_retrieveHierarchy(options: {id? : number[],
precondition? : number,
search? : string,
order? : {by: ss_nm_PlaybackSchedule_retrieveHierarchy_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PlaybackScheduleFullDTO[]> {
if(!options)
options={};
let url = '/SS/NM/PlaybackSchedule/Hierarchy?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.precondition!=null?'&precondition='+options.precondition:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PlaybackScheduleFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_show
*	All: -
*/
public ss_nm_PlaybackSchedule_retrieveSlotsById(playback_schedule_id : number, mode:Mode=Mode.Entity) : Observable<PlaybackScheduleSlotFullDTO[]> {
let url = '/SS/NM/PlaybackSchedule/'+playback_schedule_id+'/Slots';
return <Observable<PlaybackScheduleSlotFullDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: playback_schedule_edit
*	All: -
*/
public ss_nm_PlaybackSchedule_updateById(playbackScheduleFullDTO : PlaybackScheduleFullDTO, mode:Mode=Mode.Entity) : Observable<PlaybackScheduleFullDTO> {
let url = '/SS/NM/PlaybackSchedule';
return <Observable<PlaybackScheduleFullDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, playbackScheduleFullDTO));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Pool:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_create
*	All: -
*/
public ss_nm_Pool_create(poolDTO : PoolDTO, mode:Mode=Mode.Entity) : Observable<PoolDTO> {
let url = '/SS/NM/Pool';
return <Observable<PoolDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, poolDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_edit
*	All: -
*/
public ss_nm_Pool_edit(poolDTO : PoolDTO, mode:Mode=Mode.Entity) : Observable<PoolDTO> {
let url = '/SS/NM/Pool';
return <Observable<PoolDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, poolDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_list
*	All: -
*/
public ss_nm_Pool_retrieveAll(options: {search? : string,
hasDevices? : boolean,
id? : number[],
notInHierarchyOf? : boolean,
order? : {by: ss_nm_Pool_retrieveAll_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PoolDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Pool?'+(options.search!=null?'&search='+options.search:'')+
''+(options.hasDevices!=null?'&hasDevices='+options.hasDevices:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.notInHierarchyOf!=null?'&notInHierarchyOf='+options.notInHierarchyOf:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PoolDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_show
*	All: -
*/
public ss_nm_Pool_retrieveById(pool_id : number, mode:Mode=Mode.Entity) : Observable<PoolDTO> {
let url = '/SS/NM/Pool/'+pool_id+'';
return <Observable<PoolDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: pool_list
*	All: -
*/
public ss_nm_Pool_retrieveHierarchy(options: {search? : string,
hasDevices? : boolean,
id? : number[],
order? : {by: ss_nm_Pool_retrieveHierarchy_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PoolHierarchyDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Pool/Hierarchy?'+(options.search!=null?'&search='+options.search:'')+
''+(options.hasDevices!=null?'&hasDevices='+options.hasDevices:'')+
''+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PoolHierarchyDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Reporting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_airtimeQuota(options: {productive? : boolean,
weekday? : Weekday[],
hour? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
location? : number[],
playerCull? : number[],
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[],
playerCullIntersection? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Reporting/AirtimeQuota?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.weekday!=null?''+this.api.queryParamArrayPrepare('weekday',options.weekday):'')+
''+(options.hour!=null?''+this.api.queryParamArrayPrepare('hour',options.hour):'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_airtimeQuotaByChannels(options: {id? : number[],
productive? : boolean,
weekday? : Weekday[],
hour? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
location? : number[],
playerCull? : number[],
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Reporting/AirtimeQuota/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.weekday!=null?''+this.api.queryParamArrayPrepare('weekday',options.weekday):'')+
''+(options.hour!=null?''+this.api.queryParamArrayPrepare('hour',options.hour):'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_airtimeQuotaByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
productive? : boolean,
weekday? : Weekday[],
hour? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
location? : number[],
playerCull? : number[],
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Reporting/AirtimeQuota/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.weekday!=null?''+this.api.queryParamArrayPrepare('weekday',options.weekday):'')+
''+(options.hour!=null?''+this.api.queryParamArrayPrepare('hour',options.hour):'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_airtimeQuotaGroupedBy(groupedBy : string, options: {productive? : boolean,
weekday? : Weekday[],
hour? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
location? : number[],
playerCull? : number[],
screen? : number[],
device? : number[],
marker? : number[],
channel? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Reporting/AirtimeQuota/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.weekday!=null?''+this.api.queryParamArrayPrepare('weekday',options.weekday):'')+
''+(options.hour!=null?''+this.api.queryParamArrayPrepare('hour',options.hour):'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_deviceStatusCountHistory(options: {productive? : boolean,
hasBeenProductive? : boolean,
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCull? : number[],
screen? : number[],
device? : number[],
location? : number[],
marker? : number[],
channel? : number[],
playerCullIntersection? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<FramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Reporting/DeviceStatusCountHistory?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.hasBeenProductive!=null?'&hasBeenProductive='+options.hasBeenProductive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
'';
return <Observable<FramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_deviceStatusCountHistoryByChannels(options: {id? : number[],
productive? : boolean,
hasBeenProductive? : boolean,
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCull? : number[],
screen? : number[],
device? : number[],
location? : number[],
marker? : number[],
channel? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Reporting/DeviceStatusCountHistory/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.hasBeenProductive!=null?'&hasBeenProductive='+options.hasBeenProductive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
'';
return <Observable<FramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_deviceStatusCountHistoryByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
productive? : boolean,
hasBeenProductive? : boolean,
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCull? : number[],
screen? : number[],
device? : number[],
location? : number[],
marker? : number[],
channel? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Reporting/DeviceStatusCountHistory/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.hasBeenProductive!=null?'&hasBeenProductive='+options.hasBeenProductive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_deviceStatusCountHistoryGroupedBy(groupedBy : string, options: {productive? : boolean,
hasBeenProductive? : boolean,
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
playerCull? : number[],
screen? : number[],
device? : number[],
location? : number[],
marker? : number[],
channel? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Reporting/DeviceStatusCountHistory/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.hasBeenProductive!=null?'&hasBeenProductive='+options.hasBeenProductive:'')+
''+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.location!=null?''+this.api.queryParamArrayPrepare('location',options.location):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_executionReport(options: {from? : SbLocalDate,
till? : SbLocalDate,
advertiser? : number[],
channel? : number[],
marker? : number[],
device? : number[],
screen? : number[],
medium? : number[],
playerCull? : number[],
playerCullIntersection? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<ExecutionReportDTO> {
if(!options)
options={};
let url = '/SS/NM/Reporting/ExecutionReport?'+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.channel!=null?''+this.api.queryParamArrayPrepare('channel',options.channel):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.device!=null?''+this.api.queryParamArrayPrepare('device',options.device):'')+
''+(options.screen!=null?''+this.api.queryParamArrayPrepare('screen',options.screen):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.playerCullIntersection!=null?'&playerCullIntersection='+options.playerCullIntersection:'')+
'';
return <Observable<ExecutionReportDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_nm_reporting
*	All: -
*/
public ss_nm_Reporting_networkOverviewReport(options: {criterion? : string,
from? : SbDateTime,
till? : SbDateTime,
deviceAttribute? : string,
refresh? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<NetworkDeviceStatistic[]> {
if(!options)
options={};
let url = '/SS/NM/Reporting/NetworkOverviewReport?criterion='+options.criterion+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.deviceAttribute!=null?'&deviceAttribute='+options.deviceAttribute:'')+
''+(options.refresh!=null?'&refresh='+options.refresh:'')+
'';
return <Observable<NetworkDeviceStatistic[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
public ss_nm_Reporting_retrieveShareOfVoice(mode:Mode=Mode.Entity) : Observable<PublisherShareOfVoiceDTO> {
let url = '/SS/NM/Reporting/SoV';
return <Observable<PublisherShareOfVoiceDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Screen:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_tracker_screen_assignment_modify
*	All: -
*/
public ss_nm_Screen_assignScreenToTrackers(screen_id : number, visitorTrackerScreenDTO : VisitorTrackerScreenDTO[], mode:Mode=Mode.Entity) : Observable<VisitorTrackerScreenDTO[]> {
let url = '/SS/NM/Device/Screen/'+screen_id+'/Trackers';
return <Observable<VisitorTrackerScreenDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, visitorTrackerScreenDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_playlist_cache_delete
*	All: -
*/
public ss_nm_Screen_deleteScreenPlaylistCache(screen_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/Device/Screen/'+screen_id+'/PlaylistCache';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_nm_Screen_exportPlayoutDescriptors(screen_id : number, options: {id? : number[],
advertiser? : number[],
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
booking? : number[],
medium? : number[],
productive? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/PlayoutDescriptor/CSV?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_nm_Screen_exportPlayoutDescriptorsWithFullDetails(screen_id : number, options: {id? : number[],
advertiser? : number[],
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
booking? : number[],
medium? : number[],
productive? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/PlayoutDescriptor/Full/CSV?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_export_playout
*	All: -
*/
public ss_nm_Screen_exportPlayouts(screen_id : number, options: {advertiser? : number[],
from? : SbDateTime,
till? : SbDateTime,
descriptor? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FileLink> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/Playout/CSV?'+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.descriptor!=null?''+this.api.queryParamArrayPrepare('descriptor',options.descriptor):'')+
'';
return <Observable<FileLink>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Screen_fetchPlayouts(screen_id : number, options: {after_timestamp? : SbDateTime,
after_descriptor? : number,
advertiser? : number[],
from? : SbDateTime,
till? : SbDateTime,
descriptor? : number[],
count? : number} = {}, mode:Mode=Mode.Entity) : Observable<PlayoutBookingBaseDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/Playout?'+(options.after_timestamp!=null?'&after_timestamp='+this.api.queryParamDatePrepare(options.after_timestamp):'')+
''+(options.after_descriptor!=null?'&after_descriptor='+options.after_descriptor:'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
''+(options.descriptor!=null?''+this.api.queryParamArrayPrepare('descriptor',options.descriptor):'')+
''+(options.count!=null?'&count='+options.count:'')+
'';
return <Observable<PlayoutBookingBaseDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Screen_findTimeRangesWithEmptyPlaylist(screen_id : number, mode:Mode=Mode.Entity) : Observable<LocalDateTimeRange[]> {
let url = '/SS/NM/Device/Screen/'+screen_id+'/EmptyPlaylist';
return <Observable<LocalDateTimeRange[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_delete
*	All: -
*/
public ss_nm_Screen_pullRejectionFromTemplateScreenEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO> {
let url = '/SS/NM/Device/Screen/TemplateEntry/'+id+'/Reject';
return <Observable<TemplateScreenEntryWithDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_delete
*	All: -
*/
public ss_nm_Screen_rejectTemplateScreenEntryById(id : number, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO> {
let url = '/SS/NM/Device/Screen/TemplateEntry/'+id+'/Reject';
return <Observable<TemplateScreenEntryWithDataSetDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: device_show
*	All: -
*/
public ss_nm_Screen_retrieveAllPlayoutDescriptors(screen_id : number, options: {id? : number[],
advertiser? : number[],
booking? : number[],
medium? : number[],
productive? : boolean,
onAirFrom? : SbDateTime,
onAirTill? : SbDateTime,
order? : {by: ss_nm_Screen_retrieveAllPlayoutDescriptors_order, param?: string, direction: Order}} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PublisherPlayoutDescriptorDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/PlayoutDescriptor?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.booking!=null?''+this.api.queryParamArrayPrepare('booking',options.booking):'')+
''+(options.medium!=null?''+this.api.queryParamArrayPrepare('medium',options.medium):'')+
''+(options.productive!=null?'&productive='+options.productive:'')+
''+(options.onAirFrom!=null?'&onAirFrom='+this.api.queryParamDatePrepare(options.onAirFrom):'')+
''+(options.onAirTill!=null?'&onAirTill='+this.api.queryParamDatePrepare(options.onAirTill):'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'';
return <Observable<PublisherPlayoutDescriptorDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
public ss_nm_Screen_retrieveLiveScreenPlaylist(screen_id : number, mode:Mode=Mode.Entity) : Observable<ScreenPlaylistDTO> {
let url = '/SS/NM/Device/Screen/'+screen_id+'/Playlist';
return <Observable<ScreenPlaylistDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateDataSetEntries(options: {ids? : number[],
identifiers? : string[],
screen_ids? : number[],
dataSet_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/TemplateEntry/DataSetEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.dataSet_ids!=null?''+this.api.queryParamArrayPrepare('dataSet_ids',options.dataSet_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateDataSetEntriesByScreen(screen_id : number, options: {ids? : number[],
identifiers? : string[],
dataSet_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
createdFrom? : SbDateTime,
createdTill? : SbDateTime,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetEntryDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/TemplateEntry/DataSetEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.identifiers!=null?''+this.api.queryParamArrayPrepare('identifiers',options.identifiers):'')+
''+(options.dataSet_ids!=null?''+this.api.queryParamArrayPrepare('dataSet_ids',options.dataSet_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.createdFrom!=null?'&createdFrom='+this.api.queryParamDatePrepare(options.createdFrom):'')+
''+(options.createdTill!=null?'&createdTill='+this.api.queryParamDatePrepare(options.createdTill):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetEntryDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateDataSets(options: {ids? : number[],
screen_ids? : number[],
company_ids? : number[],
group_ids? : number[],
source_ids? : number[],
subscription_ids? : number[],
inUse? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/TemplateEntry/DataSet?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.company_ids!=null?''+this.api.queryParamArrayPrepare('company_ids',options.company_ids):'')+
''+(options.group_ids!=null?''+this.api.queryParamArrayPrepare('group_ids',options.group_ids):'')+
''+(options.source_ids!=null?''+this.api.queryParamArrayPrepare('source_ids',options.source_ids):'')+
''+(options.subscription_ids!=null?''+this.api.queryParamArrayPrepare('subscription_ids',options.subscription_ids):'')+
''+(options.inUse!=null?'&inUse='+options.inUse:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateDataSetsByScreen(screen_id : number, options: {ids? : number[],
company_ids? : number[],
group_ids? : number[],
source_ids? : number[],
subscription_ids? : number[],
inUse? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateDataSetDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/TemplateEntry/DataSet?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.company_ids!=null?''+this.api.queryParamArrayPrepare('company_ids',options.company_ids):'')+
''+(options.group_ids!=null?''+this.api.queryParamArrayPrepare('group_ids',options.group_ids):'')+
''+(options.source_ids!=null?''+this.api.queryParamArrayPrepare('source_ids',options.source_ids):'')+
''+(options.subscription_ids!=null?''+this.api.queryParamArrayPrepare('subscription_ids',options.subscription_ids):'')+
''+(options.inUse!=null?'&inUse='+options.inUse:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateGroups(options: {ids? : number[],
screen_ids? : number[],
global? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/TemplateEntry/Group?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateGroupsByScreen(screen_id : number, options: {ids? : number[],
global? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateGroupDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/TemplateEntry/Group?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.global!=null?'&global='+options.global:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateGroupDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateScreenEntries(options: {ids? : number[],
dataSet? : number[],
dataSetEntry? : number[],
group? : number[],
device_ids? : number[],
screen_ids? : number[],
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
rejected? : boolean,
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.dataSet!=null?''+this.api.queryParamArrayPrepare('dataSet',options.dataSet):'')+
''+(options.dataSetEntry!=null?''+this.api.queryParamArrayPrepare('dataSetEntry',options.dataSetEntry):'')+
''+(options.group!=null?''+this.api.queryParamArrayPrepare('group',options.group):'')+
''+(options.device_ids!=null?''+this.api.queryParamArrayPrepare('device_ids',options.device_ids):'')+
''+(options.screen_ids!=null?''+this.api.queryParamArrayPrepare('screen_ids',options.screen_ids):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.rejected!=null?'&rejected='+options.rejected:'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryWithDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: template_screen_entry_list
*	All: -
*/
public ss_nm_Screen_retrieveTemplateScreenEntriesByScreen(screen_id : number, options: {ids? : number[],
renderedAtFrom? : SbDateTime,
renderedAtTill? : SbDateTime,
validFrom? : SbLocalDateTime,
validTill? : SbLocalDateTime,
rejected? : boolean,
dataSet? : number[],
dataSetEntry? : number[],
group? : number[],
search? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<TemplateScreenEntryWithDataSetDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Device/Screen/'+screen_id+'/TemplateEntry?'+(options.ids!=null?''+this.api.queryParamArrayPrepare('ids',options.ids):'')+
''+(options.renderedAtFrom!=null?'&renderedAtFrom='+this.api.queryParamDatePrepare(options.renderedAtFrom):'')+
''+(options.renderedAtTill!=null?'&renderedAtTill='+this.api.queryParamDatePrepare(options.renderedAtTill):'')+
''+(options.validFrom!=null?'&validFrom='+this.api.queryParamDatePrepare(options.validFrom):'')+
''+(options.validTill!=null?'&validTill='+this.api.queryParamDatePrepare(options.validTill):'')+
''+(options.rejected!=null?'&rejected='+options.rejected:'')+
''+(options.dataSet!=null?''+this.api.queryParamArrayPrepare('dataSet',options.dataSet):'')+
''+(options.dataSetEntry!=null?''+this.api.queryParamArrayPrepare('dataSetEntry',options.dataSetEntry):'')+
''+(options.group!=null?''+this.api.queryParamArrayPrepare('group',options.group):'')+
''+(options.search!=null?'&search='+options.search:'')+
'';
return <Observable<TemplateScreenEntryWithDataSetDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.ScreenVisitorReporting:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framed(options: {interval? : number,
from? : SbDateTime,
till? : SbDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<FramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedByChannels(options: {id? : number[],
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<FramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<FramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
interval? : number,
from? : SbDateTime,
till? : SbDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedGroupedBy(groupedBy : string, options: {interval? : number,
from? : SbDateTime,
till? : SbDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedLocal(options: {interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/Local?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedLocalByChannels(options: {id? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<LocalizedFramedReportingDTO> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/Local/Channel?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<LocalizedFramedReportingDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedLocalByChannelsGroupedBy(groupedBy : string, options: {id? : number[],
interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/Local/Channel/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+this.api.queryParamArrayPrepare('id',options.id)+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: ss_fm_reporting
*	All: -
*/
public ss_nm_ScreenVisitorReporting_framedLocalGroupedBy(groupedBy : string, options: {interval? : number,
from? : SbLocalDateTime,
till? : SbLocalDateTime,
productive? : boolean,
playerCull? : number[],
locations? : number[]} = {}, mode:Mode=Mode.Entity) : Observable<any> {
if(!options)
options={};
let url = '/SS/NM/Screen/Visitor/Reporting/Framed/Local/GroupedBy/'+encodeURIComponent(groupedBy)+'?'+(options.interval!=null?'&interval='+options.interval:'')+
''+(options.from!=null?'&from='+this.api.queryParamDatePrepare(options.from):'')+
''+(options.till!=null?'&till='+this.api.queryParamDatePrepare(options.till):'')+
'&'+(options.productive!=null?'&productive='+options.productive:'')+'&'+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+'&'+(options.locations!=null?''+this.api.queryParamArrayPrepare('locations',options.locations):'')+'';
return <Observable<any>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.Verification:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_list
*	All: -
*/
public ss_nm_Verification_all(options: {marker? : number,
medium? : number,
geoCull? : number[],
playerCull? : number[],
stateSpaceCull? : number[],
timeCull? : number[],
hasReason? : boolean,
search? : string,
order? : {by: ss_nm_Verification_all_order, param?: string, direction: Order},
current? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VerificationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification?'+(options.marker!=null?'&marker='+options.marker:'')+
''+(options.medium!=null?'&medium='+options.medium:'')+
''+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.stateSpaceCull!=null?''+this.api.queryParamArrayPrepare('stateSpaceCull',options.stateSpaceCull):'')+
''+(options.timeCull!=null?''+this.api.queryParamArrayPrepare('timeCull',options.timeCull):'')+
''+(options.hasReason!=null?'&hasReason='+options.hasReason:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'&'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_verify, verification_reject
*	All: -
*/
public ss_nm_Verification_edit(verificationDTO : VerificationDTO, options: {current? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<VerificationDTO> {
if(!options)
options={};
let url = '/SS/NM/Verification?'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, verificationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_verify, verification_reject
*	All: -
*/
public ss_nm_Verification_editMultiple(verificationDTO : VerificationDTO[], options: {current? : boolean} = {}, mode:Mode=Mode.Entity) : Observable<VerificationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification/Mass?'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, verificationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_list
*	All: -
*/
public ss_nm_Verification_pending(options: {marker? : number,
medium? : number,
geoCull? : number[],
playerCull? : number[],
stateSpaceCull? : number[],
timeCull? : number[],
hasReason? : boolean,
channel? : number,
advertiser? : number,
search? : string,
order? : {by: ss_nm_Verification_pending_order, param?: string, direction: Order},
current? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VerificationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification/Pending?'+(options.marker!=null?'&marker='+options.marker:'')+
''+(options.medium!=null?'&medium='+options.medium:'')+
''+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.stateSpaceCull!=null?''+this.api.queryParamArrayPrepare('stateSpaceCull',options.stateSpaceCull):'')+
''+(options.timeCull!=null?''+this.api.queryParamArrayPrepare('timeCull',options.timeCull):'')+
''+(options.hasReason!=null?'&hasReason='+options.hasReason:'')+
''+(options.channel!=null?'&channel='+options.channel:'')+
''+(options.advertiser!=null?'&advertiser='+options.advertiser:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'&'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_list
*	All: -
*/
public ss_nm_Verification_permitted(options: {marker? : number,
medium? : number,
geoCull? : number[],
playerCull? : number[],
stateSpaceCull? : number[],
timeCull? : number[],
hasReason? : boolean,
search? : string,
order? : {by: ss_nm_Verification_permitted_order, param?: string, direction: Order},
current? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VerificationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification/Permitted?'+(options.marker!=null?'&marker='+options.marker:'')+
''+(options.medium!=null?'&medium='+options.medium:'')+
''+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.stateSpaceCull!=null?''+this.api.queryParamArrayPrepare('stateSpaceCull',options.stateSpaceCull):'')+
''+(options.timeCull!=null?''+this.api.queryParamArrayPrepare('timeCull',options.timeCull):'')+
''+(options.hasReason!=null?'&hasReason='+options.hasReason:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'&'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_list
*	All: -
*/
public ss_nm_Verification_rejected(options: {marker? : number,
medium? : number,
geoCull? : number[],
playerCull? : number[],
stateSpaceCull? : number[],
timeCull? : number[],
hasReason? : boolean,
search? : string,
order? : {by: ss_nm_Verification_rejected_order, param?: string, direction: Order},
current? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VerificationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification/Rejected?'+(options.marker!=null?'&marker='+options.marker:'')+
''+(options.medium!=null?'&medium='+options.medium:'')+
''+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.stateSpaceCull!=null?''+this.api.queryParamArrayPrepare('stateSpaceCull',options.stateSpaceCull):'')+
''+(options.timeCull!=null?''+this.api.queryParamArrayPrepare('timeCull',options.timeCull):'')+
''+(options.hasReason!=null?'&hasReason='+options.hasReason:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'&'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_show
*	All: -
*/
public ss_nm_Verification_retrieveAllMedia(options: {id? : number[],
advertiser? : number[],
marker? : number[],
pending? : boolean,
verified? : boolean,
rejected? : boolean,
permitted? : boolean,
search? : string,
order? : {by: ss_nm_Verification_retrieveAllMedia_order, param?: string, direction: Order},
current? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<PublicMediumDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification/Medium?'+(options.id!=null?''+this.api.queryParamArrayPrepare('id',options.id):'')+
''+(options.advertiser!=null?''+this.api.queryParamArrayPrepare('advertiser',options.advertiser):'')+
''+(options.marker!=null?''+this.api.queryParamArrayPrepare('marker',options.marker):'')+
''+(options.pending!=null?'&pending='+options.pending:'')+
''+(options.verified!=null?'&verified='+options.verified:'')+
''+(options.rejected!=null?'&rejected='+options.rejected:'')+
''+(options.permitted!=null?'&permitted='+options.permitted:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'&'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<PublicMediumDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: verification_list
*	All: -
*/
public ss_nm_Verification_verified(options: {marker? : number,
medium? : number,
geoCull? : number[],
playerCull? : number[],
stateSpaceCull? : number[],
timeCull? : number[],
hasReason? : boolean,
search? : string,
order? : {by: ss_nm_Verification_verified_order, param?: string, direction: Order},
current? : boolean} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VerificationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/Verification/Verified?'+(options.marker!=null?'&marker='+options.marker:'')+
''+(options.medium!=null?'&medium='+options.medium:'')+
''+(options.geoCull!=null?''+this.api.queryParamArrayPrepare('geoCull',options.geoCull):'')+
''+(options.playerCull!=null?''+this.api.queryParamArrayPrepare('playerCull',options.playerCull):'')+
''+(options.stateSpaceCull!=null?''+this.api.queryParamArrayPrepare('stateSpaceCull',options.stateSpaceCull):'')+
''+(options.timeCull!=null?''+this.api.queryParamArrayPrepare('timeCull',options.timeCull):'')+
''+(options.hasReason!=null?'&hasReason='+options.hasReason:'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.order!=null?'&order='+options.order.by + (options.order.param?"(" + options.order.param + ")" :"") + " "+ options.order.direction:'')+
'&'+(options.current!=null?'&current='+options.current:'')+'';
return <Observable<VerificationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}// Methods implemented by de.seatback.adplacer.api.ss.nm.VisitorAudienceTranslation:

/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_audience_translation_create
*	All: -
*/
public ss_nm_VisitorAudienceTranslation_createVisitorAudienceTranslation(visitorAudienceTranslationDTO : VisitorAudienceTranslationDTO, mode:Mode=Mode.Entity) : Observable<VisitorAudienceTranslationDTO> {
let url = '/SS/NM/VisitorAudienceTranslation';
return <Observable<VisitorAudienceTranslationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.POST})) : this.api.POST(url, visitorAudienceTranslationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_audience_translation_delete
*	All: -
*/
public ss_nm_VisitorAudienceTranslation_deleteVisitorAudienceTranslation(visitorAudienceTranslation_id : number, mode:Mode=Mode.Entity) : Observable<boolean> {
let url = '/SS/NM/VisitorAudienceTranslation/'+visitorAudienceTranslation_id+'';
return <Observable<boolean>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.DELETE})) : this.api.DELETE(url));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_audience_translation_edit
*	All: -
*/
public ss_nm_VisitorAudienceTranslation_editVisitorAudienceTranslation(visitorAudienceTranslationDTO : VisitorAudienceTranslationDTO, mode:Mode=Mode.Entity) : Observable<VisitorAudienceTranslationDTO> {
let url = '/SS/NM/VisitorAudienceTranslation';
return <Observable<VisitorAudienceTranslationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.PUT})) : this.api.PUT(url, visitorAudienceTranslationDTO));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_audience_translation_list
*	All: -
*/
public ss_nm_VisitorAudienceTranslation_retrieveAll(options: {visitor_audience_translation_id? : number[],
search? : string,
regression_model? : string} = {}, pagination: BehaviorSubject<Pagination> | null = null, mode:Mode=Mode.Entity) : Observable<VisitorAudienceTranslationDTO[]> {
if(!options)
options={};
let url = '/SS/NM/VisitorAudienceTranslation?'+(options.visitor_audience_translation_id!=null?''+this.api.queryParamArrayPrepare('visitor_audience_translation_id',options.visitor_audience_translation_id):'')+
''+(options.search!=null?'&search='+options.search:'')+
''+(options.regression_model!=null?'&regression_model='+options.regression_model:'')+
'';
return <Observable<VisitorAudienceTranslationDTO[]>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url, pagination));
}
/**
*	Permission Required
*
*	Model: EntityUserClient
*	One: visitor_audience_translation_show
*	All: -
*/
public ss_nm_VisitorAudienceTranslation_retrieveById(visitorAudienceTranslation_id : number, mode:Mode=Mode.Entity) : Observable<VisitorAudienceTranslationDTO> {
let url = '/SS/NM/VisitorAudienceTranslation/'+visitorAudienceTranslation_id+'';
return <Observable<VisitorAudienceTranslationDTO>> (mode===Mode.URL||mode===Mode.Definition? new Observable<any>((o)=>o.next(Mode.URL?url:{url:url,method:this.GET})) : this.api.GET(url));
}// Methods implemented by de.seatback.adplacer.api.ss.SS:
// Methods implemented by de.seatback.adplacer.api.websockets.DiscussionWebSocket:
// Methods implemented by de.seatback.adplacer.api.websockets.WebSocket:
  constructor(private api: APIService){  
api.api = this;
}
createDTO(name: any): any {
	let t = null;
	if (name == null)
		t = null;
	else if (name === "IdentityDTO") {
		t = new IdentityDTO();
}
	else if (name === "NamedIdentityDTO") {
		t = new NamedIdentityDTO();
}
	else if (name === "NotificationCategoryDTO") {
		t = new NotificationCategoryDTO();
}
	else if (name === "PlayoutMetaDTO") {
		t = new PlayoutMetaDTO();
}
	else if (name === "CullAtomDTO") {
		t = new CullAtomDTO();
}
	else if (name === "StructureCullAtomDTO") {
		t = new StructureCullAtomDTO();
}
	else if (name === "PlayerCullAtomDTO") {
		t = new PlayerCullAtomDTO();
}
	else if (name === "NamedIdentityWithCreatorDTO") {
		t = new NamedIdentityWithCreatorDTO();
}
	else if (name === "ModifiableNamedIdentityWithCreatorDTO") {
		t = new ModifiableNamedIdentityWithCreatorDTO();
}
	else if (name === "ColoredModifiableNamedIdentityWithCreatorDTO") {
		t = new ColoredModifiableNamedIdentityWithCreatorDTO();
}
	else if (name === "ColorDefinitionDTO") {
		t = new ColorDefinitionDTO();
}
	else if (name === "DeviceConfiguration") {
		t = new DeviceConfiguration();
}
	else if (name === "AbstractTrackedVisitorDTO") {
		t = new AbstractTrackedVisitorDTO();
}
	else if (name === "TrackedVisitorDTO") {
		t = new TrackedVisitorDTO();
}
	else if (name === "ContentShareQuotaDTO") {
		t = new ContentShareQuotaDTO();
}
	else if (name === "CredentialsDTO") {
		t = new CredentialsDTO();
}
	else if (name === "LoginRestoreDTO") {
		t = new LoginRestoreDTO();
}
	else if (name === "SetlistDTO") {
		t = new SetlistDTO();
}
	else if (name === "SetlistFullDTO") {
		t = new SetlistFullDTO();
}
	else if (name === "DeviceStatusCount") {
		t = new DeviceStatusCount();
}
	else if (name === "ReportingSetupDTO") {
		t = new ReportingSetupDTO();
}
	else if (name === "ScheduledReportingSetupDTO") {
		t = new ScheduledReportingSetupDTO();
}
	else if (name === "StringDTO") {
		t = new StringDTO();
}
	else if (name === "LabeledValueDTO") {
		t = new LabeledValueDTO();
}
	else if (name === "BookingBaseDTO") {
		t = new BookingBaseDTO();
}
	else if (name === "BookingBaseInfoDTO") {
		t = new BookingBaseInfoDTO();
}
	else if (name === "InventoryBookingDTO") {
		t = new InventoryBookingDTO();
}
	else if (name === "NamedIdentityWithIdentifierAndCreatorDTO") {
		t = new NamedIdentityWithIdentifierAndCreatorDTO();
}
	else if (name === "ClientBaseDTO") {
		t = new ClientBaseDTO();
}
	else if (name === "VisitorAudienceImpressionTranslationDTO") {
		t = new VisitorAudienceImpressionTranslationDTO();
}
	else if (name === "IdentityWithCreatorDTO") {
		t = new IdentityWithCreatorDTO();
}
	else if (name === "ThreadStatistic") {
		t = new ThreadStatistic();
}
	else if (name === "MarkerBaseDTO") {
		t = new MarkerBaseDTO();
}
	else if (name === "PlaybackScheduleSlotDTO") {
		t = new PlaybackScheduleSlotDTO();
}
	else if (name === "PlaybackScheduleSlotFullDTO") {
		t = new PlaybackScheduleSlotFullDTO();
}
	else if (name === "UserClientBaseDTO") {
		t = new UserClientBaseDTO();
}
	else if (name === "UserClientWithPermissionsDTO") {
		t = new UserClientWithPermissionsDTO();
}
	else if (name === "NamedIdentityWithCreatorGlobalAndClientBoundDTO") {
		t = new NamedIdentityWithCreatorGlobalAndClientBoundDTO();
}
	else if (name === "NestedNamedIdentityCreatorGlobalAndClientBoundDTO") {
		t = new NestedNamedIdentityCreatorGlobalAndClientBoundDTO();
}
	else if (name === "AreaCategoryDTO") {
		t = new AreaCategoryDTO();
}
	else if (name === "EntityDefinitionDTO") {
		t = new EntityDefinitionDTO();
}
	else if (name === "CullAggregationDTO") {
		t = new CullAggregationDTO();
}
	else if (name === "ContentAggregationDTO") {
		t = new ContentAggregationDTO();
}
	else if (name === "PointDTO") {
		t = new PointDTO();
}
	else if (name === "ModifiableNamedIdentityWithIdentifierAndCreatorDTO") {
		t = new ModifiableNamedIdentityWithIdentifierAndCreatorDTO();
}
	else if (name === "AssetDTO") {
		t = new AssetDTO();
}
	else if (name === "AssetFullDTO") {
		t = new AssetFullDTO();
}
	else if (name === "ContactFieldDTO") {
		t = new ContactFieldDTO();
}
	else if (name === "ChannelBaseDTO") {
		t = new ChannelBaseDTO();
}
	else if (name === "ChannelDTO") {
		t = new ChannelDTO();
}
	else if (name === "CompanyDTO") {
		t = new CompanyDTO();
}
	else if (name === "CompanyFullDTO") {
		t = new CompanyFullDTO();
}
	else if (name === "ScreenBaseDTO") {
		t = new ScreenBaseDTO();
}
	else if (name === "ScreenDTO") {
		t = new ScreenDTO();
}
	else if (name === "OwnedScreenDTO") {
		t = new OwnedScreenDTO();
}
	else if (name === "TemplateDistributionConfigurationDTO") {
		t = new TemplateDistributionConfigurationDTO();
}
	else if (name === "AssetRepositoryBaseDTO") {
		t = new AssetRepositoryBaseDTO();
}
	else if (name === "AssetRepositoryDTO") {
		t = new AssetRepositoryDTO();
}
	else if (name === "GeoAggregationDTO") {
		t = new GeoAggregationDTO();
}
	else if (name === "Number") {
		t = new Number();
}
	else if (name === "PlayoutAggregationData") {
		t = new PlayoutAggregationData();
}
	else if (name === "PlayoutDescriptorBaseDTO") {
		t = new PlayoutDescriptorBaseDTO();
}
	else if (name === "CachedPlayoutDescriptorDTO") {
		t = new CachedPlayoutDescriptorDTO();
}
	else if (name === "MarkerDTO") {
		t = new MarkerDTO();
}
	else if (name === "MarkerFullDTO") {
		t = new MarkerFullDTO();
}
	else if (name === "MarkerInfo") {
		t = new MarkerInfo();
}
	else if (name === "ScreenHardwareDTO") {
		t = new ScreenHardwareDTO();
}
	else if (name === "FieldReference") {
		t = new FieldReference();
}
	else if (name === "AtomTypeGroupDTO") {
		t = new AtomTypeGroupDTO();
}
	else if (name === "CalendarEntryDTO") {
		t = new CalendarEntryDTO();
}
	else if (name === "CalendarEntryFullDTO") {
		t = new CalendarEntryFullDTO();
}
	else if (name === "ChannelDeviceStatusDTO") {
		t = new ChannelDeviceStatusDTO();
}
	else if (name === "BookingRecalculationDTO") {
		t = new BookingRecalculationDTO();
}
	else if (name === "PlayoutImpressionReportDTO") {
		t = new PlayoutImpressionReportDTO();
}
	else if (name === "NamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO") {
		t = new NamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO();
}
	else if (name === "ColoredNamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO") {
		t = new ColoredNamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO();
}
	else if (name === "CalendarEntryTypeDTO") {
		t = new CalendarEntryTypeDTO();
}
	else if (name === "RatingDTO") {
		t = new RatingDTO();
}
	else if (name === "NamedIdentityWithIdentifierDTO") {
		t = new NamedIdentityWithIdentifierDTO();
}
	else if (name === "ProductBaseDTO") {
		t = new ProductBaseDTO();
}
	else if (name === "PlayerBasedAggregationDTO") {
		t = new PlayerBasedAggregationDTO();
}
	else if (name === "VisitorAggregationDTO") {
		t = new VisitorAggregationDTO();
}
	else if (name === "CalendarEntryTypeFullDTO") {
		t = new CalendarEntryTypeFullDTO();
}
	else if (name === "IdentifierDTO") {
		t = new IdentifierDTO();
}
	else if (name === "SharedByScreenDTO") {
		t = new SharedByScreenDTO();
}
	else if (name === "SharedByScreenAndTimeDTO") {
		t = new SharedByScreenAndTimeDTO();
}
	else if (name === "SharedSetlistDTO") {
		t = new SharedSetlistDTO();
}
	else if (name === "ModifiableIdentityWithCreatorDTO") {
		t = new ModifiableIdentityWithCreatorDTO();
}
	else if (name === "PostDTO") {
		t = new PostDTO();
}
	else if (name === "InventoryMarkerDTO") {
		t = new InventoryMarkerDTO();
}
	else if (name === "ChangeEmailDTO") {
		t = new ChangeEmailDTO();
}
	else if (name === "ElementCountDTO") {
		t = new ElementCountDTO();
}
	else if (name === "TimeCullAtomDTO") {
		t = new TimeCullAtomDTO();
}
	else if (name === "DateTimeCullAtomDTO") {
		t = new DateTimeCullAtomDTO();
}
	else if (name === "DateTimeRangeCullAtomDTO") {
		t = new DateTimeRangeCullAtomDTO();
}
	else if (name === "SSPDTO") {
		t = new SSPDTO();
}
	else if (name === "DiurnalBucketDTO") {
		t = new DiurnalBucketDTO();
}
	else if (name === "TargetingDiurnalBucketDTO") {
		t = new TargetingDiurnalBucketDTO();
}
	else if (name === "ColoredModifiableNamedIdentityWithIdentifierAndCreatorDTO") {
		t = new ColoredModifiableNamedIdentityWithIdentifierAndCreatorDTO();
}
	else if (name === "DiversifiedNamedIdentityWithIdentifierAndCreatorDTO") {
		t = new DiversifiedNamedIdentityWithIdentifierAndCreatorDTO();
}
	else if (name === "ScheduledDiversifiedNamedIdentityWithRequirementFiltersDTO") {
		t = new ScheduledDiversifiedNamedIdentityWithRequirementFiltersDTO();
}
	else if (name === "ScheduledRequirementDTO") {
		t = new ScheduledRequirementDTO();
}
	else if (name === "InventoryClientDTO") {
		t = new InventoryClientDTO();
}
	else if (name === "AttributeDatatypeDTO") {
		t = new AttributeDatatypeDTO();
}
	else if (name === "DeviceAttributeDatatypeDTO") {
		t = new DeviceAttributeDatatypeDTO();
}
	else if (name === "SettingDTO") {
		t = new SettingDTO();
}
	else if (name === "SSPContractDTO") {
		t = new SSPContractDTO();
}
	else if (name === "TrackedVisitorLocalDTO") {
		t = new TrackedVisitorLocalDTO();
}
	else if (name === "CampaignReportDTO") {
		t = new CampaignReportDTO();
}
	else if (name === "ResolvedErrorDTO") {
		t = new ResolvedErrorDTO();
}
	else if (name === "CalendarEntryMetaDataDTO") {
		t = new CalendarEntryMetaDataDTO();
}
	else if (name === "AggregatedPlaylistSchemaDTO") {
		t = new AggregatedPlaylistSchemaDTO();
}
	else if (name === "DeviceBaseDTO") {
		t = new DeviceBaseDTO();
}
	else if (name === "InventoryDeviceDTO") {
		t = new InventoryDeviceDTO();
}
	else if (name === "SSPSlotConfigurationDTO") {
		t = new SSPSlotConfigurationDTO();
}
	else if (name === "ExecutionReportDTO") {
		t = new ExecutionReportDTO();
}
	else if (name === "DealDTO") {
		t = new DealDTO();
}
	else if (name === "ModifiableNamedIdentityWithIdentifierAndCreatorWithRequirementFiltersDTO") {
		t = new ModifiableNamedIdentityWithIdentifierAndCreatorWithRequirementFiltersDTO();
}
	else if (name === "CommercialDTO") {
		t = new CommercialDTO();
}
	else if (name === "CommercialFullDTO") {
		t = new CommercialFullDTO();
}
	else if (name === "ColoredNamedIdentityWithIdentifierAndCreatorDTO") {
		t = new ColoredNamedIdentityWithIdentifierAndCreatorDTO();
}
	else if (name === "PublicMediumDTO") {
		t = new PublicMediumDTO();
}
	else if (name === "MediumDTO") {
		t = new MediumDTO();
}
	else if (name === "MediumFullDTO") {
		t = new MediumFullDTO();
}
	else if (name === "ExecutionStatisticsDTO") {
		t = new ExecutionStatisticsDTO();
}
	else if (name === "QueryExecutionStatisticsDTO") {
		t = new QueryExecutionStatisticsDTO();
}
	else if (name === "ReportingFileDTO") {
		t = new ReportingFileDTO();
}
	else if (name === "VisitorTrackerDTO") {
		t = new VisitorTrackerDTO();
}
	else if (name === "CalendarEntryMetaDataTypeDTO") {
		t = new CalendarEntryMetaDataTypeDTO();
}
	else if (name === "Medium") {
		t = new Medium();
}
	else if (name === "ScreenOfflinePlaybackScheduleSlotDTO") {
		t = new ScreenOfflinePlaybackScheduleSlotDTO();
}
	else if (name === "GeoCullAtomDTO") {
		t = new GeoCullAtomDTO();
}
	else if (name === "ChainedGeoCullAtomDTO") {
		t = new ChainedGeoCullAtomDTO();
}
	else if (name === "AttributeDTO") {
		t = new AttributeDTO();
}
	else if (name === "DeviceAttributeDTO") {
		t = new DeviceAttributeDTO();
}
	else if (name === "DiurnalCycleDataDTO") {
		t = new DiurnalCycleDataDTO();
}
	else if (name === "CurrencyDTO") {
		t = new CurrencyDTO();
}
	else if (name === "ScreenTargetingInfoDTO") {
		t = new ScreenTargetingInfoDTO();
}
	else if (name === "OwnedDeviceBaseDTO") {
		t = new OwnedDeviceBaseDTO();
}
	else if (name === "DeviceFullDTO") {
		t = new DeviceFullDTO();
}
	else if (name === "ScreenBlacklistDTO") {
		t = new ScreenBlacklistDTO();
}
	else if (name === "BiddingparametersDTO") {
		t = new BiddingparametersDTO();
}
	else if (name === "PlaylistSchemaIterationDTO") {
		t = new PlaylistSchemaIterationDTO();
}
	else if (name === "SharedScreenOfflinePlaylistDTO") {
		t = new SharedScreenOfflinePlaylistDTO();
}
	else if (name === "ContentCullAtomDTO") {
		t = new ContentCullAtomDTO();
}
	else if (name === "LocationStatusDTO") {
		t = new LocationStatusDTO();
}
	else if (name === "AbstractTrackedVisitorFullDTO") {
		t = new AbstractTrackedVisitorFullDTO();
}
	else if (name === "TrackedVisitorFullDTO") {
		t = new TrackedVisitorFullDTO();
}
	else if (name === "ScheduledBookingDTO") {
		t = new ScheduledBookingDTO();
}
	else if (name === "TemplateEntryDTO") {
		t = new TemplateEntryDTO();
}
	else if (name === "TemplateScreenEntryDTO") {
		t = new TemplateScreenEntryDTO();
}
	else if (name === "TemplateScreenEntryFullDTO") {
		t = new TemplateScreenEntryFullDTO();
}
	else if (name === "PlayoutAggregationDataDateEntryDTO") {
		t = new PlayoutAggregationDataDateEntryDTO();
}
	else if (name === "DateTimeRangeDTO") {
		t = new DateTimeRangeDTO();
}
	else if (name === "LocalizedFramedReportingDTO") {
		t = new LocalizedFramedReportingDTO();
}
	else if (name === "MediumGroupDTO") {
		t = new MediumGroupDTO();
}
	else if (name === "ClientCentricContentShareAssignmentDTO") {
		t = new ClientCentricContentShareAssignmentDTO();
}
	else if (name === "ServiceHourDTO") {
		t = new ServiceHourDTO();
}
	else if (name === "CullDTO") {
		t = new CullDTO();
}
	else if (name === "CullWithAtomsDTO") {
		t = new CullWithAtomsDTO();
}
	else if (name === "StateSpaceCullDTO") {
		t = new StateSpaceCullDTO();
}
	else if (name === "UserDTO") {
		t = new UserDTO();
}
	else if (name === "ClientCullAtomDTO") {
		t = new ClientCullAtomDTO();
}
	else if (name === "ChainedClientCullAtomDTO") {
		t = new ChainedClientCullAtomDTO();
}
	else if (name === "ClientByClientCullAtomDTO") {
		t = new ClientByClientCullAtomDTO();
}
	else if (name === "FileLink") {
		t = new FileLink();
}
	else if (name === "LoadLicenseRequest") {
		t = new LoadLicenseRequest();
}
	else if (name === "ContactDTO") {
		t = new ContactDTO();
}
	else if (name === "AddressedNamedIdentityDTO") {
		t = new AddressedNamedIdentityDTO();
}
	else if (name === "LocationBaseDTO") {
		t = new LocationBaseDTO();
}
	else if (name === "OwnedLocationBaseDTO") {
		t = new OwnedLocationBaseDTO();
}
	else if (name === "PlayerIdentityReturningPathBasedStructureCullAtomDTO") {
		t = new PlayerIdentityReturningPathBasedStructureCullAtomDTO();
}
	else if (name === "PathBasedGeoCullAtomDTO") {
		t = new PathBasedGeoCullAtomDTO();
}
	else if (name === "IdentityReturningPathBasedGeoCullAtomDTO") {
		t = new IdentityReturningPathBasedGeoCullAtomDTO();
}
	else if (name === "RadialPolygonIdentityReturningPathBasedGeoCullAtomDTO") {
		t = new RadialPolygonIdentityReturningPathBasedGeoCullAtomDTO();
}
	else if (name === "CampaignDTO") {
		t = new CampaignDTO();
}
	else if (name === "ChainedTimeCullAtomDTO") {
		t = new ChainedTimeCullAtomDTO();
}
	else if (name === "TimeByTimeCullAtomDTO") {
		t = new TimeByTimeCullAtomDTO();
}
	else if (name === "ContentPathBasedStructureCullAtomDTO") {
		t = new ContentPathBasedStructureCullAtomDTO();
}
	else if (name === "PositionDTO") {
		t = new PositionDTO();
}
	else if (name === "AttachmentAssignmentDTO") {
		t = new AttachmentAssignmentDTO();
}
	else if (name === "TemplateVariableDTO") {
		t = new TemplateVariableDTO();
}
	else if (name === "MediumGroupAttributeDTO") {
		t = new MediumGroupAttributeDTO();
}
	else if (name === "LocalizedHourBasedReportingDTO") {
		t = new LocalizedHourBasedReportingDTO();
}
	else if (name === "LocalDateTimeRange") {
		t = new LocalDateTimeRange();
}
	else if (name === "ChainedContentCullAtomDTO") {
		t = new ChainedContentCullAtomDTO();
}
	else if (name === "DeviceConfigurationTokenDTO") {
		t = new DeviceConfigurationTokenDTO();
}
	else if (name === "ReportingTemplateDTO") {
		t = new ReportingTemplateDTO();
}
	else if (name === "ReportingTemplateFullDTO") {
		t = new ReportingTemplateFullDTO();
}
	else if (name === "ProductCategoryDTO") {
		t = new ProductCategoryDTO();
}
	else if (name === "ProductCategoryFullDTO") {
		t = new ProductCategoryFullDTO();
}
	else if (name === "MultipartFormDataInput") {
		t = new MultipartFormDataInput();
}
	else if (name === "ChainedPlayerCullAtomDTO") {
		t = new ChainedPlayerCullAtomDTO();
}
	else if (name === "FilterDescriptor") {
		t = new FilterDescriptor();
}
	else if (name === "Serializable") {
		t = new Serializable();
}
	else if (name === "ColoredNamedIdentityWithCreatorDTO") {
		t = new ColoredNamedIdentityWithCreatorDTO();
}
	else if (name === "ScheduledNamedIdentityWithCreatorWithRequirementFiltersDTO") {
		t = new ScheduledNamedIdentityWithCreatorWithRequirementFiltersDTO();
}
	else if (name === "ScheduledCommercialDTO") {
		t = new ScheduledCommercialDTO();
}
	else if (name === "Comparator") {
		t = new Comparator();
}
	else if (name === "ThreadGroupDTO") {
		t = new ThreadGroupDTO();
}
	else if (name === "InventoryIdentityDescriptorDTO") {
		t = new InventoryIdentityDescriptorDTO();
}
	else if (name === "EndpointStatisticsDTO") {
		t = new EndpointStatisticsDTO();
}
	else if (name === "PublisherPlayoutDescriptorDTO") {
		t = new PublisherPlayoutDescriptorDTO();
}
	else if (name === "PublisherPlayoutDescriptorWithScreenDTO") {
		t = new PublisherPlayoutDescriptorWithScreenDTO();
}
	else if (name === "PublisherPlayoutDescriptorFullDTO") {
		t = new PublisherPlayoutDescriptorFullDTO();
}
	else if (name === "InventoryChannelDTO") {
		t = new InventoryChannelDTO();
}
	else if (name === "InventoryChannelFullDTO") {
		t = new InventoryChannelFullDTO();
}
	else if (name === "PlayoutBaseDTO") {
		t = new PlayoutBaseDTO();
}
	else if (name === "PlayoutBookingBaseDTO") {
		t = new PlayoutBookingBaseDTO();
}
	else if (name === "InventoryPlayoutDTO") {
		t = new InventoryPlayoutDTO();
}
	else if (name === "LicenseDTO") {
		t = new LicenseDTO();
}
	else if (name === "MachineLicenseDTO") {
		t = new MachineLicenseDTO();
}
	else if (name === "ScreenMachineLicenseDTO") {
		t = new ScreenMachineLicenseDTO();
}
	else if (name === "ClientIdentityReturningPathBasedStructureCullAtomDTO") {
		t = new ClientIdentityReturningPathBasedStructureCullAtomDTO();
}
	else if (name === "IndexedBookingSetDTO") {
		t = new IndexedBookingSetDTO();
}
	else if (name === "DateTimePartCullAtomDTO") {
		t = new DateTimePartCullAtomDTO();
}
	else if (name === "PlayoutAggregationDataDateEntry") {
		t = new PlayoutAggregationDataDateEntry();
}
	else if (name === "AdHocReportingSetupDTO") {
		t = new AdHocReportingSetupDTO();
}
	else if (name === "MediumGroupAttributeDatatypeDTO") {
		t = new MediumGroupAttributeDatatypeDTO();
}
	else if (name === "TargetingBucketDTO") {
		t = new TargetingBucketDTO();
}
	else if (name === "AggregatedPlaylistSchemaIterationSlotDTO") {
		t = new AggregatedPlaylistSchemaIterationSlotDTO();
}
	else if (name === "ScheduledCampaignDTO") {
		t = new ScheduledCampaignDTO();
}
	else if (name === "SharedPlaylistDTO") {
		t = new SharedPlaylistDTO();
}
	else if (name === "InventoryFilterValueListResponseDTO") {
		t = new InventoryFilterValueListResponseDTO();
}
	else if (name === "SelectionFieldReference") {
		t = new SelectionFieldReference();
}
	else if (name === "PoolBaseDTO") {
		t = new PoolBaseDTO();
}
	else if (name === "PoolDTO") {
		t = new PoolDTO();
}
	else if (name === "InventoryElementDTO") {
		t = new InventoryElementDTO();
}
	else if (name === "InventoryCompanyDTO") {
		t = new InventoryCompanyDTO();
}
	else if (name === "InventoryCompanyFullDTO") {
		t = new InventoryCompanyFullDTO();
}
	else if (name === "VerificationDTO") {
		t = new VerificationDTO();
}
	else if (name === "FramedReportingDTO") {
		t = new FramedReportingDTO();
}
	else if (name === "PostFullDTO") {
		t = new PostFullDTO();
}
	else if (name === "ThreadDTO") {
		t = new ThreadDTO();
}
	else if (name === "FormatDTO") {
		t = new FormatDTO();
}
	else if (name === "ElementCountDataDTO") {
		t = new ElementCountDataDTO();
}
	else if (name === "CampaignReportElementCountDataDTO") {
		t = new CampaignReportElementCountDataDTO();
}
	else if (name === "TemplateGroupRequestDefinitionDTO") {
		t = new TemplateGroupRequestDefinitionDTO();
}
	else if (name === "WeeklyScheduleDTO") {
		t = new WeeklyScheduleDTO();
}
	else if (name === "BookingparametersDTO") {
		t = new BookingparametersDTO();
}
	else if (name === "TargetedScreenOfflinePlaylistDTO") {
		t = new TargetedScreenOfflinePlaylistDTO();
}
	else if (name === "ContentByContentCullAtomDTO") {
		t = new ContentByContentCullAtomDTO();
}
	else if (name === "FolderDTO") {
		t = new FolderDTO();
}
	else if (name === "SizedFolderDTO") {
		t = new SizedFolderDTO();
}
	else if (name === "MediumFolderDTO") {
		t = new MediumFolderDTO();
}
	else if (name === "CompanyFullShortAttributeDTO") {
		t = new CompanyFullShortAttributeDTO();
}
	else if (name === "Response") {
		t = new Response();
}
	else if (name === "ScreenOfflineBookingDTO") {
		t = new ScreenOfflineBookingDTO();
}
	else if (name === "SingleFileUpload") {
		t = new SingleFileUpload();
}
	else if (name === "AggregationGroupDTO") {
		t = new AggregationGroupDTO();
}
	else if (name === "SettingFullDTO") {
		t = new SettingFullDTO();
}
	else if (name === "InventoryFieldDTO") {
		t = new InventoryFieldDTO();
}
	else if (name === "FilterableInventoryRequestDTO") {
		t = new FilterableInventoryRequestDTO();
}
	else if (name === "DeviceGeoStatsDTO") {
		t = new DeviceGeoStatsDTO();
}
	else if (name === "DeviceConfigurationEntryDTO") {
		t = new DeviceConfigurationEntryDTO();
}
	else if (name === "PublisherBookingDTO") {
		t = new PublisherBookingDTO();
}
	else if (name === "ClientDTO") {
		t = new ClientDTO();
}
	else if (name === "MediumWithMD5DTO") {
		t = new MediumWithMD5DTO();
}
	else if (name === "InventoryPoolDTO") {
		t = new InventoryPoolDTO();
}
	else if (name === "VisitorTrackerScreenBaseDTO") {
		t = new VisitorTrackerScreenBaseDTO();
}
	else if (name === "VisitorTrackerScreenFullDTO") {
		t = new VisitorTrackerScreenFullDTO();
}
	else if (name === "PlayerAggregationDataDTO") {
		t = new PlayerAggregationDataDTO();
}
	else if (name === "VisitorDiurnalCycleDataDTO") {
		t = new VisitorDiurnalCycleDataDTO();
}
	else if (name === "VisitorAggregationDate") {
		t = new VisitorAggregationDate();
}
	else if (name === "SharedTargetedScreenOfflinePlaylistDTO") {
		t = new SharedTargetedScreenOfflinePlaylistDTO();
}
	else if (name === "TrackedVisitorLocalFullDTO") {
		t = new TrackedVisitorLocalFullDTO();
}
	else if (name === "ResolutionDTO") {
		t = new ResolutionDTO();
}
	else if (name === "SharedAssetDTO") {
		t = new SharedAssetDTO();
}
	else if (name === "ShareOfVoiceDTO") {
		t = new ShareOfVoiceDTO();
}
	else if (name === "CompanyShareOfVoiceDTO") {
		t = new CompanyShareOfVoiceDTO();
}
	else if (name === "ApiKeyCreationInfoDTO") {
		t = new ApiKeyCreationInfoDTO();
}
	else if (name === "AttributeMapDTO") {
		t = new AttributeMapDTO();
}
	else if (name === "AdvertiserShareOfVoiceDTO") {
		t = new AdvertiserShareOfVoiceDTO();
}
	else if (name === "UniqueVisitorAggregationDate") {
		t = new UniqueVisitorAggregationDate();
}
	else if (name === "DiversifiedNamedIdentityWithCreatorDTO") {
		t = new DiversifiedNamedIdentityWithCreatorDTO();
}
	else if (name === "NetworkShareDTO") {
		t = new NetworkShareDTO();
}
	else if (name === "RoleDTO") {
		t = new RoleDTO();
}
	else if (name === "LocalDateTimeRangeDTO") {
		t = new LocalDateTimeRangeDTO();
}
	else if (name === "IdentityArrayDTO") {
		t = new IdentityArrayDTO();
}
	else if (name === "SharedClientNetworkAccessDTO") {
		t = new SharedClientNetworkAccessDTO();
}
	else if (name === "MediaFileInfo") {
		t = new MediaFileInfo();
}
	else if (name === "LocationTypeDTO") {
		t = new LocationTypeDTO();
}
	else if (name === "AreaDTO") {
		t = new AreaDTO();
}
	else if (name === "MediaFileTag") {
		t = new MediaFileTag();
}
	else if (name === "InventoryGeoAggregationFrontendEnhancedDTO") {
		t = new InventoryGeoAggregationFrontendEnhancedDTO();
}
	else if (name === "DeviceSocketCommandLogStatisticDTO") {
		t = new DeviceSocketCommandLogStatisticDTO();
}
	else if (name === "ApiKeyCreationDTO") {
		t = new ApiKeyCreationDTO();
}
	else if (name === "PlayerCullDTO") {
		t = new PlayerCullDTO();
}
	else if (name === "HashDTO") {
		t = new HashDTO();
}
	else if (name === "LocationAttributeDTO") {
		t = new LocationAttributeDTO();
}
	else if (name === "ReportingSchedulingDTO") {
		t = new ReportingSchedulingDTO();
}
	else if (name === "ReportingSchedulingFullDTO") {
		t = new ReportingSchedulingFullDTO();
}
	else if (name === "CullGraphTreeNodeDTO") {
		t = new CullGraphTreeNodeDTO();
}
	else if (name === "CampaignFullDTO") {
		t = new CampaignFullDTO();
}
	else if (name === "VisitorTrackerScreenAssignmentDTO") {
		t = new VisitorTrackerScreenAssignmentDTO();
}
	else if (name === "PlanningSubmissionDTO") {
		t = new PlanningSubmissionDTO();
}
	else if (name === "TemplateEntryWithCreatorDTO") {
		t = new TemplateEntryWithCreatorDTO();
}
	else if (name === "TemplateDataSetDTO") {
		t = new TemplateDataSetDTO();
}
	else if (name === "FreeTextFieldReference") {
		t = new FreeTextFieldReference();
}
	else if (name === "GeoByGeoCullAtomDTO") {
		t = new GeoByGeoCullAtomDTO();
}
	else if (name === "NetworkAccessPatternDTO") {
		t = new NetworkAccessPatternDTO();
}
	else if (name === "PlayerHardwareDTO") {
		t = new PlayerHardwareDTO();
}
	else if (name === "TemplateStoreDataDTO") {
		t = new TemplateStoreDataDTO();
}
	else if (name === "TemplateDataSetSourceSubscriptionDTO") {
		t = new TemplateDataSetSourceSubscriptionDTO();
}
	else if (name === "Vast") {
		t = new Vast();
}
	else if (name === "ReportingDTO") {
		t = new ReportingDTO();
}
	else if (name === "ReportingFullDTO") {
		t = new ReportingFullDTO();
}
	else if (name === "InventoryFieldValueDTO") {
		t = new InventoryFieldValueDTO();
}
	else if (name === "PublisherShareOfVoiceDTO") {
		t = new PublisherShareOfVoiceDTO();
}
	else if (name === "LocalizedFrameDTO") {
		t = new LocalizedFrameDTO();
}
	else if (name === "DiversifiedNamedIdentityWithRequirementFiltersDTO") {
		t = new DiversifiedNamedIdentityWithRequirementFiltersDTO();
}
	else if (name === "RequirementDTO") {
		t = new RequirementDTO();
}
	else if (name === "RequirementFullDTO") {
		t = new RequirementFullDTO();
}
	else if (name === "WordingDTO") {
		t = new WordingDTO();
}
	else if (name === "DeviceLicenseDTO") {
		t = new DeviceLicenseDTO();
}
	else if (name === "MediaFileDisposition") {
		t = new MediaFileDisposition();
}
	else if (name === "ManagedUserDTO") {
		t = new ManagedUserDTO();
}
	else if (name === "MediumGroupShareOfVoiceDTO") {
		t = new MediumGroupShareOfVoiceDTO();
}
	else if (name === "PerThreadStatistic") {
		t = new PerThreadStatistic();
}
	else if (name === "InventoryMarkerFullDTO") {
		t = new InventoryMarkerFullDTO();
}
	else if (name === "PlayerByPlayerCullAtomDTO") {
		t = new PlayerByPlayerCullAtomDTO();
}
	else if (name === "TimeCullDTO") {
		t = new TimeCullDTO();
}
	else if (name === "DiscussableBulkOptions") {
		t = new DiscussableBulkOptions();
}
	else if (name === "MediumGroupCategoryShareOfVoiceDTO") {
		t = new MediumGroupCategoryShareOfVoiceDTO();
}
	else if (name === "OrderDescriptor") {
		t = new OrderDescriptor();
}
	else if (name === "ClientInfoDTO") {
		t = new ClientInfoDTO();
}
	else if (name === "AssetFileDTO") {
		t = new AssetFileDTO();
}
	else if (name === "AssetFileFullDTO") {
		t = new AssetFileFullDTO();
}
	else if (name === "InventoryFieldValueAggregationDTO") {
		t = new InventoryFieldValueAggregationDTO();
}
	else if (name === "VisitorTrackerScreenAssignmentsDTO") {
		t = new VisitorTrackerScreenAssignmentsDTO();
}
	else if (name === "PlayoutparametersDTO") {
		t = new PlayoutparametersDTO();
}
	else if (name === "InventoryAggregationDTO") {
		t = new InventoryAggregationDTO();
}
	else if (name === "StackTraceElementDTO") {
		t = new StackTraceElementDTO();
}
	else if (name === "AttributeValueDTO") {
		t = new AttributeValueDTO();
}
	else if (name === "ClientConnectionEstablishmentRequestDTO") {
		t = new ClientConnectionEstablishmentRequestDTO();
}
	else if (name === "ClientCullDTO") {
		t = new ClientCullDTO();
}
	else if (name === "FixedAspectRatioImageBaseDTO") {
		t = new FixedAspectRatioImageBaseDTO();
}
	else if (name === "InventoryFilterValueListRequestDTO") {
		t = new InventoryFilterValueListRequestDTO();
}
	else if (name === "ContentCullDTO") {
		t = new ContentCullDTO();
}
	else if (name === "BudgetDTO") {
		t = new BudgetDTO();
}
	else if (name === "CalendarDTO") {
		t = new CalendarDTO();
}
	else if (name === "CalendarFullDTO") {
		t = new CalendarFullDTO();
}
	else if (name === "MediumGroupFullDTO") {
		t = new MediumGroupFullDTO();
}
	else if (name === "StaticPlaylistSlotDTO") {
		t = new StaticPlaylistSlotDTO();
}
	else if (name === "ScreenFullDTO") {
		t = new ScreenFullDTO();
}
	else if (name === "CompanyAttributeDTO") {
		t = new CompanyAttributeDTO();
}
	else if (name === "AggregatedPlaylistSchemaIterationDTO") {
		t = new AggregatedPlaylistSchemaIterationDTO();
}
	else if (name === "CampaignWithPreviewDTO") {
		t = new CampaignWithPreviewDTO();
}
	else if (name === "CalendarEntryMetaDataFullDTO") {
		t = new CalendarEntryMetaDataFullDTO();
}
	else if (name === "AttachmentCountDTO") {
		t = new AttachmentCountDTO();
}
	else if (name === "TopicDTO") {
		t = new TopicDTO();
}
	else if (name === "LocationFullShortAttributeDTO") {
		t = new LocationFullShortAttributeDTO();
}
	else if (name === "VisitorAudienceTranslationDTO") {
		t = new VisitorAudienceTranslationDTO();
}
	else if (name === "ProductAttributeDatatypeDTO") {
		t = new ProductAttributeDatatypeDTO();
}
	else if (name === "MediumTransformationDTO") {
		t = new MediumTransformationDTO();
}
	else if (name === "DeviceTripDTO") {
		t = new DeviceTripDTO();
}
	else if (name === "DeviceFullShortAttributeDTO") {
		t = new DeviceFullShortAttributeDTO();
}
	else if (name === "InventoryScreenHardwareDTO") {
		t = new InventoryScreenHardwareDTO();
}
	else if (name === "TemplateSourceEntryDTO") {
		t = new TemplateSourceEntryDTO();
}
	else if (name === "PlayoutImpressionReportDataDTO") {
		t = new PlayoutImpressionReportDataDTO();
}
	else if (name === "CampaignReportDataDTO") {
		t = new CampaignReportDataDTO();
}
	else if (name === "SharedAssetRepositoryDTO") {
		t = new SharedAssetRepositoryDTO();
}
	else if (name === "EntityDTO") {
		t = new EntityDTO();
}
	else if (name === "DeviceTripFullDTO") {
		t = new DeviceTripFullDTO();
}
	else if (name === "GroupedThreads") {
		t = new GroupedThreads();
}
	else if (name === "PlayoutImpressionReportEntryDTO") {
		t = new PlayoutImpressionReportEntryDTO();
}
	else if (name === "VisitorTrackerScreenDTO") {
		t = new VisitorTrackerScreenDTO();
}
	else if (name === "CommandQueueManagerDTO") {
		t = new CommandQueueManagerDTO();
}
	else if (name === "MediumGroupFolderDTO") {
		t = new MediumGroupFolderDTO();
}
	else if (name === "FrameDTO") {
		t = new FrameDTO();
}
	else if (name === "CoordinateClusterDTO") {
		t = new CoordinateClusterDTO();
}
	else if (name === "CompanyAttributeDatatypeDTO") {
		t = new CompanyAttributeDatatypeDTO();
}
	else if (name === "TopicFullDTO") {
		t = new TopicFullDTO();
}
	else if (name === "NetworkPriceModelDTO") {
		t = new NetworkPriceModelDTO();
}
	else if (name === "MediumWithMediaFileInfo") {
		t = new MediumWithMediaFileInfo();
}
	else if (name === "ChangeUsernameDTO") {
		t = new ChangeUsernameDTO();
}
	else if (name === "PlayerAggregationDTO") {
		t = new PlayerAggregationDTO();
}
	else if (name === "TemplateDataSetEntryDTO") {
		t = new TemplateDataSetEntryDTO();
}
	else if (name === "TemplateDataSetEntryWithDataSetDTO") {
		t = new TemplateDataSetEntryWithDataSetDTO();
}
	else if (name === "TemplateDataSetEntryWithScreenEntryAggregationDTO") {
		t = new TemplateDataSetEntryWithScreenEntryAggregationDTO();
}
	else if (name === "AddressDTO") {
		t = new AddressDTO();
}
	else if (name === "ReportingTypeDTO") {
		t = new ReportingTypeDTO();
}
	else if (name === "ScreenEntryAggregationDTO") {
		t = new ScreenEntryAggregationDTO();
}
	else if (name === "PlayoutAggregationDTO") {
		t = new PlayoutAggregationDTO();
}
	else if (name === "ProductFullShortAttributeDTO") {
		t = new ProductFullShortAttributeDTO();
}
	else if (name === "FixedAspectRatioImageDTO") {
		t = new FixedAspectRatioImageDTO();
}
	else if (name === "CampaignLevelDTO") {
		t = new CampaignLevelDTO();
}
	else if (name === "CampaignReportElementCountDTO") {
		t = new CampaignReportElementCountDTO();
}
	else if (name === "DisplayableValueDTO") {
		t = new DisplayableValueDTO();
}
	else if (name === "ProductDTO") {
		t = new ProductDTO();
}
	else if (name === "MediumGroupCategoryDTO") {
		t = new MediumGroupCategoryDTO();
}
	else if (name === "CronDefinitionDTO") {
		t = new CronDefinitionDTO();
}
	else if (name === "CronDefinitionFullDTO") {
		t = new CronDefinitionFullDTO();
}
	else if (name === "ClientNetworkAccessDTO") {
		t = new ClientNetworkAccessDTO();
}
	else if (name === "StrongBytesDescriptedPlayout") {
		t = new StrongBytesDescriptedPlayout();
}
	else if (name === "TargetingDTO") {
		t = new TargetingDTO();
}
	else if (name === "TemplateStoreDTO") {
		t = new TemplateStoreDTO();
}
	else if (name === "Result") {
		t = new Result();
}
	else if (name === "ProductFullDTO") {
		t = new ProductFullDTO();
}
	else if (name === "InventoryLocationDTO") {
		t = new InventoryLocationDTO();
}
	else if (name === "VisitorRecalculationParameters") {
		t = new VisitorRecalculationParameters();
}
	else if (name === "ScreenOfflinePlaylistSlotDTO") {
		t = new ScreenOfflinePlaylistSlotDTO();
}
	else if (name === "DayTimeHoursDTO") {
		t = new DayTimeHoursDTO();
}
	else if (name === "InventoryGeoAggregationDTO") {
		t = new InventoryGeoAggregationDTO();
}
	else if (name === "InventoryGeoAggregationWithElementIdsDTO") {
		t = new InventoryGeoAggregationWithElementIdsDTO();
}
	else if (name === "CampaignTypeDTO") {
		t = new CampaignTypeDTO();
}
	else if (name === "CampaignTypeHierarchyDTO") {
		t = new CampaignTypeHierarchyDTO();
}
	else if (name === "RadialPolygonPathBasedGeoCullAtomDTO") {
		t = new RadialPolygonPathBasedGeoCullAtomDTO();
}
	else if (name === "AggregatedPlaylistDTO") {
		t = new AggregatedPlaylistDTO();
}
	else if (name === "PlayoutAggregationDataDTO") {
		t = new PlayoutAggregationDataDTO();
}
	else if (name === "TemplateGroupDTO") {
		t = new TemplateGroupDTO();
}
	else if (name === "TagEntityDTO") {
		t = new TagEntityDTO();
}
	else if (name === "SharedAssetFileFullDTO") {
		t = new SharedAssetFileFullDTO();
}
	else if (name === "RenderedScreenPlaylistIterationDTO") {
		t = new RenderedScreenPlaylistIterationDTO();
}
	else if (name === "MediaFileStream") {
		t = new MediaFileStream();
}
	else if (name === "ProductAttributeDTO") {
		t = new ProductAttributeDTO();
}
	else if (name === "TimeRangeDTO") {
		t = new TimeRangeDTO();
}
	else if (name === "AuthenticationOptionDTO") {
		t = new AuthenticationOptionDTO();
}
	else if (name === "ClientCreationDTO") {
		t = new ClientCreationDTO();
}
	else if (name === "GroupMediumDTO") {
		t = new GroupMediumDTO();
}
	else if (name === "BookedMediumGroupAggregationGroupDTO") {
		t = new BookedMediumGroupAggregationGroupDTO();
}
	else if (name === "ScreenConfiguration") {
		t = new ScreenConfiguration();
}
	else if (name === "GroupDTO") {
		t = new GroupDTO();
}
	else if (name === "HourBasedReportingDTO") {
		t = new HourBasedReportingDTO();
}
	else if (name === "RangeFieldReference") {
		t = new RangeFieldReference();
}
	else if (name === "ClientPathBasedStructureCullAtomDTO") {
		t = new ClientPathBasedStructureCullAtomDTO();
}
	else if (name === "MediaFileFormat") {
		t = new MediaFileFormat();
}
	else if (name === "LocationAttributeDatatypeDTO") {
		t = new LocationAttributeDatatypeDTO();
}
	else if (name === "DeviceConfigurationRequestDTO") {
		t = new DeviceConfigurationRequestDTO();
}
	else if (name === "IdentifierWithCreationDTO") {
		t = new IdentifierWithCreationDTO();
}
	else if (name === "PlaylistSlotDTO") {
		t = new PlaylistSlotDTO();
}
	else if (name === "GeoCullDTO") {
		t = new GeoCullDTO();
}
	else if (name === "ChangePasswordDTO") {
		t = new ChangePasswordDTO();
}
	else if (name === "SharedAssetFullDTO") {
		t = new SharedAssetFullDTO();
}
	else if (name === "BackgroundWorkerDTO") {
		t = new BackgroundWorkerDTO();
}
	else if (name === "DeviceStatisticFields") {
		t = new DeviceStatisticFields();
}
	else if (name === "PasswordRequirementDTO") {
		t = new PasswordRequirementDTO();
}
	else if (name === "FixedAspectRatioImageDefinitionDTO") {
		t = new FixedAspectRatioImageDefinitionDTO();
}
	else if (name === "CommercialWithPreviewDTO") {
		t = new CommercialWithPreviewDTO();
}
	else if (name === "TemplateDataSetFullDTO") {
		t = new TemplateDataSetFullDTO();
}
	else if (name === "InventoryScreenDTO") {
		t = new InventoryScreenDTO();
}
	else if (name === "InventoryScreenFullDTO") {
		t = new InventoryScreenFullDTO();
}
	else if (name === "ContentShareQuotaFullDTO") {
		t = new ContentShareQuotaFullDTO();
}
	else if (name === "PriceDTO") {
		t = new PriceDTO();
}
	else if (name === "TemplateDataSetSourceSubscriptionKeyDTO") {
		t = new TemplateDataSetSourceSubscriptionKeyDTO();
}
	else if (name === "CullCategoryDTO") {
		t = new CullCategoryDTO();
}
	else if (name === "TargetedScreenOfflinePlaylistSlotDTO") {
		t = new TargetedScreenOfflinePlaylistSlotDTO();
}
	else if (name === "DeviceTripPartDTO") {
		t = new DeviceTripPartDTO();
}
	else if (name === "EndpointDescriptorDTO") {
		t = new EndpointDescriptorDTO();
}
	else if (name === "CullCountDTO") {
		t = new CullCountDTO();
}
	else if (name === "ThumbnailableFileLink") {
		t = new ThumbnailableFileLink();
}
	else if (name === "CampaignBadgesDTO") {
		t = new CampaignBadgesDTO();
}
	else if (name === "InventoryFieldDefinitionDTO") {
		t = new InventoryFieldDefinitionDTO();
}
	else if (name === "ContentIdentityReturningPathBasedStructureCullAtomDTO") {
		t = new ContentIdentityReturningPathBasedStructureCullAtomDTO();
}
	else if (name === "DiurnalCycleDTO") {
		t = new DiurnalCycleDTO();
}
	else if (name === "VisitorDiurnalCycleDTO") {
		t = new VisitorDiurnalCycleDTO();
}
	else if (name === "AttachmentFolderDTO") {
		t = new AttachmentFolderDTO();
}
	else if (name === "PlaylistSchemaDTO") {
		t = new PlaylistSchemaDTO();
}
	else if (name === "AssetCategoryDTO") {
		t = new AssetCategoryDTO();
}
	else if (name === "QueryExecutionDescriptorDTO") {
		t = new QueryExecutionDescriptorDTO();
}
	else if (name === "TemplateDataSetEntryFullDTO") {
		t = new TemplateDataSetEntryFullDTO();
}
	else if (name === "ExecutionReportEntryDTO") {
		t = new ExecutionReportEntryDTO();
}
	else if (name === "AtomTypeDTO") {
		t = new AtomTypeDTO();
}
	else if (name === "BookingDTO") {
		t = new BookingDTO();
}
	else if (name === "BookingFullDTO") {
		t = new BookingFullDTO();
}
	else if (name === "SharedPlaybackScheduleDTO") {
		t = new SharedPlaybackScheduleDTO();
}
	else if (name === "DayTimeIntervalDTO") {
		t = new DayTimeIntervalDTO();
}
	else if (name === "FilterBadgesDTO") {
		t = new FilterBadgesDTO();
}
	else if (name === "LocationFullDTO") {
		t = new LocationFullDTO();
}
	else if (name === "StateSpaceCullAtomDTO") {
		t = new StateSpaceCullAtomDTO();
}
	else if (name === "ScreenOfflinePlaylistDTO") {
		t = new ScreenOfflinePlaylistDTO();
}
	else if (name === "LocationOnlineStatusCount") {
		t = new LocationOnlineStatusCount();
}
	else if (name === "DeviceStatisticCounts") {
		t = new DeviceStatisticCounts();
}
	else if (name === "NetworkDeviceStatistic") {
		t = new NetworkDeviceStatistic();
}
	else if (name === "ReportingFileFullDTO") {
		t = new ReportingFileFullDTO();
}
	else if (name === "AssetRepositoryFullDTO") {
		t = new AssetRepositoryFullDTO();
}
	else if (name === "BookedMediumGroupAggregatedPlaylistDTO") {
		t = new BookedMediumGroupAggregatedPlaylistDTO();
}
	else if (name === "IncomingClientConnectionEstablishmentRequestDTO") {
		t = new IncomingClientConnectionEstablishmentRequestDTO();
}
	else if (name === "NetworkAggregationDTO") {
		t = new NetworkAggregationDTO();
}
	else if (name === "DeviceDTO") {
		t = new DeviceDTO();
}
	else if (name === "ContentShareDTO") {
		t = new ContentShareDTO();
}
	else if (name === "ContentShareFullDTO") {
		t = new ContentShareFullDTO();
}
	else if (name === "PermissionEntryDTO") {
		t = new PermissionEntryDTO();
}
	else if (name === "PerformanceCheckResultDTO") {
		t = new PerformanceCheckResultDTO();
}
	else if (name === "CalendarTypeDTO") {
		t = new CalendarTypeDTO();
}
	else if (name === "TemplateScreenEntryWithDataSetDTO") {
		t = new TemplateScreenEntryWithDataSetDTO();
}
	else if (name === "LinkedEntityDTO") {
		t = new LinkedEntityDTO();
}
	else if (name === "PlaylistSchemaIterationSlotDTO") {
		t = new PlaylistSchemaIterationSlotDTO();
}
	else if (name === "PlaylistSchemaIterationSlotFullDTO") {
		t = new PlaylistSchemaIterationSlotFullDTO();
}
	else if (name === "ScreenOfflineMediumDTO") {
		t = new ScreenOfflineMediumDTO();
}
	else if (name === "UserFullDTO") {
		t = new UserFullDTO();
}
	else if (name === "BadgesDTO") {
		t = new BadgesDTO();
}
	else if (name === "UserClientFullDTO") {
		t = new UserClientFullDTO();
}
	else if (name === "AttachmentDTO") {
		t = new AttachmentDTO();
}
	else if (name === "SharedTargetedOfflinePlaylistDTO") {
		t = new SharedTargetedOfflinePlaylistDTO();
}
	else if (name === "StructureCullDTO") {
		t = new StructureCullDTO();
}
	else if (name === "CalendarCategoryDTO") {
		t = new CalendarCategoryDTO();
}
	else if (name === "InventoryDeviceFullDTO") {
		t = new InventoryDeviceFullDTO();
}
	else if (name === "ExecutionReportDataDTO") {
		t = new ExecutionReportDataDTO();
}
	else if (name === "PlayoutDTO") {
		t = new PlayoutDTO();
}
	else if (name === "NetworkBadgesDTO") {
		t = new NetworkBadgesDTO();
}
	else if (name === "CheckRestoreDTO") {
		t = new CheckRestoreDTO();
}
	else if (name === "ApiKeyDTO") {
		t = new ApiKeyDTO();
}
	else if (name === "AssetFileLink") {
		t = new AssetFileLink();
}
	else if (name === "ImpressionBidDTO") {
		t = new ImpressionBidDTO();
}
	else if (name === "DeviceLogDTO") {
		t = new DeviceLogDTO();
}
	else if (name === "ScreenLicenseDTO") {
		t = new ScreenLicenseDTO();
}
	else if (name === "TimeRangeCullAtomDTO") {
		t = new TimeRangeCullAtomDTO();
}
	else if (name === "HtmlDTO") {
		t = new HtmlDTO();
}
	else if (name === "LeveledBookingsDTO") {
		t = new LeveledBookingsDTO();
}
	else if (name === "PolygonDTO") {
		t = new PolygonDTO();
}
	else if (name === "LocalizedFrameBucketDTO") {
		t = new LocalizedFrameBucketDTO();
}
	else if (name === "PlaybackScheduleDTO") {
		t = new PlaybackScheduleDTO();
}
	else if (name === "PlaybackScheduleFullDTO") {
		t = new PlaybackScheduleFullDTO();
}
	else if (name === "ScreenPlaylistDTO") {
		t = new ScreenPlaylistDTO();
}
	else if (name === "ClientAggregationDTO") {
		t = new ClientAggregationDTO();
}
	else if (name === "FrameBucketDTO") {
		t = new FrameBucketDTO();
}
	else if (name === "ImpressionRequestDTO") {
		t = new ImpressionRequestDTO();
}
	else if (name === "AssetCategoryFullDTO") {
		t = new AssetCategoryFullDTO();
}
	else if (name === "InventoryFilterDTO") {
		t = new InventoryFilterDTO();
}
	else if (name === "PlayerSoftwareDTO") {
		t = new PlayerSoftwareDTO();
}
	else if (name === "TemplateSourceDTO") {
		t = new TemplateSourceDTO();
}
	else if (name === "TagDTO") {
		t = new TagDTO();
}
	else if (name === "MediumShareOfVoiceDTO") {
		t = new MediumShareOfVoiceDTO();
}
	else if (name === "VisitorTrackerFullDTO") {
		t = new VisitorTrackerFullDTO();
}
	else if (name === "TransactionExecutionStatisticsDTO") {
		t = new TransactionExecutionStatisticsDTO();
}
	else if (name === "ManagedUserClientDTO") {
		t = new ManagedUserClientDTO();
}
	else if (name === "PlayerPathBasedStructureCullAtomDTO") {
		t = new PlayerPathBasedStructureCullAtomDTO();
}
	else if (name === "PlayerBase") {
		t = new PlayerBase();
}
	else if (name === "DeviceMachineLicenseDTO") {
		t = new DeviceMachineLicenseDTO();
}
	else if (name === "SharedClientCentricContentShareAssignmentDTO") {
		t = new SharedClientCentricContentShareAssignmentDTO();
}
	else if (name === "PlanningDTO") {
		t = new PlanningDTO();
}
	else if (name === "NotificationDTO") {
		t = new NotificationDTO();
}
	else if (name === "LineStringDTO") {
		t = new LineStringDTO();
}
	else if (name === "CampaignReportEntryDTO") {
		t = new CampaignReportEntryDTO();
}
	else if (name === "PoolHierarchyDTO") {
		t = new PoolHierarchyDTO();
}
	else if (name === "LocationDTO") {
		t = new LocationDTO();
}
	else if (name === "CustomerSetlistDTO") {
		t = new CustomerSetlistDTO();
}
	else if (name === "CalendarEntryCategoryDTO") {
		t = new CalendarEntryCategoryDTO();
}
	else if (name === "ChannelStatistic") {
		t = new ChannelStatistic();
}
	else if (name === "ChannelFullDTO") {
		t = new ChannelFullDTO();
}
		if (t != null)
		this.initDTO(t);
	return t;
}

initDTO(dto: unknown) {
		
		try {
			const casted: { _properties: string[] } = <{ _properties: string[] }>dto;
			if (casted._properties) {
				for (let prop of casted._properties) {
					if (!(prop in casted)) {
						Object.assign(casted, JSON.parse('{'+prop+': null}'));
					}
				}
			}
			
		} catch (e) {
			
		}
	}}
function _window(): any {
    // return the global native browser window object
    return window;
}
export class DTO {
  _checkOwner? : any;
  _type? : string='DTO';
  toString():string {
    return encodeURI(JSON.stringify(this));
  }
  static get _properties():string[]{return ["_checkOwner","_type"];}
}


export class Pagination {
 	page : number | null = null;
	pages : number | null = null;
	count : number | null = null;
	resultcount : number | null = null;
	static  get _properties():string[]{return ["page","pages","count","resultcount"];}
}


export class IdentityDTO extends DTO {
 	id : any | null = null;
	static override get _properties():string[]{return ["id","_checkOwner","_type"];}
}
export class NamedIdentityDTO extends IdentityDTO {
 	name : string | null = null;
	static override get _properties():string[]{return ["name","id","_checkOwner","_type"];}
}
export class NotificationCategoryDTO extends NamedIdentityDTO {
 	static override get _properties():string[]{return ["name","id","_checkOwner","_type"];}
}
export class PlayoutMetaDTO extends DTO {
 	currentTimestamp : SbDateTime | null = null;
	progress : number | null = null;
	data : any | null = null;
	static override get _properties():string[]{return ["currentTimestamp","progress","data","_checkOwner","_type"];}
}
export class CullAtomDTO extends IdentityDTO {
 	type : string | null = null;
	readonly valid : boolean | null = null;
	operator : ComparisonOperator | null = null;
	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class StructureCullAtomDTO extends CullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class PlayerCullAtomDTO extends StructureCullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class NamedIdentityWithCreatorDTO extends NamedIdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly createdBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ModifiableNamedIdentityWithCreatorDTO extends NamedIdentityWithCreatorDTO {
 	readonly modifiedAt : SbDateTime | null = null;
	readonly modifiedBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ColoredModifiableNamedIdentityWithCreatorDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	color : string | null = null;
	static override get _properties():string[]{return ["color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ColorDefinitionDTO extends ColoredModifiableNamedIdentityWithCreatorDTO {
 	global : boolean | null = null;
	description : string | null = null;
	static override get _properties():string[]{return ["global","description","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DeviceConfiguration {
 	legacy : boolean | null = null;
	user : string | null = null;
	pass : string | null = null;
	device : number | null = null;
	screens : ScreenConfiguration[] | null = null;
	static  get _properties():string[]{return ["legacy","user","pass","device","screens"];}
}
export class AbstractTrackedVisitorDTO extends DTO {
 	count : number[] | null = null;
	unique : number[] | null = null;
	dwellTime : number[] | null = null;
	static override get _properties():string[]{return ["count","unique","dwellTime","_checkOwner","_type"];}
}
export class TrackedVisitorDTO extends AbstractTrackedVisitorDTO {
 	date : SbDateTime | null = null;
	static override get _properties():string[]{return ["date","count","unique","dwellTime","_checkOwner","_type"];}
}
export class ContentShareQuotaDTO extends NamedIdentityDTO {
 	override id: {
		contentShare?:ContentShareDTO;
		num?:number
	} | null = null;
	readonly orderNum : number | null = null;
	share : number | null = null;
	static override get _properties():string[]{return ["orderNum","share","name","id","_checkOwner","_type"];}
}
export class CredentialsDTO extends DTO {
 	username : string | null = null;
	password : string | null = null;
	static override get _properties():string[]{return ["username","password","_checkOwner","_type"];}
}
export class LoginRestoreDTO extends CredentialsDTO {
 	restore : string | null = null;
	static override get _properties():string[]{return ["restore","username","password","_checkOwner","_type"];}
}
export class SetlistDTO extends DTO {
 	marker : MarkerFullDTO | null = null;
	static override get _properties():string[]{return ["marker","_checkOwner","_type"];}
}
export class SetlistFullDTO extends SetlistDTO {
 	bookingCount : number | null = null;
	customerSetlists : CustomerSetlistDTO[] | null = null;
	static override get _properties():string[]{return ["bookingCount","customerSetlists","marker","_checkOwner","_type"];}
}
export class DeviceStatusCount {
 	total : number | null = null;
	quotaOnlineStatus_Online : number | null = null;
	quotaOnlineStatus_CurrentlyOffline : number | null = null;
	quotaOnlineStatus_Offline : number | null = null;
	quotaOnlineStatus_PlannedOffline : number | null = null;
	quotaOnlineStatus_Unknown : number | null = null;
	subsetProductive : number | null = null;
	subsetOffline : number | null = null;
	subsetExternal : number | null = null;
	subsetProposed : number | null = null;
	subsetServiceRequested : number | null = null;
	subsetPaired : number | null = null;
	subsetDisabled : number | null = null;
	static  get _properties():string[]{return ["total","quotaOnlineStatus_Online","quotaOnlineStatus_CurrentlyOffline","quotaOnlineStatus_Offline","quotaOnlineStatus_PlannedOffline","quotaOnlineStatus_Unknown","subsetProductive","subsetOffline","subsetExternal","subsetProposed","subsetServiceRequested","subsetPaired","subsetDisabled"];}
}
export class ReportingSetupDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly reportingType : ReportingTypeDTO | null = null;
	readonly global : boolean | null = null;
	description : string | null = null;
	reportingTemplate : ReportingTemplateDTO | null = null;
	createRawDataReport : boolean | null = null;
	rawDataReports : string[] | null = null;
	playerCullReportingMode : CullReportingMode | null = null;
	contentCullReportingMode : CullReportingMode | null = null;
	clientCullReportingMode : CullReportingMode | null = null;
	timeCullReportingMode : CullReportingMode | null = null;
	geoCullReportingMode : CullReportingMode | null = null;
	usedContentCulls : ContentCullDTO[] | null = null;
	usedClientCulls : ClientCullDTO[] | null = null;
	usedPlayerCulls : PlayerCullDTO[] | null = null;
	usedGeoCulls : GeoCullDTO[] | null = null;
	usedTimeCulls : TimeCullDTO[] | null = null;
	active : boolean | null = null;
	static override get _properties():string[]{return ["reportingType","global","description","reportingTemplate","createRawDataReport","rawDataReports","playerCullReportingMode","contentCullReportingMode","clientCullReportingMode","timeCullReportingMode","geoCullReportingMode","usedContentCulls","usedClientCulls","usedPlayerCulls","usedGeoCulls","usedTimeCulls","active","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScheduledReportingSetupDTO extends ReportingSetupDTO {
 	cronCreation : CronDefinitionDTO | null = null;
	cronRangeEnd : CronDefinitionDTO | null = null;
	timeRange : TimeRangeDTO | null = null;
	minInterval : number | null = null;
	static override get _properties():string[]{return ["cronCreation","cronRangeEnd","timeRange","minInterval","reportingType","global","description","reportingTemplate","createRawDataReport","rawDataReports","playerCullReportingMode","contentCullReportingMode","clientCullReportingMode","timeCullReportingMode","geoCullReportingMode","usedContentCulls","usedClientCulls","usedPlayerCulls","usedGeoCulls","usedTimeCulls","active","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class StringDTO extends DTO {
 	string : string | null = null;
	static override get _properties():string[]{return ["string","_checkOwner","_type"];}
}
export class LabeledValueDTO extends DTO {
 	value : string | null = null;
	label : string | null = null;
	static override get _properties():string[]{return ["value","label","_checkOwner","_type"];}
}
export class BookingBaseDTO extends IdentityDTO {
 	readonly marker : InventoryMarkerDTO | null = null;
	readonly channel : InventoryChannelDTO | null = null;
	medium : MediumFullDTO | null = null;
	templateDataSet : TemplateDataSetDTO | null = null;
	templateDataSetEntry : TemplateDataSetEntryDTO | null = null;
	excluded : boolean | null = null;
	deprecated : boolean | null = null;
	finished : boolean | null = null;
	status : BookingStatus | null = null;
	static override get _properties():string[]{return ["marker","channel","medium","templateDataSet","templateDataSetEntry","excluded","deprecated","finished","status","id","_checkOwner","_type"];}
}
export class BookingBaseInfoDTO extends BookingBaseDTO {
 	name : string | null = null;
	active : boolean | null = null;
	from : SbLocalDateTime | null = null;
	till : SbLocalDateTime | null = null;
	timingStatus : TimingStatus | null = null;
	duration : number | null = null;
	frequency : number | null = null;
	readonly advertiser : InventoryClientDTO | null = null;
	readonly customer : InventoryCompanyDTO | null = null;
	verificationRequested : SbDateTime | null = null;
	verifiedAt : SbDateTime | null = null;
	rejectedAt : SbDateTime | null = null;
	readonly rejectedBy : UserDTO | null = null;
	readonly verifiedBy : UserDTO | null = null;
	reason : string | null = null;
	static override get _properties():string[]{return ["name","active","from","till","timingStatus","duration","frequency","advertiser","customer","verificationRequested","verifiedAt","rejectedAt","rejectedBy","verifiedBy","reason","marker","channel","medium","templateDataSet","templateDataSetEntry","excluded","deprecated","finished","status","id","_checkOwner","_type"];}
}
export class InventoryBookingDTO extends BookingBaseInfoDTO {
 	readonly publisher : ClientDTO | null = null;
	static override get _properties():string[]{return ["publisher","name","active","from","till","timingStatus","duration","frequency","advertiser","customer","verificationRequested","verifiedAt","rejectedAt","rejectedBy","verifiedBy","reason","marker","channel","medium","templateDataSet","templateDataSetEntry","excluded","deprecated","finished","status","id","_checkOwner","_type"];}
}
export class NamedIdentityWithIdentifierAndCreatorDTO extends NamedIdentityWithCreatorDTO {
 	identifier : string | null = null;
	static override get _properties():string[]{return ["identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ClientBaseDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	static override get _properties():string[]{return ["identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class VisitorAudienceImpressionTranslationDTO extends DTO {
 	duration : number | null = null;
	advertisingExposureFactor : number | null = null;
	static override get _properties():string[]{return ["duration","advertisingExposureFactor","_checkOwner","_type"];}
}
export class IdentityWithCreatorDTO extends IdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly createdBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["createdAt","createdBy","id","_checkOwner","_type"];}
}
export class ThreadStatistic {
 	statistics : PerThreadStatistic[] | null = null;
	bySeenCount : any | null = null;
	static  get _properties():string[]{return ["statistics","bySeenCount"];}
}
export class MarkerBaseDTO extends NamedIdentityDTO {
 	resolution : ResolutionDTO | null = null;
	image : boolean | null = null;
	video : boolean | null = null;
	audio : boolean | null = null;
	html : boolean | null = null;
	sound : boolean | null = null;
	interactive : boolean | null = null;
	static override get _properties():string[]{return ["resolution","image","video","audio","html","sound","interactive","name","id","_checkOwner","_type"];}
}
export class PlaybackScheduleSlotDTO extends NamedIdentityDTO {
 	override id: {
		playbackSchedule?:PlaybackScheduleDTO;
		slot?:number
	} | null = null;
	readonly orderNum : number | null = null;
	readonly share : number | null = null;
	static override get _properties():string[]{return ["orderNum","share","name","id","_checkOwner","_type"];}
}
export class PlaybackScheduleSlotFullDTO extends PlaybackScheduleSlotDTO {
 	clientCull : ClientCullDTO | null = null;
	contentCull : ContentCullDTO | null = null;
	duration : number | null = null;
	minDuration : number | null = null;
	percentage : number | null = null;
	currency : CurrencyDTO | null = null;
	minCPM : number | null = null;
	minCPMDuration : number | null = null;
	minCPS : number | null = null;
	deals : DealDTO[] | null = null;
	readonly fallback : PlaybackScheduleSlotFullDTO[] | null = null;
	fallbackOrderNum : number[] | null = null;
	clientType : PlaybackScheduleSlotClientType | null = null;
	static override get _properties():string[]{return ["clientCull","contentCull","duration","minDuration","percentage","currency","minCPM","minCPMDuration","minCPS","deals","fallback","fallbackOrderNum","clientType","orderNum","share","name","id","_checkOwner","_type"];}
}
export class UserClientBaseDTO extends IdentityWithCreatorDTO {
 	readonly clientOrderNum : number | null = null;
	readonly blocked : SbDateTime | null = null;
	readonly lastLogin : SbDateTime | null = null;
	client : ClientDTO | null = null;
	effectivePermissions : string[] | null = null;
	static override get _properties():string[]{return ["clientOrderNum","blocked","lastLogin","client","effectivePermissions","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class UserClientWithPermissionsDTO extends UserClientBaseDTO {
 	explicitPermissions : string[] | null = null;
	explicitRoles : RoleDTO[] | null = null;
	static override get _properties():string[]{return ["explicitPermissions","explicitRoles","clientOrderNum","blocked","lastLogin","client","effectivePermissions","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class NamedIdentityWithCreatorGlobalAndClientBoundDTO extends NamedIdentityWithCreatorDTO {
 	global : boolean | null = null;
	static override get _properties():string[]{return ["global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class NestedNamedIdentityCreatorGlobalAndClientBoundDTO extends NamedIdentityWithCreatorGlobalAndClientBoundDTO {
 	parent : NestedNamedIdentityCreatorGlobalAndClientBoundDTO | null = null;
	readonly modifiedAt : SbDateTime | null = null;
	readonly modifiedBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AreaCategoryDTO extends NestedNamedIdentityCreatorGlobalAndClientBoundDTO {
 	company : CompanyDTO | null = null;
	countAreas : number | null = null;
	children : AreaCategoryDTO[] | null = null;
	static override get _properties():string[]{return ["company","countAreas","children","parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum DistanceUnit {
 	METER = "METER",
	KILOMETER = "KILOMETER",
	MILE = "MILE",
}
export class EntityDefinitionDTO extends DTO {
 	parent : Entity | null = null;
	entity : Entity | null = null;
	definition : string | null = null;
	taggable : boolean | null = null;
	discussable : boolean | null = null;
	softDeletable : boolean | null = null;
	static override get _properties():string[]{return ["parent","entity","definition","taggable","discussable","softDeletable","_checkOwner","_type"];}
}
export class CullAggregationDTO extends DTO {
 	static override get _properties():string[]{return ["_checkOwner","_type"];}
}
export class ContentAggregationDTO extends CullAggregationDTO {
 	scope : BookingScope | null = null;
	bookings : number | null = null;
	publishers : number | null = null;
	advertisers : number | null = null;
	requirements : number | null = null;
	campaigns : number | null = null;
	commercials : number | null = null;
	motives : number | null = null;
	motiveGroups : number | null = null;
	static override get _properties():string[]{return ["scope","bookings","publishers","advertisers","requirements","campaigns","commercials","motives","motiveGroups","_checkOwner","_type"];}
}
export class PointDTO extends IdentityDTO {
 	data : Point | null = null;
	static override get _properties():string[]{return ["data","id","_checkOwner","_type"];}
}
export class ModifiableNamedIdentityWithIdentifierAndCreatorDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	identifier : string | null = null;
	static override get _properties():string[]{return ["identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AssetDTO extends ModifiableNamedIdentityWithIdentifierAndCreatorDTO {
 	assetFiles : AssetFileDTO[] | null = null;
	description : string | null = null;
	shareStart : SbDateTime | null = null;
	shareEnd : SbDateTime | null = null;
	sharedBy : UserDTO | null = null;
	tags : string[] | null = null;
	category : AssetCategoryDTO | null = null;
	preview : AssetFileDTO | null = null;
	static override get _properties():string[]{return ["assetFiles","description","shareStart","shareEnd","sharedBy","tags","category","preview","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AssetFullDTO extends AssetDTO {
 	repository : AssetRepositoryDTO | null = null;
	static override get _properties():string[]{return ["repository","assetFiles","description","shareStart","shareEnd","sharedBy","tags","category","preview","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ContactFieldDTO extends DTO {
 	fieldType : ContactFieldType | null = null;
	value : string | null = null;
	static override get _properties():string[]{return ["fieldType","value","_checkOwner","_type"];}
}
export class ChannelBaseDTO extends NamedIdentityWithCreatorDTO {
 	description : string | null = null;
	color : string | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	readonly ambianceImage : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["description","color","logo","ambianceImage","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ChannelDTO extends ChannelBaseDTO {
 	readonly clientOrderNum : number | null = null;
	publisher : ClientDTO | null = null;
	readonly locked : boolean | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["clientOrderNum","publisher","locked","attachmentCount","description","color","logo","ambianceImage","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CompanyDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	readonly primaryCompany : boolean | null = null;
	email : string | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	address : AddressDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["primaryCompany","email","logo","address","attachmentCount","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CompanyFullDTO extends CompanyDTO {
 	readonly headerImage : FixedAspectRatioImageDTO | null = null;
	currency : CurrencyDTO | null = null;
	readonly countAreas : number | null = null;
	readonly countCampaigns : number | null = null;
	readonly countCulls : number | null = null;
	readonly countManagedLocations : number | null = null;
	readonly countMedia : number | null = null;
	readonly countMediumGroups : number | null = null;
	attributes : CompanyAttributeDTO[] | null = null;
	static override get _properties():string[]{return ["headerImage","currency","countAreas","countCampaigns","countCulls","countManagedLocations","countMedia","countMediumGroups","attributes","primaryCompany","email","logo","address","attachmentCount","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScreenBaseDTO extends NamedIdentityDTO {
 	static override get _properties():string[]{return ["name","id","_checkOwner","_type"];}
}
export class ScreenDTO extends ScreenBaseDTO {
 	marker : MarkerFullDTO | null = null;
	static override get _properties():string[]{return ["marker","name","id","_checkOwner","_type"];}
}
export class OwnedScreenDTO extends ScreenDTO {
 	hardware : ScreenHardwareDTO | null = null;
	readonly machineCode : string | null = null;
	mediumTransformation : MediumTransformationDTO | null = null;
	static override get _properties():string[]{return ["hardware","machineCode","mediumTransformation","marker","name","id","_checkOwner","_type"];}
}
export class TemplateDistributionConfigurationDTO extends DTO {
 	geoCull : GeoCullDTO | null = null;
	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	readonly verified : boolean | null = null;
	readonly rejected : boolean | null = null;
	static override get _properties():string[]{return ["geoCull","timeCull","playerCull","stateSpaceCull","verified","rejected","_checkOwner","_type"];}
}
export class AssetRepositoryBaseDTO extends ModifiableNamedIdentityWithIdentifierAndCreatorDTO {
 	description : string | null = null;
	shareEnd : SbDateTime | null = null;
	static override get _properties():string[]{return ["description","shareEnd","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AssetRepositoryDTO extends AssetRepositoryBaseDTO {
 	assetCount : number | null = null;
	sharedAssetCount : number | null = null;
	shareStart : SbDateTime | null = null;
	static override get _properties():string[]{return ["assetCount","sharedAssetCount","shareStart","description","shareEnd","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class GeoAggregationDTO extends CullAggregationDTO {
 	scope : ScreenScope | null = null;
	publishers : number | null = null;
	locations : number | null = null;
	channels : number | null = null;
	markers : number | null = null;
	devices : number | null = null;
	screens : number | null = null;
	static override get _properties():string[]{return ["scope","publishers","locations","channels","markers","devices","screens","_checkOwner","_type"];}
}
export class Number {
 }
export class PlayoutAggregationData {
 	hourCount : number[] | null = null;
	hourTime : number[] | null = null;
	static  get _properties():string[]{return ["hourCount","hourTime"];}
}
export class PlayoutDescriptorBaseDTO extends DTO {
 	id : number | null = null;
	productive : boolean | null = null;
	createdAt : SbDateTime | null = null;
	firstPlayout : SbDateTime | null = null;
	lastPlayout : SbDateTime | null = null;
	static override get _properties():string[]{return ["id","productive","createdAt","firstPlayout","lastPlayout","_checkOwner","_type"];}
}
export class CachedPlayoutDescriptorDTO extends PlayoutDescriptorBaseDTO {
 	screen : number | null = null;
	booking : number | null = null;
	static override get _properties():string[]{return ["screen","booking","id","productive","createdAt","firstPlayout","lastPlayout","_checkOwner","_type"];}
}
export class MarkerDTO extends MarkerBaseDTO {
 	static override get _properties():string[]{return ["resolution","image","video","audio","html","sound","interactive","name","id","_checkOwner","_type"];}
}
export class MarkerFullDTO extends MarkerDTO {
 	channel : ChannelDTO | null = null;
	static override get _properties():string[]{return ["channel","resolution","image","video","audio","html","sound","interactive","name","id","_checkOwner","_type"];}
}
export class MarkerInfo {
 	id : number | null = null;
	name : string | null = null;
	static  get _properties():string[]{return ["id","name"];}
}
export class ScreenHardwareDTO extends NamedIdentityDTO {
 	global : boolean | null = null;
	description : string | null = null;
	color : string | null = null;
	width : number | null = null;
	height : number | null = null;
	diagonal : number | null = null;
	nativeResolution : ResolutionDTO | null = null;
	readonly createdAt : SbDateTime | null = null;
	manufacturer : CompanyDTO | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	readonly depiction : FixedAspectRatioImageDTO | null = null;
	mountedTo : PlayerHardwareDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["global","description","color","width","height","diagonal","nativeResolution","createdAt","manufacturer","logo","depiction","mountedTo","attachmentCount","name","id","_checkOwner","_type"];}
}
export enum Order {
 	asc = "asc",
	desc = "desc",
}
export class FieldReference extends DTO {
 	type : string | null = null;
	requires : string[] | null = null;
	order : number | null = null;
	static override get _properties():string[]{return ["type","requires","order","_checkOwner","_type"];}
}
export enum AccessOption {
 	None = "None",
	Read = "Read",
	Manage = "Manage",
}
export class AtomTypeGroupDTO extends NamedIdentityDTO {
 	atomTypes : AtomTypeDTO[] | null = null;
	static override get _properties():string[]{return ["atomTypes","name","id","_checkOwner","_type"];}
}
export enum BookingScope {
 	ALL = "ALL",
	ADVERTISER = "ADVERTISER",
	PUBLISHER = "PUBLISHER",
}
export class CalendarEntryDTO extends NamedIdentityWithCreatorGlobalAndClientBoundDTO {
 	startDate : SbLocalDate | null = null;
	startTime : SbLocalTime | null = null;
	endDate : SbLocalDate | null = null;
	endTime : SbLocalTime | null = null;
	readonly type : CalendarEntryTypeDTO | null = null;
	static override get _properties():string[]{return ["startDate","startTime","endDate","endTime","type","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CalendarEntryFullDTO extends CalendarEntryDTO {
 	category : CalendarEntryCategoryDTO | null = null;
	calendar : CalendarDTO | null = null;
	validity : LocalDateTimeRangeDTO[] | null = null;
	metaData : CalendarEntryMetaDataDTO[] | null = null;
	static override get _properties():string[]{return ["category","calendar","validity","metaData","startDate","startTime","endDate","endTime","type","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ChannelDeviceStatusDTO extends DTO {
 	channel : ChannelDTO | null = null;
	deviceStatus : DeviceStatusCount | null = null;
	static override get _properties():string[]{return ["channel","deviceStatus","_checkOwner","_type"];}
}
export class BookingRecalculationDTO extends DTO {
 	created : BookingDTO[] | null = null;
	deprecated : BookingDTO[] | null = null;
	restored : BookingDTO[] | null = null;
	unmodified : BookingDTO[] | null = null;
	static override get _properties():string[]{return ["created","deprecated","restored","unmodified","_checkOwner","_type"];}
}
export class PlayoutImpressionReportDTO extends DTO {
 	media : any | null = null;
	channels : any | null = null;
	markers : any | null = null;
	clients : any | null = null;
	static override get _properties():string[]{return ["media","channels","markers","clients","_checkOwner","_type"];}
}
export class NamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO extends NamedIdentityWithCreatorGlobalAndClientBoundDTO {
 	identifier : string | null = null;
	static override get _properties():string[]{return ["identifier","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ColoredNamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO extends NamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO {
 	color : string | null = null;
	static override get _properties():string[]{return ["color","identifier","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CalendarEntryTypeDTO extends ColoredNamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO {
 	icon : string | null = null;
	static override get _properties():string[]{return ["icon","color","identifier","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class RatingDTO extends DTO {
 	element : Serializable | null = null;
	rate : number | null = null;
	static override get _properties():string[]{return ["element","rate","_checkOwner","_type"];}
}
export class NamedIdentityWithIdentifierDTO extends NamedIdentityDTO {
 	identifier : string | null = null;
	static override get _properties():string[]{return ["identifier","name","id","_checkOwner","_type"];}
}
export class ProductBaseDTO extends NamedIdentityWithIdentifierDTO {
 	description : string | null = null;
	color : string | null = null;
	gtin : number | null = null;
	gtinRepresentation : GTINRepresentation | null = null;
	plu : number | null = null;
	asin : string | null = null;
	manufacturer : CompanyDTO | null = null;
	readonly depiction : FixedAspectRatioImageDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["description","color","gtin","gtinRepresentation","plu","asin","manufacturer","depiction","attachmentCount","identifier","name","id","_checkOwner","_type"];}
}
export class PlayerBasedAggregationDTO extends DTO {
 	playerBase : PlayerBase | null = null;
	static override get _properties():string[]{return ["playerBase","_checkOwner","_type"];}
}
export class VisitorAggregationDTO extends PlayerBasedAggregationDTO {
 	count : number | null = null;
	unique : number | null = null;
	dwellTime : number | null = null;
	static override get _properties():string[]{return ["count","unique","dwellTime","playerBase","_checkOwner","_type"];}
}
export class CalendarEntryTypeFullDTO extends CalendarEntryTypeDTO {
 	allowedMetaDataTypes : CalendarEntryMetaDataTypeDTO[] | null = null;
	static override get _properties():string[]{return ["allowedMetaDataTypes","icon","color","identifier","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class IdentifierDTO extends DTO {
 	readonly identifier : string | null = null;
	static override get _properties():string[]{return ["identifier","_checkOwner","_type"];}
}
export class SharedByScreenDTO extends IdentifierDTO {
 	screens : ScreenFullDTO[] | null = null;
	static override get _properties():string[]{return ["screens","identifier","_checkOwner","_type"];}
}
export class SharedByScreenAndTimeDTO extends SharedByScreenDTO {
 	ranges : LocalDateTimeRangeDTO[] | null = null;
	static override get _properties():string[]{return ["ranges","screens","identifier","_checkOwner","_type"];}
}
export class SharedSetlistDTO extends SharedByScreenAndTimeDTO {
 	setlist : SetlistFullDTO | null = null;
	static override get _properties():string[]{return ["setlist","ranges","screens","identifier","_checkOwner","_type"];}
}
export class ModifiableIdentityWithCreatorDTO extends IdentityWithCreatorDTO {
 	readonly modifiedAt : SbDateTime | null = null;
	readonly modifiedBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["modifiedAt","modifiedBy","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class PostDTO extends ModifiableIdentityWithCreatorDTO {
 	text : string | null = null;
	readonly pinned : boolean | null = null;
	readonly solution : boolean | null = null;
	mentions : UserDTO[] | null = null;
	readonly deletedAt : SbDateTime | null = null;
	readonly answerTo : PostDTO | null = null;
	readonly entity : LinkedEntityDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["text","pinned","solution","mentions","deletedAt","answerTo","entity","attachmentCount","modifiedAt","modifiedBy","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class InventoryMarkerDTO extends MarkerBaseDTO {
 	static override get _properties():string[]{return ["resolution","image","video","audio","html","sound","interactive","name","id","_checkOwner","_type"];}
}
export class ChangeEmailDTO extends DTO {
 	newEmail : string | null = null;
	static override get _properties():string[]{return ["newEmail","_checkOwner","_type"];}
}
export class ElementCountDTO extends DTO {
 	type : string | null = null;
	id : number | null = null;
	static override get _properties():string[]{return ["type","id","_checkOwner","_type"];}
}
export class TimeCullAtomDTO extends CullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class DateTimeCullAtomDTO extends TimeCullAtomDTO {
 	start : SbLocalDateTime | null = null;
	static override get _properties():string[]{return ["start","type","valid","operator","id","_checkOwner","_type"];}
}
export class DateTimeRangeCullAtomDTO extends DateTimeCullAtomDTO {
 	end : SbLocalDateTime | null = null;
	static override get _properties():string[]{return ["end","start","type","valid","operator","id","_checkOwner","_type"];}
}
export enum ThreadState {
 	NEW = "NEW",
	RUNNABLE = "RUNNABLE",
	BLOCKED = "BLOCKED",
	WAITING = "WAITING",
	TIMED_WAITING = "TIMED_WAITING",
	TERMINATED = "TERMINATED",
}
export class SSPDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	currency : CurrencyDTO | null = null;
	readonly primaryCompany : CompanyDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["currency","primaryCompany","attachmentCount","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DiurnalBucketDTO extends DTO {
 	readonly date : SbDateTime | null = null;
	readonly reached : number | null = null;
	readonly target : number | null = null;
	static override get _properties():string[]{return ["date","reached","target","_checkOwner","_type"];}
}
export class TargetingDiurnalBucketDTO extends DiurnalBucketDTO {
 	static override get _properties():string[]{return ["date","reached","target","_checkOwner","_type"];}
}
export enum HttpMethod {
 	GET = "GET",
	HEAD = "HEAD",
	POST = "POST",
	PUT = "PUT",
	DELETE = "DELETE",
	OPTIONS = "OPTIONS",
	TRACE = "TRACE",
	PATCH = "PATCH",
}
export class ColoredModifiableNamedIdentityWithIdentifierAndCreatorDTO extends ModifiableNamedIdentityWithIdentifierAndCreatorDTO {
 	color : string | null = null;
	static override get _properties():string[]{return ["color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DiversifiedNamedIdentityWithIdentifierAndCreatorDTO extends ColoredModifiableNamedIdentityWithIdentifierAndCreatorDTO {
 	diversify : boolean | null = null;
	readonly level : number | null = null;
	priority : number | null = null;
	static override get _properties():string[]{return ["diversify","level","priority","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScheduledDiversifiedNamedIdentityWithRequirementFiltersDTO extends DiversifiedNamedIdentityWithIdentifierAndCreatorDTO {
 	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	static override get _properties():string[]{return ["timeCull","playerCull","geoCull","stateSpaceCull","diversify","level","priority","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScheduledRequirementDTO extends ScheduledDiversifiedNamedIdentityWithRequirementFiltersDTO {
 	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	precondition : ScheduledRequirementDTO | null = null;
	bookings : ScheduledBookingDTO[] | null = null;
	active : boolean | null = null;
	readonly mediumGroups : MediumGroupDTO[] | null = null;
	readonly previewMedia : PublicMediumDTO[] | null = null;
	readonly actualPlayouts : number | null = null;
	readonly actualSecondsPlayed : number | null = null;
	readonly bookingStatus : any | null = null;
	playerAggregation : PlayerAggregationDTO | null = null;
	readonly preview : PublicMediumDTO[] | null = null;
	static override get _properties():string[]{return ["planning","overwrites","precondition","bookings","active","mediumGroups","previewMedia","actualPlayouts","actualSecondsPlayed","bookingStatus","playerAggregation","preview","timeCull","playerCull","geoCull","stateSpaceCull","diversify","level","priority","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryClientDTO extends ClientBaseDTO {
 	currency : CurrencyDTO | null = null;
	readonly address : AddressDTO | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["currency","address","logo","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AttributeDatatypeDTO extends NamedIdentityWithCreatorDTO {
 	description : string | null = null;
	readonly customized : boolean | null = null;
	readonly global : boolean | null = null;
	adPlacerAbleToSet : boolean | null = null;
	externalSynchronized : boolean | null = null;
	multiline : boolean | null = null;
	searchable : boolean | null = null;
	uniqueValues : boolean | null = null;
	askForConfirmation : boolean | null = null;
	usableForFilters : boolean | null = null;
	disclosedToPublic : boolean | null = null;
	forceRegEx : string | null = null;
	defaultValue : string | null = null;
	allowedValues : string[] | null = null;
	allowedValuesMinCount : number | null = null;
	allowedValuesMaxCount : number | null = null;
	static override get _properties():string[]{return ["description","customized","global","adPlacerAbleToSet","externalSynchronized","multiline","searchable","uniqueValues","askForConfirmation","usableForFilters","disclosedToPublic","forceRegEx","defaultValue","allowedValues","allowedValuesMinCount","allowedValuesMaxCount","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DeviceAttributeDatatypeDTO extends AttributeDatatypeDTO {
 	deviceAbleToSet : boolean | null = null;
	static override get _properties():string[]{return ["deviceAbleToSet","description","customized","global","adPlacerAbleToSet","externalSynchronized","multiline","searchable","uniqueValues","askForConfirmation","usableForFilters","disclosedToPublic","forceRegEx","defaultValue","allowedValues","allowedValuesMinCount","allowedValuesMaxCount","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum AttributeType {
 	Device = "Device",
	Location = "Location",
	Company = "Company",
	Product = "Product",
	Medium = "Medium",
}
export class SettingDTO extends DTO {
 	readonly override : boolean | null = null;
	value : string | null = null;
	static override get _properties():string[]{return ["override","value","_checkOwner","_type"];}
}
export class SSPContractDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	ssp : SSPDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	screenIdPrefix : string | null = null;
	screenIdSuffix : string | null = null;
	static override get _properties():string[]{return ["ssp","attachmentCount","screenIdPrefix","screenIdSuffix","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TrackedVisitorLocalDTO extends AbstractTrackedVisitorDTO {
 	date : SbLocalDateTime | null = null;
	static override get _properties():string[]{return ["date","count","unique","dwellTime","_checkOwner","_type"];}
}
export class CampaignReportDTO extends PlayoutImpressionReportDTO {
 	campaigns : any | null = null;
	campaignTypes : any | null = null;
	commercials : any | null = null;
	requirements : any | null = null;
	bookings : any | null = null;
	mediumGroups : any | null = null;
	customers : any | null = null;
	products : any | null = null;
	productCategories : any | null = null;
	data : CampaignReportEntryDTO[] | null = null;
	static override get _properties():string[]{return ["campaigns","campaignTypes","commercials","requirements","bookings","mediumGroups","customers","products","productCategories","data","media","channels","markers","clients","_checkOwner","_type"];}
}
export class ResolvedErrorDTO extends DTO {
 	status : number | null = null;
	errorCode : string | null = null;
	errorId : number | null = null;
	occured : SbDateTime | null = null;
	method : string | null = null;
	url : string | null = null;
	application : string | null = null;
	version : string | null = null;
	file : string | null = null;
	line : number | null = null;
	message : string | null = null;
	stackTrace : string[] | null = null;
	static override get _properties():string[]{return ["status","errorCode","errorId","occured","method","url","application","version","file","line","message","stackTrace","_checkOwner","_type"];}
}
export class CalendarEntryMetaDataDTO extends DTO {
 	id : number | null = null;
	value : string | null = null;
	static override get _properties():string[]{return ["id","value","_checkOwner","_type"];}
}
export class AggregatedPlaylistSchemaDTO extends IdentifierDTO {
 	iterations : AggregatedPlaylistSchemaIterationDTO[] | null = null;
	groups : AggregationGroupDTO[] | null = null;
	static override get _properties():string[]{return ["iterations","groups","identifier","_checkOwner","_type"];}
}
export class DeviceBaseDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	readonly currentPosition : PointDTO | null = null;
	readonly positionUpdated : SbDateTime | null = null;
	readonly positionValidity : SbDateTime | null = null;
	static override get _properties():string[]{return ["currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryDeviceDTO extends DeviceBaseDTO {
 	channel : InventoryChannelDTO | null = null;
	disclosedAttributes : DeviceAttributeDTO[] | null = null;
	pool : InventoryPoolDTO | null = null;
	location : InventoryLocationDTO | null = null;
	onlineStatus : DeviceOnlineStatus | null = null;
	static override get _properties():string[]{return ["channel","disclosedAttributes","pool","location","onlineStatus","currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class SSPSlotConfigurationDTO extends IdentifierDTO {
 	readonly deal : DealDTO | null = null;
	readonly contract : SSPContractDTO | null = null;
	static override get _properties():string[]{return ["deal","contract","identifier","_checkOwner","_type"];}
}
export class ExecutionReportDTO extends PlayoutImpressionReportDTO {
 	devices : any | null = null;
	screens : any | null = null;
	pools : any | null = null;
	locations : any | null = null;
	data : ExecutionReportEntryDTO[] | null = null;
	static override get _properties():string[]{return ["devices","screens","pools","locations","data","media","channels","markers","clients","_checkOwner","_type"];}
}
export class DealDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	readonly sspContract : SSPContractDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["sspContract","attachmentCount","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ModifiableNamedIdentityWithIdentifierAndCreatorWithRequirementFiltersDTO extends ColoredModifiableNamedIdentityWithIdentifierAndCreatorDTO {
 	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	playerAggregation : PlayerAggregationDTO | null = null;
	static override get _properties():string[]{return ["timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CommercialDTO extends ModifiableNamedIdentityWithIdentifierAndCreatorWithRequirementFiltersDTO {
 	description : string | null = null;
	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	readonly customer : NamedIdentityDTO | null = null;
	readonly sequence : number | null = null;
	active : boolean | null = null;
	from : SbLocalDateTime | null = null;
	till : SbLocalDateTime | null = null;
	timingStatus : TimingStatus | null = null;
	duration : number | null = null;
	frequency : number | null = null;
	dailyPlayouts : number | null = null;
	actualPlayouts : number | null = null;
	targetPlayouts : number | null = null;
	actualSecondsPlayed : number | null = null;
	totalSecondsBooked : number | null = null;
	secondsToNextPlay : number | null = null;
	readonly requirementCount : number | null = null;
	readonly bookingStatus : any | null = null;
	playoutAggregation : PlayoutAggregationDTO | null = null;
	static override get _properties():string[]{return ["description","planning","overwrites","customer","sequence","active","from","till","timingStatus","duration","frequency","dailyPlayouts","actualPlayouts","targetPlayouts","actualSecondsPlayed","totalSecondsBooked","secondsToNextPlay","requirementCount","bookingStatus","playoutAggregation","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CommercialFullDTO extends CommercialDTO {
 	requirements : RequirementFullDTO[] | null = null;
	static override get _properties():string[]{return ["requirements","description","planning","overwrites","customer","sequence","active","from","till","timingStatus","duration","frequency","dailyPlayouts","actualPlayouts","targetPlayouts","actualSecondsPlayed","totalSecondsBooked","secondsToNextPlay","requirementCount","bookingStatus","playoutAggregation","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ColoredNamedIdentityWithIdentifierAndCreatorDTO extends NamedIdentityWithIdentifierAndCreatorDTO {
 	color : string | null = null;
	static override get _properties():string[]{return ["color","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PublicMediumDTO extends ColoredNamedIdentityWithIdentifierAndCreatorDTO {
 	company : NamedIdentityDTO | null = null;
	readonly duration : number | null = null;
	readonly contentType : string | null = null;
	readonly fileName : string | null = null;
	readonly format : FormatDTO | null = null;
	readonly resolution : ResolutionDTO | null = null;
	readonly size : number | null = null;
	readonly hash : HashDTO | null = null;
	templateGroup : TemplateGroupDTO | null = null;
	readonly url : ThumbnailableFileLink | null = null;
	readonly stillImage : ThumbnailableFileLink | null = null;
	readonly publicUrl : string | null = null;
	readonly assetFile : SharedAssetFileFullDTO | null = null;
	static override get _properties():string[]{return ["company","duration","contentType","fileName","format","resolution","size","hash","templateGroup","url","stillImage","publicUrl","assetFile","color","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumDTO extends PublicMediumDTO {
 	description : string | null = null;
	readonly processing : boolean | null = null;
	readonly uploading : boolean | null = null;
	readonly progress : number | null = null;
	readonly locked : boolean | null = null;
	readonly uploaded : boolean | null = null;
	readonly original : PublicMediumDTO | null = null;
	templateStoreData : TemplateStoreDataDTO | null = null;
	folder : MediumFolderDTO | null = null;
	readonly usageCount : number | null = null;
	previewProgress : number | null = null;
	static override get _properties():string[]{return ["description","processing","uploading","progress","locked","uploaded","original","templateStoreData","folder","usageCount","previewProgress","company","duration","contentType","fileName","format","resolution","size","hash","templateGroup","url","stillImage","publicUrl","assetFile","color","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumFullDTO extends MediumDTO {
 	readonly mediumGroup : MediumGroupDTO | null = null;
	readonly promotedProducts : ProductDTO[] | null = null;
	readonly promotedProductCategories : ProductCategoryDTO[] | null = null;
	static override get _properties():string[]{return ["mediumGroup","promotedProducts","promotedProductCategories","description","processing","uploading","progress","locked","uploaded","original","templateStoreData","folder","usageCount","previewProgress","company","duration","contentType","fileName","format","resolution","size","hash","templateGroup","url","stillImage","publicUrl","assetFile","color","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ExecutionStatisticsDTO extends DTO {
 	resourceDescriptor : QueryExecutionDescriptorDTO | null = null;
	calls : number | null = null;
	minExecutionTime : number | null = null;
	avgExecutionTime : number | null = null;
	maxExecutionTime : number | null = null;
	firstStarted : SbDateTime | null = null;
	firstFinished : SbDateTime | null = null;
	lastStarted : SbDateTime | null = null;
	lastFinished : SbDateTime | null = null;
	static override get _properties():string[]{return ["resourceDescriptor","calls","minExecutionTime","avgExecutionTime","maxExecutionTime","firstStarted","firstFinished","lastStarted","lastFinished","_checkOwner","_type"];}
}
export class QueryExecutionStatisticsDTO extends ExecutionStatisticsDTO {
 	minResultCount : number | null = null;
	avgResultCount : number | null = null;
	maxResultCount : number | null = null;
	static override get _properties():string[]{return ["minResultCount","avgResultCount","maxResultCount","resourceDescriptor","calls","minExecutionTime","avgExecutionTime","maxExecutionTime","firstStarted","firstFinished","lastStarted","lastFinished","_checkOwner","_type"];}
}
export class ReportingFileDTO extends IdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly fileName : string | null = null;
	readonly fileSize : number | null = null;
	readonly url : FileLink | null = null;
	readonly reportingTemplate : ReportingTemplateDTO | null = null;
	static override get _properties():string[]{return ["createdAt","fileName","fileSize","url","reportingTemplate","id","_checkOwner","_type"];}
}
export class VisitorTrackerDTO extends NamedIdentityWithIdentifierDTO {
 	timezone : string | null = null;
	technique : TrackingTechnique | null = null;
	productive : boolean | null = null;
	offline : boolean | null = null;
	external : boolean | null = null;
	disabled : boolean | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["timezone","technique","productive","offline","external","disabled","attachmentCount","identifier","name","id","_checkOwner","_type"];}
}
export class CalendarEntryMetaDataTypeDTO extends NamedIdentityWithCreatorGlobalAndClientBoundDTO {
 	description : string | null = null;
	static override get _properties():string[]{return ["description","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class Medium extends DTO {
 	id : number | null = null;
	name : string | null = null;
	url : string | null = null;
	data : PlayoutAggregationDataDateEntry[] | null = null;
	static override get _properties():string[]{return ["id","name","url","data","_checkOwner","_type"];}
}
export class ScreenOfflinePlaybackScheduleSlotDTO extends NamedIdentityDTO {
 	override id: {
		playbackSchedule?:PlaybackScheduleDTO;
		slot?:number
	} | null = null;
	readonly orderNum : number | null = null;
	duration : number | null = null;
	minDuration : number | null = null;
	percentage : number | null = null;
	readonly share : number | null = null;
	static override get _properties():string[]{return ["orderNum","duration","minDuration","percentage","share","name","id","_checkOwner","_type"];}
}
export class GeoCullAtomDTO extends CullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class ChainedGeoCullAtomDTO extends GeoCullAtomDTO {
 	chainedCull : string | null = null;
	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class AttributeDTO extends NamedIdentityDTO {
 	value : string | null = null;
	lastUpdate : SbDateTime | null = null;
	anchor : IdentityDTO | null = null;
	static override get _properties():string[]{return ["value","lastUpdate","anchor","name","id","_checkOwner","_type"];}
}
export class DeviceAttributeDTO extends AttributeDTO {
 	override id: {
		datatype?:DeviceAttributeDatatypeDTO;
		device?:DeviceDTO
	} | null = null;
	datatype : DeviceAttributeDatatypeDTO | null = null;
	static override get _properties():string[]{return ["datatype","value","lastUpdate","anchor","name","id","_checkOwner","_type"];}
}
export class DiurnalCycleDataDTO extends DTO {
 	start : SbLocalTime | null = null;
	end : SbLocalTime | null = null;
	static override get _properties():string[]{return ["start","end","_checkOwner","_type"];}
}
export class CurrencyDTO extends DTO {
 	code : string | null = null;
	name : string | null = null;
	symbol : string | null = null;
	static override get _properties():string[]{return ["code","name","symbol","_checkOwner","_type"];}
}
export class ScreenTargetingInfoDTO extends DTO {
 	targetingId : number | null = null;
	targetValue : number | null = null;
	bookingIds : number[] | null = null;
	static override get _properties():string[]{return ["targetingId","targetValue","bookingIds","_checkOwner","_type"];}
}
export class OwnedDeviceBaseDTO extends DeviceBaseDTO {
 	notes : string | null = null;
	readonly lastOnline : SbDateTime | null = null;
	readonly screens : OwnedScreenDTO[] | null = null;
	readonly lastIP : string | null = null;
	readonly connected : boolean | null = null;
	productive : boolean | null = null;
	offline : boolean | null = null;
	external : boolean | null = null;
	disabled : boolean | null = null;
	readonly paired : boolean | null = null;
	readonly proposed : boolean | null = null;
	pool : PoolDTO | null = null;
	readonly serviceRequest : NotificationDTO | null = null;
	position : PointDTO | null = null;
	homeArea : AreaDTO | null = null;
	whitelistArea : AreaDTO | null = null;
	positionValidityDuration : number | null = null;
	readonly channel : ChannelDTO | null = null;
	readonly onlineStatus : DeviceOnlineStatus | null = null;
	hardware : PlayerHardwareDTO | null = null;
	software : PlayerSoftwareDTO | null = null;
	readonly machineCode : string | null = null;
	static override get _properties():string[]{return ["notes","lastOnline","screens","lastIP","connected","productive","offline","external","disabled","paired","proposed","pool","serviceRequest","position","homeArea","whitelistArea","positionValidityDuration","channel","onlineStatus","hardware","software","machineCode","currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DeviceFullDTO extends OwnedDeviceBaseDTO {
 	readonly lastPairing : DeviceLogDTO | null = null;
	readonly attributes : DeviceAttributeDTO[] | null = null;
	readonly serviceFulfilled : NotificationDTO | null = null;
	readonly publisher : ClientDTO | null = null;
	location : LocationFullDTO | null = null;
	readonly serviceHours : ServiceHourDTO[] | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	readonly headerImage : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["lastPairing","attributes","serviceFulfilled","publisher","location","serviceHours","attachmentCount","headerImage","notes","lastOnline","screens","lastIP","connected","productive","offline","external","disabled","paired","proposed","pool","serviceRequest","position","homeArea","whitelistArea","positionValidityDuration","channel","onlineStatus","hardware","software","machineCode","currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScreenBlacklistDTO extends IdentityWithCreatorDTO {
 	id : number | null = null;
	screen : ScreenDTO | null = null;
	booking : BookingDTO | null = null;
	client : ClientDTO | null = null;
	static override get _properties():string[]{return ["id","screen","booking","client","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class BiddingparametersDTO extends DTO {
 	maxBid : number | null = null;
	parentMaxBid : number | null = null;
	static override get _properties():string[]{return ["maxBid","parentMaxBid","_checkOwner","_type"];}
}
export class PlaylistSchemaIterationDTO extends DTO {
 	index : number | null = null;
	repetition : number | null = null;
	slots : PlaylistSchemaIterationSlotDTO[] | null = null;
	static override get _properties():string[]{return ["index","repetition","slots","_checkOwner","_type"];}
}
export enum CodeStyle {
 	Vanilla = "Vanilla",
	Barebone = "Barebone",
	Angular = "Angular",
}
export class SharedScreenOfflinePlaylistDTO extends DTO {
 	ranges : LocalDateTimeRangeDTO[] | null = null;
	screens : IdentityDTO[] | null = null;
	playlist : ScreenOfflinePlaylistDTO | null = null;
	static override get _properties():string[]{return ["ranges","screens","playlist","_checkOwner","_type"];}
}
export enum ComparisonOperator {
 	Equal = "Equal",
	NotEqual = "NotEqual",
	LessThan = "LessThan",
	LessOrEqual = "LessOrEqual",
	GreaterThan = "GreaterThan",
	GreaterOrEqual = "GreaterOrEqual",
	Like = "Like",
	NotLike = "NotLike",
	In = "In",
	NotIn = "NotIn",
	IsNull = "IsNull",
	IsNotNull = "IsNotNull",
}
export class ContentCullAtomDTO extends StructureCullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class LocationStatusDTO extends DTO {
 	manager : CompanyDTO | null = null;
	onlineStatus : LocationOnlineStatusCount | null = null;
	static override get _properties():string[]{return ["manager","onlineStatus","_checkOwner","_type"];}
}
export enum TargetingType {
 	Impressions = "Impressions",
	Playouts = "Playouts",
	PlaybackTime = "PlaybackTime",
}
export enum CommandDirection {
 	INCOMING = "INCOMING",
	OUTGOING = "OUTGOING",
}
export class AbstractTrackedVisitorFullDTO extends AbstractTrackedVisitorDTO {
 	visitorTracker : VisitorTrackerDTO | null = null;
	static override get _properties():string[]{return ["visitorTracker","count","unique","dwellTime","_checkOwner","_type"];}
}
export class TrackedVisitorFullDTO extends AbstractTrackedVisitorFullDTO {
 	date : SbDateTime | null = null;
	static override get _properties():string[]{return ["date","visitorTracker","count","unique","dwellTime","_checkOwner","_type"];}
}
export class ScheduledBookingDTO extends IdentityDTO {
 	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	readonly publisher : InventoryClientDTO | null = null;
	readonly marker : InventoryMarkerDTO | null = null;
	readonly channel : InventoryChannelDTO | null = null;
	medium : MediumFullDTO | null = null;
	excluded : boolean | null = null;
	deprecated : boolean | null = null;
	finished : boolean | null = null;
	verificationRequested : SbDateTime | null = null;
	verifiedAt : SbDateTime | null = null;
	rejectedAt : SbDateTime | null = null;
	readonly rejectedBy : UserDTO | null = null;
	readonly verifiedBy : UserDTO | null = null;
	reason : string | null = null;
	status : BookingStatus | null = null;
	static override get _properties():string[]{return ["planning","overwrites","publisher","marker","channel","medium","excluded","deprecated","finished","verificationRequested","verifiedAt","rejectedAt","rejectedBy","verifiedBy","reason","status","id","_checkOwner","_type"];}
}
export enum ReportingStatus {
 	Scheduled = "Scheduled",
	Canceled = "Canceled",
	CalculationPending = "CalculationPending",
	Calculating = "Calculating",
	CalculationFailed = "CalculationFailed",
	Calculated = "Calculated",
	Outdated = "Outdated",
	Rendering = "Rendering",
	RenderingFailed = "RenderingFailed",
	Rendered = "Rendered",
}
export class TemplateEntryDTO extends NamedIdentityWithIdentifierDTO {
 	createdAt : SbDateTime | null = null;
	values : any | null = null;
	static override get _properties():string[]{return ["createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class TemplateScreenEntryDTO extends TemplateEntryDTO {
 	rejectedAt : SbDateTime | null = null;
	rejectedBy : NamedIdentityDTO | null = null;
	rejected : boolean | null = null;
	invalidatedAt : SbDateTime | null = null;
	invalidated : boolean | null = null;
	static override get _properties():string[]{return ["rejectedAt","rejectedBy","rejected","invalidatedAt","invalidated","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class TemplateScreenEntryFullDTO extends TemplateScreenEntryDTO {
 	screen : ScreenDTO | null = null;
	static override get _properties():string[]{return ["screen","rejectedAt","rejectedBy","rejected","invalidatedAt","invalidated","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class PlayoutAggregationDataDateEntryDTO extends DTO {
 	data : PlayoutAggregationDataDTO | null = null;
	date : SbLocalDate | null = null;
	static override get _properties():string[]{return ["data","date","_checkOwner","_type"];}
}
export class DateTimeRangeDTO extends DTO {
 	from : SbDateTime | null = null;
	till : SbDateTime | null = null;
	millis : number | null = null;
	static override get _properties():string[]{return ["from","till","millis","_checkOwner","_type"];}
}
export class LocalizedFramedReportingDTO extends DTO {
 	interval : number | null = null;
	range : LocalDateTimeRangeDTO | null = null;
	buckets : LocalizedFrameBucketDTO[] | null = null;
	static override get _properties():string[]{return ["interval","range","buckets","_checkOwner","_type"];}
}
export class MediumGroupDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	identifier : string | null = null;
	readonly company : NamedIdentityDTO | null = null;
	description : string | null = null;
	color : string | null = null;
	folder : MediumGroupFolderDTO | null = null;
	preview : PublicMediumDTO | null = null;
	category : MediumGroupCategoryDTO | null = null;
	readonly mediaCount : number | null = null;
	readonly usageCount : number | null = null;
	readonly templateGroup : TemplateGroupDTO | null = null;
	readonly asset : SharedAssetDTO | null = null;
	static override get _properties():string[]{return ["identifier","company","description","color","folder","preview","category","mediaCount","usageCount","templateGroup","asset","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ClientCentricContentShareAssignmentDTO extends IdentifierDTO {
 	contentShare : ContentShareFullDTO | null = null;
	competingClients : ClientDTO[] | null = null;
	static override get _properties():string[]{return ["contentShare","competingClients","identifier","_checkOwner","_type"];}
}
export class ServiceHourDTO extends IdentityDTO {
 	readonly createdForDate : SbDateTime | null = null;
	readonly from : SbDateTime | null = null;
	readonly till : SbDateTime | null = null;
	static override get _properties():string[]{return ["createdForDate","from","till","id","_checkOwner","_type"];}
}
export class CullDTO extends ColoredModifiableNamedIdentityWithCreatorDTO {
 	category : CullCategoryDTO | null = null;
	global : boolean | null = null;
	description : string | null = null;
	company : CompanyDTO | null = null;
	type : string | null = null;
	expression : string | null = null;
	invertedStatic : boolean | null = null;
	easyMode : boolean | null = null;
	hidden : boolean | null = null;
	readonly valid : boolean | null = null;
	readonly currentUsageCount : number | null = null;
	readonly usageCount : number | null = null;
	readonly lockedBy : NamedIdentityDTO | null = null;
	readonly cached : SbDateTime | null = null;
	static override get _properties():string[]{return ["category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CullWithAtomsDTO extends CullDTO {
  atoms : CullAtomDTO[];
 	static override get _properties():string[]{return ["category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class StateSpaceCullDTO extends CullWithAtomsDTO {
 	override atoms : StateSpaceCullAtomDTO[] | null = null;
	static override get _properties():string[]{return ["atoms","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class UserDTO extends NamedIdentityWithCreatorDTO {
 	firstname : string | null = null;
	lastname : string | null = null;
	readonly avatar : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["firstname","lastname","avatar","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ClientCullAtomDTO extends StructureCullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class ChainedClientCullAtomDTO extends ClientCullAtomDTO {
 	chainedCull : string | null = null;
	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class ClientByClientCullAtomDTO extends ChainedClientCullAtomDTO {
 	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class FileLink extends DTO {
 	data : string | null = null;
	disposition : Disposition | null = null;
	static override get _properties():string[]{return ["data","disposition","_checkOwner","_type"];}
}
export class LoadLicenseRequest {
 	serials : string[] | null = null;
	static  get _properties():string[]{return ["serials"];}
}
export enum TimingStatus {
 	Unknown = "Unknown",
	Future = "Future",
	Present = "Present",
	Past = "Past",
}
export class ContactDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	company : CompanyDTO | null = null;
	title : string | null = null;
	firstName : string | null = null;
	lastName : string | null = null;
	user : UserDTO | null = null;
	contactFields : ContactFieldDTO[] | null = null;
	static override get _properties():string[]{return ["company","title","firstName","lastName","user","contactFields","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AddressedNamedIdentityDTO extends NamedIdentityWithCreatorDTO {
 	address : AddressDTO | null = null;
	static override get _properties():string[]{return ["address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class LocationBaseDTO extends AddressedNamedIdentityDTO {
 	identifier : string | null = null;
	locationType : LocationTypeDTO | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	readonly headerImage : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["identifier","locationType","logo","headerImage","address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class OwnedLocationBaseDTO extends LocationBaseDTO {
 	onlineStatus : LocationOnlineStatus | null = null;
	readonly countDevices : number | null = null;
	readonly countDevicesProductive : number | null = null;
	readonly countVisitorTracker : number | null = null;
	readonly countVisitorTrackerProductive : number | null = null;
	static override get _properties():string[]{return ["onlineStatus","countDevices","countDevicesProductive","countVisitorTracker","countVisitorTrackerProductive","identifier","locationType","logo","headerImage","address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PlayerIdentityReturningPathBasedStructureCullAtomDTO extends PlayerCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class PathBasedGeoCullAtomDTO extends GeoCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class IdentityReturningPathBasedGeoCullAtomDTO extends PathBasedGeoCullAtomDTO {
 	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class RadialPolygonIdentityReturningPathBasedGeoCullAtomDTO extends IdentityReturningPathBasedGeoCullAtomDTO {
 	radius : number | null = null;
	unit : DistanceUnit | null = null;
	static override get _properties():string[]{return ["radius","unit","field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class CampaignDTO extends ModifiableNamedIdentityWithIdentifierAndCreatorWithRequirementFiltersDTO {
 	readonly clientOrderNum : number | null = null;
	readonly planning : boolean | null = null;
	readonly overwrites : CampaignDTO | null = null;
	readonly customer : NamedIdentityDTO | null = null;
	campaignId : string | null = null;
	description : string | null = null;
	campaignType : CampaignTypeDTO | null = null;
	bookingparameters : BookingparametersDTO | null = null;
	active : boolean | null = null;
	readonly from : SbLocalDateTime | null = null;
	readonly till : SbLocalDateTime | null = null;
	readonly timingStatus : TimingStatus | null = null;
	level : CampaignLevelDTO | null = null;
	readonly commercialCount : any | null = null;
	readonly bookingStatus : any | null = null;
	budget : BudgetDTO | null = null;
	targeting : TargetingDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	playoutAggregation : PlayoutAggregationDTO | null = null;
	static override get _properties():string[]{return ["clientOrderNum","planning","overwrites","customer","campaignId","description","campaignType","bookingparameters","active","from","till","timingStatus","level","commercialCount","bookingStatus","budget","targeting","attachmentCount","playoutAggregation","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum TemplateVariableType {
 	TEXT = "TEXT",
	IMAGE = "IMAGE",
	VIDEO = "VIDEO",
	INTEGER = "INTEGER",
	DECIMAL = "DECIMAL",
	JSON_OBJECT = "JSON_OBJECT",
	JSON_ARRAY = "JSON_ARRAY",
}
export class ChainedTimeCullAtomDTO extends TimeCullAtomDTO {
 	chainedCull : string | null = null;
	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class TimeByTimeCullAtomDTO extends ChainedTimeCullAtomDTO {
 	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class ContentPathBasedStructureCullAtomDTO extends ContentCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class PositionDTO extends DTO {
 	timestamp : SbDateTime | null = null;
	coordinate : Point | null = null;
	static override get _properties():string[]{return ["timestamp","coordinate","_checkOwner","_type"];}
}
export class AttachmentAssignmentDTO extends DTO {
 	attachment : AttachmentDTO | null = null;
	isPublic : boolean | null = null;
	static override get _properties():string[]{return ["attachment","isPublic","_checkOwner","_type"];}
}
export class TemplateVariableDTO extends NamedIdentityDTO {
 	type : TemplateVariableType | null = null;
	position : number | null = null;
	label : string | null = null;
	description : string | null = null;
	defaultValue : string | null = null;
	mandatory : boolean | null = null;
	allowEmptyValue : boolean | null = null;
	replacePlaceholders : boolean | null = null;
	placeholder : string | null = null;
	maxDisplayLength : number | null = null;
	decimalPlaces : number | null = null;
	staticSelection : LabeledValueDTO[] | null = null;
	forceRegEx : string | null = null;
	dependsOn : TemplateVariableDTO[] | null = null;
	onScreenEntryRender : TemplateGroupRequestDefinitionDTO | null = null;
	static override get _properties():string[]{return ["type","position","label","description","defaultValue","mandatory","allowEmptyValue","replacePlaceholders","placeholder","maxDisplayLength","decimalPlaces","staticSelection","forceRegEx","dependsOn","onScreenEntryRender","name","id","_checkOwner","_type"];}
}
export class MediumGroupAttributeDTO extends AttributeDTO {
 	override id: {
		datatype?:MediumGroupAttributeDatatypeDTO;
		mediumGroup?:MediumGroupDTO
	} | null = null;
	datatype : MediumGroupAttributeDatatypeDTO | null = null;
	static override get _properties():string[]{return ["datatype","value","lastUpdate","anchor","name","id","_checkOwner","_type"];}
}
export class LocalizedHourBasedReportingDTO extends DTO {
 	range : LocalDateTimeRangeDTO | null = null;
	static override get _properties():string[]{return ["range","_checkOwner","_type"];}
}
export class LocalDateTimeRange {
 	FROM_ORDERING : Comparator | null = null;
	TILL_ORDERING : Comparator | null = null;
	static  get _properties():string[]{return ["FROM_ORDERING","TILL_ORDERING"];}
}
export class ChainedContentCullAtomDTO extends ContentCullAtomDTO {
 	chainedCull : string | null = null;
	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class DeviceConfigurationTokenDTO extends DTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly validTill : SbDateTime | null = null;
	readonly token : string | null = null;
	readonly uuid : string | null = null;
	readonly hostname : string | null = null;
	readonly configuration : DeviceConfiguration | null = null;
	static override get _properties():string[]{return ["createdAt","validTill","token","uuid","hostname","configuration","_checkOwner","_type"];}
}
export class ReportingTemplateDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly client : ClientDTO | null = null;
	nameTemplate : string | null = null;
	readonly global : boolean | null = null;
	static override get _properties():string[]{return ["client","nameTemplate","global","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ReportingTemplateFullDTO extends ReportingTemplateDTO {
 	htmlTemplate : string | null = null;
	readonly reportingType : ReportingTypeDTO | null = null;
	static override get _properties():string[]{return ["htmlTemplate","reportingType","client","nameTemplate","global","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ProductCategoryDTO extends NamedIdentityWithCreatorDTO {
 	parent : ProductCategoryDTO | null = null;
	description : string | null = null;
	color : string | null = null;
	readonly illustration : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["parent","description","color","illustration","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ProductCategoryFullDTO extends ProductCategoryDTO {
 	children : ProductCategoryFullDTO[] | null = null;
	products : ProductDTO[] | null = null;
	static override get _properties():string[]{return ["children","products","parent","description","color","illustration","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum Weekday {
 	MONDAY = "MONDAY",
	TUESDAY = "TUESDAY",
	WEDNESDAY = "WEDNESDAY",
	THURSDAY = "THURSDAY",
	FRIDAY = "FRIDAY",
	SATURDAY = "SATURDAY",
	SUNDAY = "SUNDAY",
}
export class MultipartFormDataInput {
 }
export class ChainedPlayerCullAtomDTO extends PlayerCullAtomDTO {
 	chainedCull : string | null = null;
	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class FilterDescriptor {
 	field : string | null = null;
	values : string[] | null = null;
	static  get _properties():string[]{return ["field","values"];}
}
export class Serializable {
 }
export class ColoredNamedIdentityWithCreatorDTO extends NamedIdentityWithCreatorDTO {
 	color : string | null = null;
	static override get _properties():string[]{return ["color","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScheduledNamedIdentityWithCreatorWithRequirementFiltersDTO extends ColoredNamedIdentityWithCreatorDTO {
 	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	static override get _properties():string[]{return ["timeCull","playerCull","geoCull","stateSpaceCull","color","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScheduledCommercialDTO extends ScheduledNamedIdentityWithCreatorWithRequirementFiltersDTO {
 	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	readonly sequence : number | null = null;
	active : boolean | null = null;
	from : SbLocalDateTime | null = null;
	till : SbLocalDateTime | null = null;
	timingStatus : TimingStatus | null = null;
	duration : number | null = null;
	dailyPlayouts : number | null = null;
	actualPlayouts : number | null = null;
	targetPlayouts : number | null = null;
	actualSecondsPlayed : number | null = null;
	totalSecondsBooked : number | null = null;
	secondsToNextPlay : number | null = null;
	readonly requirementCount : number | null = null;
	requirements : ScheduledRequirementDTO[] | null = null;
	readonly bookingStatus : any | null = null;
	playerAggregation : PlayerAggregationDTO | null = null;
	readonly preview : MediumDTO[] | null = null;
	static override get _properties():string[]{return ["planning","overwrites","sequence","active","from","till","timingStatus","duration","dailyPlayouts","actualPlayouts","targetPlayouts","actualSecondsPlayed","totalSecondsBooked","secondsToNextPlay","requirementCount","requirements","bookingStatus","playerAggregation","preview","timeCull","playerCull","geoCull","stateSpaceCull","color","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class Comparator {
 }
export class ThreadGroupDTO extends DTO {
 	name : string | null = null;
	hashCode : number | null = null;
	static override get _properties():string[]{return ["name","hashCode","_checkOwner","_type"];}
}
export class InventoryIdentityDescriptorDTO extends DTO {
 	descriptorId : string | null = null;
	static override get _properties():string[]{return ["descriptorId","_checkOwner","_type"];}
}
export class EndpointStatisticsDTO extends DTO {
 	resourceDescriptor : EndpointDescriptorDTO | null = null;
	endpointCalls : number | null = null;
	minExecutionTime : number | null = null;
	avgExecutionTime : number | null = null;
	maxExecutionTime : number | null = null;
	firstStarted : SbDateTime | null = null;
	firstFinished : SbDateTime | null = null;
	lastStarted : SbDateTime | null = null;
	lastFinished : SbDateTime | null = null;
	static override get _properties():string[]{return ["resourceDescriptor","endpointCalls","minExecutionTime","avgExecutionTime","maxExecutionTime","firstStarted","firstFinished","lastStarted","lastFinished","_checkOwner","_type"];}
}
export class PublisherPlayoutDescriptorDTO extends PlayoutDescriptorBaseDTO {
 	booking : BookingBaseInfoDTO | null = null;
	static override get _properties():string[]{return ["booking","id","productive","createdAt","firstPlayout","lastPlayout","_checkOwner","_type"];}
}
export class PublisherPlayoutDescriptorWithScreenDTO extends PublisherPlayoutDescriptorDTO {
 	screen : ScreenDTO | null = null;
	static override get _properties():string[]{return ["screen","booking","id","productive","createdAt","firstPlayout","lastPlayout","_checkOwner","_type"];}
}
export class PublisherPlayoutDescriptorFullDTO extends PublisherPlayoutDescriptorWithScreenDTO {
 	device : DeviceDTO | null = null;
	static override get _properties():string[]{return ["device","screen","booking","id","productive","createdAt","firstPlayout","lastPlayout","_checkOwner","_type"];}
}
export class InventoryChannelDTO extends ChannelBaseDTO {
 	static override get _properties():string[]{return ["description","color","logo","ambianceImage","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryChannelFullDTO extends InventoryChannelDTO {
 	markers : InventoryMarkerDTO[] | null = null;
	static override get _properties():string[]{return ["markers","description","color","logo","ambianceImage","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PlayoutBaseDTO extends DTO {
 	descriptor : number | null = null;
	start : SbDateTime | null = null;
	playbacktime : number | null = null;
	static override get _properties():string[]{return ["descriptor","start","playbacktime","_checkOwner","_type"];}
}
export class PlayoutBookingBaseDTO extends PlayoutBaseDTO {
 	booking : BookingDTO | null = null;
	usedTemplateEntry : TemplateEntryDTO | null = null;
	static override get _properties():string[]{return ["booking","usedTemplateEntry","descriptor","start","playbacktime","_checkOwner","_type"];}
}
export class InventoryPlayoutDTO extends PlayoutBookingBaseDTO {
 	screen : InventoryScreenDTO | null = null;
	static override get _properties():string[]{return ["screen","booking","usedTemplateEntry","descriptor","start","playbacktime","_checkOwner","_type"];}
}
export class LicenseDTO extends NamedIdentityWithCreatorDTO {
 	serial : string | null = null;
	issuedAt : SbDateTime | null = null;
	uuid : string | null = null;
	application : string | null = null;
	type : LicenseType | null = null;
	domain : string | null = null;
	client : NamedIdentityDTO | null = null;
	configuration : string | null = null;
	manuallyAssigned : boolean | null = null;
	inUse : boolean | null = null;
	static override get _properties():string[]{return ["serial","issuedAt","uuid","application","type","domain","client","configuration","manuallyAssigned","inUse","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MachineLicenseDTO extends LicenseDTO {
 	machineCode : string | null = null;
	static override get _properties():string[]{return ["machineCode","serial","issuedAt","uuid","application","type","domain","client","configuration","manuallyAssigned","inUse","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScreenMachineLicenseDTO extends MachineLicenseDTO {
 	static override get _properties():string[]{return ["machineCode","serial","issuedAt","uuid","application","type","domain","client","configuration","manuallyAssigned","inUse","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum CullReportingMode {
 	COMBINED = "COMBINED",
	FILTERED = "FILTERED",
	GROUPED = "GROUPED",
}
export class ClientIdentityReturningPathBasedStructureCullAtomDTO extends ClientCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class IndexedBookingSetDTO extends DTO {
 	index : number | null = null;
	bookings : PublisherBookingDTO[] | null = null;
	static override get _properties():string[]{return ["index","bookings","_checkOwner","_type"];}
}
export class DateTimePartCullAtomDTO extends TimeCullAtomDTO {
 	part : DateTimePart | null = null;
	partValue : number | null = null;
	static override get _properties():string[]{return ["part","partValue","type","valid","operator","id","_checkOwner","_type"];}
}
export class PlayoutAggregationDataDateEntry {
 	date : SbLocalDate | null = null;
	data : PlayoutAggregationData | null = null;
	static  get _properties():string[]{return ["date","data"];}
}
export class AdHocReportingSetupDTO extends ReportingSetupDTO {
 	readonly adHocScheduling : ReportingSchedulingDTO | null = null;
	static override get _properties():string[]{return ["adHocScheduling","reportingType","global","description","reportingTemplate","createRawDataReport","rawDataReports","playerCullReportingMode","contentCullReportingMode","clientCullReportingMode","timeCullReportingMode","geoCullReportingMode","usedContentCulls","usedClientCulls","usedPlayerCulls","usedGeoCulls","usedTimeCulls","active","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumGroupAttributeDatatypeDTO extends AttributeDatatypeDTO {
 	static override get _properties():string[]{return ["description","customized","global","adPlacerAbleToSet","externalSynchronized","multiline","searchable","uniqueValues","askForConfirmation","usableForFilters","disclosedToPublic","forceRegEx","defaultValue","allowedValues","allowedValuesMinCount","allowedValuesMaxCount","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TargetingBucketDTO extends IdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	range : DateTimeRangeDTO | null = null;
	readonly reached : number | null = null;
	readonly target : number | null = null;
	diurnalBuckets : TargetingDiurnalBucketDTO[] | null = null;
	static override get _properties():string[]{return ["createdAt","range","reached","target","diurnalBuckets","id","_checkOwner","_type"];}
}
export class AggregatedPlaylistSchemaIterationSlotDTO extends IdentifierDTO {
 	slot : PlaybackScheduleSlotDTO | null = null;
	fallbackSlot : boolean | null = null;
	staticBooking : IdentityDTO | null = null;
	sspSlotConfigurations : SSPSlotConfigurationDTO[] | null = null;
	static override get _properties():string[]{return ["slot","fallbackSlot","staticBooking","sspSlotConfigurations","identifier","_checkOwner","_type"];}
}
export enum Entity {
 	_UNDEFINED = "_UNDEFINED",
	Area = "Area",
	AreaCategory = "AreaCategory",
	Booking = "Booking",
	Budget = "Budget",
	Campaign = "Campaign",
	CampaignType = "CampaignType",
	Channel = "Channel",
	Client = "Client",
	ClientUser = "ClientUser",
	Cull = "Cull",
	ClientCull = "ClientCull",
	Commercial = "Commercial",
	Company = "Company",
	Contact = "Contact",
	ContentCull = "ContentCull",
	ContentShare = "ContentShare",
	ContentShareQuota = "ContentShareQuota",
	CullAtom = "CullAtom",
	ChainedCullAtom = "ChainedCullAtom",
	ChainedClientCullAtom = "ChainedClientCullAtom",
	ChainedContentCullAtom = "ChainedContentCullAtom",
	ChainedGeoCullAtom = "ChainedGeoCullAtom",
	ChainedPlayerCullAtom = "ChainedPlayerCullAtom",
	ChainedTimeCullAtom = "ChainedTimeCullAtom",
	CullCategory = "CullCategory",
	Device = "Device",
	GeoCull = "GeoCull",
	Location = "Location",
	LocationType = "LocationType",
	Marker = "Marker",
	Medium = "Medium",
	MediumGroup = "MediumGroup",
	MediumGroupCategory = "MediumGroupCategory",
	NetworkPriceModel = "NetworkPriceModel",
	NetworkShare = "NetworkShare",
	Notification = "Notification",
	Planning = "Planning",
	PlaybackSchedule = "PlaybackSchedule",
	PlaybackScheduleSlot = "PlaybackScheduleSlot",
	PlayerCull = "PlayerCull",
	PlayerHardware = "PlayerHardware",
	PlayerSoftware = "PlayerSoftware",
	Playlist = "Playlist",
	Pool = "Pool",
	Product = "Product",
	ProductCategory = "ProductCategory",
	Requirement = "Requirement",
	Role = "Role",
	Screen = "Screen",
	ScreenHardware = "ScreenHardware",
	SSP = "SSP",
	SSPContract = "SSPContract",
	Deal = "Deal",
	Tag = "Tag",
	Targeting = "Targeting",
	TemplateDataSet = "TemplateDataSet",
	TemplateDataSetEntry = "TemplateDataSetEntry",
	TemplateGroup = "TemplateGroup",
	TemplateScreenEntry = "TemplateScreenEntry",
	TemplateVariable = "TemplateVariable",
	TimeCull = "TimeCull",
	User = "User",
	Verification = "Verification",
}
export class ScheduledCampaignDTO extends ScheduledNamedIdentityWithCreatorWithRequirementFiltersDTO {
 	readonly clientOrderNum : number | null = null;
	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	readonly customer : CompanyDTO | null = null;
	campaignId : string | null = null;
	description : string | null = null;
	campaignType : CampaignTypeDTO | null = null;
	commercials : ScheduledCommercialDTO[] | null = null;
	active : boolean | null = null;
	readonly from : SbLocalDateTime | null = null;
	readonly till : SbLocalDateTime | null = null;
	readonly timingStatus : TimingStatus | null = null;
	level : CampaignLevelDTO | null = null;
	readonly bookingStatus : any | null = null;
	playerAggregation : PlayerAggregationDTO | null = null;
	readonly preview : PublicMediumDTO[] | null = null;
	static override get _properties():string[]{return ["clientOrderNum","planning","overwrites","customer","campaignId","description","campaignType","commercials","active","from","till","timingStatus","level","bookingStatus","playerAggregation","preview","timeCull","playerCull","geoCull","stateSpaceCull","color","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class SharedPlaylistDTO extends SharedByScreenAndTimeDTO {
 	playlist : PlaylistSchemaDTO | null = null;
	static override get _properties():string[]{return ["playlist","ranges","screens","identifier","_checkOwner","_type"];}
}
export class InventoryFilterValueListResponseDTO extends InventoryIdentityDescriptorDTO {
 	values : InventoryFieldValueAggregationDTO[] | null = null;
	static override get _properties():string[]{return ["values","descriptorId","_checkOwner","_type"];}
}
export class SelectionFieldReference extends FieldReference {
 	values : DisplayableValueDTO[] | null = null;
	lookup : string | null = null;
	static override get _properties():string[]{return ["values","lookup","type","requires","order","_checkOwner","_type"];}
}
export class PoolBaseDTO extends NamedIdentityWithCreatorDTO {
 	parent : PoolBaseDTO | null = null;
	static override get _properties():string[]{return ["parent","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PoolDTO extends PoolBaseDTO {
 	readonly clientOrderNum : number | null = null;
	description : string | null = null;
	color : string | null = null;
	countDevices : number | null = null;
	countDevicesProductive : number | null = null;
	static override get _properties():string[]{return ["clientOrderNum","description","color","countDevices","countDevicesProductive","parent","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryElementDTO extends InventoryIdentityDescriptorDTO {
 	publisher : InventoryClientDTO | null = null;
	location : InventoryLocationDTO | null = null;
	channel : InventoryChannelDTO | null = null;
	device : InventoryDeviceDTO | null = null;
	marker : InventoryMarkerDTO | null = null;
	screen : InventoryScreenDTO | null = null;
	pool : InventoryPoolDTO | null = null;
	static override get _properties():string[]{return ["publisher","location","channel","device","marker","screen","pool","descriptorId","_checkOwner","_type"];}
}
export class InventoryCompanyDTO extends NamedIdentityDTO {
 	disclosedAttributes : CompanyAttributeDTO[] | null = null;
	static override get _properties():string[]{return ["disclosedAttributes","name","id","_checkOwner","_type"];}
}
export class InventoryCompanyFullDTO extends InventoryCompanyDTO {
 	client : InventoryClientDTO | null = null;
	static override get _properties():string[]{return ["client","disclosedAttributes","name","id","_checkOwner","_type"];}
}
export enum GTINRepresentation {
 	GTIN14 = "GTIN14",
	GTIN13 = "GTIN13",
	GTIN12 = "GTIN12",
	GTIN8 = "GTIN8",
	ISBN = "ISBN",
	EAN = "EAN",
	UPC = "UPC",
}
export class VerificationDTO extends IdentityDTO {
 	override id: {
		advertiser?:CompanyDTO;
		publisher?:CompanyDTO;
		medium?:MediumDTO;
		marker?:MarkerDTO
	} | null = null;
	readonly publisher : ClientDTO | null = null;
	readonly marker : MarkerDTO | null = null;
	readonly channel : ChannelDTO | null = null;
	readonly advertiser : ClientDTO | null = null;
	readonly medium : PublicMediumDTO | null = null;
	readonly rejectedBy : UserDTO | null = null;
	readonly verifiedBy : UserDTO | null = null;
	readonly createdAt : SbDateTime | null = null;
	readonly notifiedPublisher : SbDateTime | null = null;
	readonly notifiedAdvertiser : SbDateTime | null = null;
	readonly current : boolean | null = null;
	readonly rejectedAt : SbDateTime | null = null;
	reason : string | null = null;
	readonly verifiedAt : SbDateTime | null = null;
	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	permitted : boolean | null = null;
	static override get _properties():string[]{return ["publisher","marker","channel","advertiser","medium","rejectedBy","verifiedBy","createdAt","notifiedPublisher","notifiedAdvertiser","current","rejectedAt","reason","verifiedAt","timeCull","playerCull","geoCull","stateSpaceCull","permitted","id","_checkOwner","_type"];}
}
export class FramedReportingDTO extends DTO {
 	interval : number | null = null;
	range : DateTimeRangeDTO | null = null;
	buckets : FrameBucketDTO[] | null = null;
	static override get _properties():string[]{return ["interval","range","buckets","_checkOwner","_type"];}
}
export class PostFullDTO extends PostDTO {
 	answers : PostFullDTO[] | null = null;
	static override get _properties():string[]{return ["answers","text","pinned","solution","mentions","deletedAt","answerTo","entity","attachmentCount","modifiedAt","modifiedBy","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class ThreadDTO extends DTO {
 	interrupted : boolean | null = null;
	alive : boolean | null = null;
	daemon : boolean | null = null;
	name : string | null = null;
	hashCode : number | null = null;
	group : ThreadGroupDTO | null = null;
	state : ThreadState | null = null;
	priority : number | null = null;
	stackTrace : StackTraceElementDTO[] | null = null;
	static override get _properties():string[]{return ["interrupted","alive","daemon","name","hashCode","group","state","priority","stackTrace","_checkOwner","_type"];}
}
export class FormatDTO extends IdentityDTO {
 	audioCodec : string | null = null;
	videoCodec : string | null = null;
	containerFormat : string | null = null;
	static override get _properties():string[]{return ["audioCodec","videoCodec","containerFormat","id","_checkOwner","_type"];}
}
export class ElementCountDataDTO extends DTO {
 	date : SbLocalDate | null = null;
	count : number | null = null;
	static override get _properties():string[]{return ["date","count","_checkOwner","_type"];}
}
export class CampaignReportElementCountDataDTO extends ElementCountDataDTO {
 	productive : boolean | null = null;
	playbacktime : number | null = null;
	playouts : number | null = null;
	static override get _properties():string[]{return ["productive","playbacktime","playouts","date","count","_checkOwner","_type"];}
}
export class TemplateGroupRequestDefinitionDTO extends IdentityDTO {
 	identifier : string | null = null;
	method : HttpMethod | null = null;
	url : string | null = null;
	body : string | null = null;
	headers : any | null = null;
	expectedStatusCodes : number[] | null = null;
	static override get _properties():string[]{return ["identifier","method","url","body","headers","expectedStatusCodes","id","_checkOwner","_type"];}
}
export class WeeklyScheduleDTO extends ModifiableNamedIdentityWithIdentifierAndCreatorDTO {
 	description : string | null = null;
	mon : DayTimeHoursDTO | null = null;
	tue : DayTimeHoursDTO | null = null;
	wed : DayTimeHoursDTO | null = null;
	thu : DayTimeHoursDTO | null = null;
	fri : DayTimeHoursDTO | null = null;
	sat : DayTimeHoursDTO | null = null;
	sun : DayTimeHoursDTO | null = null;
	static override get _properties():string[]{return ["description","mon","tue","wed","thu","fri","sat","sun","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class BookingparametersDTO extends DTO {
 	from : SbLocalDateTime | null = null;
	till : SbLocalDateTime | null = null;
	maxBudget : number | null = null;
	currentBudget : number | null = null;
	maxPlaybacktime : number | null = null;
	currentPlaybacktime : number | null = null;
	maxPlayouts : number | null = null;
	currentPlayouts : number | null = null;
	maxImpressions : number | null = null;
	currentImpressions : number | null = null;
	parentFrom : SbLocalDateTime | null = null;
	parentTill : SbLocalDateTime | null = null;
	parentMaxBudget : number | null = null;
	parentMaxPlaybacktime : number | null = null;
	parentMaxPlayouts : number | null = null;
	parentMaxImpressions : number | null = null;
	static override get _properties():string[]{return ["from","till","maxBudget","currentBudget","maxPlaybacktime","currentPlaybacktime","maxPlayouts","currentPlayouts","maxImpressions","currentImpressions","parentFrom","parentTill","parentMaxBudget","parentMaxPlaybacktime","parentMaxPlayouts","parentMaxImpressions","_checkOwner","_type"];}
}
export class TargetedScreenOfflinePlaylistDTO extends IdentifierDTO {
 	slots : TargetedScreenOfflinePlaylistSlotDTO[] | null = null;
	targetedBookings : IndexedBookingSetDTO[] | null = null;
	static override get _properties():string[]{return ["slots","targetedBookings","identifier","_checkOwner","_type"];}
}
export class ContentByContentCullAtomDTO extends ChainedContentCullAtomDTO {
 	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class FolderDTO extends NamedIdentityWithCreatorDTO {
 	description : string | null = null;
	company : NamedIdentityDTO | null = null;
	readonly parentFolder : NamedIdentityDTO | null = null;
	readonly elementsCount : number | null = null;
	readonly elementsCountHierarchy : number | null = null;
	readonly subfoldersCount : number | null = null;
	readonly subfoldersCountHierarchy : number | null = null;
	subfolders : NamedIdentityDTO[] | null = null;
	static override get _properties():string[]{return ["description","company","parentFolder","elementsCount","elementsCountHierarchy","subfoldersCount","subfoldersCountHierarchy","subfolders","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class SizedFolderDTO extends FolderDTO {
 	readonly elementsSize : number | null = null;
	readonly folderSize : number | null = null;
	readonly subfolderElementsSize : number | null = null;
	readonly subfoldersSize : number | null = null;
	readonly subfolderElementsSizeHierarchy : number | null = null;
	readonly subfoldersSizeHierarchy : number | null = null;
	static override get _properties():string[]{return ["elementsSize","folderSize","subfolderElementsSize","subfoldersSize","subfolderElementsSizeHierarchy","subfoldersSizeHierarchy","description","company","parentFolder","elementsCount","elementsCountHierarchy","subfoldersCount","subfoldersCountHierarchy","subfolders","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumFolderDTO extends SizedFolderDTO {
 	media : MediumDTO[] | null = null;
	static override get _properties():string[]{return ["media","elementsSize","folderSize","subfolderElementsSize","subfoldersSize","subfolderElementsSizeHierarchy","subfoldersSizeHierarchy","description","company","parentFolder","elementsCount","elementsCountHierarchy","subfoldersCount","subfoldersCountHierarchy","subfolders","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CompanyFullShortAttributeDTO extends CompanyDTO {
 	attributes : any | null = null;
	static override get _properties():string[]{return ["attributes","primaryCompany","email","logo","address","attachmentCount","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class Response {
 }
export class ScreenOfflineBookingDTO extends IdentityDTO {
 	medium : ScreenOfflineMediumDTO | null = null;
	static override get _properties():string[]{return ["medium","id","_checkOwner","_type"];}
}
export class SingleFileUpload extends MultipartDefinition {
 	file : File | null = null;
partDefinitions() { return [{name: "file", field: this.file}];}}
export class AggregationGroupDTO extends IdentityDTO {
 	static override get _properties():string[]{return ["id","_checkOwner","_type"];}
}
export class SettingFullDTO extends SettingDTO {
 	setting : string | null = null;
	static override get _properties():string[]{return ["setting","override","value","_checkOwner","_type"];}
}
export class InventoryFieldDTO extends DTO {
 	type : string | null = null;
	field : string | null = null;
	static override get _properties():string[]{return ["type","field","_checkOwner","_type"];}
}
export class FilterableInventoryRequestDTO extends InventoryIdentityDescriptorDTO {
 	filters : InventoryFilterDTO[] | null = null;
	whitelistPolygons : Polygon[] | null = null;
	blacklistPolygons : Polygon[] | null = null;
	playerCulls : PlayerCullDTO[] | null = null;
	geoCulls : GeoCullDTO[] | null = null;
	static override get _properties():string[]{return ["filters","whitelistPolygons","blacklistPolygons","playerCulls","geoCulls","descriptorId","_checkOwner","_type"];}
}
export class DeviceGeoStatsDTO extends IdentityDTO {
 	readonly roms : PolygonDTO[] | null = null;
	readonly pos : PolygonDTO | null = null;
	readonly pobs : PolygonDTO[] | null = null;
	readonly lobs : PolygonDTO[] | null = null;
	static override get _properties():string[]{return ["roms","pos","pobs","lobs","id","_checkOwner","_type"];}
}
export class DeviceConfigurationEntryDTO extends DTO {
 	deviceId : number | null = null;
	username : string | null = null;
	password : string | null = null;
	config : string | null = null;
	static override get _properties():string[]{return ["deviceId","username","password","config","_checkOwner","_type"];}
}
export class PublisherBookingDTO extends BookingBaseInfoDTO {
 	static override get _properties():string[]{return ["name","active","from","till","timingStatus","duration","frequency","advertiser","customer","verificationRequested","verifiedAt","rejectedAt","rejectedBy","verifiedBy","reason","marker","channel","medium","templateDataSet","templateDataSetEntry","excluded","deprecated","finished","status","id","_checkOwner","_type"];}
}
export class ClientDTO extends ClientBaseDTO {
 	currency : CurrencyDTO | null = null;
	readonly primaryCompany : CompanyDTO | null = null;
	readonly ssp : SSPDTO | null = null;
	static override get _properties():string[]{return ["currency","primaryCompany","ssp","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumWithMD5DTO extends MediumDTO {
 	MD5 : string | null = null;
	static override get _properties():string[]{return ["MD5","description","processing","uploading","progress","locked","uploaded","original","templateStoreData","folder","usageCount","previewProgress","company","duration","contentType","fileName","format","resolution","size","hash","templateGroup","url","stillImage","publicUrl","assetFile","color","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryPoolDTO extends PoolBaseDTO {
 	static override get _properties():string[]{return ["parent","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class VisitorTrackerScreenBaseDTO extends DTO {
 	amount : number | null = null;
	static override get _properties():string[]{return ["amount","_checkOwner","_type"];}
}
export class VisitorTrackerScreenFullDTO extends VisitorTrackerScreenBaseDTO {
 	screen : ScreenFullDTO | null = null;
	visitorTracker : VisitorTrackerFullDTO | null = null;
	static override get _properties():string[]{return ["screen","visitorTracker","amount","_checkOwner","_type"];}
}
export enum PDFRenderMode {
 	Print = "Print",
	Screen = "Screen",
}
export class PlayerAggregationDataDTO extends DTO {
 	min : PlayerAggregationDTO | null = null;
	avg : PlayerAggregationDTO | null = null;
	max : PlayerAggregationDTO | null = null;
	static override get _properties():string[]{return ["min","avg","max","_checkOwner","_type"];}
}
export class VisitorDiurnalCycleDataDTO extends DiurnalCycleDataDTO {
 	total : number | null = null;
	uniqueRatio : number | null = null;
	dwellTime : number | null = null;
	niveau : number | null = null;
	static override get _properties():string[]{return ["total","uniqueRatio","dwellTime","niveau","start","end","_checkOwner","_type"];}
}
export class VisitorAggregationDate {
 	count : number | null = null;
	unique : number | null = null;
	count0 : number | null = null;
	unique0 : number | null = null;
	count1 : number | null = null;
	unique1 : number | null = null;
	count2 : number | null = null;
	unique2 : number | null = null;
	count3 : number | null = null;
	unique3 : number | null = null;
	count4 : number | null = null;
	unique4 : number | null = null;
	count5 : number | null = null;
	unique5 : number | null = null;
	count6 : number | null = null;
	unique6 : number | null = null;
	count7 : number | null = null;
	unique7 : number | null = null;
	count8 : number | null = null;
	unique8 : number | null = null;
	count9 : number | null = null;
	unique9 : number | null = null;
	count10 : number | null = null;
	unique10 : number | null = null;
	count11 : number | null = null;
	unique11 : number | null = null;
	count12 : number | null = null;
	unique12 : number | null = null;
	count13 : number | null = null;
	unique13 : number | null = null;
	count14 : number | null = null;
	unique14 : number | null = null;
	count15 : number | null = null;
	unique15 : number | null = null;
	count16 : number | null = null;
	unique16 : number | null = null;
	count17 : number | null = null;
	unique17 : number | null = null;
	count18 : number | null = null;
	unique18 : number | null = null;
	count19 : number | null = null;
	unique19 : number | null = null;
	count20 : number | null = null;
	unique20 : number | null = null;
	count21 : number | null = null;
	unique21 : number | null = null;
	count22 : number | null = null;
	unique22 : number | null = null;
	count23 : number | null = null;
	unique23 : number | null = null;
	static  get _properties():string[]{return ["count","unique","count0","unique0","count1","unique1","count2","unique2","count3","unique3","count4","unique4","count5","unique5","count6","unique6","count7","unique7","count8","unique8","count9","unique9","count10","unique10","count11","unique11","count12","unique12","count13","unique13","count14","unique14","count15","unique15","count16","unique16","count17","unique17","count18","unique18","count19","unique19","count20","unique20","count21","unique21","count22","unique22","count23","unique23"];}
}
export class SharedTargetedScreenOfflinePlaylistDTO extends DTO {
 	screen : IdentityDTO | null = null;
	playlists : SharedTargetedOfflinePlaylistDTO[] | null = null;
	targetings : ScreenTargetingInfoDTO[] | null = null;
	static override get _properties():string[]{return ["screen","playlists","targetings","_checkOwner","_type"];}
}
export class TrackedVisitorLocalFullDTO extends AbstractTrackedVisitorFullDTO {
 	date : SbLocalDateTime | null = null;
	static override get _properties():string[]{return ["date","visitorTracker","count","unique","dwellTime","_checkOwner","_type"];}
}
export class ResolutionDTO extends DTO {
 	id : string | null = null;
	width : number | null = null;
	height : number | null = null;
	static override get _properties():string[]{return ["id","width","height","_checkOwner","_type"];}
}
export class SharedAssetDTO extends NamedIdentityDTO {
 	description : string | null = null;
	shareEnd : SbDateTime | null = null;
	tags : string[] | null = null;
	category : AssetCategoryFullDTO | null = null;
	preview : AssetFileDTO | null = null;
	modifiedAt : SbDateTime | null = null;
	static override get _properties():string[]{return ["description","shareEnd","tags","category","preview","modifiedAt","name","id","_checkOwner","_type"];}
}
export class ShareOfVoiceDTO extends DTO {
 	dates : PlayoutAggregationDataDateEntryDTO[] | null = null;
	data : PlayoutAggregationDataDTO | null = null;
	playerAggregation : PlayerAggregationDataDTO | null = null;
	static override get _properties():string[]{return ["dates","data","playerAggregation","_checkOwner","_type"];}
}
export class CompanyShareOfVoiceDTO extends ShareOfVoiceDTO {
 	company : CompanyDTO | null = null;
	mediumGroupCategories : MediumGroupCategoryShareOfVoiceDTO[] | null = null;
	static override get _properties():string[]{return ["company","mediumGroupCategories","dates","data","playerAggregation","_checkOwner","_type"];}
}
export class ApiKeyCreationInfoDTO extends DTO {
 	reference : ApiKeyDTO | null = null;
	apiKey : string | null = null;
	static override get _properties():string[]{return ["reference","apiKey","_checkOwner","_type"];}
}
export enum ThumbnailSize {
 	XS = "XS",
	S = "S",
	M = "M",
	L = "L",
	XL = "XL",
}
export class AttributeMapDTO extends DTO {
 	deviceAttributes : NamedIdentityDTO[] | null = null;
	locationAttributes : NamedIdentityDTO[] | null = null;
	companyAttributes : NamedIdentityDTO[] | null = null;
	productAttributes : NamedIdentityDTO[] | null = null;
	mediumGroupAttributes : NamedIdentityDTO[] | null = null;
	static override get _properties():string[]{return ["deviceAttributes","locationAttributes","companyAttributes","productAttributes","mediumGroupAttributes","_checkOwner","_type"];}
}
export class AdvertiserShareOfVoiceDTO extends ShareOfVoiceDTO {
 	advertiser : ClientDTO | null = null;
	companies : CompanyShareOfVoiceDTO[] | null = null;
	static override get _properties():string[]{return ["advertiser","companies","dates","data","playerAggregation","_checkOwner","_type"];}
}
export class UniqueVisitorAggregationDate {
 	count : number | null = null;
	count0 : number | null = null;
	count1 : number | null = null;
	count2 : number | null = null;
	count3 : number | null = null;
	count4 : number | null = null;
	count5 : number | null = null;
	count6 : number | null = null;
	count7 : number | null = null;
	count8 : number | null = null;
	count9 : number | null = null;
	count10 : number | null = null;
	count11 : number | null = null;
	count12 : number | null = null;
	count13 : number | null = null;
	count14 : number | null = null;
	count15 : number | null = null;
	count16 : number | null = null;
	count17 : number | null = null;
	count18 : number | null = null;
	count19 : number | null = null;
	count20 : number | null = null;
	count21 : number | null = null;
	count22 : number | null = null;
	count23 : number | null = null;
	static  get _properties():string[]{return ["count","count0","count1","count2","count3","count4","count5","count6","count7","count8","count9","count10","count11","count12","count13","count14","count15","count16","count17","count18","count19","count20","count21","count22","count23"];}
}
export class DiversifiedNamedIdentityWithCreatorDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	diversify : boolean | null = null;
	readonly level : number | null = null;
	priority : number | null = null;
	static override get _properties():string[]{return ["diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class NetworkShareDTO extends DiversifiedNamedIdentityWithCreatorDTO {
 	description : string | null = null;
	precondition : NetworkShareDTO | null = null;
	preconditionOf : NetworkShareDTO[] | null = null;
	playerCull : PlayerCullDTO | null = null;
	clientCull : ClientCullDTO | null = null;
	bookable : boolean | null = null;
	subletable : boolean | null = null;
	showOnlineStatus : boolean | null = null;
	showPlaylist : boolean | null = null;
	showPlayouts : boolean | null = null;
	showLogs : boolean | null = null;
	bookings : AccessOption | null = null;
	templateData : AccessOption | null = null;
	static override get _properties():string[]{return ["description","precondition","preconditionOf","playerCull","clientCull","bookable","subletable","showOnlineStatus","showPlaylist","showPlayouts","showLogs","bookings","templateData","diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class RoleDTO extends NamedIdentityWithCreatorDTO {
 	description : string | null = null;
	readonly custom : boolean | null = null;
	explicitPermissions : string[] | null = null;
	inheritedRoles : RoleDTO[] | null = null;
	readonly effectivePermissions : string[] | null = null;
	static override get _properties():string[]{return ["description","custom","explicitPermissions","inheritedRoles","effectivePermissions","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class LocalDateTimeRangeDTO extends DTO {
 	from : SbLocalDateTime | null = null;
	till : SbLocalDateTime | null = null;
	millis : number | null = null;
	static override get _properties():string[]{return ["from","till","millis","_checkOwner","_type"];}
}
export class IdentityArrayDTO extends DTO {
 	ids : any[] | null = null;
	static override get _properties():string[]{return ["ids","_checkOwner","_type"];}
}
export class SharedClientNetworkAccessDTO extends SharedByScreenDTO {
 	clientNetworkAccesses : ClientNetworkAccessDTO[] | null = null;
	static override get _properties():string[]{return ["clientNetworkAccesses","screens","identifier","_checkOwner","_type"];}
}
export class MediaFileInfo {
 	format : MediaFileFormat | null = null;
	streams : MediaFileStream[] | null = null;
	unmappedFields : any | null = null;
	static  get _properties():string[]{return ["format","streams","unmappedFields"];}
}
export class LocationTypeDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	global : boolean | null = null;
	parent : LocationTypeDTO | null = null;
	description : string | null = null;
	color : string | null = null;
	forceHierarchy : boolean | null = null;
	enforceHierarchy : boolean | null = null;
	readonly illustration : FixedAspectRatioImageDTO | null = null;
	static override get _properties():string[]{return ["global","parent","description","color","forceHierarchy","enforceHierarchy","illustration","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AreaDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	global : boolean | null = null;
	description : string | null = null;
	company : CompanyDTO | null = null;
	address : AddressDTO | null = null;
	points : PointDTO[] | null = null;
	lineStrings : LineStringDTO[] | null = null;
	polygons : PolygonDTO[] | null = null;
	category : AreaCategoryDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["global","description","company","address","points","lineStrings","polygons","category","attachmentCount","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediaFileTag {
 	major_brand : string | null = null;
	minor_version : string | null = null;
	compatible_brands : string | null = null;
	creation_time : string | null = null;
	language : string | null = null;
	handler_name : string | null = null;
	preview_progress : BigNumber | null = null;
	preview_frame : number | null = null;
	unmappedFields : any | null = null;
	static  get _properties():string[]{return ["major_brand","minor_version","compatible_brands","creation_time","language","handler_name","preview_progress","preview_frame","unmappedFields"];}
}
export enum TimingRelation {
 	WholePeriod = "WholePeriod",
	Day = "Day",
	Week = "Week",
	Month = "Month",
	Year = "Year",
}
export class InventoryGeoAggregationFrontendEnhancedDTO extends DTO {
 	data : InventoryGeoAggregationWithElementIdsDTO[] | null = null;
	clients : any | null = null;
	locations : any | null = null;
	channels : any | null = null;
	devices : any | null = null;
	markers : any | null = null;
	screens : any | null = null;
	static override get _properties():string[]{return ["data","clients","locations","channels","devices","markers","screens","_checkOwner","_type"];}
}
export enum ScreenshotFormat {
 	PNG = "PNG",
	JPG = "JPG",
}
export enum LocationOnlineStatus {
 	Unknown = "Unknown",
	AllOffline = "AllOffline",
	AllCurrentlyOffline = "AllCurrentlyOffline",
	AllOnline = "AllOnline",
	Offline = "Offline",
	Online = "Online",
	MostlyOffline = "MostlyOffline",
	MostlyOnline = "MostlyOnline",
}
export class DeviceSocketCommandLogStatisticDTO extends DTO {
 	commandStatistics : any | null = null;
	static override get _properties():string[]{return ["commandStatistics","_checkOwner","_type"];}
}
export enum DeviceOnlineStatus {
 	Unknown = "Unknown",
	Offline = "Offline",
	CurrentlyOffline = "CurrentlyOffline",
	Online = "Online",
	PlannedOffline = "PlannedOffline",
}
export class ApiKeyCreationDTO extends DTO {
 	name : string | null = null;
	expiry : SbDateTime | null = null;
	static override get _properties():string[]{return ["name","expiry","_checkOwner","_type"];}
}
export class PlayerCullDTO extends CullWithAtomsDTO {
 	override atoms : PlayerCullAtomDTO[] | null = null;
	staticElements : ScreenFullDTO[] | null = null;
	aggregation : PlayerAggregationDTO | null = null;
	static override get _properties():string[]{return ["atoms","staticElements","aggregation","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class HashDTO extends DTO {
 	kind : string | null = null;
	value : string | null = null;
	static override get _properties():string[]{return ["kind","value","_checkOwner","_type"];}
}
export class LocationAttributeDTO extends AttributeDTO {
 	override id: {
		datatype?:LocationAttributeDatatypeDTO;
		location?:LocationDTO
	} | null = null;
	datatype : LocationAttributeDatatypeDTO | null = null;
	static override get _properties():string[]{return ["datatype","value","lastUpdate","anchor","name","id","_checkOwner","_type"];}
}
export class ReportingSchedulingDTO extends NamedIdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly reportingSetup : ReportingSetupDTO | null = null;
	readonly dataFrom : SbDateTime | null = null;
	readonly dataTill : SbDateTime | null = null;
	readonly calculationAt : SbDateTime | null = null;
	static override get _properties():string[]{return ["createdAt","reportingSetup","dataFrom","dataTill","calculationAt","name","id","_checkOwner","_type"];}
}
export class ReportingSchedulingFullDTO extends ReportingSchedulingDTO {
 	static override get _properties():string[]{return ["createdAt","reportingSetup","dataFrom","dataTill","calculationAt","name","id","_checkOwner","_type"];}
}
export class CullGraphTreeNodeDTO extends DTO {
 	cull : CullDTO | null = null;
	id : string | null = null;
	nodeLabel : string | null = null;
	parentEdgeLabel : string | null = null;
	predecessors : CullGraphTreeNodeDTO[] | null = null;
	static override get _properties():string[]{return ["cull","id","nodeLabel","parentEdgeLabel","predecessors","_checkOwner","_type"];}
}
export class CampaignFullDTO extends CampaignDTO {
 	commercials : CommercialFullDTO[] | null = null;
	static override get _properties():string[]{return ["commercials","clientOrderNum","planning","overwrites","customer","campaignId","description","campaignType","bookingparameters","active","from","till","timingStatus","level","commercialCount","bookingStatus","budget","targeting","attachmentCount","playoutAggregation","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class VisitorTrackerScreenAssignmentDTO extends DTO {
 	tracker : number | null = null;
	screen : number | null = null;
	amount : number | null = null;
	static override get _properties():string[]{return ["tracker","screen","amount","_checkOwner","_type"];}
}
export class PlanningSubmissionDTO extends NamedIdentityWithCreatorDTO {
 	readonly description : string | null = null;
	readonly planning : PlanningDTO | null = null;
	readonly selectedFrom : SbLocalDateTime | null = null;
	readonly selectedTill : SbLocalDateTime | null = null;
	readonly selectedCampaignsCount : number | null = null;
	readonly selectedCommercialsCount : number | null = null;
	readonly selectedRequirementsCount : number | null = null;
	readonly selectedContentSharesCount : number | null = null;
	readonly deleteOtherPlannigs : boolean | null = null;
	static override get _properties():string[]{return ["description","planning","selectedFrom","selectedTill","selectedCampaignsCount","selectedCommercialsCount","selectedRequirementsCount","selectedContentSharesCount","deleteOtherPlannigs","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TemplateEntryWithCreatorDTO extends TemplateEntryDTO {
 	readonly createdBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["createdBy","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class TemplateDataSetDTO extends NamedIdentityWithCreatorDTO {
 	client : ClientDTO | null = null;
	group : TemplateGroupDTO | null = null;
	static override get _properties():string[]{return ["client","group","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class FreeTextFieldReference extends FieldReference {
 	values : any[] | null = null;
	autocomplete : string | null = null;
	static override get _properties():string[]{return ["values","autocomplete","type","requires","order","_checkOwner","_type"];}
}
export class GeoByGeoCullAtomDTO extends ChainedGeoCullAtomDTO {
 	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class NetworkAccessPatternDTO extends DTO {
 	bookable : boolean | null = null;
	subletable : boolean | null = null;
	onlineStatusAccess : boolean | null = null;
	playlistAccess : boolean | null = null;
	playoutAccess : boolean | null = null;
	logAccess : boolean | null = null;
	bookingRead : boolean | null = null;
	bookingManage : boolean | null = null;
	templateEntryRead : boolean | null = null;
	templateEntryManage : boolean | null = null;
	static override get _properties():string[]{return ["bookable","subletable","onlineStatusAccess","playlistAccess","playoutAccess","logAccess","bookingRead","bookingManage","templateEntryRead","templateEntryManage","_checkOwner","_type"];}
}
export class PlayerHardwareDTO extends NamedIdentityDTO {
 	global : boolean | null = null;
	readonly createdAt : SbDateTime | null = null;
	description : string | null = null;
	color : string | null = null;
	os : string | null = null;
	version : string | null = null;
	manufacturer : CompanyDTO | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	readonly depiction : FixedAspectRatioImageDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["global","createdAt","description","color","os","version","manufacturer","logo","depiction","attachmentCount","name","id","_checkOwner","_type"];}
}
export class TemplateStoreDataDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly id : number | null = null;
	readonly client : ClientDTO | null = null;
	readonly medium : MediumDTO | null = null;
	templateStore : TemplateStoreDTO | null = null;
	name : string | null = null;
	description : string | null = null;
	value : string | null = null;
	static override get _properties():string[]{return ["id","client","medium","templateStore","name","description","value","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TemplateDataSetSourceSubscriptionDTO extends TemplateDistributionConfigurationDTO {
 	id : TemplateDataSetSourceSubscriptionKeyDTO | null = null;
	static override get _properties():string[]{return ["id","geoCull","timeCull","playerCull","stateSpaceCull","verified","rejected","_checkOwner","_type"];}
}
export class Vast {
 }
export class ReportingDTO extends NamedIdentityDTO {
 	readonly status : ReportingStatus | null = null;
	readonly createdAt : SbDateTime | null = null;
	readonly calculationStartedAt : SbDateTime | null = null;
	readonly calculationFailedAt : SbDateTime | null = null;
	readonly calculationFinishedAt : SbDateTime | null = null;
	readonly renderingStartedAt : SbDateTime | null = null;
	readonly renderingFailedAt : SbDateTime | null = null;
	readonly renderingFinishedAt : SbDateTime | null = null;
	readonly playerCullGroup : PlayerCullDTO | null = null;
	readonly clientCullGroup : ClientCullDTO | null = null;
	readonly contentCullGroup : ContentCullDTO | null = null;
	readonly timeCullGroup : TimeCullDTO | null = null;
	readonly geoCullGroup : GeoCullDTO | null = null;
	static override get _properties():string[]{return ["status","createdAt","calculationStartedAt","calculationFailedAt","calculationFinishedAt","renderingStartedAt","renderingFailedAt","renderingFinishedAt","playerCullGroup","clientCullGroup","contentCullGroup","timeCullGroup","geoCullGroup","name","id","_checkOwner","_type"];}
}
export class ReportingFullDTO extends ReportingDTO {
 	readonly files : ReportingFileDTO[] | null = null;
	static override get _properties():string[]{return ["files","status","createdAt","calculationStartedAt","calculationFailedAt","calculationFinishedAt","renderingStartedAt","renderingFailedAt","renderingFinishedAt","playerCullGroup","clientCullGroup","contentCullGroup","timeCullGroup","geoCullGroup","name","id","_checkOwner","_type"];}
}
export class InventoryFieldValueDTO extends DTO {
 	value : any | null = null;
	displayValue : any | null = null;
	static override get _properties():string[]{return ["value","displayValue","_checkOwner","_type"];}
}
export class PublisherShareOfVoiceDTO extends ShareOfVoiceDTO {
 	static override get _properties():string[]{return ["dates","data","playerAggregation","_checkOwner","_type"];}
}
export class LocalizedFrameDTO extends DTO {
 	range : LocalDateTimeRangeDTO | null = null;
	data : any | null = null;
	static override get _properties():string[]{return ["range","data","_checkOwner","_type"];}
}
export class DiversifiedNamedIdentityWithRequirementFiltersDTO extends DiversifiedNamedIdentityWithIdentifierAndCreatorDTO {
 	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	playerAggregation : PlayerAggregationDTO | null = null;
	static override get _properties():string[]{return ["timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","diversify","level","priority","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class RequirementDTO extends DiversifiedNamedIdentityWithRequirementFiltersDTO {
 	description : string | null = null;
	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	precondition : RequirementDTO | null = null;
	readonly customer : NamedIdentityDTO | null = null;
	active : boolean | null = null;
	readonly mediumGroups : MediumGroupDTO[] | null = null;
	readonly previewMedia : PublicMediumDTO[] | null = null;
	readonly actualPlayouts : number | null = null;
	readonly actualSecondsPlayed : number | null = null;
	readonly bookingStatus : any | null = null;
	playoutAggregation : PlayoutAggregationDTO | null = null;
	assignedMediumGroup : MediumGroupDTO | null = null;
	assignedTemplateDataSet : TemplateDataSetDTO | null = null;
	assignedTemplateDataSetEntry : TemplateDataSetEntryDTO | null = null;
	autoBook : boolean | null = null;
	static override get _properties():string[]{return ["description","planning","overwrites","precondition","customer","active","mediumGroups","previewMedia","actualPlayouts","actualSecondsPlayed","bookingStatus","playoutAggregation","assignedMediumGroup","assignedTemplateDataSet","assignedTemplateDataSetEntry","autoBook","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","diversify","level","priority","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class RequirementFullDTO extends RequirementDTO {
 	preconditionOf : RequirementFullDTO[] | null = null;
	bookings : BookingDTO[] | null = null;
	static override get _properties():string[]{return ["preconditionOf","bookings","description","planning","overwrites","precondition","customer","active","mediumGroups","previewMedia","actualPlayouts","actualSecondsPlayed","bookingStatus","playoutAggregation","assignedMediumGroup","assignedTemplateDataSet","assignedTemplateDataSetEntry","autoBook","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","diversify","level","priority","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class WordingDTO extends DTO {
 	entity : Entity | null = null;
	property : string | null = null;
	word : string | null = null;
	occurrences : number | null = null;
	static override get _properties():string[]{return ["entity","property","word","occurrences","_checkOwner","_type"];}
}
export class DeviceLicenseDTO extends LicenseDTO {
 	device : DeviceFullDTO | null = null;
	static override get _properties():string[]{return ["device","serial","issuedAt","uuid","application","type","domain","client","configuration","manuallyAssigned","inUse","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum LicenseType {
 	ScreenLicense = "ScreenLicense",
	ScreenMachineLicense = "ScreenMachineLicense",
	DeviceLicense = "DeviceLicense",
	DeviceMachineLicense = "DeviceMachineLicense",
}
export class MediaFileDisposition {
 	Default : number | null = null;
	dub : number | null = null;
	original : number | null = null;
	comment : number | null = null;
	lyrics : number | null = null;
	karaoke : number | null = null;
	forced : number | null = null;
	hearing_impaired : number | null = null;
	visual_impaired : number | null = null;
	clean_effects : number | null = null;
	attached_pic : number | null = null;
	unmappedFields : any | null = null;
	static  get _properties():string[]{return ["Default","dub","original","comment","lyrics","karaoke","forced","hearing_impaired","visual_impaired","clean_effects","attached_pic","unmappedFields"];}
}
export class ManagedUserDTO extends UserDTO {
 	readonly lastLogin : SbDateTime | null = null;
	readonly blocked : SbDateTime | null = null;
	email : string | null = null;
	static override get _properties():string[]{return ["lastLogin","blocked","email","firstname","lastname","avatar","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumGroupShareOfVoiceDTO extends ShareOfVoiceDTO {
 	mediumGroup : MediumGroupDTO | null = null;
	media : MediumShareOfVoiceDTO[] | null = null;
	static override get _properties():string[]{return ["mediumGroup","media","dates","data","playerAggregation","_checkOwner","_type"];}
}
export class PerThreadStatistic {
 	thread : ThreadDTO | null = null;
	countSeen : number | null = null;
	static  get _properties():string[]{return ["thread","countSeen"];}
}
export class InventoryMarkerFullDTO extends InventoryMarkerDTO {
 	client : InventoryClientDTO | null = null;
	channel : InventoryChannelDTO | null = null;
	static override get _properties():string[]{return ["client","channel","resolution","image","video","audio","html","sound","interactive","name","id","_checkOwner","_type"];}
}
export class PlayerByPlayerCullAtomDTO extends ChainedPlayerCullAtomDTO {
 	static override get _properties():string[]{return ["chainedCull","type","valid","operator","id","_checkOwner","_type"];}
}
export class TimeCullDTO extends CullWithAtomsDTO {
 	override atoms : TimeCullAtomDTO[] | null = null;
	staticElements : LocalDateTimeRangeDTO[] | null = null;
	currentlyValid : boolean | null = null;
	validTimeRanges : LocalDateTimeRangeDTO[] | null = null;
	static override get _properties():string[]{return ["atoms","staticElements","currentlyValid","validTimeRanges","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DiscussableBulkOptions {
 	linkedEntities : LinkedEntityDTO[] | null = null;
	static  get _properties():string[]{return ["linkedEntities"];}
}
export class MediumGroupCategoryShareOfVoiceDTO extends ShareOfVoiceDTO {
 	mediumGroupCategory : MediumGroupCategoryDTO | null = null;
	mediumGroups : MediumGroupShareOfVoiceDTO[] | null = null;
	subCategories : MediumGroupCategoryShareOfVoiceDTO[] | null = null;
	static override get _properties():string[]{return ["mediumGroupCategory","mediumGroups","subCategories","dates","data","playerAggregation","_checkOwner","_type"];}
}
export class OrderDescriptor {
 	field : string | null = null;
	order : Order | null = null;
	static  get _properties():string[]{return ["field","order"];}
}
export class ClientInfoDTO extends DTO {
 	createdAt : SbDateTime | null = null;
	client : ClientDTO | null = null;
	existingTypeInstance : string[] | null = null;
	missingTypeInstance : string[] | null = null;
	static override get _properties():string[]{return ["createdAt","client","existingTypeInstance","missingTypeInstance","_checkOwner","_type"];}
}
export enum TrackingTechnique {
 	Unknown = "Unknown",
	Study = "Study",
	Counting = "Counting",
	Turnstile = "Turnstile",
	OpticalBarrier = "OpticalBarrier",
	LiDARScanner = "LiDARScanner",
	ThermalImage = "ThermalImage",
	CameraImage = "CameraImage",
	BluetoothBeacon = "BluetoothBeacon",
	WLANTracker = "WLANTracker",
	WLANAccessPoint = "WLANAccessPoint",
	ProcessData = "ProcessData",
}
export class AssetFileDTO extends NamedIdentityWithIdentifierDTO {
 	size : number | null = null;
	link : string | null = null;
	thumbnailLink : string | null = null;
	mimeType : string | null = null;
	resolution : ResolutionDTO | null = null;
	static override get _properties():string[]{return ["size","link","thumbnailLink","mimeType","resolution","identifier","name","id","_checkOwner","_type"];}
}
export class AssetFileFullDTO extends AssetFileDTO {
 	asset : AssetDTO | null = null;
	static override get _properties():string[]{return ["asset","size","link","thumbnailLink","mimeType","resolution","identifier","name","id","_checkOwner","_type"];}
}
export class InventoryFieldValueAggregationDTO extends InventoryFieldValueDTO {
 	aggregation : InventoryAggregationDTO | null = null;
	static override get _properties():string[]{return ["aggregation","value","displayValue","_checkOwner","_type"];}
}
export enum AuthenticationType {
 	NATIVE = "NATIVE",
	CREDENTIALS = "CREDENTIALS",
	IDP = "IDP",
	API_KEY = "API_KEY",
	CERTIFICATE = "CERTIFICATE",
}
export class VisitorTrackerScreenAssignmentsDTO extends DTO {
 	location : LocationDTO | null = null;
	trackers : VisitorTrackerFullDTO[] | null = null;
	screens : ScreenFullDTO[] | null = null;
	assignments : VisitorTrackerScreenAssignmentDTO[] | null = null;
	static override get _properties():string[]{return ["location","trackers","screens","assignments","_checkOwner","_type"];}
}
export class PlayoutparametersDTO extends DTO {
 	secondsToNextPlay : number | null = null;
	duration : number | null = null;
	dailyPlayouts : number | null = null;
	static override get _properties():string[]{return ["secondsToNextPlay","duration","dailyPlayouts","_checkOwner","_type"];}
}
export class InventoryAggregationDTO extends InventoryIdentityDescriptorDTO {
 	publishers : number | null = null;
	locations : number | null = null;
	channels : number | null = null;
	devices : number | null = null;
	markers : number | null = null;
	screens : number | null = null;
	pools : number | null = null;
	static override get _properties():string[]{return ["publishers","locations","channels","devices","markers","screens","pools","descriptorId","_checkOwner","_type"];}
}
export class StackTraceElementDTO extends DTO {
 	fileName : string | null = null;
	className : string | null = null;
	methodName : string | null = null;
	lineNumber : number | null = null;
	static override get _properties():string[]{return ["fileName","className","methodName","lineNumber","_checkOwner","_type"];}
}
export class AttributeValueDTO extends DTO {
 	value : string | null = null;
	lastUpdate : SbDateTime | null = null;
	static override get _properties():string[]{return ["value","lastUpdate","_checkOwner","_type"];}
}
export class ClientConnectionEstablishmentRequestDTO extends DTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly requested : InventoryClientDTO | null = null;
	static override get _properties():string[]{return ["createdAt","requested","_checkOwner","_type"];}
}
export class ClientCullDTO extends CullWithAtomsDTO {
 	override atoms : ClientCullAtomDTO[] | null = null;
	staticElements : ClientDTO[] | null = null;
	companyAllowed : boolean | null = null;
	aggregation : ClientAggregationDTO | null = null;
	static override get _properties():string[]{return ["atoms","staticElements","companyAllowed","aggregation","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class FixedAspectRatioImageBaseDTO extends NamedIdentityWithCreatorDTO {
 	readonly fileName : string | null = null;
	readonly url : ThumbnailableFileLink | null = null;
	static override get _properties():string[]{return ["fileName","url","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum AttachmentType {
 	UPLOAD = "UPLOAD",
	LINK = "LINK",
}
export class InventoryFilterValueListRequestDTO extends FilterableInventoryRequestDTO {
 	selection : InventoryFieldDTO | null = null;
	static override get _properties():string[]{return ["selection","filters","whitelistPolygons","blacklistPolygons","playerCulls","geoCulls","descriptorId","_checkOwner","_type"];}
}
export class ContentCullDTO extends CullWithAtomsDTO {
 	override atoms : ContentCullAtomDTO[] | null = null;
	staticElements : BookingFullDTO[] | null = null;
	aggregation : ContentAggregationDTO | null = null;
	static override get _properties():string[]{return ["atoms","staticElements","aggregation","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class BudgetDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly planning : boolean | null = null;
	readonly overwrites : BudgetDTO | null = null;
	readonly customer : NamedIdentityDTO | null = null;
	description : string | null = null;
	currency : CurrencyDTO | null = null;
	amount : number | null = null;
	relation : TimingRelation | null = null;
	maxCPM : number | null = null;
	maxCPMDuration : number | null = null;
	maxCPS : number | null = null;
	static override get _properties():string[]{return ["planning","overwrites","customer","description","currency","amount","relation","maxCPM","maxCPMDuration","maxCPS","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CalendarDTO extends NamedIdentityWithCreatorGlobalAndClientBoundDTO {
 	readonly type : CalendarTypeDTO | null = null;
	static override get _properties():string[]{return ["type","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CalendarFullDTO extends CalendarDTO {
 	category : CalendarCategoryDTO | null = null;
	static override get _properties():string[]{return ["category","type","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumGroupFullDTO extends MediumGroupDTO {
 	attributes : MediumGroupAttributeDTO[] | null = null;
	media : GroupMediumDTO[] | null = null;
	readonly promotedProducts : ProductDTO[] | null = null;
	readonly promotedProductCategories : ProductCategoryDTO[] | null = null;
	static override get _properties():string[]{return ["attributes","media","promotedProducts","promotedProductCategories","identifier","company","description","color","folder","preview","category","mediaCount","usageCount","templateGroup","asset","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class StaticPlaylistSlotDTO extends DTO {
 	bookingId : number | null = null;
	index : number | null = null;
	slot : number | null = null;
	duration : number | null = null;
	delivered : boolean | null = null;
	played : boolean | null = null;
	static override get _properties():string[]{return ["bookingId","index","slot","duration","delivered","played","_checkOwner","_type"];}
}
export class ScreenFullDTO extends OwnedScreenDTO {
 	device : DeviceDTO | null = null;
	static override get _properties():string[]{return ["device","hardware","machineCode","mediumTransformation","marker","name","id","_checkOwner","_type"];}
}
export class CompanyAttributeDTO extends AttributeDTO {
 	override id: {
		datatype?:CompanyAttributeDatatypeDTO;
		company?:CompanyDTO
	} | null = null;
	datatype : CompanyAttributeDatatypeDTO | null = null;
	static override get _properties():string[]{return ["datatype","value","lastUpdate","anchor","name","id","_checkOwner","_type"];}
}
export enum DeviceCommand {
 	Error = "Error",
	Playlist = "Playlist",
	Commercials = "Commercials",
	Setlist = "Setlist",
	News = "News",
	Categories = "Categories",
	CommercialPlayed = "CommercialPlayed",
	Interaction = "Interaction",
	PositionUpdate = "PositionUpdate",
	DeviceInfoRequest = "DeviceInfoRequest",
	DeviceInfo = "DeviceInfo",
	Areas = "Areas",
	WhitelistAreas = "WhitelistAreas",
	Messages = "Messages",
	Log = "Log",
	Shell = "Shell",
	ApplicationSettings = "ApplicationSettings",
	Ping = "Ping",
	VersionInformation = "VersionInformation",
	BookingtimeDefinitions = "BookingtimeDefinitions",
	DeviceAttributeRequest = "DeviceAttributeRequest",
	DeviceAttributeInstruction = "DeviceAttributeInstruction",
	CommercialsOnDevice = "CommercialsOnDevice",
	BookingSetlist = "BookingSetlist",
	Bookings = "Bookings",
	BookingPlaylist = "BookingPlaylist",
	BookingPlayed = "BookingPlayed",
	Filters = "Filters",
	ExitPlayer = "ExitPlayer",
	RebootSystem = "RebootSystem",
	TemplateFillings = "TemplateFillings",
	TemplateEntries = "TemplateEntries",
	TemplateGroups = "TemplateGroups",
	TemplateFillingHashes = "TemplateFillingHashes",
	BookingPlayedConfirmation = "BookingPlayedConfirmation",
	EmptyPlaylistRanges = "EmptyPlaylistRanges",
	ClearLocalData = "ClearLocalData",
	ClearSettings = "ClearSettings",
	Unpair = "Unpair",
	ShowCalibrationImage = "ShowCalibrationImage",
	HideCalibrationImage = "HideCalibrationImage",
	TemplateFillingHashesFullList = "TemplateFillingHashesFullList",
	DEBUG_Error = "DEBUG_Error",
	DEBUG_BookingPlaylist = "DEBUG_BookingPlaylist",
}
export class AggregatedPlaylistSchemaIterationDTO extends DTO {
 	index : number | null = null;
	repetition : number | null = null;
	slots : AggregatedPlaylistSchemaIterationSlotDTO[] | null = null;
	static override get _properties():string[]{return ["index","repetition","slots","_checkOwner","_type"];}
}
export class CampaignWithPreviewDTO extends CampaignDTO {
 	preview : PublicMediumDTO[] | null = null;
	static override get _properties():string[]{return ["preview","clientOrderNum","planning","overwrites","customer","campaignId","description","campaignType","bookingparameters","active","from","till","timingStatus","level","commercialCount","bookingStatus","budget","targeting","attachmentCount","playoutAggregation","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CalendarEntryMetaDataFullDTO extends CalendarEntryMetaDataDTO {
 	calendarEntry : CalendarEntryDTO | null = null;
	datatype : CalendarEntryMetaDataTypeDTO | null = null;
	static override get _properties():string[]{return ["calendarEntry","datatype","id","value","_checkOwner","_type"];}
}
export class AttachmentCountDTO extends DTO {
 	readonly publicAttachmentCount : number | null = null;
	readonly attachmentCount : number | null = null;
	static override get _properties():string[]{return ["publicAttachmentCount","attachmentCount","_checkOwner","_type"];}
}
export class TopicDTO extends ModifiableIdentityWithCreatorDTO {
 	title : string | null = null;
	text : string | null = null;
	readonly entity : LinkedEntityDTO | null = null;
	doneAt : SbDateTime | null = null;
	readonly participants : UserDTO[] | null = null;
	readonly lastParticipation : PostDTO | null = null;
	readonly pinnedPost : PostDTO | null = null;
	readonly solution : PostDTO | null = null;
	mentions : UserDTO[] | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["title","text","entity","doneAt","participants","lastParticipation","pinnedPost","solution","mentions","attachmentCount","modifiedAt","modifiedBy","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class LocationFullShortAttributeDTO extends OwnedLocationBaseDTO {
 	attributes : any | null = null;
	serviceHours : ServiceHourDTO[] | null = null;
	managedBy : CompanyFullShortAttributeDTO | null = null;
	static override get _properties():string[]{return ["attributes","serviceHours","managedBy","onlineStatus","countDevices","countDevicesProductive","countVisitorTracker","countVisitorTrackerProductive","identifier","locationType","logo","headerImage","address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class VisitorAudienceTranslationDTO extends NamedIdentityWithCreatorDTO {
 	readonly client : ClientDTO | null = null;
	regressionModel : string | null = null;
	mediaExposureFactor : number | null = null;
	visitorAudienceImpressionTranslations : VisitorAudienceImpressionTranslationDTO[] | null = null;
	static override get _properties():string[]{return ["client","regressionModel","mediaExposureFactor","visitorAudienceImpressionTranslations","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ProductAttributeDatatypeDTO extends AttributeDatatypeDTO {
 	static override get _properties():string[]{return ["description","customized","global","adPlacerAbleToSet","externalSynchronized","multiline","searchable","uniqueValues","askForConfirmation","usableForFilters","disclosedToPublic","forceRegEx","defaultValue","allowedValues","allowedValuesMinCount","allowedValuesMaxCount","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumTransformationDTO extends NamedIdentityWithCreatorGlobalAndClientBoundDTO {
 	description : string | null = null;
	command : string | null = null;
	static override get _properties():string[]{return ["description","command","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DeviceTripDTO extends IdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly start : SbDateTime | null = null;
	readonly end : SbDateTime | null = null;
	readonly roms : PolygonDTO[] | null = null;
	readonly routes : LineStringDTO[] | null = null;
	readonly parts : DeviceTripPartDTO[] | null = null;
	static override get _properties():string[]{return ["createdAt","start","end","roms","routes","parts","id","_checkOwner","_type"];}
}
export class DeviceFullShortAttributeDTO extends OwnedDeviceBaseDTO {
 	readonly lastPairing : DeviceLogDTO | null = null;
	readonly attributes : any | null = null;
	readonly serviceFulfilled : NotificationDTO | null = null;
	readonly publisher : ClientDTO | null = null;
	location : LocationFullShortAttributeDTO | null = null;
	readonly serviceHours : ServiceHourDTO[] | null = null;
	static override get _properties():string[]{return ["lastPairing","attributes","serviceFulfilled","publisher","location","serviceHours","notes","lastOnline","screens","lastIP","connected","productive","offline","external","disabled","paired","proposed","pool","serviceRequest","position","homeArea","whitelistArea","positionValidityDuration","channel","onlineStatus","hardware","software","machineCode","currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryScreenHardwareDTO extends NamedIdentityDTO {
 	width : number | null = null;
	height : number | null = null;
	diagonal : number | null = null;
	nativeResolution : ResolutionDTO | null = null;
	static override get _properties():string[]{return ["width","height","diagonal","nativeResolution","name","id","_checkOwner","_type"];}
}
export class TemplateSourceEntryDTO extends TemplateEntryWithCreatorDTO {
 	validTill : SbLocalDateTime | null = null;
	validFrom : SbLocalDateTime | null = null;
	static override get _properties():string[]{return ["validTill","validFrom","createdBy","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class PlayoutImpressionReportDataDTO extends DTO {
 	date : SbLocalDate | null = null;
	totalPlayouts : number | null = null;
	totalPlaybacktime : number | null = null;
	totalVisitors : number | null = null;
	totalUniqueVisitors : number | null = null;
	totalImpressions : number | null = null;
	hoursPlayouts : number[] | null = null;
	hoursPlaybacktime : number[] | null = null;
	hoursVisitors : number[] | null = null;
	hoursUniqueVisitors : number[] | null = null;
	hoursImpressions : number[] | null = null;
	static override get _properties():string[]{return ["date","totalPlayouts","totalPlaybacktime","totalVisitors","totalUniqueVisitors","totalImpressions","hoursPlayouts","hoursPlaybacktime","hoursVisitors","hoursUniqueVisitors","hoursImpressions","_checkOwner","_type"];}
}
export class CampaignReportDataDTO extends PlayoutImpressionReportDataDTO {
 	totalScreens : number | null = null;
	static override get _properties():string[]{return ["totalScreens","date","totalPlayouts","totalPlaybacktime","totalVisitors","totalUniqueVisitors","totalImpressions","hoursPlayouts","hoursPlaybacktime","hoursVisitors","hoursUniqueVisitors","hoursImpressions","_checkOwner","_type"];}
}
export class SharedAssetRepositoryDTO extends AssetRepositoryBaseDTO {
 	assetCount : number | null = null;
	sharedBy : InventoryClientDTO | null = null;
	static override get _properties():string[]{return ["assetCount","sharedBy","description","shareEnd","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class EntityDTO extends DTO {
 	readonly entity : Entity | null = null;
	object : Serializable | null = null;
	static override get _properties():string[]{return ["entity","object","_checkOwner","_type"];}
}
export class DeviceTripFullDTO extends DeviceTripDTO {
 	readonly device : DeviceDTO | null = null;
	static override get _properties():string[]{return ["device","createdAt","start","end","roms","routes","parts","id","_checkOwner","_type"];}
}
export class GroupedThreads {
 	groups : any | null = null;
	stackTraceElementCounts : any | null = null;
	static  get _properties():string[]{return ["groups","stackTraceElementCounts"];}
}
export class PlayoutImpressionReportEntryDTO extends DTO {
 	medium : Serializable | null = null;
	channel : Serializable | null = null;
	marker : Serializable | null = null;
	static override get _properties():string[]{return ["medium","channel","marker","_checkOwner","_type"];}
}
export class VisitorTrackerScreenDTO extends VisitorTrackerScreenBaseDTO {
 	screen : ScreenDTO | null = null;
	visitorTracker : VisitorTrackerDTO | null = null;
	static override get _properties():string[]{return ["screen","visitorTracker","amount","_checkOwner","_type"];}
}
export class CommandQueueManagerDTO extends DTO {
 	command : DeviceCommand | null = null;
	minThreads : number | null = null;
	maxThreads : number | null = null;
	threadCount : number | null = null;
	threadStates : any | null = null;
	queueLength : number | null = null;
	static override get _properties():string[]{return ["command","minThreads","maxThreads","threadCount","threadStates","queueLength","_checkOwner","_type"];}
}
export class MediumGroupFolderDTO extends FolderDTO {
 	mediumGroups : MediumGroupDTO[] | null = null;
	static override get _properties():string[]{return ["mediumGroups","description","company","parentFolder","elementsCount","elementsCountHierarchy","subfoldersCount","subfoldersCountHierarchy","subfolders","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class FrameDTO extends DTO {
 	range : DateTimeRangeDTO | null = null;
	data : any | null = null;
	static override get _properties():string[]{return ["range","data","_checkOwner","_type"];}
}
export class CoordinateClusterDTO extends DTO {
 	center : Point | null = null;
	radius : number | null = null;
	size : number | null = null;
	hull : Point[] | null = null;
	static override get _properties():string[]{return ["center","radius","size","hull","_checkOwner","_type"];}
}
export class CompanyAttributeDatatypeDTO extends AttributeDatatypeDTO {
 	static override get _properties():string[]{return ["description","customized","global","adPlacerAbleToSet","externalSynchronized","multiline","searchable","uniqueValues","askForConfirmation","usableForFilters","disclosedToPublic","forceRegEx","defaultValue","allowedValues","allowedValuesMinCount","allowedValuesMaxCount","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TopicFullDTO extends TopicDTO {
 	readonly posts : PostFullDTO[] | null = null;
	static override get _properties():string[]{return ["posts","title","text","entity","doneAt","participants","lastParticipation","pinnedPost","solution","mentions","attachmentCount","modifiedAt","modifiedBy","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class NetworkPriceModelDTO extends DiversifiedNamedIdentityWithCreatorDTO {
 	description : string | null = null;
	precondition : NetworkPriceModelDTO | null = null;
	preconditionOf : NetworkPriceModelDTO[] | null = null;
	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	currency : CurrencyDTO | null = null;
	minCPM : number | null = null;
	minCPMDuration : number | null = null;
	minCPS : number | null = null;
	static override get _properties():string[]{return ["description","precondition","preconditionOf","timeCull","playerCull","geoCull","stateSpaceCull","currency","minCPM","minCPMDuration","minCPS","diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumWithMediaFileInfo {
 	medium : MediumDTO | null = null;
	mediaFileInfo : MediaFileInfo | null = null;
	static  get _properties():string[]{return ["medium","mediaFileInfo"];}
}
export class ChangeUsernameDTO extends DTO {
 	newUsername : string | null = null;
	static override get _properties():string[]{return ["newUsername","_checkOwner","_type"];}
}
export class PlayerAggregationDTO extends CullAggregationDTO {
 	scope : ScreenScope | null = null;
	publishers : number | null = null;
	locations : number | null = null;
	channels : number | null = null;
	markers : number | null = null;
	devices : number | null = null;
	screens : number | null = null;
	static override get _properties():string[]{return ["scope","publishers","locations","channels","markers","devices","screens","_checkOwner","_type"];}
}
export class TemplateDataSetEntryDTO extends TemplateEntryWithCreatorDTO {
 	validTill : SbLocalDateTime | null = null;
	validFrom : SbLocalDateTime | null = null;
	verified : boolean | null = null;
	rejected : boolean | null = null;
	geoCull : GeoCullDTO | null = null;
	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	static override get _properties():string[]{return ["validTill","validFrom","verified","rejected","geoCull","timeCull","playerCull","stateSpaceCull","createdBy","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class TemplateDataSetEntryWithDataSetDTO extends TemplateDataSetEntryDTO {
 	dataSet : TemplateDataSetDTO | null = null;
	static override get _properties():string[]{return ["dataSet","validTill","validFrom","verified","rejected","geoCull","timeCull","playerCull","stateSpaceCull","createdBy","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class TemplateDataSetEntryWithScreenEntryAggregationDTO extends TemplateDataSetEntryWithDataSetDTO {
 	screenEntryAggregation : ScreenEntryAggregationDTO | null = null;
	static override get _properties():string[]{return ["screenEntryAggregation","dataSet","validTill","validFrom","verified","rejected","geoCull","timeCull","playerCull","stateSpaceCull","createdBy","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export enum ScreenScope {
 	ALL = "ALL",
	BOOKABLE = "BOOKABLE",
	OWNED = "OWNED",
	SUBLETABLE = "SUBLETABLE",
	ONLINE_STATUS_ACCESS = "ONLINE_STATUS_ACCESS",
	PLAYLIST_ACCESS = "PLAYLIST_ACCESS",
	PLAYOUT_ACCESS = "PLAYOUT_ACCESS",
	LOG_ACCESS = "LOG_ACCESS",
	BOOKING_READ = "BOOKING_READ",
	BOOKING_MANAGE = "BOOKING_MANAGE",
	TEMPLATE_ENTRY_READ = "TEMPLATE_ENTRY_READ",
	TEMPLATE_ENTRY_MANAGE = "TEMPLATE_ENTRY_MANAGE",
}
export class AddressDTO extends DTO {
 	borough : string | null = null;
	city : string | null = null;
	country : string | null = null;
	county : string | null = null;
	state : string | null = null;
	street : string | null = null;
	street2 : string | null = null;
	zip : string | null = null;
	tags : string | null = null;
	position : Point | null = null;
	static override get _properties():string[]{return ["borough","city","country","county","state","street","street2","zip","tags","position","_checkOwner","_type"];}
}
export class ReportingTypeDTO extends NamedIdentityDTO {
 	readonly parameterTypeDefinition : string | null = null;
	readonly returnTypeDefinition : string | null = null;
	readonly defaultTemplate : ReportingTemplateDTO | null = null;
	readonly playerCullAllowed : boolean | null = null;
	readonly clientCullAllowed : boolean | null = null;
	readonly timeCullAllowed : boolean | null = null;
	readonly contentCullAllowed : boolean | null = null;
	readonly geoCullAllowed : boolean | null = null;
	readonly createsTemplatedReport : boolean | null = null;
	readonly createsRawDataReport : boolean | null = null;
	readonly rawDataReports : any | null = null;
	static override get _properties():string[]{return ["parameterTypeDefinition","returnTypeDefinition","defaultTemplate","playerCullAllowed","clientCullAllowed","timeCullAllowed","contentCullAllowed","geoCullAllowed","createsTemplatedReport","createsRawDataReport","rawDataReports","name","id","_checkOwner","_type"];}
}
export class ScreenEntryAggregationDTO extends DTO {
 	countRejected : number | null = null;
	count : number | null = null;
	firstRejectedAt : SbDateTime | null = null;
	static override get _properties():string[]{return ["countRejected","count","firstRejectedAt","_checkOwner","_type"];}
}
export class PlayoutAggregationDTO extends DTO {
 	productivePlayouts : number | null = null;
	productivePlaybacktime : number | null = null;
	nonProductivePlayouts : number | null = null;
	nonProductivePlaybacktime : number | null = null;
	static override get _properties():string[]{return ["productivePlayouts","productivePlaybacktime","nonProductivePlayouts","nonProductivePlaybacktime","_checkOwner","_type"];}
}
export class ProductFullShortAttributeDTO extends ProductBaseDTO {
 	attributes : any | null = null;
	serviceHours : ServiceHourDTO[] | null = null;
	managedBy : CompanyFullShortAttributeDTO | null = null;
	static override get _properties():string[]{return ["attributes","serviceHours","managedBy","description","color","gtin","gtinRepresentation","plu","asin","manufacturer","depiction","attachmentCount","identifier","name","id","_checkOwner","_type"];}
}
export class FixedAspectRatioImageDTO extends FixedAspectRatioImageBaseDTO {
 	readonly resolution : ResolutionDTO | null = null;
	readonly size : number | null = null;
	readonly hash : HashDTO | null = null;
	readonly clipped : ThumbnailableFileLink | null = null;
	readonly original : ThumbnailableFileLink | null = null;
	readonly clippedResolution : ResolutionDTO | null = null;
	clippingTLX : number | null = null;
	clippingTLY : number | null = null;
	clippingBRX : number | null = null;
	clippingBRY : number | null = null;
	readonly definition : FixedAspectRatioImageDefinitionDTO | null = null;
	static override get _properties():string[]{return ["resolution","size","hash","clipped","original","clippedResolution","clippingTLX","clippingTLY","clippingBRX","clippingBRY","definition","fileName","url","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CampaignLevelDTO extends NamedIdentityDTO {
 	override id: {
		client?:ClientDTO;
		company?:CompanyDTO;
		level?:number
	} | null = null;
	description : string | null = null;
	static override get _properties():string[]{return ["description","name","id","_checkOwner","_type"];}
}
export class CampaignReportElementCountDTO extends ElementCountDTO {
 	data : CampaignReportElementCountDataDTO[] | null = null;
	static override get _properties():string[]{return ["data","type","id","_checkOwner","_type"];}
}
export class DisplayableValueDTO extends DTO {
 	display : Serializable | null = null;
	value : Serializable | null = null;
	static override get _properties():string[]{return ["display","value","_checkOwner","_type"];}
}
export class ProductDTO extends ProductBaseDTO {
 	static override get _properties():string[]{return ["description","color","gtin","gtinRepresentation","plu","asin","manufacturer","depiction","attachmentCount","identifier","name","id","_checkOwner","_type"];}
}
export class MediumGroupCategoryDTO extends NestedNamedIdentityCreatorGlobalAndClientBoundDTO {
 	company : CompanyDTO | null = null;
	static override get _properties():string[]{return ["company","parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum DisplayType {
 	IFRAME = "IFRAME",
	EMBED = "EMBED",
	LINK = "LINK",
}
export class CronDefinitionDTO extends NamedIdentityDTO {
 	global : boolean | null = null;
	description : string | null = null;
	minute : string | null = null;
	hour : string | null = null;
	dayOfMonth : string | null = null;
	month : string | null = null;
	dayOfWeek : string | null = null;
	readonly lastExecution : SbDateTime | null = null;
	readonly nextExecution : SbDateTime | null = null;
	readonly cronString : string | null = null;
	previewDateTime : SbDateTime | null = null;
	static override get _properties():string[]{return ["global","description","minute","hour","dayOfMonth","month","dayOfWeek","lastExecution","nextExecution","cronString","previewDateTime","name","id","_checkOwner","_type"];}
}
export class CronDefinitionFullDTO extends CronDefinitionDTO {
 	static override get _properties():string[]{return ["global","description","minute","hour","dayOfMonth","month","dayOfWeek","lastExecution","nextExecution","cronString","previewDateTime","name","id","_checkOwner","_type"];}
}
export class ClientNetworkAccessDTO extends DTO {
 	client : ClientDTO | null = null;
	accessPattern : NetworkAccessPatternDTO | null = null;
	static override get _properties():string[]{return ["client","accessPattern","_checkOwner","_type"];}
}
export class StrongBytesDescriptedPlayout {
 	id : number | null = null;
	location_id : number | null = null;
	location_identifier : string | null = null;
	location_name : string | null = null;
	device_id : number | null = null;
	device_identifier : string | null = null;
	channel_id : number | null = null;
	channel_name : string | null = null;
	marker_id : number | null = null;
	marker_name : string | null = null;
	screen_id : number | null = null;
	advertiser_id : number | null = null;
	advertiser_name : string | null = null;
	booking_id : number | null = null;
	medium_id : number | null = null;
	medium_name : string | null = null;
	medium_group_id : number | null = null;
	medium_group_name : string | null = null;
	product_identifiers : string[] | null = null;
	playouts : Serializable[][] | null = null;
	static  get _properties():string[]{return ["id","location_id","location_identifier","location_name","device_id","device_identifier","channel_id","channel_name","marker_id","marker_name","screen_id","advertiser_id","advertiser_name","booking_id","medium_id","medium_name","medium_group_id","medium_group_name","product_identifiers","playouts"];}
}
export class TargetingDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly planning : boolean | null = null;
	readonly overwrites : TargetingDTO | null = null;
	readonly customer : NamedIdentityDTO | null = null;
	description : string | null = null;
	target : TargetingType | null = null;
	relation : TimingRelation | null = null;
	amount : number | null = null;
	static override get _properties():string[]{return ["planning","overwrites","customer","description","target","relation","amount","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TemplateStoreDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly id : number | null = null;
	readonly client : ClientDTO | null = null;
	name : string | null = null;
	description : string | null = null;
	value : string | null = null;
	static override get _properties():string[]{return ["id","client","name","description","value","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class Result {
 	status : number | null = null;
	error : string | null = null;
	errorCode : number | null = null;
	success : boolean | null = null;
	message : string | null = null;
	data : any | null = null;
	pagination : Pagination | null = null;
	_type : string | null = null;
	static  get _properties():string[]{return ["status","error","errorCode","success","message","data","pagination","_type"];}
}
export class ProductFullDTO extends ProductBaseDTO {
 	attributes : ProductAttributeDTO[] | null = null;
	categories : ProductCategoryDTO[] | null = null;
	static override get _properties():string[]{return ["attributes","categories","description","color","gtin","gtinRepresentation","plu","asin","manufacturer","depiction","attachmentCount","identifier","name","id","_checkOwner","_type"];}
}
export enum BookingStatus {
 	Unknown = "Unknown",
	Editing = "Editing",
	Deleted = "Deleted",
	VerificationRequested = "VerificationRequested",
	Active = "Active",
	Rejected = "Rejected",
	PausedByCustomer = "PausedByCustomer",
	PausedInPoolByCustomer = "PausedInPoolByCustomer",
	CampaignEnded = "CampaignEnded",
	VerificationRevoked = "VerificationRevoked",
	CampaignNotStarted = "CampaignNotStarted",
	Paused = "Paused",
	Excluded = "Excluded",
	Proposed = "Proposed",
	VerificationNotRequested = "VerificationNotRequested",
	Deprecated = "Deprecated",
	PlanningCompleted = "PlanningCompleted",
}
export class InventoryLocationDTO extends LocationBaseDTO {
 	disclosedAttributes : LocationAttributeDTO[] | null = null;
	static override get _properties():string[]{return ["disclosedAttributes","identifier","locationType","logo","headerImage","address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class VisitorRecalculationParameters {
 	screenIds : number[] | null = null;
	static  get _properties():string[]{return ["screenIds"];}
}
export class ScreenOfflinePlaylistSlotDTO extends IdentifierDTO {
 	index : number | null = null;
	slot : ScreenOfflinePlaybackScheduleSlotDTO | null = null;
	booking : ScreenOfflineBookingDTO | null = null;
	static override get _properties():string[]{return ["index","slot","booking","identifier","_checkOwner","_type"];}
}
export class DayTimeHoursDTO extends DTO {
 	intervals : DayTimeIntervalDTO[] | null = null;
	static override get _properties():string[]{return ["intervals","_checkOwner","_type"];}
}
export class InventoryGeoAggregationDTO extends InventoryAggregationDTO {
 	center : Point | null = null;
	radius : number | null = null;
	size : number | null = null;
	hull : Point[] | null = null;
	static override get _properties():string[]{return ["center","radius","size","hull","publishers","locations","channels","devices","markers","screens","pools","descriptorId","_checkOwner","_type"];}
}
export class InventoryGeoAggregationWithElementIdsDTO extends InventoryGeoAggregationDTO {
 	publisherIds : Serializable[] | null = null;
	locationIds : Serializable[] | null = null;
	channelIds : Serializable[] | null = null;
	deviceIds : Serializable[] | null = null;
	markerIds : Serializable[] | null = null;
	screenIds : Serializable[] | null = null;
	static override get _properties():string[]{return ["publisherIds","locationIds","channelIds","deviceIds","markerIds","screenIds","center","radius","size","hull","publishers","locations","channels","devices","markers","screens","pools","descriptorId","_checkOwner","_type"];}
}
export class CampaignTypeDTO extends NamedIdentityDTO {
 	global : boolean | null = null;
	description : string | null = null;
	parent : CampaignTypeDTO | null = null;
	static override get _properties():string[]{return ["global","description","parent","name","id","_checkOwner","_type"];}
}
export class CampaignTypeHierarchyDTO extends CampaignTypeDTO {
 	children : CampaignTypeHierarchyDTO[] | null = null;
	static override get _properties():string[]{return ["children","global","description","parent","name","id","_checkOwner","_type"];}
}
export class RadialPolygonPathBasedGeoCullAtomDTO extends PathBasedGeoCullAtomDTO {
 	radius : number | null = null;
	unit : DistanceUnit | null = null;
	static override get _properties():string[]{return ["radius","unit","field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class AggregatedPlaylistDTO extends SharedByScreenAndTimeDTO {
 	playlist : AggregatedPlaylistSchemaDTO | null = null;
	static override get _properties():string[]{return ["playlist","ranges","screens","identifier","_checkOwner","_type"];}
}
export class PlayoutAggregationDataDTO extends DTO {
 	hourCount : number[] | null = null;
	hourTime : number[] | null = null;
	static override get _properties():string[]{return ["hourCount","hourTime","_checkOwner","_type"];}
}
export class TemplateGroupDTO extends NamedIdentityWithCreatorDTO {
 	requestResultInvalidationInterval : number | null = null;
	variables : TemplateVariableDTO[] | null = null;
	static override get _properties():string[]{return ["requestResultInvalidationInterval","variables","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum DistributionBasis {
 	Count = "Count",
	Time = "Time",
}
export class TagEntityDTO extends DTO {
 	readonly tag : TagDTO | null = null;
	readonly entity : LinkedEntityDTO | null = null;
	readonly createdAt : SbDateTime | null = null;
	readonly createdBy : NamedIdentityDTO | null = null;
	static override get _properties():string[]{return ["tag","entity","createdAt","createdBy","_checkOwner","_type"];}
}
export class SharedAssetFileFullDTO extends AssetFileDTO {
 	asset : SharedAssetDTO | null = null;
	static override get _properties():string[]{return ["asset","size","link","thumbnailLink","mimeType","resolution","identifier","name","id","_checkOwner","_type"];}
}
export class RenderedScreenPlaylistIterationDTO extends DTO {
 	createdAt : SbDateTime | null = null;
	slots : StaticPlaylistSlotDTO[] | null = null;
	static override get _properties():string[]{return ["createdAt","slots","_checkOwner","_type"];}
}
export class MediaFileStream {
 	index : number | null = null;
	codec_type : string | null = null;
	codec_name : string | null = null;
	width : number | null = null;
	height : number | null = null;
	coded_width : number | null = null;
	coded_height : number | null = null;
	codec_long_name : string | null = null;
	codec_time_base : string | null = null;
	codec_tag_string : string | null = null;
	codec_tag : string | null = null;
	r_frame_rate : string | null = null;
	avg_frame_rate : string | null = null;
	time_base : string | null = null;
	start_pts : number | null = null;
	start_time : number | null = null;
	duration_ts : number | null = null;
	duration : number | null = null;
	bit_rate : number | null = null;
	nb_frames : number | null = null;
	disposition : MediaFileDisposition | null = null;
	tags : MediaFileTag | null = null;
	unmappedFields : any | null = null;
	static  get _properties():string[]{return ["index","codec_type","codec_name","width","height","coded_width","coded_height","codec_long_name","codec_time_base","codec_tag_string","codec_tag","r_frame_rate","avg_frame_rate","time_base","start_pts","start_time","duration_ts","duration","bit_rate","nb_frames","disposition","tags","unmappedFields"];}
}
export class ProductAttributeDTO extends AttributeDTO {
 	override id: {
		datatype?:ProductAttributeDatatypeDTO;
		product?:ProductDTO
	} | null = null;
	datatype : ProductAttributeDatatypeDTO | null = null;
	static override get _properties():string[]{return ["datatype","value","lastUpdate","anchor","name","id","_checkOwner","_type"];}
}
export class TimeRangeDTO extends NamedIdentityDTO {
 	global : boolean | null = null;
	description : string | null = null;
	years : number | null = null;
	months : number | null = null;
	weeks : number | null = null;
	days : number | null = null;
	hours : number | null = null;
	minutes : number | null = null;
	nextDateTime : SbDateTime | null = null;
	previousDateTime : SbDateTime | null = null;
	previewDateTime : SbDateTime | null = null;
	static override get _properties():string[]{return ["global","description","years","months","weeks","days","hours","minutes","nextDateTime","previousDateTime","previewDateTime","name","id","_checkOwner","_type"];}
}
export class AuthenticationOptionDTO extends NamedIdentityDTO {
 	type : AuthenticationType | null = null;
	description : string | null = null;
	logoUrl : string | null = null;
	authUrl : string | null = null;
	static override get _properties():string[]{return ["type","description","logoUrl","authUrl","name","id","_checkOwner","_type"];}
}
export class ClientCreationDTO extends ClientDTO {
 	companyCreationInfo : CompanyDTO | null = null;
	static override get _properties():string[]{return ["companyCreationInfo","currency","primaryCompany","ssp","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class GroupMediumDTO extends MediumDTO {
 	isPreview : boolean | null = null;
	defaultMarkers : MarkerFullDTO[] | null = null;
	static override get _properties():string[]{return ["isPreview","defaultMarkers","description","processing","uploading","progress","locked","uploaded","original","templateStoreData","folder","usageCount","previewProgress","company","duration","contentType","fileName","format","resolution","size","hash","templateGroup","url","stillImage","publicUrl","assetFile","color","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class BookedMediumGroupAggregationGroupDTO extends AggregationGroupDTO {
 	mediumGroup : MediumGroupDTO | null = null;
	templateDataSet : TemplateDataSetDTO | null = null;
	templateDataSetEntry : TemplateDataSetEntryDTO | null = null;
	media : PublicMediumDTO[] | null = null;
	advertiser : InventoryClientDTO | null = null;
	static override get _properties():string[]{return ["mediumGroup","templateDataSet","templateDataSetEntry","media","advertiser","id","_checkOwner","_type"];}
}
export class ScreenConfiguration {
 	id : number | null = null;
	marker : MarkerInfo | null = null;
	static  get _properties():string[]{return ["id","marker"];}
}
export class GroupDTO extends NamedIdentityDTO {
 	static override get _properties():string[]{return ["name","id","_checkOwner","_type"];}
}
export class HourBasedReportingDTO extends DTO {
 	range : DateTimeRangeDTO | null = null;
	static override get _properties():string[]{return ["range","_checkOwner","_type"];}
}
export class RangeFieldReference extends FieldReference {
 	min : any | null = null;
	max : any | null = null;
	static override get _properties():string[]{return ["min","max","type","requires","order","_checkOwner","_type"];}
}
export class ClientPathBasedStructureCullAtomDTO extends ClientCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export enum Disposition {
 	inline = "inline",
	attachment = "attachment",
}
export class MediaFileFormat {
 	filename : string | null = null;
	nb_streams : number | null = null;
	nb_programs : number | null = null;
	format_name : string | null = null;
	format_long_name : string | null = null;
	start_time : number | null = null;
	duration : number | null = null;
	size : number | null = null;
	probe_score : number | null = null;
	tags : MediaFileTag | null = null;
	unmappedFields : any | null = null;
	static  get _properties():string[]{return ["filename","nb_streams","nb_programs","format_name","format_long_name","start_time","duration","size","probe_score","tags","unmappedFields"];}
}
export class LocationAttributeDatatypeDTO extends AttributeDatatypeDTO {
 	static override get _properties():string[]{return ["description","customized","global","adPlacerAbleToSet","externalSynchronized","multiline","searchable","uniqueValues","askForConfirmation","usableForFilters","disclosedToPublic","forceRegEx","defaultValue","allowedValues","allowedValuesMinCount","allowedValuesMaxCount","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class DeviceConfigurationRequestDTO extends DTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly token : string | null = null;
	readonly ip : string | null = null;
	readonly uuid : string | null = null;
	readonly hostname : string | null = null;
	readonly validTill : SbDateTime | null = null;
	static override get _properties():string[]{return ["createdAt","token","ip","uuid","hostname","validTill","_checkOwner","_type"];}
}
export class IdentifierWithCreationDTO extends IdentifierDTO {
 	readonly createdAt : SbDateTime | null = null;
	static override get _properties():string[]{return ["createdAt","identifier","_checkOwner","_type"];}
}
export class PlaylistSlotDTO extends IdentifierDTO {
 	slot : PlaybackScheduleSlotFullDTO | null = null;
	booking : BookingFullDTO | null = null;
	static override get _properties():string[]{return ["slot","booking","identifier","_checkOwner","_type"];}
}
export class GeoCullDTO extends CullWithAtomsDTO {
 	override atoms : GeoCullAtomDTO[] | null = null;
	staticElements : PolygonDTO[] | null = null;
	validPolygons : PolygonDTO[] | null = null;
	aggregation : GeoAggregationDTO | null = null;
	static override get _properties():string[]{return ["atoms","staticElements","validPolygons","aggregation","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ChangePasswordDTO extends DTO {
 	oldPassword : string | null = null;
	newPassword : string | null = null;
	static override get _properties():string[]{return ["oldPassword","newPassword","_checkOwner","_type"];}
}
export class SharedAssetFullDTO extends SharedAssetDTO {
 	repository : SharedAssetRepositoryDTO | null = null;
	assetFiles : AssetFileDTO[] | null = null;
	static override get _properties():string[]{return ["repository","assetFiles","description","shareEnd","tags","category","preview","modifiedAt","name","id","_checkOwner","_type"];}
}
export class BackgroundWorkerDTO extends ThreadDTO {
 	idleTime : number | null = null;
	executing : boolean | null = null;
	loop : number | null = null;
	lastStart : SbDateTime | null = null;
	lastEnd : SbDateTime | null = null;
	lastFail : SbDateTime | null = null;
	lastFailMessage : string | null = null;
	lastFailStack : StackTraceElementDTO[] | null = null;
	static override get _properties():string[]{return ["idleTime","executing","loop","lastStart","lastEnd","lastFail","lastFailMessage","lastFailStack","interrupted","alive","daemon","name","hashCode","group","state","priority","stackTrace","_checkOwner","_type"];}
}
export class DeviceStatisticFields {
 	timestamp : SbDateTime | null = null;
	productive : number | null = null;
	assembled : number | null = null;
	disassembled : number | null = null;
	unproductive : number | null = null;
	noService : number | null = null;
	serviceRequested : number | null = null;
	serviceFulfilled : number | null = null;
	servicePending : number | null = null;
	serviceRecurring : number | null = null;
	paired : number | null = null;
	static  get _properties():string[]{return ["timestamp","productive","assembled","disassembled","unproductive","noService","serviceRequested","serviceFulfilled","servicePending","serviceRecurring","paired"];}
}
export class PasswordRequirementDTO extends DTO {
 	readonly minLength : number | null = null;
	readonly maxLength : number | null = null;
	readonly minUpperCase : number | null = null;
	readonly minLowerCase : number | null = null;
	readonly minSpecialCharacter : number | null = null;
	readonly minNumber : number | null = null;
	readonly minSpace : number | null = null;
	readonly requirementCount : number | null = null;
	readonly regex : string | null = null;
	readonly warning : string | null = null;
	static override get _properties():string[]{return ["minLength","maxLength","minUpperCase","minLowerCase","minSpecialCharacter","minNumber","minSpace","requirementCount","regex","warning","_checkOwner","_type"];}
}
export class FixedAspectRatioImageDefinitionDTO extends DTO {
 	maxFileSize : number | null = null;
	name : string | null = null;
	height : number | null = null;
	width : number | null = null;
	minWidth : number | null = null;
	maxWidth : number | null = null;
	minHeight : number | null = null;
	maxHeight : number | null = null;
	allowedTypes : ImageType[] | null = null;
	static override get _properties():string[]{return ["maxFileSize","name","height","width","minWidth","maxWidth","minHeight","maxHeight","allowedTypes","_checkOwner","_type"];}
}
export enum ClientScope {
 	ALL = "ALL",
	ACCESSIBLE = "ACCESSIBLE",
	MANAGED = "MANAGED",
}
export class CommercialWithPreviewDTO extends CommercialDTO {
 	preview : PublicMediumDTO[] | null = null;
	static override get _properties():string[]{return ["preview","description","planning","overwrites","customer","sequence","active","from","till","timingStatus","duration","frequency","dailyPlayouts","actualPlayouts","targetPlayouts","actualSecondsPlayed","totalSecondsBooked","secondsToNextPlay","requirementCount","bookingStatus","playoutAggregation","timeCull","playerCull","geoCull","stateSpaceCull","playerAggregation","color","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum ContactFieldType {
 	Other = "Other",
	Telephone = "Telephone",
	Mobile = "Mobile",
	Email = "Email",
}
export class TemplateDataSetFullDTO extends TemplateDataSetDTO {
 	entries : TemplateDataSetEntryDTO[] | null = null;
	static override get _properties():string[]{return ["entries","client","group","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum ImageType {
 	PNG = "PNG",
	JPG = "JPG",
	GIF = "GIF",
	BMP = "BMP",
}
export class InventoryScreenDTO extends ScreenBaseDTO {
 	marker : InventoryMarkerDTO | null = null;
	hardware : InventoryScreenHardwareDTO | null = null;
	static override get _properties():string[]{return ["marker","hardware","name","id","_checkOwner","_type"];}
}
export class InventoryScreenFullDTO extends InventoryScreenDTO {
 	device : InventoryDeviceDTO | null = null;
	static override get _properties():string[]{return ["device","marker","hardware","name","id","_checkOwner","_type"];}
}
export class ContentShareQuotaFullDTO extends ContentShareQuotaDTO {
 	contentCull : ContentCullDTO | null = null;
	static override get _properties():string[]{return ["contentCull","orderNum","share","name","id","_checkOwner","_type"];}
}
export class PriceDTO extends DTO {
 	static override get _properties():string[]{return ["_checkOwner","_type"];}
}
export class TemplateDataSetSourceSubscriptionKeyDTO extends DTO {
 	dataSet : TemplateDataSetDTO | null = null;
	source : TemplateSourceDTO | null = null;
	static override get _properties():string[]{return ["dataSet","source","_checkOwner","_type"];}
}
export class CullCategoryDTO extends NestedNamedIdentityCreatorGlobalAndClientBoundDTO {
 	company : CompanyDTO | null = null;
	static override get _properties():string[]{return ["company","parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TargetedScreenOfflinePlaylistSlotDTO extends ScreenOfflinePlaylistSlotDTO {
 	targetedBookingSetIndex : number | null = null;
	static override get _properties():string[]{return ["targetedBookingSetIndex","index","slot","booking","identifier","_checkOwner","_type"];}
}
export class DeviceTripPartDTO extends DTO {
 	readonly timestamp : SbDateTime | null = null;
	readonly position : Point | null = null;
	readonly height : number | null = null;
	readonly speed : number | null = null;
	static override get _properties():string[]{return ["timestamp","position","height","speed","_checkOwner","_type"];}
}
export class EndpointDescriptorDTO extends DTO {
 	packageName : string | null = null;
	resourceName : string | null = null;
	methodName : string | null = null;
	apiPath : string | null = null;
	static override get _properties():string[]{return ["packageName","resourceName","methodName","apiPath","_checkOwner","_type"];}
}
export class CullCountDTO {
 	type : Entity | null = null;
	count : number | null = null;
	static  get _properties():string[]{return ["type","count"];}
}
export class ThumbnailableFileLink extends DTO {
 	data : string | null = null;
	disposition : Disposition | null = null;
	static override get _properties():string[]{return ["data","disposition","_checkOwner","_type"];}
}
export class CampaignBadgesDTO extends DTO {
 	activeCount : number | null = null;
	onHoldCount : number | null = null;
	finishedCount : number | null = null;
	programmaticCount : number | null = null;
	classicCount : number | null = null;
	static override get _properties():string[]{return ["activeCount","onHoldCount","finishedCount","programmaticCount","classicCount","_checkOwner","_type"];}
}
export class InventoryFieldDefinitionDTO extends InventoryFieldDTO {
 	fieldType : string | null = null;
	static override get _properties():string[]{return ["fieldType","type","field","_checkOwner","_type"];}
}
export class ContentIdentityReturningPathBasedStructureCullAtomDTO extends ContentCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class DiurnalCycleDTO extends NamedIdentityWithCreatorDTO {
 	static override get _properties():string[]{return ["createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class VisitorDiurnalCycleDTO extends DiurnalCycleDTO {
 	fadeIn : number | null = null;
	fadeOut : number | null = null;
	data : VisitorDiurnalCycleDataDTO[] | null = null;
	static override get _properties():string[]{return ["fadeIn","fadeOut","data","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class AttachmentFolderDTO extends SizedFolderDTO {
 	attachments : AttachmentDTO[] | null = null;
	static override get _properties():string[]{return ["attachments","elementsSize","folderSize","subfolderElementsSize","subfoldersSize","subfolderElementsSizeHierarchy","subfoldersSizeHierarchy","description","company","parentFolder","elementsCount","elementsCountHierarchy","subfoldersCount","subfoldersCountHierarchy","subfolders","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PlaylistSchemaDTO extends IdentifierWithCreationDTO {
 	schedule : PlaybackScheduleDTO | null = null;
	setlist : SetlistDTO | null = null;
	iterations : PlaylistSchemaIterationDTO[] | null = null;
	staticBookings : PublisherBookingDTO[] | null = null;
	targetedBookings : IndexedBookingSetDTO[] | null = null;
	slotCount : number | null = null;
	repeated : boolean | null = null;
	static override get _properties():string[]{return ["schedule","setlist","iterations","staticBookings","targetedBookings","slotCount","repeated","createdAt","identifier","_checkOwner","_type"];}
}
export class AssetCategoryDTO extends NestedNamedIdentityCreatorGlobalAndClientBoundDTO {
 	parent : AssetCategoryDTO | null = null;
	static override get _properties():string[]{return ["parent","parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class QueryExecutionDescriptorDTO extends DTO {
 	packageName : string | null = null;
	className : string | null = null;
	methodName : string | null = null;
	lineNumber : number | null = null;
	static override get _properties():string[]{return ["packageName","className","methodName","lineNumber","_checkOwner","_type"];}
}
export class TemplateDataSetEntryFullDTO extends TemplateDataSetEntryWithDataSetDTO {
 	sourceEntry : TemplateSourceEntryDTO | null = null;
	static override get _properties():string[]{return ["sourceEntry","dataSet","validTill","validFrom","verified","rejected","geoCull","timeCull","playerCull","stateSpaceCull","createdBy","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class ExecutionReportEntryDTO extends PlayoutImpressionReportEntryDTO {
 	advertiser : Serializable | null = null;
	pool : Serializable | null = null;
	location : Serializable | null = null;
	device : Serializable | null = null;
	screen : Serializable | null = null;
	data : ExecutionReportDataDTO[] | null = null;
	static override get _properties():string[]{return ["advertiser","pool","location","device","screen","data","medium","channel","marker","_checkOwner","_type"];}
}
export class AtomTypeDTO extends NamedIdentityDTO {
 	description : string | null = null;
	dto : string | null = null;
	static override get _properties():string[]{return ["description","dto","name","id","_checkOwner","_type"];}
}
export class BookingDTO extends BookingBaseDTO {
 	readonly planning : boolean | null = null;
	readonly overwrites : IdentityDTO | null = null;
	requirement : RequirementDTO | null = null;
	readonly publisher : InventoryClientDTO | null = null;
	verificationRequested : SbDateTime | null = null;
	verifiedAt : SbDateTime | null = null;
	rejectedAt : SbDateTime | null = null;
	readonly rejectedBy : UserDTO | null = null;
	readonly verifiedBy : UserDTO | null = null;
	reason : string | null = null;
	playoutAggregation : PlayoutAggregationDTO | null = null;
	static override get _properties():string[]{return ["planning","overwrites","requirement","publisher","verificationRequested","verifiedAt","rejectedAt","rejectedBy","verifiedBy","reason","playoutAggregation","marker","channel","medium","templateDataSet","templateDataSetEntry","excluded","deprecated","finished","status","id","_checkOwner","_type"];}
}
export class BookingFullDTO extends BookingDTO {
 	readonly advertiser : InventoryClientDTO | null = null;
	static override get _properties():string[]{return ["advertiser","planning","overwrites","requirement","publisher","verificationRequested","verifiedAt","rejectedAt","rejectedBy","verifiedBy","reason","playoutAggregation","marker","channel","medium","templateDataSet","templateDataSetEntry","excluded","deprecated","finished","status","id","_checkOwner","_type"];}
}
export class SharedPlaybackScheduleDTO extends SharedByScreenAndTimeDTO {
 	playbackSchedule : PlaybackScheduleFullDTO | null = null;
	static override get _properties():string[]{return ["playbackSchedule","ranges","screens","identifier","_checkOwner","_type"];}
}
export class DayTimeIntervalDTO extends DTO {
 	fromHour : number | null = null;
	fromMinute : number | null = null;
	tillHour : number | null = null;
	tillMinute : number | null = null;
	static override get _properties():string[]{return ["fromHour","fromMinute","tillHour","tillMinute","_checkOwner","_type"];}
}
export class FilterBadgesDTO extends DTO {
 	usageCount : number | null = null;
	timeCount : number | null = null;
	companyCount : number | null = null;
	contentCount : number | null = null;
	playerCount : number | null = null;
	geoCount : number | null = null;
	static override get _properties():string[]{return ["usageCount","timeCount","companyCount","contentCount","playerCount","geoCount","_checkOwner","_type"];}
}
export class LocationFullDTO extends OwnedLocationBaseDTO {
 	serviceHours : WeeklyScheduleDTO | null = null;
	attributes : LocationAttributeDTO[] | null = null;
	managedBy : CompanyFullDTO | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["serviceHours","attributes","managedBy","attachmentCount","onlineStatus","countDevices","countDevicesProductive","countVisitorTracker","countVisitorTrackerProductive","identifier","locationType","logo","headerImage","address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class StateSpaceCullAtomDTO extends CullAtomDTO {
 	static override get _properties():string[]{return ["type","valid","operator","id","_checkOwner","_type"];}
}
export class ScreenOfflinePlaylistDTO extends IdentifierDTO {
 	slots : ScreenOfflinePlaylistSlotDTO[] | null = null;
	static override get _properties():string[]{return ["slots","identifier","_checkOwner","_type"];}
}
export class LocationOnlineStatusCount {
 	total : number | null = null;
	quotaMostlyOnline : number | null = null;
	quotaMostlyOffline : number | null = null;
	quotaOnline : number | null = null;
	quotaOffline : number | null = null;
	quotaAllOnline : number | null = null;
	quotaAllCurrentlyOffline : number | null = null;
	quotaAllOffline : number | null = null;
	quotaUnknown : number | null = null;
	static  get _properties():string[]{return ["total","quotaMostlyOnline","quotaMostlyOffline","quotaOnline","quotaOffline","quotaAllOnline","quotaAllCurrentlyOffline","quotaAllOffline","quotaUnknown"];}
}
export class DeviceStatisticCounts {
 	devices : number | null = null;
	locations : number | null = null;
	productive : number | null = null;
	offline : number | null = null;
	external : number | null = null;
	stateOnline : number | null = null;
	stateOffline : number | null = null;
	stateUntracked : number | null = null;
	playoutsInternal : number | null = null;
	playoutsExternal : number | null = null;
	playbacktimeInternal : number | null = null;
	devicesInternal : number | null = null;
	screensInternal : number | null = null;
	playbacktimeExternal : number | null = null;
	devicesExternal : number | null = null;
	screensExternal : number | null = null;
	serviceTime : number | null = null;
	devicesServiceTime : number | null = null;
	playoutRate : number | null = null;
	static  get _properties():string[]{return ["devices","locations","productive","offline","external","stateOnline","stateOffline","stateUntracked","playoutsInternal","playoutsExternal","playbacktimeInternal","devicesInternal","screensInternal","playbacktimeExternal","devicesExternal","screensExternal","serviceTime","devicesServiceTime","playoutRate"];}
}
export class NetworkDeviceStatistic extends DeviceStatisticCounts {
 	key : string | null = null;
	position : Point | null = null;
	channelStatistics : ChannelStatistic[] | null = null;
	static override get _properties():string[]{return ["key","position","channelStatistics","devices","locations","productive","offline","external","stateOnline","stateOffline","stateUntracked","playoutsInternal","playoutsExternal","playbacktimeInternal","devicesInternal","screensInternal","playbacktimeExternal","devicesExternal","screensExternal","serviceTime","devicesServiceTime","playoutRate"];}
}
export class ReportingFileFullDTO extends ReportingFileDTO {
 	readonly reporting : ReportingDTO | null = null;
	static override get _properties():string[]{return ["reporting","createdAt","fileName","fileSize","url","reportingTemplate","id","_checkOwner","_type"];}
}
export class AssetRepositoryFullDTO extends AssetRepositoryDTO {
 	clientCull : ClientCullDTO | null = null;
	static override get _properties():string[]{return ["clientCull","assetCount","sharedAssetCount","shareStart","description","shareEnd","identifier","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class BookedMediumGroupAggregatedPlaylistDTO extends AggregatedPlaylistDTO {
 	static override get _properties():string[]{return ["playlist","ranges","screens","identifier","_checkOwner","_type"];}
}
export class IncomingClientConnectionEstablishmentRequestDTO extends DTO {
 	readonly createdAt : SbDateTime | null = null;
	readonly requesting : InventoryClientDTO | null = null;
	static override get _properties():string[]{return ["createdAt","requesting","_checkOwner","_type"];}
}
export class NetworkAggregationDTO extends DTO {
 	element : DTO | null = null;
	countDevices : number | null = null;
	countScreens : number | null = null;
	static override get _properties():string[]{return ["element","countDevices","countScreens","_checkOwner","_type"];}
}
export class DeviceDTO extends OwnedDeviceBaseDTO {
 	location : LocationDTO | null = null;
	static override get _properties():string[]{return ["location","notes","lastOnline","screens","lastIP","connected","productive","offline","external","disabled","paired","proposed","pool","serviceRequest","position","homeArea","whitelistArea","positionValidityDuration","channel","onlineStatus","hardware","software","machineCode","currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ContentShareDTO extends DiversifiedNamedIdentityWithCreatorDTO {
 	description : string | null = null;
	precondition : ContentShareFullDTO | null = null;
	validFrom : SbLocalDateTime | null = null;
	validTill : SbLocalDateTime | null = null;
	readonly planning : boolean | null = null;
	readonly overwrites : ContentShareFullDTO | null = null;
	static override get _properties():string[]{return ["description","precondition","validFrom","validTill","planning","overwrites","diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ContentShareFullDTO extends ContentShareDTO {
 	preconditionOf : ContentShareFullDTO[] | null = null;
	quotaDistributionBasis : DistributionBasis | null = null;
	quotas : ContentShareQuotaFullDTO[] | null = null;
	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	static override get _properties():string[]{return ["preconditionOf","quotaDistributionBasis","quotas","timeCull","playerCull","geoCull","stateSpaceCull","description","precondition","validFrom","validTill","planning","overwrites","diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PermissionEntryDTO extends DTO {
 	permission : string | null = null;
	implications : PermissionEntryDTO[] | null = null;
	static override get _properties():string[]{return ["permission","implications","_checkOwner","_type"];}
}
export class PerformanceCheckResultDTO extends DTO {
 	start : SbDateTime | null = null;
	finish : SbDateTime | null = null;
	total : number | null = null;
	database : number | null = null;
	io : number | null = null;
	network : number | null = null;
	calculation : number | null = null;
	static override get _properties():string[]{return ["start","finish","total","database","io","network","calculation","_checkOwner","_type"];}
}
export class CalendarTypeDTO extends ColoredNamedIdentityWithIdentifierAndCreatorGlobalAndClientBoundDTO {
 	icon : string | null = null;
	static override get _properties():string[]{return ["icon","color","identifier","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TemplateScreenEntryWithDataSetDTO extends TemplateScreenEntryDTO {
 	dataSetEntry : TemplateDataSetEntryWithDataSetDTO | null = null;
	static override get _properties():string[]{return ["dataSetEntry","rejectedAt","rejectedBy","rejected","invalidatedAt","invalidated","createdAt","values","identifier","name","id","_checkOwner","_type"];}
}
export class LinkedEntityDTO extends DTO {
 	type : string | null = null;
	id : number | null = null;
	static override get _properties():string[]{return ["type","id","_checkOwner","_type"];}
}
export class PlaylistSchemaIterationSlotDTO extends IdentifierDTO {
 	index : number | null = null;
	slot : PlaybackScheduleSlotDTO | null = null;
	fallbackSlot : boolean | null = null;
	staticBooking : IdentityDTO | null = null;
	targetedBookingSetIndex : number | null = null;
	sspSlotConfigurations : SSPSlotConfigurationDTO[] | null = null;
	static override get _properties():string[]{return ["index","slot","fallbackSlot","staticBooking","targetedBookingSetIndex","sspSlotConfigurations","identifier","_checkOwner","_type"];}
}
export class PlaylistSchemaIterationSlotFullDTO extends PlaylistSchemaIterationSlotDTO {
 	iteration : PlaylistSchemaIterationDTO | null = null;
	targetedBookings : PublisherBookingDTO[] | null = null;
	static override get _properties():string[]{return ["iteration","targetedBookings","index","slot","fallbackSlot","staticBooking","targetedBookingSetIndex","sspSlotConfigurations","identifier","_checkOwner","_type"];}
}
export enum DateTimePart {
 	Year = "Year",
	Month = "Month",
	DayOfYear = "DayOfYear",
	DayOfMonth = "DayOfMonth",
	WeekOfYear = "WeekOfYear",
	WeekOfMonth = "WeekOfMonth",
	DayOfWeek = "DayOfWeek",
	Hour = "Hour",
	Minute = "Minute",
}
export class ScreenOfflineMediumDTO extends IdentityDTO {
 	readonly duration : number | null = null;
	readonly contentType : string | null = null;
	readonly locked : boolean | null = null;
	readonly resolution : ResolutionDTO | null = null;
	readonly hash : HashDTO | null = null;
	static override get _properties():string[]{return ["duration","contentType","locked","resolution","hash","id","_checkOwner","_type"];}
}
export class UserFullDTO extends ManagedUserDTO {
 	username : string | null = null;
	readonly primaryClient : ClientDTO | null = null;
	static override get _properties():string[]{return ["username","primaryClient","lastLogin","blocked","email","firstname","lastname","avatar","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class BadgesDTO extends DTO {
 	campaign : CampaignBadgesDTO | null = null;
	network : NetworkBadgesDTO | null = null;
	filter : FilterBadgesDTO | null = null;
	static override get _properties():string[]{return ["campaign","network","filter","_checkOwner","_type"];}
}
export class UserClientFullDTO extends UserClientWithPermissionsDTO {
 	user : UserFullDTO | null = null;
	static override get _properties():string[]{return ["user","explicitPermissions","explicitRoles","clientOrderNum","blocked","lastLogin","client","effectivePermissions","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class AttachmentDTO extends NamedIdentityWithCreatorDTO {
 	readonly fileName : string | null = null;
	readonly fileType : string | null = null;
	link : string | null = null;
	readonly linkBroken : boolean | null = null;
	readonly embeddable : boolean | null = null;
	readonly attachmentType : AttachmentType | null = null;
	displayType : DisplayType | null = null;
	description : string | null = null;
	readonly fileLink : FileLink | null = null;
	readonly thumbnail : ThumbnailableFileLink | null = null;
	folder : AttachmentFolderDTO | null = null;
	static override get _properties():string[]{return ["fileName","fileType","link","linkBroken","embeddable","attachmentType","displayType","description","fileLink","thumbnail","folder","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class SharedTargetedOfflinePlaylistDTO extends DTO {
 	ranges : LocalDateTimeRangeDTO[] | null = null;
	playlist : TargetedScreenOfflinePlaylistDTO | null = null;
	static override get _properties():string[]{return ["ranges","playlist","_checkOwner","_type"];}
}
export class StructureCullDTO extends CullWithAtomsDTO {
 	override atoms : StructureCullAtomDTO[] | null = null;
	static override get _properties():string[]{return ["atoms","category","global","description","company","type","expression","invertedStatic","easyMode","hidden","valid","currentUsageCount","usageCount","lockedBy","cached","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CalendarCategoryDTO extends NestedNamedIdentityCreatorGlobalAndClientBoundDTO {
 	static override get _properties():string[]{return ["parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryDeviceFullDTO extends InventoryDeviceDTO {
 	publisher : InventoryClientDTO | null = null;
	screens : InventoryScreenDTO[] | null = null;
	static override get _properties():string[]{return ["publisher","screens","channel","disclosedAttributes","pool","location","onlineStatus","currentPosition","positionUpdated","positionValidity","identifier","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ExecutionReportDataDTO extends PlayoutImpressionReportDataDTO {
 	totalBookings : number | null = null;
	static override get _properties():string[]{return ["totalBookings","date","totalPlayouts","totalPlaybacktime","totalVisitors","totalUniqueVisitors","totalImpressions","hoursPlayouts","hoursPlaybacktime","hoursVisitors","hoursUniqueVisitors","hoursImpressions","_checkOwner","_type"];}
}
export enum LocalDataScope {
 	ALL = "ALL",
	MEDIA = "MEDIA",
	TPL = "TPL",
	TPL_RES = "TPL_RES",
	LOGS = "LOGS",
	CFG = "CFG",
	TPL_CACHE = "TPL_CACHE",
	TPL_RENDER_CACHE = "TPL_RENDER_CACHE",
}
export class PlayoutDTO extends PlayoutBookingBaseDTO {
 	screen : ScreenFullDTO | null = null;
	static override get _properties():string[]{return ["screen","booking","usedTemplateEntry","descriptor","start","playbacktime","_checkOwner","_type"];}
}
export class NetworkBadgesDTO extends DTO {
 	network_deviceOnlineCount : number | null = null;
	network_devicesOfflineCount : number | null = null;
	static override get _properties():string[]{return ["network_deviceOnlineCount","network_devicesOfflineCount","_checkOwner","_type"];}
}
export class CheckRestoreDTO extends DTO {
 	username : string | null = null;
	restore : string | null = null;
	static override get _properties():string[]{return ["username","restore","_checkOwner","_type"];}
}
export class ApiKeyDTO extends IdentifierWithCreationDTO {
 	name : string | null = null;
	readonly expiry : SbDateTime | null = null;
	readonly expired : boolean | null = null;
	static override get _properties():string[]{return ["name","expiry","expired","createdAt","identifier","_checkOwner","_type"];}
}
export class AssetFileLink {
 	link : string | null = null;
	thumbnailLink : string | null = null;
	static  get _properties():string[]{return ["link","thumbnailLink"];}
}
export class ImpressionBidDTO extends DTO {
 	static override get _properties():string[]{return ["_checkOwner","_type"];}
}
export class DeviceLogDTO extends IdentityDTO {
 	timestamp : SbDateTime | null = null;
	device : number | null = null;
	datatype : string | null = null;
	value : string | null = null;
	causedBy : UserDTO | null = null;
	static override get _properties():string[]{return ["timestamp","device","datatype","value","causedBy","id","_checkOwner","_type"];}
}
export class ScreenLicenseDTO extends LicenseDTO {
 	screen : ScreenFullDTO | null = null;
	static override get _properties():string[]{return ["screen","serial","issuedAt","uuid","application","type","domain","client","configuration","manuallyAssigned","inUse","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class TimeRangeCullAtomDTO extends TimeCullAtomDTO {
 	override id: {
		cull?:TimeCullDTO;
		num?:number
	} | null = null;
	start : SbLocalTime | null = null;
	end : SbLocalTime | null = null;
	static override get _properties():string[]{return ["start","end","type","valid","operator","id","_checkOwner","_type"];}
}
export class HtmlDTO extends DTO {
 	base64 : string | null = null;
	width : number | null = null;
	height : number | null = null;
	templateStoreData : TemplateStoreDataDTO | null = null;
	static override get _properties():string[]{return ["base64","width","height","templateStoreData","_checkOwner","_type"];}
}
export class LeveledBookingsDTO extends DTO {
 	level : number | null = null;
	bookings : PublisherBookingDTO[] | null = null;
	static override get _properties():string[]{return ["level","bookings","_checkOwner","_type"];}
}
export class PolygonDTO extends IdentityDTO {
 	data : Polygon | null = null;
	mbr : Polygon | null = null;
	simple : Polygon | null = null;
	static override get _properties():string[]{return ["data","mbr","simple","id","_checkOwner","_type"];}
}
export class LocalizedFrameBucketDTO extends DTO {
 	key : any | null = null;
	frames : LocalizedFrameDTO[] | null = null;
	static override get _properties():string[]{return ["key","frames","_checkOwner","_type"];}
}
export class PlaybackScheduleDTO extends DiversifiedNamedIdentityWithCreatorDTO {
 	description : string | null = null;
	precondition : PlaybackScheduleFullDTO | null = null;
	validFrom : SbLocalDateTime | null = null;
	validTill : SbLocalDateTime | null = null;
	static override get _properties():string[]{return ["description","precondition","validFrom","validTill","diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class PlaybackScheduleFullDTO extends PlaybackScheduleDTO {
 	preconditionOf : PlaybackScheduleFullDTO[] | null = null;
	slots : PlaybackScheduleSlotFullDTO[] | null = null;
	timeCull : TimeCullDTO | null = null;
	playerCull : PlayerCullDTO | null = null;
	geoCull : GeoCullDTO | null = null;
	stateSpaceCull : StateSpaceCullDTO | null = null;
	static override get _properties():string[]{return ["preconditionOf","slots","timeCull","playerCull","geoCull","stateSpaceCull","description","precondition","validFrom","validTill","diversify","level","priority","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ScreenPlaylistDTO extends IdentifierWithCreationDTO {
 	id : Serializable | null = null;
	screen : ScreenFullDTO | null = null;
	lastAccess : SbDateTime | null = null;
	productive : boolean | null = null;
	position : Point | null = null;
	currentPosition : Point | null = null;
	validity : LocalDateTimeRangeDTO | null = null;
	geoValidity : Polygon | null = null;
	playlistSchema : PlaylistSchemaDTO | null = null;
	succeedingPlaylistSchema : PlaylistSchemaDTO | null = null;
	schemaIterationIndex : number | null = null;
	renderedBookings : PublisherBookingDTO[] | null = null;
	renderedIterations : RenderedScreenPlaylistIterationDTO[] | null = null;
	previousPlaylist : ScreenPlaylistDTO | null = null;
	static override get _properties():string[]{return ["id","screen","lastAccess","productive","position","currentPosition","validity","geoValidity","playlistSchema","succeedingPlaylistSchema","schemaIterationIndex","renderedBookings","renderedIterations","previousPlaylist","createdAt","identifier","_checkOwner","_type"];}
}
export class ClientAggregationDTO extends CullAggregationDTO {
 	scope : ClientScope | null = null;
	agents : number | null = null;
	managed : number | null = null;
	clients : number | null = null;
	static override get _properties():string[]{return ["scope","agents","managed","clients","_checkOwner","_type"];}
}
export class FrameBucketDTO extends DTO {
 	key : any | null = null;
	frames : FrameDTO[] | null = null;
	static override get _properties():string[]{return ["key","frames","_checkOwner","_type"];}
}
export class ImpressionRequestDTO extends DTO {
 	static override get _properties():string[]{return ["_checkOwner","_type"];}
}
export class AssetCategoryFullDTO extends AssetCategoryDTO {
 	children : AssetCategoryDTO[] | null = null;
	repository : AssetRepositoryDTO | null = null;
	static override get _properties():string[]{return ["children","repository","parent","parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class InventoryFilterDTO extends DTO {
 	path : InventoryFieldDTO | null = null;
	values : InventoryFieldValueDTO[] | null = null;
	static override get _properties():string[]{return ["path","values","_checkOwner","_type"];}
}
export class PlayerSoftwareDTO extends NamedIdentityDTO {
 	global : boolean | null = null;
	readonly createdAt : SbDateTime | null = null;
	description : string | null = null;
	color : string | null = null;
	version : string | null = null;
	protocol : string | null = null;
	readonly logo : FixedAspectRatioImageDTO | null = null;
	os : string | null = null;
	readonly attachmentCount : AttachmentCountDTO | null = null;
	static override get _properties():string[]{return ["global","createdAt","description","color","version","protocol","logo","os","attachmentCount","name","id","_checkOwner","_type"];}
}
export class TemplateSourceDTO extends NamedIdentityDTO {
 	client : ClientDTO | null = null;
	templateGroup : TemplateGroupDTO | null = null;
	publiclyAvailable : boolean | null = null;
	static override get _properties():string[]{return ["client","templateGroup","publiclyAvailable","name","id","_checkOwner","_type"];}
}
export class TagDTO extends ColoredModifiableNamedIdentityWithCreatorDTO {
 	description : string | null = null;
	readonly associationCount : number | null = null;
	static override get _properties():string[]{return ["description","associationCount","color","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class MediumShareOfVoiceDTO extends ShareOfVoiceDTO {
 	medium : PublicMediumDTO | null = null;
	media : MediumShareOfVoiceDTO[] | null = null;
	static override get _properties():string[]{return ["medium","media","dates","data","playerAggregation","_checkOwner","_type"];}
}
export class VisitorTrackerFullDTO extends VisitorTrackerDTO {
 	location : LocationDTO | null = null;
	static override get _properties():string[]{return ["location","timezone","technique","productive","offline","external","disabled","attachmentCount","identifier","name","id","_checkOwner","_type"];}
}
export class TransactionExecutionStatisticsDTO extends ExecutionStatisticsDTO {
 	committed : number | null = null;
	rolledBack : number | null = null;
	nonCommitted : number | null = null;
	static override get _properties():string[]{return ["committed","rolledBack","nonCommitted","resourceDescriptor","calls","minExecutionTime","avgExecutionTime","maxExecutionTime","firstStarted","firstFinished","lastStarted","lastFinished","_checkOwner","_type"];}
}
export class ManagedUserClientDTO extends UserClientWithPermissionsDTO {
 	user : ManagedUserDTO | null = null;
	static override get _properties():string[]{return ["user","explicitPermissions","explicitRoles","clientOrderNum","blocked","lastLogin","client","effectivePermissions","createdAt","createdBy","id","_checkOwner","_type"];}
}
export class PlayerPathBasedStructureCullAtomDTO extends PlayerCullAtomDTO {
 	field : string | null = null;
	values : string[] | null = null;
	static override get _properties():string[]{return ["field","values","type","valid","operator","id","_checkOwner","_type"];}
}
export class PlayerBase {
 	publishers : number | null = null;
	locations : number | null = null;
	channels : number | null = null;
	markers : number | null = null;
	devices : number | null = null;
	screens : number | null = null;
	static  get _properties():string[]{return ["publishers","locations","channels","markers","devices","screens"];}
}
export class DeviceMachineLicenseDTO extends MachineLicenseDTO {
 	static override get _properties():string[]{return ["machineCode","serial","issuedAt","uuid","application","type","domain","client","configuration","manuallyAssigned","inUse","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class SharedClientCentricContentShareAssignmentDTO extends SharedByScreenAndTimeDTO {
 	contentShareAssignment : ClientCentricContentShareAssignmentDTO | null = null;
	static override get _properties():string[]{return ["contentShareAssignment","ranges","screens","identifier","_checkOwner","_type"];}
}
export class PlanningDTO extends ModifiableNamedIdentityWithCreatorDTO {
 	readonly clientOrderNum : number | null = null;
	readonly forCustomer : NamedIdentityDTO | null = null;
	description : string | null = null;
	readonly submissions : PlanningSubmissionDTO[] | null = null;
	static override get _properties():string[]{return ["clientOrderNum","forCustomer","description","submissions","modifiedAt","modifiedBy","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class NotificationDTO extends NamedIdentityDTO {
 	readonly createdAt : SbDateTime | null = null;
	logLevel : string | null = null;
	category : NotificationCategoryDTO | null = null;
	status : string | null = null;
	checked : SbDateTime | null = null;
	checkedBy : UserDTO | null = null;
	archived : SbDateTime | null = null;
	archivedBy : UserDTO | null = null;
	message : string | null = null;
	entity : IdentityDTO | null = null;
	static override get _properties():string[]{return ["createdAt","logLevel","category","status","checked","checkedBy","archived","archivedBy","message","entity","name","id","_checkOwner","_type"];}
}
export class LineStringDTO extends IdentityDTO {
 	data : LineString | null = null;
	mbr : Polygon | null = null;
	simple : LineString | null = null;
	static override get _properties():string[]{return ["data","mbr","simple","id","_checkOwner","_type"];}
}
export class CampaignReportEntryDTO extends PlayoutImpressionReportEntryDTO {
 	customer : Serializable | null = null;
	campaign : Serializable | null = null;
	campaignType : Serializable | null = null;
	commercial : Serializable | null = null;
	requirement : Serializable | null = null;
	booking : Serializable | null = null;
	mediumGroup : Serializable | null = null;
	products : Serializable[] | null = null;
	productCategories : Serializable[] | null = null;
	publisher : Serializable | null = null;
	data : CampaignReportDataDTO[] | null = null;
	static override get _properties():string[]{return ["customer","campaign","campaignType","commercial","requirement","booking","mediumGroup","products","productCategories","publisher","data","medium","channel","marker","_checkOwner","_type"];}
}
export enum PlaybackScheduleSlotClientType {
 	UNKNOWN = "UNKNOWN",
	OWN = "OWN",
	FOREIGN = "FOREIGN",
	MIXED = "MIXED",
	FREE = "FREE",
}
export class PoolHierarchyDTO extends PoolDTO {
 	children : PoolHierarchyDTO[] | null = null;
	static override get _properties():string[]{return ["children","clientOrderNum","description","color","countDevices","countDevicesProductive","parent","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class LocationDTO extends OwnedLocationBaseDTO {
 	managedBy : CompanyDTO | null = null;
	static override get _properties():string[]{return ["managedBy","onlineStatus","countDevices","countDevicesProductive","countVisitorTracker","countVisitorTrackerProductive","identifier","locationType","logo","headerImage","address","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class CustomerSetlistDTO extends DTO {
 	customer : InventoryCompanyFullDTO | null = null;
	staticBookings : PublisherBookingDTO[] | null = null;
	targetedBookings : LeveledBookingsDTO[] | null = null;
	static override get _properties():string[]{return ["customer","staticBookings","targetedBookings","_checkOwner","_type"];}
}
export class CalendarEntryCategoryDTO extends NestedNamedIdentityCreatorGlobalAndClientBoundDTO {
 	static override get _properties():string[]{return ["parent","modifiedAt","modifiedBy","global","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export class ChannelStatistic extends DeviceStatisticCounts {
 	channel : string | null = null;
	values : DeviceStatisticFields[] | null = null;
	static override get _properties():string[]{return ["channel","values","devices","locations","productive","offline","external","stateOnline","stateOffline","stateUntracked","playoutsInternal","playoutsExternal","playbacktimeInternal","devicesInternal","screensInternal","playbacktimeExternal","devicesExternal","screensExternal","serviceTime","devicesServiceTime","playoutRate"];}
}
export class ChannelFullDTO extends ChannelDTO {
 	markers : MarkerDTO[] | null = null;
	countDevices : number | null = null;
	countDevicesProductive : number | null = null;
	static override get _properties():string[]{return ["markers","countDevices","countDevicesProductive","clientOrderNum","publisher","locked","attachmentCount","description","color","logo","ambianceImage","createdAt","createdBy","name","id","_checkOwner","_type"];}
}
export enum _admin_Area_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
COMPANY = "COMPANY",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum _admin_category_AreaCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum _admin_category_CalendarCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum _admin_category_CalendarEntryCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum _admin_Client_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum _admin_Client_retrieveConnectedClients_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum _admin_Role_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CLIENT_USER_HAS_ROLE = "CLIENT_USER_HAS_ROLE"
}
export enum ca_am_ApiKey_retrieveAll_order {
IDENTIFIER = "IDENTIFIER",
CREATED_AT = "CREATED_AT",
NAME = "NAME"
}
export enum ca_am_Role_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CLIENT_USER_HAS_ROLE = "CLIENT_USER_HAS_ROLE"
}
export enum ca_am_Role_retrieveAllInUserContext_order {
ID = "ID",
NAME = "NAME",
CLIENT_USER_HAS_ROLE = "CLIENT_USER_HAS_ROLE"
}
export enum ca_am_User_retrieveAll_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
USER_LASTNAME = "USER_LASTNAME",
USER_FIRSTNAME = "USER_FIRSTNAME",
USER_EMAIL = "USER_EMAIL"
}
export enum ca_md_AreaCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum ca_md_AreaCategory_retrieveOfficial_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum ca_md_CampaignType_retrieveAll_order {
ID = "ID",
NAME = "NAME"
}
export enum ca_md_CampaignType_retrieveHierarchy_order {
ID = "ID",
NAME = "NAME"
}
export enum cs_Cull_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
NAME = "NAME",
USAGE_COUNT = "USAGE_COUNT",
CURRENT_USAGE_COUNT = "CURRENT_USAGE_COUNT"
}
export enum cs_Cull_retrieveCullGraphs_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
NAME = "NAME",
USAGE_COUNT = "USAGE_COUNT",
CURRENT_USAGE_COUNT = "CURRENT_USAGE_COUNT"
}
export enum dm_assets_Asset_repositoryAssetsRetrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
SHARE_START = "SHARE_START",
SHARE_END = "SHARE_END"
}
export enum dm_assets_AssetRepository_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
SHARE_START = "SHARE_START",
SHARE_END = "SHARE_END",
ASSET_COUNT = "ASSET_COUNT"
}
export enum dm_geo_Area_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
COMPANY = "COMPANY",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum dm_geo_Area_retrieveOfficial_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
COMPANY = "COMPANY",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum dm_time_CalendarCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum dm_time_CalendarEntryCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum ds_cm_Booking_retrieveAll_order {
ID = "ID",
CHANNEL_NAME = "CHANNEL_NAME",
PUBLISHER_NAME = "PUBLISHER_NAME",
MEDIUM_NAME = "MEDIUM_NAME"
}
export enum ds_cm_Campaign_retrieveAll_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_Campaign_retrieveAllFrontendEnhanced_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_Campaign_retrieveAllInPlanning_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_Campaign_retrieveAllInPlanningFrontendEnhanced_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_Campaign_retrieveCommercialsByCampaignId_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Campaign_retrieveCommercialsByCampaignIdFrontendEnhanced_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Campaign_retrieveCommercialsInPlanningByCampaignId_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Campaign_retrieveCommercialsInPlanningByCampaignIdFrontendEnhanced_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Campaign_retrieveCommercialsInPlanningSubmissionByCampaignId_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Campaign_retrieveCommercialsInPlanningSubmissionByCampaignIdFrontendEnhanced_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Commercial_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Commercial_retrieveAllFrontendEnhanced_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Commercial_retrieveAllInPlanning_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Commercial_retrieveAllInPlanningFrontendEnhanced_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
PRIORITY = "PRIORITY",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME"
}
export enum ds_cm_Commercial_retrieveRequirements_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
PRIORITY = "PRIORITY"
}
export enum ds_cm_Commercial_retrieveRequirementsInPlanningByCommercialId_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
PRIORITY = "PRIORITY"
}
export enum ds_cm_ContentShare_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ds_cm_ContentShare_retrieveAllInPlanning_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ds_cm_ContentShare_retrieveHierarchy_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ds_cm_ContentShare_retrieveHierarchyInPlanning_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ds_cm_Planning_retrieveAll_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_Requirement_retrieveNonBookedMarkers_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME"
}
export enum ds_cm_Requirement_retrieveNonBookedMarkersPlanning_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME"
}
export enum ds_cm_ScheduledCampaign_retrieveAll_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_ScheduledCampaign_retrieveAllBookingsBelowRequirement_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_ScheduledCampaign_retrieveAllCommercialsBelowCampaign_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_cm_ScheduledCampaign_retrieveAllRequirementsBelowCommercial_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
FROM_TIME = "FROM_TIME",
TILL_TIME = "TILL_TIME",
LEVEL = "LEVEL",
CAMPAIGN_TYPE = "CAMPAIGN_TYPE",
CUSTOMER = "CUSTOMER"
}
export enum ds_rm_Inventory_retrieveAllDevices_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_Inventory_retrieveAllLocations_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
MANAGED_BY_CREATED_AT = "MANAGED_BY_CREATED_AT",
MANAGED_BY_IDENTIFIER = "MANAGED_BY_IDENTIFIER",
MANAGED_BY_NAME = "MANAGED_BY_NAME",
MANAGED_BY_STREET = "MANAGED_BY_STREET",
MANAGED_BY_STREET2 = "MANAGED_BY_STREET2",
MANAGED_BY_ZIP = "MANAGED_BY_ZIP",
MANAGED_BY_CITY = "MANAGED_BY_CITY",
MANAGED_BY_COUNTRY = "MANAGED_BY_COUNTRY",
MANAGED_BY_COUNTY = "MANAGED_BY_COUNTY",
MANAGED_BY_STATE = "MANAGED_BY_STATE",
MANAGED_BY_BOROUGH = "MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANAGED_BY_ATTRIBUTES = "MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_InventoryBlacklist_retrieveAllBlacklistedBookings_order {
ID = "ID",
ADVERTISER_NAME = "ADVERTISER_NAME",
CHANNEL_NAME = "CHANNEL_NAME",
MEDIUM_NAME = "MEDIUM_NAME"
}
export enum ds_rm_InventoryBooking_retrieveAll_order {
ID = "ID",
ADVERTISER_NAME = "ADVERTISER_NAME",
CHANNEL_NAME = "CHANNEL_NAME",
MEDIUM_NAME = "MEDIUM_NAME"
}
export enum ds_rm_InventoryBooking_retrieveAllAdvertisers_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum ds_rm_InventoryBooking_retrieveAllLocations_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum ds_rm_InventoryBooking_retrieveAllPublishers_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum ds_rm_InventoryScreen_export_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_InventoryScreen_retrieveAll_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_Publisher_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum mm_assets_Asset_retrieveSharedAssets_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
SHARE_START = "SHARE_START",
SHARE_END = "SHARE_END"
}
export enum mm_assets_AssetRepository_retrieveSharedRepositories_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
SHARE_START = "SHARE_START",
SHARE_END = "SHARE_END",
ASSET_COUNT = "ASSET_COUNT"
}
export enum mm_Medium_bookedDevicesById_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LAST_PAIRING_TIMESTAMP = "LAST_PAIRING_TIMESTAMP",
SERVICE_REQUEST_CREATED_AT = "SERVICE_REQUEST_CREATED_AT",
SERVICE_FULFILLED_CREATED_AT = "SERVICE_FULFILLED_CREATED_AT",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum mm_Medium_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
DURATION = "DURATION",
WIDTH = "WIDTH",
HEIGHT = "HEIGHT",
COMPANY = "COMPANY"
}
export enum mm_MediumGroup_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
MODIFIED_AT = "MODIFIED_AT",
COMPANY = "COMPANY"
}
export enum mm_templating_advertiser_TemplateDataSet_retrieveAll_order {
ID = "ID",
NAME = "NAME",
TEMPLATE_GROUP = "TEMPLATE_GROUP"
}
export enum mm_templating_advertiser_TemplateDataSetEntry_retrieveAll_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
VALID_TILL = "VALID_TILL"
}
export enum mm_templating_provider_TemplateGroup_retrieveAll_order {
ID = "ID",
TITLE = "TITLE",
CREATED_AT = "CREATED_AT"
}
export enum mm_templating_provider_TemplateSource_retrieveAll_order {
ID = "ID",
NAME = "NAME",
TEMPLATE_GROUP = "TEMPLATE_GROUP"
}
export enum pm_Product_retrieveAll_order {
ID = "ID",
NAME = "NAME",
IDENTIFIER = "IDENTIFIER",
ASIN = "ASIN",
GTIN = "GTIN",
PLU = "PLU",
MANUFACTURER_CREATED_AT = "MANUFACTURER_CREATED_AT",
MANUFACTURER_IDENTIFIER = "MANUFACTURER_IDENTIFIER",
MANUFACTURER_NAME = "MANUFACTURER_NAME",
MANUFACTURER_STREET = "MANUFACTURER_STREET",
MANUFACTURER_STREET2 = "MANUFACTURER_STREET2",
MANUFACTURER_ZIP = "MANUFACTURER_ZIP",
MANUFACTURER_CITY = "MANUFACTURER_CITY",
MANUFACTURER_STATE = "MANUFACTURER_STATE",
MANUFACTURER_COUNTRY = "MANUFACTURER_COUNTRY",
MANUFACTURER_COUNTY = "MANUFACTURER_COUNTY",
MANUFACTURER_BOROUGH = "MANUFACTURER_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANUFACTURER_ATTRIBUTES = "MANUFACTURER_ATTRIBUTES"
}
export enum pm_ProductCategory_retrieveAll_order {
ID = "ID",
NAME = "NAME"
}
export enum shared_Attachment_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
FILE_TYPE = "FILE_TYPE"
}
export enum shared_Attachment_retrieveAllAttachmentsForEntity_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
FILE_TYPE = "FILE_TYPE"
}
export enum shared_Client_retrieveAccessibleClients_order {
ID = "ID",
NAME = "NAME",
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM"
}
export enum shared_Client_retrieveConnectedClients_order {
ID = "ID",
NAME = "NAME",
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM"
}
export enum shared_ClientConnection_retrieveClientConnectionEstablishmentRequests_order {
ID = "ID",
NAME = "NAME",
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM"
}
export enum shared_ClientConnection_retrieveConnectedClients_order {
ID = "ID",
NAME = "NAME",
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM"
}
export enum shared_ClientConnection_retrieveIncomingClientConnectionEstablishmentRequests_order {
ID = "ID",
NAME = "NAME",
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM"
}
export enum shared_Company_export_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES"
}
export enum shared_Company_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES"
}
export enum shared_Notification_retrieveAll_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
STATUS = "STATUS",
LOGLEVEL = "LOGLEVEL",
CATEGORY = "CATEGORY",
MESSAGE = "MESSAGE",
ENTITY_ID = "ENTITY_ID",
ENTITY_TYPE = "ENTITY_TYPE"
}
export enum shared_Notification_retrieveCategories_order {
ID = "ID"
}
export enum shared_ReportingSetup_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME"
}
export enum shared_ReportingSetup_retrieveAllAdHocReportingSetups_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME"
}
export enum shared_ReportingSetup_retrieveAllScheduledReportingSetups_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME"
}
export enum ss_cd_PlayoutDescriptor_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
FIRST_PLAYOUT = "FIRST_PLAYOUT",
LAST_PLAYOUT = "LAST_PLAYOUT"
}
export enum ss_fm_Location_export_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
MANAGED_BY_CREATED_AT = "MANAGED_BY_CREATED_AT",
MANAGED_BY_IDENTIFIER = "MANAGED_BY_IDENTIFIER",
MANAGED_BY_NAME = "MANAGED_BY_NAME",
MANAGED_BY_STREET = "MANAGED_BY_STREET",
MANAGED_BY_STREET2 = "MANAGED_BY_STREET2",
MANAGED_BY_ZIP = "MANAGED_BY_ZIP",
MANAGED_BY_CITY = "MANAGED_BY_CITY",
MANAGED_BY_COUNTRY = "MANAGED_BY_COUNTRY",
MANAGED_BY_COUNTY = "MANAGED_BY_COUNTY",
MANAGED_BY_STATE = "MANAGED_BY_STATE",
MANAGED_BY_BOROUGH = "MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANAGED_BY_ATTRIBUTES = "MANAGED_BY_ATTRIBUTES"
}
export enum ss_fm_Location_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
MANAGED_BY_CREATED_AT = "MANAGED_BY_CREATED_AT",
MANAGED_BY_IDENTIFIER = "MANAGED_BY_IDENTIFIER",
MANAGED_BY_NAME = "MANAGED_BY_NAME",
MANAGED_BY_STREET = "MANAGED_BY_STREET",
MANAGED_BY_STREET2 = "MANAGED_BY_STREET2",
MANAGED_BY_ZIP = "MANAGED_BY_ZIP",
MANAGED_BY_CITY = "MANAGED_BY_CITY",
MANAGED_BY_COUNTRY = "MANAGED_BY_COUNTRY",
MANAGED_BY_COUNTY = "MANAGED_BY_COUNTY",
MANAGED_BY_STATE = "MANAGED_BY_STATE",
MANAGED_BY_BOROUGH = "MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANAGED_BY_ATTRIBUTES = "MANAGED_BY_ATTRIBUTES"
}
export enum ss_fm_Location_retrieveDevicesByLocationId_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LAST_PAIRING_TIMESTAMP = "LAST_PAIRING_TIMESTAMP",
SERVICE_REQUEST_CREATED_AT = "SERVICE_REQUEST_CREATED_AT",
SERVICE_FULFILLED_CREATED_AT = "SERVICE_FULFILLED_CREATED_AT",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Blacklist_retrieveAllBlacklistedBookings_order {
ID = "ID",
ADVERTISER_NAME = "ADVERTISER_NAME",
CHANNEL_NAME = "CHANNEL_NAME",
MEDIUM_NAME = "MEDIUM_NAME"
}
export enum ss_nm_Booking_retrieveAll_order {
ID = "ID",
ADVERTISER_NAME = "ADVERTISER_NAME",
CHANNEL_NAME = "CHANNEL_NAME",
MEDIUM_NAME = "MEDIUM_NAME"
}
export enum ss_nm_Channel_retrieveAll_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME",
MARKER_WIDTH = "MARKER_WIDTH",
MARKER_HEIGHT = "MARKER_HEIGHT",
COUNT_DEVICES = "COUNT_DEVICES",
COUNT_DEVICES_PRODUCTIVE = "COUNT_DEVICES_PRODUCTIVE",
CREATED_AT = "CREATED_AT"
}
export enum ss_nm_Device_export_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LAST_PAIRING_TIMESTAMP = "LAST_PAIRING_TIMESTAMP",
SERVICE_REQUEST_CREATED_AT = "SERVICE_REQUEST_CREATED_AT",
SERVICE_FULFILLED_CREATED_AT = "SERVICE_FULFILLED_CREATED_AT",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_retrieveAll_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LAST_PAIRING_TIMESTAMP = "LAST_PAIRING_TIMESTAMP",
SERVICE_REQUEST_CREATED_AT = "SERVICE_REQUEST_CREATED_AT",
SERVICE_FULFILLED_CREATED_AT = "SERVICE_FULFILLED_CREATED_AT",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_retrieveAllPlayoutDescriptors_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
FIRST_PLAYOUT = "FIRST_PLAYOUT",
LAST_PLAYOUT = "LAST_PLAYOUT"
}
export enum ss_nm_Device_retrieveAllShortAttributes_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LAST_PAIRING_TIMESTAMP = "LAST_PAIRING_TIMESTAMP",
SERVICE_REQUEST_CREATED_AT = "SERVICE_REQUEST_CREATED_AT",
SERVICE_FULFILLED_CREATED_AT = "SERVICE_FULFILLED_CREATED_AT",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_retrieveDeviceTrips_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
START = "START",
END = "END"
}
export enum ss_nm_Device_setCredentials_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_setCredentialsCSV_order {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_NetworkShare_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ss_nm_NetworkShare_retrieveClients_order {
ID = "ID",
NAME = "NAME"
}
export enum ss_nm_NetworkShare_retrieveClientsByNetworkShare_order {
ID = "ID",
NAME = "NAME"
}
export enum ss_nm_NetworkShare_retrieveHierarchy_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ss_nm_PlaybackSchedule_retrieveAll_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ss_nm_PlaybackSchedule_retrieveHierarchy_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
NAME = "NAME",
PRIORITY = "PRIORITY",
LEVEL = "LEVEL"
}
export enum ss_nm_Pool_retrieveAll_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME"
}
export enum ss_nm_Pool_retrieveHierarchy_order {
CLIENT_ORDER_NUM = "CLIENT_ORDER_NUM",
ID = "ID",
NAME = "NAME"
}
export enum ss_nm_Screen_retrieveAllPlayoutDescriptors_order {
ID = "ID",
CREATED_AT = "CREATED_AT",
FIRST_PLAYOUT = "FIRST_PLAYOUT",
LAST_PLAYOUT = "LAST_PLAYOUT"
}
export enum ss_nm_Verification_all_order {
MARKER_NAME = "MARKER_NAME",
MEDIUM_NAME = "MEDIUM_NAME",
COMPANY_NAME = "COMPANY_NAME",
ID = "ID",
CREATED_AT = "CREATED_AT",
VERIFIED_AT = "VERIFIED_AT",
REJECTED_AT = "REJECTED_AT"
}
export enum ss_nm_Verification_pending_order {
MARKER_NAME = "MARKER_NAME",
MEDIUM_NAME = "MEDIUM_NAME",
COMPANY_NAME = "COMPANY_NAME",
CHANNEL_NAME = "CHANNEL_NAME",
ID = "ID",
CREATED_AT = "CREATED_AT",
VERIFIED_AT = "VERIFIED_AT",
REJECTED_AT = "REJECTED_AT"
}
export enum ss_nm_Verification_permitted_order {
MARKER_NAME = "MARKER_NAME",
MEDIUM_NAME = "MEDIUM_NAME",
COMPANY_NAME = "COMPANY_NAME",
ID = "ID",
CREATED_AT = "CREATED_AT",
VERIFIED_AT = "VERIFIED_AT",
REJECTED_AT = "REJECTED_AT"
}
export enum ss_nm_Verification_rejected_order {
MARKER_NAME = "MARKER_NAME",
MEDIUM_NAME = "MEDIUM_NAME",
COMPANY_NAME = "COMPANY_NAME",
ID = "ID",
CREATED_AT = "CREATED_AT",
VERIFIED_AT = "VERIFIED_AT",
REJECTED_AT = "REJECTED_AT"
}
export enum ss_nm_Verification_retrieveAllMedia_order {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
DURATION = "DURATION",
WIDTH = "WIDTH",
HEIGHT = "HEIGHT",
COMPANY = "COMPANY"
}
export enum ss_nm_Verification_verified_order {
MARKER_NAME = "MARKER_NAME",
MEDIUM_NAME = "MEDIUM_NAME",
COMPANY_NAME = "COMPANY_NAME",
ID = "ID",
CREATED_AT = "CREATED_AT",
VERIFIED_AT = "VERIFIED_AT",
REJECTED_AT = "REJECTED_AT"
}
export enum _admin_Area_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
COMPANY = "COMPANY",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum _admin_category_AreaCategory_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum _admin_category_CalendarCategory_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum _admin_category_CalendarEntryCategory_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum ca_md_AreaCategory_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum ca_md_AreaCategory_retrieveOfficial_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum dm_geo_Area_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
COMPANY = "COMPANY",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum dm_geo_Area_retrieveOfficial_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
COMPANY = "COMPANY",
COMPANY_ID = "COMPANY_ID",
COMPANY_CREATED_AT = "COMPANY_CREATED_AT",
COMPANY_IDENTIFIER = "COMPANY_IDENTIFIER",
COMPANY_NAME = "COMPANY_NAME",
COMPANY_STREET = "COMPANY_STREET",
COMPANY_STREET2 = "COMPANY_STREET2",
COMPANY_ZIP = "COMPANY_ZIP",
COMPANY_CITY = "COMPANY_CITY",
COMPANY_STATE = "COMPANY_STATE",
COMPANY_COUNTRY = "COMPANY_COUNTRY",
COMPANY_COUNTY = "COMPANY_COUNTY",
COMPANY_BOROUGH = "COMPANY_BOROUGH",
// PARAMETERIZED:
COMPANY_ATTRIBUTES = "COMPANY_ATTRIBUTES"
}
export enum dm_time_CalendarCategory_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum dm_time_CalendarEntryCategory_retrieveAll_filter {
ID = "ID",
NAME = "NAME",
CREATED_AT = "CREATED_AT"
}
export enum ds_rm_Inventory_retrieveAllDevices_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_Inventory_retrieveAllLocations_filter {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
MANAGED_BY_CREATED_AT = "MANAGED_BY_CREATED_AT",
MANAGED_BY_IDENTIFIER = "MANAGED_BY_IDENTIFIER",
MANAGED_BY_NAME = "MANAGED_BY_NAME",
MANAGED_BY_STREET = "MANAGED_BY_STREET",
MANAGED_BY_STREET2 = "MANAGED_BY_STREET2",
MANAGED_BY_ZIP = "MANAGED_BY_ZIP",
MANAGED_BY_CITY = "MANAGED_BY_CITY",
MANAGED_BY_COUNTRY = "MANAGED_BY_COUNTRY",
MANAGED_BY_COUNTY = "MANAGED_BY_COUNTY",
MANAGED_BY_STATE = "MANAGED_BY_STATE",
MANAGED_BY_BOROUGH = "MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANAGED_BY_ATTRIBUTES = "MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_InventoryScreen_export_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_InventoryScreen_retrieveAll_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ds_rm_Publisher_retrieveAll_filter {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH"
}
export enum mm_Medium_bookedDevicesById_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum shared_Company_export_filter {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES"
}
export enum shared_Company_retrieveAll_filter {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES"
}
export enum ss_fm_Location_export_filter {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
MANAGED_BY_CREATED_AT = "MANAGED_BY_CREATED_AT",
MANAGED_BY_IDENTIFIER = "MANAGED_BY_IDENTIFIER",
MANAGED_BY_NAME = "MANAGED_BY_NAME",
MANAGED_BY_STREET = "MANAGED_BY_STREET",
MANAGED_BY_STREET2 = "MANAGED_BY_STREET2",
MANAGED_BY_ZIP = "MANAGED_BY_ZIP",
MANAGED_BY_CITY = "MANAGED_BY_CITY",
MANAGED_BY_COUNTRY = "MANAGED_BY_COUNTRY",
MANAGED_BY_COUNTY = "MANAGED_BY_COUNTY",
MANAGED_BY_STATE = "MANAGED_BY_STATE",
MANAGED_BY_BOROUGH = "MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANAGED_BY_ATTRIBUTES = "MANAGED_BY_ATTRIBUTES"
}
export enum ss_fm_Location_retrieveAll_filter {
ID = "ID",
CREATED_AT = "CREATED_AT",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
STREET = "STREET",
STREET2 = "STREET2",
ZIP = "ZIP",
CITY = "CITY",
STATE = "STATE",
COUNTRY = "COUNTRY",
COUNTY = "COUNTY",
BOROUGH = "BOROUGH",
MANAGED_BY_CREATED_AT = "MANAGED_BY_CREATED_AT",
MANAGED_BY_IDENTIFIER = "MANAGED_BY_IDENTIFIER",
MANAGED_BY_NAME = "MANAGED_BY_NAME",
MANAGED_BY_STREET = "MANAGED_BY_STREET",
MANAGED_BY_STREET2 = "MANAGED_BY_STREET2",
MANAGED_BY_ZIP = "MANAGED_BY_ZIP",
MANAGED_BY_CITY = "MANAGED_BY_CITY",
MANAGED_BY_COUNTRY = "MANAGED_BY_COUNTRY",
MANAGED_BY_COUNTY = "MANAGED_BY_COUNTY",
MANAGED_BY_STATE = "MANAGED_BY_STATE",
MANAGED_BY_BOROUGH = "MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
MANAGED_BY_ATTRIBUTES = "MANAGED_BY_ATTRIBUTES"
}
export enum ss_fm_Location_retrieveDevicesByLocationId_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_export_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_retrieveAll_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_retrieveAllShortAttributes_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LAST_ONLINE = "LAST_ONLINE",
ONLINE_STATUS = "ONLINE_STATUS",
POSITION_UPDATED = "POSITION_UPDATED",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_setCredentials_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}
export enum ss_nm_Device_setCredentialsCSV_filter {
ID = "ID",
IDENTIFIER = "IDENTIFIER",
NAME = "NAME",
LAST_IP = "LAST_IP",
LOCATION_ID = "LOCATION_ID",
LOCATION_CREATED_AT = "LOCATION_CREATED_AT",
LOCATION_IDENTIFIER = "LOCATION_IDENTIFIER",
LOCATION_NAME = "LOCATION_NAME",
LOCATION_STREET = "LOCATION_STREET",
LOCATION_STREET2 = "LOCATION_STREET2",
LOCATION_ZIP = "LOCATION_ZIP",
LOCATION_CITY = "LOCATION_CITY",
LOCATION_STATE = "LOCATION_STATE",
LOCATION_COUNTRY = "LOCATION_COUNTRY",
LOCATION_COUNTY = "LOCATION_COUNTY",
LOCATION_BOROUGH = "LOCATION_BOROUGH",
LOCATION_MANAGED_BY_CREATED_AT = "LOCATION_MANAGED_BY_CREATED_AT",
LOCATION_MANAGED_BY_IDENTIFIER = "LOCATION_MANAGED_BY_IDENTIFIER",
LOCATION_MANAGED_BY_NAME = "LOCATION_MANAGED_BY_NAME",
LOCATION_MANAGED_BY_STREET = "LOCATION_MANAGED_BY_STREET",
LOCATION_MANAGED_BY_STREET2 = "LOCATION_MANAGED_BY_STREET2",
LOCATION_MANAGED_BY_ZIP = "LOCATION_MANAGED_BY_ZIP",
LOCATION_MANAGED_BY_CITY = "LOCATION_MANAGED_BY_CITY",
LOCATION_MANAGED_BY_STATE = "LOCATION_MANAGED_BY_STATE",
LOCATION_MANAGED_BY_COUNTRY = "LOCATION_MANAGED_BY_COUNTRY",
LOCATION_MANAGED_BY_COUNTY = "LOCATION_MANAGED_BY_COUNTY",
LOCATION_MANAGED_BY_BOROUGH = "LOCATION_MANAGED_BY_BOROUGH",
// PARAMETERIZED:
ATTRIBUTES = "ATTRIBUTES",
LOCATION_ATTRIBUTES = "LOCATION_ATTRIBUTES",
LOCATION_MANAGED_BY_ATTRIBUTES = "LOCATION_MANAGED_BY_ATTRIBUTES"
}